{
    "brand": "Brand",
    "brands": "Brands",
    "brands_index_description": "Connect your products to brands to let customers filter by brand in the storefront. You can also show the brand name as the title on product cards — change \"Product box title\" under Product card in the design builder.",
    "brands_open_design_editor": "Open the design builder",
    "brands_page": "Brands page",
    "type_name": "Type name",
    "new_brand": "New brand",
    "no_brand": "— No brand —",
    "select_a_brand": "Select a brand",
    "delete_brand": "Delete brand",
    "brand_type_name_help": "Label for this brand's type, e.g. Producer or Manufacturer.",
    "set_brand": "Set brand",
    "set_brand_action_description": "Assign a brand to the selected products",
    "remove_brand": "Remove brand",
    "remove_brand_action_description": "Remove the brand from the selected products",
    "are_you_sure_you_want_to_remove_the_brand_from_{count}_products": "Are you sure you want to remove the brand from {count} product? | Are you sure you want to remove the brand from {count} products?",
    "set_brand_modal_description": "Choose a brand to assign to the selected products.",
    "set_brand_on_x_amount_of_products": "Set brand on {count} product | Set brand on {count} products",
    "delete_brand_modal_description": "This will delete the brand {name}, used by {count} product | This will delete the brand {name}, used by {count} products",
    "brand_deleted": "Brand deleted",
    "brand_updated": "Brand updated",
    "brand_created": "Brand created",
    "product_brand_tooltip": "The brand assigned to this product.",
    "product_box_title_mode": "Product box title",
    "product_box_title_mode_description": "Choose whether the product box shows the product name with intro text, or the brand name with the product name.",
    "product_box_title_mode_name": "Product name + intro",
    "product_box_title_mode_brand": "Brand + product name",
    "brand_display": "Brand display",
    "brand_display_description": "Replace the product title with the brand name, with or without its logo above. The product name is shown in small text below, and the brand links to its brand page.",
    "brand_display_hidden": "hidden",
    "brand_display_name": "brand name as title",
    "brand_display_logo": "logo and brand name as title",
    "google_category_column": "Google category",
    "sale_price_filter": "sale price",
    "with_sale_price": "with sale price",
    "without_sale_price": "without sale price",
    "stock_tracking_filter": "stock tracking",
    "with_stock_tracking": "with stock tracking",
    "without_stock_tracking": "without stock tracking",
    "set_product_form": "set product form",
    "remove_product_form": "remove product form",
    "set_product_form_action_description": "Attach a form with free text fields to the selected products",
    "remove_product_form_action_description": "Remove the product form from the selected products",
    "set_product_form_for_x_amount_of_products": "Set product form for {count} product | Set product form for {count} products",
    "set_product_form_modal_description": "The products get the selected form on the product page. Any existing form is replaced.",
    "are_you_sure_you_want_to_remove_product_form_from_{count}_products": "Are you sure you want to remove the product form from {count} product? | Are you sure you want to remove the product form from {count} products?",
    "enable_stock_notifications": "enable stock notifications",
    "disable_stock_notifications": "disable stock notifications",
    "enable_stock_notifications_action_description": "Let customers sign up for a notification when the products are back in stock",
    "disable_stock_notifications_action_description": "Turn off stock notification signup for the selected products",
    "are_you_sure_you_want_to_enable_stock_notifications_for_{count}_products": "Are you sure you want to enable stock notifications for {count} product? | Are you sure you want to enable stock notifications for {count} products?",
    "are_you_sure_you_want_to_disable_stock_notifications_for_{count}_products": "Are you sure you want to disable stock notifications for {count} product? | Are you sure you want to disable stock notifications for {count} products?",
    "category_column_manual_only_hint": "Shows manual categories only",
    "filter": "filter",
    "no_products_match_the_current_filters": "No products match the current filters or search",
    "showing_results_from_to_of_total": "Showing {from}–{to} of {total}",
    "out_of_stock": "out of stock",
    "columns": "columns",
    "column_price": "price",
    "stock_empty": "Empty",
    "search_for_products_sku_or_gtin": "Search products, SKU or GTIN …",
    "add_badges": "Add badges",
    "remove_badges": "Remove badges",
    "add_badges_products_action_description": "Add badges to the selected products",
    "remove_badges_products_action_description": "Remove badges from the selected products",
    "delete_tags_action_description": "Delete the selected tags and remove them from all products",
    "add_product_to_categories_action_description": "Add the product to the selected categories",
    "move_to_top_action_description": "Move the selected products to the start of the category",
    "remove_from_category_action_description": "Remove the selected products from the category",
    "add_badges_to_x_amount_of_products": "Add badges to {count} product | Add badges to {count} products",
    "remove_badges_from_x_amount_of_products": "Remove badges from {count} product | Remove badges from {count} products",
    "add_x_badges": "Add {count} badge | Add {count} badges",
    "remove_x_badges": "Remove {count} badge | Remove {count} badges",
    "add_badges_modal_description": "Any products that already have the selected badges will not have them added again",
    "bulk_group_visibility": "visibility",
    "bulk_group_prices": "prices",
    "bulk_group_organize": "organize",
    "bulk_group_connections": "connections",
    "bulk_group_data": "data",
    "bulk_group_remove": "remove",
    "all_actions": "all actions",
    "quick_actions_label": "quick",
    "search_actions_placeholder": "Search actions — price, tags, delete …",
    "no_actions_found_for": "No actions match “{query}”",
    "select_current_page_only": "Select this page only",
    "all_x_products_selected": "all {count} selected",
    "x_of_y_actions": "{x} of {y} actions",
    "palette_navigate": "navigate",
    "palette_choose": "choose",
    "general.brand_asc": "Brand A–Z",
    "general.brand_desc": "Brand Z–A",
    "bulk_group_stock": "stock",
    "bulk_group_images": "images",
    "set_stock": "set stock level",
    "adjust_stock": "adjust stock level",
    "set_stock_action_description": "Set the same stock level for the selected products",
    "adjust_stock_action_description": "Increase or decrease the stock level for the selected products",
    "set_stock_for_x_amount_of_products": "Set stock level for {count} product | Set stock level for {count} products",
    "adjust_stock_for_x_amount_of_products": "Adjust stock level for {count} product | Adjust stock level for {count} products",
    "set_stock_modal_description": "All selected products get the same stock level",
    "adjust_stock_modal_description": "The stock level changes by the value you enter, and stops at zero",
    "new_stock_value": "new stock level",
    "stock_adjustment_label": "change in quantity (use minus to decrease)",
    "bulk_stock_applies_to_all_variants": "For products with variants, all variants are updated.",
    "no_tags_created_yet": "No tags have been created yet",
    "webhook": "webhooks",
    "dashboard": "dashboard",
    "sales": "sales",
    "orders": "orders",
    "contacts": "contacts",
    "customers": "customers",
    "companies": "companies",
    "customer_groups": "customer groups",
    "typography": "typography",
    "colors": "colors",
    "product_card": "Product card",
    "product_card_layout": "Layout",
    "product_card_badges": "Discount badges & labels",
    "product_card_variants": "Variant options",
    "product_card_colors": "Colors",
    "products": "Products",
    "listings": "Listings",
    "product": "Product",
    "all_products": "all products",
    "categories": "Categories",
    "discounts": "discounts",
    "marketing": "marketing",
    "newsletter_subscribers": "newsletter subscribers",
    "subscribers": "Subscribers",
    "product_management": "Product management",
    "pages": "pages",
    "fixed_pages": "Fixed pages",
    "fixed_text_updated": "Text updated",
    "design": "design",
    "themes": "themes",
    "reports": "reports",
    "settings": "settings",
    "general": "general",
    "footer_font_size": "Footer font size",
    "b2b_and_wholesale": "B2B",
    "users": "users",
    "shipping": "shipping",
    "working": "Working...",
    "customs_data_help": "Used for customs declarations when a shipment crosses a border — including domestic orders where the transport route passes through another country.",
    "hs_code": "HS code (tariff)",
    "hs_code_placeholder": "e.g. 6109.10",
    "hs_code_check_unknown": "The HS code is not in the tariff. You can still save it, but check it against",
    "hs_code_check_tariff_link": "the Norwegian Customs tariff",
    "country_of_origin": "Country of origin",
    "country_of_origin_placeholder": "Search for a country...",
    "customs_description": "Customs declaration text",
    "customs_description_placeholder": "Short description of the goods for customs, if undefined the lead paragraph is used",
    "customs_data_title": "Customs data",
    "hs_code_batch_link_lead": "Do several products lack an HS code?",
    "hs_code_batch_link": "Suggest codes for all of them at once",
    "missing_customs_cta": "{count} product is missing customs data | {count} products are missing customs data",
    "missing_customs_banner_title": "{count} product is missing an HS code | {count} products are missing an HS code",
    "missing_customs_banner_body": "Shipments to Northern Norway may be transported via Sweden or Finland. Such shipments require an HS code on the products.",
    "missing_customs_banner_link": "View the products",
    "hs_code_explainer_summary": "Why do products need an HS code? A missing code can cause transport problems and higher costs.",
    "hs_code_explainer_nvit_title": "Shipping goods between southern and northern Norway? New information requirements may apply to you.",
    "hs_code_explainer_nvit_body": "Goods sent from one place in Norway to another but transported through Sweden or Finland on the way count as <strong>Norwegian goods in transit (NVIT)</strong>. For such shipments the carrier needs more detailed information about the goods, including a correct <strong>six-digit HS commodity number (HS code)</strong> for every product type. Missing or incomplete information can cause transport problems and potentially higher costs.",
    "hs_code_explainer_what_title": "What is an HS code?",
    "hs_code_explainer_what_body": "An <strong>HS code</strong> is an international commodity number that classifies what kind of goods are being shipped. Different products have different HS codes, so it matters that the products in your store carry the right one.",
    "hs_code_explainer_help_title": "We help you with the work",
    "hs_code_explainer_help_body": "With many product lines, adding every HS code is demanding, so we built a service to help. The AI feature speeds up classification, but its suggestions should be checked before use. <strong>As the owner of the goods you are responsible for the HS code and other details given to the carrier being correct.</strong> If you are unsure how to classify a product, check it against the Norwegian Customs tariff or contact Norwegian Customs for guidance. Once an HS code is registered on the product it is sent to the carrier automatically when the shipment is booked.",
    "hs_code_explainer_link": "Read more about NVIT at Norwegian Customs",
    "all_products_have_hs_code": "All products have an HS code",
    "all_products_have_hs_code_help": "No products are missing customs data right now.",
    "add_hs_code": "Add HS code",
    "import_customs_data": "Import customs data",
    "export_customs_data": "Export all products",
    "customs_export_failed": "Could not export customs data",
    "customs_import_failed": "Could not import customs data",
    "customs_import_result_page_title": "Import result",
    "customs_import_result_heading": "Customs data import result",
    "total_rows_processed": "Rows processed",
    "successfully_updated": "Successfully updated",
    "rejected_rows": "Rejected rows",
    "customs_import_all_succeeded": "All rows were imported without errors.",
    "customs_import_how_to_fix": "Download the error report below to see every rejected row. Fix the values directly in the file and re-upload it via the Import button.",
    "customs_import_preview_truncated": "Showing the first {shown} of {total} rejected rows. Download the error report to see all.",
    "download_error_report": "Download error report (CSV)",
    "row": "Row",
    "problem": "Problem",
    "rejected_value": "Rejected value",
    "rows_with_warnings": "Rows with warnings",
    "customs_import_warnings_help": "These rows were updated, but the HS code was not recognised as a six-digit code in the tariff. Check the codes against the Norwegian Customs tariff.",
    "saved_value": "Saved value",
    "customs_import_reason_invalid_product_id": "Product ID missing or not a number.",
    "customs_import_reason_product_not_found": "Product does not exist.",
    "customs_import_reason_variant_row": "Variant row ignored (customs data is stored per product).",
    "customs_import_reason_hs_code_not_recognized": "The HS code was saved but is not in the tariff. Please check it.",
    "customs_import_reason_invalid_country_code": "The country of origin is not a valid ISO 3166-1 alpha-2 code.",
    "customs_import_reason_description_too_long": "The customs description is longer than 255 characters.",
    "could_not_read_upload": "The file could not be read.",
    "csv_missing_header_row": "The CSV file is missing a valid header row.",
    "csv_no_customs_columns_found": "No customs columns (HS code, Country of origin, Customs description) were found in the CSV.",
    "suggest_hs_code": "Suggest HS code",
    "suggesting_hs_code": "Suggesting...",
    "suggested_hs_code": "Suggested HS code",
    "ai_confidence": "AI confidence",
    "accept": "Use",
    "dismiss": "Dismiss",
    "hs_code_suggester_unavailable": "The suggestion service is not available right now. Try again shortly.",
    "hs_code_suggest_trial": "HS code suggestions are an AI feature and require a paid subscription.",
    "hs_code_suggest_topup_link": "Top up AI balance",
    "hs_code_suggest_charged": "Charged {amount} · balance {balance}",
    "hs_code_suggest_cached": "Free (cached suggestion) · balance {balance}",
    "hs_code_suggest_empty_title": "Give the product a name before asking for a suggestion.",
    "hs_code_batch_intro_title": "Get suggestions for missing HS codes",
    "hs_code_batch_intro_body": "Get AI suggestions based on product information. You choose which codes to save.",
    "hs_code_batch_scope_short": "The run covers the whole store, not just your search or the current page.",
    "hs_code_batch_scope": "Requests suggestions for all eligible products without an HS code in the store, including other pages and products outside your search. Products already processing or awaiting review are not sent again.",
    "hs_code_batch_sending_help": "Keep this page open until all products have been sent. You can then leave while the suggestions are processed.",
    "hs_code_batch_processing_help": "Submission has ended. Submitted products are processed in the background. You can leave and return here to see the results.",
    "hs_code_batch_review_help": "No codes are saved until you accept them. You pay for generating suggestions, even if you dismiss them.",
    "hs_code_batch_confidence_help": "The percentage is the AI’s own assessment, not a guarantee of the correct code.",
    "hs_code_batch_bulk_scope": "Applies to all suggestions meeting the threshold, including other pages and results outside your search.",
    "hs_code_batch_threshold_empty": "No suggestions meet this threshold. Review them individually or choose a lower threshold.",
    "hs_code_batch_view_reasoning": "View reasoning",
    "hs_code_batch_page_help": "{count} products are missing an HS code. Enter codes manually, import customs data or request AI suggestions.",
    "hs_code_batch_reserved": "reserved {amount}",
    "hs_code_batch_try_again": "Wait a moment before trying again.",
    "hs_code_batch_run": "Suggest HS codes ({count})",
    "hs_code_batch_confirm_title": "Request HS-code suggestions ({count})",
    "hs_code_batch_confirm_price": "Estimate: {estimate} total · {price} per new suggestion",
    "hs_code_batch_confirm_body": "The actual price and the amount reserved from your AI balance may exceed the estimate. Unused reservations are returned. Reused cached suggestions are free.",
    "hs_code_batch_start": "Submit for processing",
    "hs_code_batch_submitting": "Sending {done} of {total} products …",
    "hs_code_batch_processing": "Fetching suggestions … {done} of {total} done",
    "hs_code_batch_completed": "{suggested} suggestions ready · {failed} without a suggestion · charged {amount}",
    "hs_code_batch_unreachable": "Cannot reach the AI service right now.",
    "hs_code_batch_overdue": "Taking longer than usual.",
    "hs_code_batch_failed": "A run failed ({code}). See the amount charged in the summary.",
    "hs_code_batch_insufficient": "The balance ran out: {sent} of {total} products were sent.",
    "hs_code_batch_accept_all": "Accept all with at least {percent} % confidence ({count})",
    "hs_code_batch_accept_all_confirm": "Confirm: accept {count}",
    "hs_code_batch_accepted_count": "{count} codes saved",
    "hs_code_with_suggestion": "With suggestion",
    "hs_code_no_suggestion": "No suggestion",
    "hs_code_no_suggestion_empty_title": "The product has no name",
    "hs_code_no_suggestion_invalid_result": "The AI service answered with a code that is not in the tariff.",
    "hs_code_no_suggestion_not_found": "The run no longer exists at the AI service.",
    "hs_code_saved": "Saved {code}",
    "hs_code_dismissed": "Dismissed",
    "hs_code_already_decided": "This row has already been decided.",
    "hs_code_already_set": "The product already has an HS code.",
    "hs_code_changed_since_recheck": "The HS code was changed after the re-check started.",
    "hs_code_no_suggestions_to_review": "No suggestions to review. Run Suggest HS codes to fetch new ones.",
    "hs_code_suggestion_column": "Suggestion",
    "hs_code_confidence_threshold": "Minimum AI confidence",
    "hs_code_not_recognized": "HS code :code is not recognized in the tariff.",
    "hs_code_tab_missing": "Missing HS code",
    "hs_code_tab_recheck": "Re-check saved codes",
    "hs_code_recheck_intro_title": "Re-check saved HS codes",
    "hs_code_recheck_intro_body": "Get a new AI suggestion for products that already have an HS code. Where the suggestion matches the saved code, the product is marked as confirmed. Only disagreements are listed for you to review.",
    "hs_code_recheck_scope_short": "Covers every product with a saved HS code, including codes you entered yourself. To check only some products, select them in the product list and choose Re-check HS codes.",
    "hs_code_recheck_run": "Re-check saved codes ({count})",
    "hs_code_recheck_confirm_title": "Re-check saved HS codes ({count})",
    "hs_code_recheck_confirm_selected_title": "Re-check {count} selected products",
    "hs_code_recheck_scope": "Requests a new suggestion for each product with a saved HS code. Saved codes are not changed until you replace them.",
    "hs_code_recheck_selected_without_code": "{count} of the selected products have no saved code. You find them under Missing HS code.",
    "hs_code_recheck_selection_expired": "The selection from the product list has expired, so the run covers all saved codes.",
    "hs_code_batch_redo_waiting": "Also get new suggestions for the {count} products waiting for review",
    "hs_code_recheck_saved": "Saved",
    "hs_code_recheck_suggested": "suggested",
    "hs_code_recheck_replace": "Replace",
    "hs_code_recheck_keep": "Keep",
    "hs_code_recheck_kept": "Kept {code}",
    "hs_code_recheck_completed": "{confirmed} confirmed · {differ} differ · {failed} without a suggestion · charged {amount}",
    "hs_code_recheck_replace_all": "Replace all with at least {percent} % confidence ({count})",
    "hs_code_recheck_replace_all_confirm": "Confirm: replace {count}",
    "hs_code_recheck_replaced_count": "{count} codes replaced",
    "hs_code_recheck_bulk_scope": "Replaces the saved code on every disagreement meeting the threshold, including codes you entered yourself, other pages and results outside your search.",
    "hs_code_recheck_empty_help": "Run a re-check to compare saved codes with a new suggestion.",
    "country_code_must_be_a_string": "Country code must be a string.",
    "country_code_not_recognized": "Country code :code is not a valid ISO 3166-1 alpha-2 code.",
    "packages": "packages",
    "order_notifications": "order notifications",
    "billing": "billing",
    "legal": "legal",
    "domains": "domains",
    "seo_and_analytics": "SEO & Analytics",
    "payment_providers": "payment providers",
    "api_access": "API Access",
    "add_product": "add product",
    "all": "all",
    "none": "none",
    "draft": "draft",
    "visible": "Visible",
    "hidden": "Hidden",
    "name": "Name",
    "name_in_the_store": "name in the store",
    "status": "status",
    "last_updated": "last updated",
    "draft_without_name": "draft without name",
    "save": "save",
    "save_amount": "Save",
    "saving": "Saving...",
    "this_shipping_method_requires_configuration": "This shipping method requires configuration.",
    "go_to_apps": "Go to apps",
    "to_enable_and_configure_this_shipping_method": "to enable and configure this shipping method.",
    "fallback_shipping_configuration": "Fallback Shipping Configuration",
    "what_is_fallback_shipping": "What is Fallback Shipping?",
    "fallback_shipping_description": "Fallback shipping is a backup shipping option that ensures customers always have at least one shipping method available during checkout. It provides a reliable shipping option when all other shipping gateways are unavailable or disabled.",
    "when_activated": "When activated",
    "fallback_shipping_activation_condition": "When no regular shipping methods (Bring, 24Shipping, etc.) are available or enabled",
    "fallback_shipping_name": "Enter shipping method name",
    "enter_price": "Enter price",
    "submit": "Submit",
    "skip": "Skip",
    "product_name": "product name",
    "lead_paragraph": "lead paragraph",
    "product_information": "product information",
    "product_layout": "product layout",
    "image": "image | images",
    "image_height_desktop": "Image height on desktop",
    "image_height_mobile": "Image height on mobile",
    "image_height_adapt_first": "Adapt to first image",
    "image_aspect_ultrawide": "Ultrawide (21:9)",
    "image_height_ratio_description": "The ratio options give every image the same frame at all screen widths. “Adapt to first image” applies the first image's ratio to the whole slider.",
    "image_title": "image title",
    "auto": "Auto",
    "gtin": "GTIN",
    "upload_a_file": "upload a file",
    "or_drag_and_drop": "or drag and drop",
    "up_to": "up to",
    "price": "price | prices",
    "sale_price": "sale price | sale prices",
    "sale_price_incl_vat": "Sale price incl. VAT",
    "tax_rate": "tax rate",
    "cost_price": "cost price",
    "in_stock": "in stock",
    "sku": "SKU",
    "is_visible": "is visible",
    "edit_profile": "edit profile",
    "log_out": "log out",
    "profile_information": "profile information",
    "update_your_account_information": "Update your account's profile information.",
    "email_cannot_be_changed_create_new_user": "your email address can't be changed. To use a different address, a new user has to be created.",
    "email": "email",
    "email_address": "email address",
    "password": "password",
    "repeat_password": "repeat password",
    "update_password": "update password",
    "ensure_your_account_is_using": "Ensure your account is using a long, random password to stay secure.",
    "current_password": "current password",
    "new_password": "new password",
    "confirm_password": "confirm password",
    "delete_account": "delete account",
    "once_your_account_is_deleted": "Once your account is deleted, all of its resources and data will be permanently deleted. Before deleting your account, please download any data or information that you wish to retain.",
    "your_email_is_unverified": "Your email address is unverified",
    "click_to_resend_verification_email": "Click here to re-send the verification email.",
    "verification_link_has_been_sent": "A new verification link has been sent to your email address.",
    "saved": "saved",
    "are_you_sure_you_want_to_delete_your_account": "Are you sure you want to delete your account?",
    "cancel": "cancel",
    "remember_me": "remember me",
    "forgot_your_password": "forgot your password?",
    "log_in": "log in",
    "forgot_your_password_no_problem": "Forgot your password? No problem. Just let us know your email address and we will email you a password reset link that will allow you to choose a new one.",
    "email_password_reset_link": "email password reset link",
    "logged_in": "You're logged in!",
    "description": "Description",
    "title": "title",
    "slug": "slug",
    "add_category": "add category",
    "edit_main_menu": "Edit main menu",
    "include_subcategories": "include subcategories",
    "new_subcategory": "new subcategory",
    "new_subcategory_in": "new subcategory in {category}",
    "new_top_level_category": "new top-level category",
    "category_creation_also_adds_to_menu": "The category is also added to the main menu in this spot.",
    "category_creation_needs_one_category": "Several categories are selected. Pick one to create a category in a particular spot.",
    "menu_depth_reached_cannot_nest": "The main menu cannot go deeper than three levels, so this category cannot have subcategories.",
    "new_product_here": "new product here",
    "will_be_added_to_category": "will be added to the category",
    "selected category could not be found": "The selected category could not be found.",
    "cannot_attach_products_to_a_smart_category": "Smart categories are defined by criteria, so products cannot be added manually.",
    "menu_placement": "main menu placement",
    "no_menu_placement": "no placement",
    "menu_placement_top_level": "top level of the main menu",
    "list_view": "list view",
    "hierarchy_view": "hierarchy view",
    "not_in_main_navigation": "not in main navigation",
    "add_new_category": "add new category",
    "category_title_placeholder": "e.g. Clothing",
    "search": "search",
    "active": "active",
    "inactive": "inactive",
    "search_products": "Search products",
    "add_products": "add products",
    "navigation": "navigation",
    "menu": "menu | menus",
    "add_menu": "add menu",
    "menu_item": "menu item | menu items",
    "add": "add",
    "create": "create",
    "product_description_name": "description name",
    "product_description_placeholder": "Size guide",
    "are_you_sure_you_want_to_delete": "are you sure you want to delete {name}?",
    "item_deleted": ":name deleted",
    "item_created": ":name created",
    "update_product_description_name": "update product description name",
    "images": "images",
    "vertical_padding": "Space above and below images",
    "files": "files",
    "variants": "variants",
    "no_variants": "No variants",
    "option": "option|options",
    "option_value": "option value|option values",
    "select": "select:",
    "cant_delete_last_option_value_please_add_another_or_delete_the_option": "can't delete the last option value. Please add another, or delete the whole option.",
    "edit": "edit",
    "done": "done",
    "already_exists": "already exists",
    "add_first_option_value": "Add first option value",
    "is_new": "new",
    "enabled": "enabled",
    "actions": "actions",
    "set_count_variants_to_enabled_status": "Set {qty} variant(s) to enabled status",
    "disabled_variants_will_not_be_buyable": "Disabled variants will not be buyable",
    "please_wait": "please wait",
    "variant": "Variant",
    "stock": "stock",
    "search_engine_listing": "search engine listing",
    "characters_of_available_used": "{characters} of {available} characters used",
    "slug_change_warning": "Warning: Changing the URL slug of your product may negatively impact its search engine ranking. Search engines like Google may already have indexed the existing URL, and altering it will break existing links and require re-indexing.",
    "change": "change",
    "change_dates": "Change dates",
    "pricing_and_tax": "pricing and taxes",
    "prices_are_defined_on_variant_level": "Prices are defined on a variant level",
    "discount_rate": "discount rate",
    "discount_percentage": "Discount percentage",
    "price_including_vat": "price including VAT",
    "price_excluding_vat": "price excluding VAT",
    "excluding_vat": "excluding VAT",
    "compare_at_price": "compare at price",
    "optional": "Optional",
    "price_adjustment": "price adjustment",
    "margin": "Margin",
    "preview": "preview",
    "previous": "Previous",
    "close": "close",
    "text_editor_empty_placeholder": "Click to write text…",
    "delete": "delete",
    "weight": "weight",
    "height": "height",
    "length": "length",
    "width": "width",
    "create_new_product": "create new product",
    "translate": "translate",
    "quantity_for_sale": "quantity for sale",
    "track_inventory": "track inventory",
    "calculated_from_variants": "calculated from variants",
    "inventory": "inventory",
    "keeps_track_of_stock_as_you_sell_items": "Keeps track of stock as you sell products",
    "allow_backorder": "allow backorders",
    "continue_selling_when_out_of_stock": "continue selling when out of stock",
    "visibility": "visibility",
    "requires_shipping": "requires shipping",
    "weight_from": "weight from",
    "weight_to": "weight to",
    "buying_this_product_means_shipping_will_be_required": "Buying this product means shipping will be required",
    "could_not_add_requested_quantity_of_item_to_cart_there_is_insufficient_stock_available": "Could not add requested quantity of item to cart. There is insufficient stock available.",
    "item_must_have_quantity_greater_than_zero": "Item must have quantity greater than zero",
    "cart_quantity_reduced_due_to_insufficient_stock": "Cart quantity reduced due to insufficient stock",
    "text": "text",
    "add_page": "add page",
    "new_page": "new page",
    "page_name": "page name",
    "are_you_sure_you_want_to_delete_the_page": "Are you sure you want to delete the page {page}?",
    "delete_page": "Delete page",
    "view_store": "View store",
    "cart_item_removed_because_it_was_no_longer_buyable": "A cart item removed because it was no longer buyable",
    "could_not_add_item_to_cart_it_is_not_available_for_purchase": "Could not add an item to cart. It is not available for purchase.",
    "show_order_summary": "show order summary",
    "hide_order_summary": "hide order summary",
    "in_your_cart": "in your cart",
    "header": "header",
    "product_slider": "product slider",
    "product_grid": "product grid",
    "single_product": "single product",
    "image_slider": "image slider",
    "image_grid": "image grid",
    "bento_grid": "Bento grid",
    "bento_layout_variant": "Layout",
    "bento_layout_variant_description": "Choose how the tiles are arranged in the grid",
    "bento_variant_feature_left": "Feature left",
    "bento_variant_feature_right": "Feature right",
    "bento_variant_showcase": "Showcase",
    "bento_variant_mosaic": "Mosaic",
    "bento_variant_hero": "Hero banner",
    "bento_variant_strips": "Strips",
    "bento_row_height": "Tile height",
    "bento_row_height_description": "Base height of each tile (px). Larger tiles become a multiple of this.",
    "before_after_image": "before/after image",
    "logo_slider": "logo slider",
    "block_description_logo_slider": "A row of logos that moves automatically — continuous scroll or paged.",
    "logos": "logos",
    "logo_slider_logos_description": "Upload the logos to display. SVG, PNG, JPG and WebP are supported.",
    "logos_per_view_desktop": "logos per view (desktop)",
    "logos_per_view_mobile": "logos per view (mobile)",
    "logo_slider_logo_height": "logo height (px)",
    "logo_slider_movement_style": "movement",
    "logo_slider_movement_style_description": "Continuous scroll glides sideways; paged advances a few logos at a time.",
    "logo_slider_movement_paged": "paged autoplay",
    "logo_slider_movement_marquee": "continuous scroll",
    "logo_slider_autoplay_interval": "autoplay speed",
    "logo_slider_marquee_speed": "scroll speed",
    "logo_slider_speed_slow": "slow",
    "logo_slider_speed_normal": "normal",
    "logo_slider_speed_fast": "fast",
    "logo_slider_pause_on_hover": "pause on hover",
    "logo_slider_controls_paged_only": "Only applies to paged autoplay.",
    "image_grid_slider": "image grid slider",
    "footer": "footer",
    "text_content": "text content",
    "campaign_bar": "campaign bar",
    "phone": "phone",
    "phone_number": "phone number",
    "store_information": "store information",
    "company_name": "company name",
    "company_number": "VAT number",
    "address": "address",
    "address2": "address 2",
    "postal_code": "postal code",
    "city": "city",
    "about_store_settings": "This information will be visible for every visitor and customer in the store",
    "about_contact_settings": "Allow customers and visitors to make any inquiries to the store",
    "notify_on_new_customer": "Notify me about new customers",
    "notify_on_new_customer_description": "Send an email to the address above when a new customer registers in the store.",
    "billing_information": "Information that 24Nettbutikk will use to invoice for the e-store",
    "created": "created",
    "created_at": "created",
    "csv_export": "CSV export",
    "newsletter_form": "newsletter form",
    "primary_color": "primary color",
    "secondary_color": "secondary color",
    "call_to_action_color": "call to action color",
    "call_to_action_text_color": "call to action text color",
    "buy_button_color_mode": "Purchase button color",
    "buy_button_color_mode_description": "Applies to Buy and Read more on product cards, Add to cart, View cart, Go to checkout and the buttons in the checkout. The Vipps button keeps its own colors.",
    "buy_button_color_mode_c2a": "Call to action color",
    "buy_button_color_mode_custom": "Custom color",
    "buy_button_color": "Purchase button background",
    "buy_button_text_color": "Purchase button text",
    "buy_button_color_disabled_hint": "Choose ‘Custom color’ under ‘Purchase button color’ to change this.",
    "sale_price_color": "Sale price colour",
    "sale_price_color_description": "Colour of the sale price when the product is on offer.",
    "social_media_use_text_color": "Social media icons follow the text color",
    "social_media_use_text_color_description": "The social media icons use the text color where they appear: the footer text color in the footer and the mobile menu text color in the menu. Turn off to pick one custom color.",
    "social_media_color": "Social media color",
    "social_media_color_description": "Used for the social media icons in the footer and the mobile menu.",
    "social_media_color_disabled_hint": "Turn off ‘Social media icons follow the text color’ to pick a color.",
    "headlines_color": "Category headings color",
    "buttons_background_color": "buttons background color",
    "buttons_text_color": "buttons text color",
    "product_box_border_color": "products border color",
    "product_box_image_hover": "Change image on hover",
    "product_box_image_hover_description": "Swap to the product's second image when hovering over the product card. Applies to category pages, search and product listings — design blocks with their own hover setting override this.",
    "show_lead_paragraph": "Show lead paragraph",
    "show_lead_paragraph_description": "Display the short description below the product name in product boxes",
    "show_lead_paragraph_mobile": "Show lead paragraph on mobile",
    "show_lead_paragraph_mobile_description": "The lead paragraph is clipped to one line on small screens. Works best when it is written as a short specification line.",
    "product_box_show_stock_status": "Show stock status",
    "product_box_show_stock_status_description": "Display stock status (In stock/Out of stock) in product boxes across the store, including category pages. The change appears after the page is reloaded.",
    "block_show_stock_status": "Show stock status",
    "block_show_stock_status_description": "Display stock status in this block's product boxes.",
    "product_box_title_bold": "Bold product title",
    "product_box_title_bold_description": "Render product names in bold across product cards (grid, list, and small variants).",
    "product_card_density": "Product card density",
    "product_card_density_description": "Adjusts title, price, and padding size in one move. Compact suits info-dense industries (gadgets, sport); comfortable suits fashion and jewelry.",
    "product_card_density_compact": "Compact",
    "product_card_density_standard": "Standard",
    "product_card_density_comfortable": "Comfortable",
    "product_box_transparent_background": "Transparent product box background",
    "product_box_transparent_background_description": "Remove the white background on the product box so it picks up the page or section background instead. Text contrast is adjusted automatically when this is active.",
    "product_box_center_content": "Text alignment in product box",
    "product_box_center_content_description": "Align title, lead paragraph, price and reviews in the product box",
    "product_box_align_left": "Left aligned",
    "product_box_align_center": "Centered",
    "product_card_discount_position": "Discount badge position",
    "product_card_favorite_position": "Favorite button position",
    "product_card_badges_position": "Labels position",
    "product_card_position_top_left": "Top left",
    "product_card_position_top_right": "Top right",
    "product_card_position_bottom_left": "Bottom left",
    "product_card_position_bottom_right": "Bottom right",
    "product_box_button_style": "Button style in product box",
    "product_box_button_style_description": "Choose between an icon button or a full-width button in the product box. The change takes effect after the page is reloaded.",
    "product_box_button_icon": "Icon button",
    "product_box_button_full_width": "Full-width button",
    "show_swatches_on_cards": "Show variant options on product cards",
    "show_swatches_on_cards_description": "When enabled, the variants are shown as color swatches, small images or text buttons below the product title on category pages. Customers see the variant's name and image on hover, and go straight to the variant on click.",
    "swatch_size": {
        "label": "Variant option size",
        "description": "Size in pixels of the variant options on the product card."
    },
    "swatch_border_color": "Variant option border color",
    "swatch_border_width": {
        "label": "Border around variant options",
        "description": "Thickness of the border around each variant option. Choose \"No border\" to turn it off.",
        "none": "No border",
        "thin": "Thin (1px)",
        "medium": "Medium (2px)",
        "thick": "Thick (3px)"
    },
    "swatch_placement": {
        "label": "Placement on the card",
        "description": "Where the variant options appear on the product card: below or above the title, or as a row at the bottom of the card image. The change appears after the page is reloaded.",
        "below": "Below the title",
        "above": "Above the title",
        "image": "At the bottom of the image"
    },
    "swatch_radius": {
        "label": "Variant option shape",
        "description": "The shape of color swatches, thumbnails and text buttons on product cards.",
        "theme": "Follow theme corners",
        "rounded": "Rounded",
        "circle": "Circle"
    },
    "swatch_unavailable": {
        "label": "Sold-out values on cards",
        "description": "How sold-out values appear on product cards. The change appears after the page is reloaded.",
        "strikethrough": "Show struck through",
        "hide": "Hide",
        "plain": "Show as normal"
    },
    "social_media_icons": "social media icons",
    "breadcrumbs_background_color": "breadcrumbs background color",
    "breadcrumbs_text_color": "breadcrumbs text color",
    "content": "content",
    "layout": "layout",
    "appearance": "appearance",
    "behavior": "behavior",
    "mobile": "mobile",
    "pages_content": "Content",
    "background_color": "background color",
    "background_image": "background image",
    "text_color": "text color",
    "logo": "logo",
    "logo_width": "logo width",
    "logo_height": "logo height",
    "header_logo_width_description": "Change the width of the logo image. Applies to all headers.",
    "header_logo_height_description": "Change the height of the logo image. Applies to all headers.",
    "header_shadow": "Header shadow",
    "header_shadow_description": "Add a subtle shadow below the header to visually separate it from the page content.",
    "header_show_account_icon": "Show account icon",
    "header_show_account_icon_description": "Shows the account icon in the header so customers can log in, register and view their account.",
    "form_width": "Form width",
    "form_vertical_padding": "Spacing above and below form",
    "content_max_width": "Default",
    "full_width": "Full width",
    "icon_color": "icon color",
    "icon_size": "icon size",
    "main_navigation_background_color": "main navigation background color",
    "main_navigation_text_color": "main navigation text color",
    "main_navigation_hover_underline_color": "main navigation hover underline color",
    "mobile_sticky_navigation_background": "mobile sticky navigation background",
    "mobile_sticky_navigation_icon_color": "mobile sticky navigation icon color",
    "block_name": "block name",
    "list_name": "list name",
    "number_of_products_to_show": "number of products to show",
    "get_products_from": "get products from",
    "number_of_columns_on_desktop": "number of columns on desktop",
    "number_of_columns_on_mobile": "number of columns on mobile",
    "slider_name": "slider name",
    "grid_name": "grid name",
    "footer_background_color": "footer background color",
    "footer_text_color": "footer text color",
    "footer_bottom_section_background_color": "footer bottom section background color",
    "manual_shipment": "manual shipment",
    "carrier": "carrier",
    "tracking_number": "tracking number",
    "tracking_url": "tracking URL",
    "notify_customer_of_shipment_via_email": "notify customer of shipment via email",
    "order": "Order",
    "of": "of",
    "customer": "customer",
    "contact_information": "contact information",
    "delivery_address": "delivery address",
    "billing_address": "billing address",
    "same_as_delivery_address": "same as delivery address",
    "fulfill": "fulfill",
    "invoice_number_start_title": "Set your starting invoice number",
    "invoice_number_start_label": "Starting invoice number",
    "invoice_number_start_intro": "This is the invoice number for your first shipment.",
    "invoice_number_start_point_auto": "Each shipment after this gets the next number automatically, one higher.",
    "invoice_number_start_point_match": "Already use an accounting system like Tripletex? Enter the same start number you use there.",
    "invoice_number_start_point_fresh": "No invoices there yet? Use any number. We recommend 10000.",
    "invoice_number_start_warn_title": "Good to know",
    "invoice_number_start_warn_locked": "Once a number is used, you can't change it yourself.",
    "invoice_number_start_warn_law": "By Norwegian law (bokføringsloven), the numbers must stay in order with no gaps.",
    "invoice_number_start_warn_support": "Need a change later, or not sure which number to pick? Contact support and we'll help.",
    "refund_noun": "Return / Refund",
    "refund_action": "refund",
    "fulfillment": "fulfillment",
    "quantity": "quantity",
    "timeline": "timeline",
    "add_internal_comment": "add internal comment",
    "here_you_can_add_notes_to_the_order_that_are_only_visible_to_you_or_other_staff": "Here you can add notes to the order, that are only visible to you or other staff.",
    "unfulfilled_items": "unfulfilled items",
    "restock_items": "restock items",
    "notify_customer_of_refund": "notify customer of refund",
    "reason_for_refund": "reason for refund",
    "only_visible_to_you_and_your_staff": "only visible to you and your staff",
    "cant_increase_shipping_cost": "Can't increase shipping cost",
    "fulfill_items_action": "fulfill items",
    "all_orders": "all orders",
    "print_documents": "print documents",
    "sum": "sum",
    "generate_return_label": "Generate return label",
    "return_label": "Return label",
    "book_return_label": "Book return label",
    "your_return_label_is_ready": "Your return label is ready",
    "include_qr_code": "Include QR code",
    "return_product": "Return product",
    "return_label_was_booked": "Return label was booked",
    "return_label_was_booked_for_fulfillment_:fulfillmentId": "Return label was booked for fulfillment #:fulfillmentId",
    "return_items": "Return items",
    "select_at_least_one_item": "Select at least one item",
    "item_not_found_in_fulfillment": "Item not found in fulfillment",
    "logistics_provider_not_available_for_returns": "The selected logistics provider is not available for returns",
    "return_quantity_exceeds_fulfilled_quantity": "Return quantity exceeds fulfilled quantity",
    "return_quantity_exceeds_returnable_quantity": "Return quantity exceeds returnable quantity",
    "edit_order": "edit order",
    "summary": "summary",
    "quantity_will_be_changed_from_to": "quantity will be reduced from {from} to {to}",
    "unit_price": "Unit price",
    "discount_all_items": "Discount on all items",
    "apply": "Apply",
    "unit_price_will_change_from_to": "unit price will change from {from} to {to}",
    "remaining_total_will_change_from_to": "remaining total will change from {from} to {to}",
    "cant_increase_unit_price": "cant increase unit price",
    "will_be_removed": "will be removed",
    "shipping_price_will_change_from_to": "shipping price will change from {from} to {to}",
    "reason_for_change": "reason for change",
    "the_order_will_be_empty": "no items will remain in the order",
    "cancel_all_remaining_action": "cancel all remaining",
    "refund_not_supported": "refund not supported",
    "this_payment_method_does_not_support_refunds": "This payment method does not support refunds",
    "please_contact_customer_support_for_more_information": "Please contact customer support for more information",
    "this_payment_method_does_not_support_editing": "This payment method does not support editing",
    "phone_number_not_provided": "phone number not provided",
    "purchase_order": "purchase order",
    "project": "project",
    "department": "department",
    "company": "company",
    "fulfilled": "fulfilled",
    "pending": "pending",
    "partially_fulfilled": "partially fulfilled",
    "tags": "tags",
    "unfulfilled": "unfulfilled",
    "tag": "tag",
    "remove_tag": "remove tag",
    "date": "date",
    "since": "Since",
    "total": "total",
    "before_discount": "Total before discount",
    "total_discount": "Total discount",
    "payment": "payment",
    "items_selected": "{n} item selected | {n} items selected",
    "select_action": "select action",
    "add_a_new_tag_to_the_selected_orders": "add a new tag to the selected orders",
    "remove_a_new_tag_to_the_selected_orders": "remove a new tag to the selected orders",
    "vipps": "vipps",
    "add_tag_to": "add tag to",
    "cancelled_order_items": "cancelled order items",
    "order_summary": "order summary",
    "original_order": "original order",
    "cancelled_at": "cancelled at",
    "nothing_left_to_refund": "nothing left to refund",
    "order_number": "order number",
    "original_sum": "original sum",
    "payment_method": "payment method",
    "shipping_method": "shipping method",
    "shipping_expected_delivery_prefix": "Expected delivery",
    "shipping_delivery_within_working_days": "Delivery within :days working day|Delivery within :days working days",
    "shipping_checkout_display_heading": "Checkout display",
    "shipping_checkout_display_description": "Choose which information from the carriers is shown on the delivery options in the checkout.",
    "shipping_checkout_display_count": "{shown} of {total} shown",
    "shipping_checkout_group_delivery_time": "Delivery time",
    "shipping_checkout_group_service_info": "Service information",
    "shipping_checkout_display_handover_warning": "You have not set up a handover plan yet. Without it the carrier assumes the parcel is handed over immediately, which makes the delivery dates too optimistic.",
    "shipping_checkout_display_updated": "Checkout display updated",
    "shipping_checkout_toggle_unavailable": "No active carrier offers this",
    "shipping_show_delivery_estimate": "Expected delivery date",
    "shipping_show_delivery_estimate_help": "Shows \"Expected delivery Thursday 4 September\" on each delivery option.",
    "shipping_show_delivery_dates": "Delivery day choice",
    "shipping_show_delivery_dates_help": "Lets the customer pick among the carrier's alternative delivery days for home delivery.",
    "shipping_show_service_description": "Service description",
    "shipping_show_service_description_help": "The carrier's own explanation of what the delivery option involves.",
    "shipping_show_environmental": "Environmental label",
    "shipping_show_environmental_help": "Shows \"Delivered by electric vehicle\" when the carrier reports fossil-free delivery.",
    "shipping_show_pickup_point_details": "Pickup point details",
    "shipping_show_pickup_point_details_help": "Distance, opening hours and a map link on each pickup point.",
    "shipping_show_delivery_at_door": "Leave the parcel at the door",
    "shipping_show_delivery_at_door_help": "Lets the customer ask for the parcel to be left outside the door when it does not fit the mailbox.",
    "checkout_shipping_heading": "Delivery",
    "checkout_shipping_choose_method": "Choose a delivery option",
    "checkout_shipping_free": "Free",
    "checkout_shipping_price_excluding_vat": "{price} excl. VAT",
    "checkout_shipping_show_all": "Show all delivery options ({count})",
    "checkout_shipping_show_fewer": "Show fewer delivery options",
    "checkout_shipping_updating": "Updating delivery options …",
    "checkout_shipping_free_shipping_nudge": "Spend {amount} more to get this shipping free",
    "checkout_shipping_choose_delivery_day": "Choose a delivery day",
    "checkout_shipping_fastest": "Fastest",
    "checkout_shipping_delivery_at_door": "Leave the parcel outside my door if it does not fit in the mailbox",
    "checkout_pickup_choose": "Choose a pickup point",
    "checkout_pickup_change": "Change pickup point",
    "checkout_pickup_close": "Close",
    "checkout_pickup_show_more": "Show more pickup points ({count})",
    "checkout_pickup_show_fewer": "Show fewer pickup points",
    "checkout_pickup_view_on_map": "View on map",
    "checkout_pickup_map_open": "Show {name} on the map",
    "checkout_pickup_map_frame_title": "Map of {name}",
    "checkout_pickup_map_loading": "Loading map …",
    "checkout_pickup_map_unavailable": "The map could not be loaded. The address is shown above.",
    "checkout_pickup_map_directions": "Directions",
    "checkout_pickup_map_previous": "Previous",
    "checkout_pickup_map_next": "Next",
    "checkout_pickup_map_position": "{current} of {total}",
    "checkout_pickup_map_choose": "Choose this pickup point",
    "checkout_pickup_map_current": "Selected pickup point",
    "delivery_time_window": "{range}",
    "what_is_24_shipping_4": "<strong>Every delivery option</strong> – mailbox, parcel locker, pickup point or home delivery.",
    "shipping_environmental_label": "Delivered by electric vehicle",
    "shipping_environmental_description": "The parcel is delivered by electric vehicle from the local terminal to the chosen delivery address",
    "shipping_address": "Shipping address",
    "about_shipping_address_settings": "The address your store ships orders from. Used as the sender on shipping bookings and to calculate shipping rates at checkout. Your company address is used if this is empty.",
    "cancel_all_remaining_explanation": "This will cancel all remaining items in the order. The order will be marked as cancelled and the customer will be notified. If you want to cancel only some items, make sure you fulfill the items you want to keep first.",
    "this_action_can_not_be_undone": "This action can not be undone!",
    "footer_bottom_section_text_color": "footer bottom section text color",
    "at_least_one_variant_must_be_active": "At least one variant must be active",
    "variant_limit_reached": "Variant limit reached",
    "could_not_create_tag": "Could not create the tag",
    "could_not_save": "Could not save",
    "error_encountered_while_saving_please_check_the_form": "An error was encountered while saving. Please check the form and try again",
    "changes_saved!": "Changes saved!",
    "the_price_must_be_greater_than_0": "The price must be greater than 0",
    "category_type": "category type",
    "category_smart": "smart category",
    "category_manual": "manual category",
    "category_type_description": "a smart category is a dynamic category that automatically includes products based on a set of rules, while a manual category is a static category that you manually add products to.",
    "criteria_product_age": "the products age",
    "criteria_has_tag": "the products has tag",
    "criteria_product_category": "the products category",
    "criteria_product_stock_status": "the products stock status",
    "criteria_product_title": "the products title",
    "to_be_included_in_this_smart_category": "to be included in this smart category",
    "smart_criteria": "smart criteria",
    "smart_category": "smart category",
    "attribute": "attribute",
    "operator": "operator",
    "criteria": "criteria",
    "smart_criteria_all": "all criteria must be met",
    "smart_criteria_any": "any criteria must be met",
    "smart_criteria_product_title": "the product title",
    "smart_criteria_has_tag": "the product has tag",
    "smart_criteria_product_category": "the product category",
    "smart_criteria_product_stock_status": "the product stock status",
    "smart_criteria_product_age": "the product age",
    "smart_criteria_operator_is_equals_to": "is",
    "smart_criteria_operator_is_not_equals_to": "is not",
    "smart_criteria_operator_contains": "contains",
    "smart_criteria_operator_does_not_contain": "does not contain",
    "smart_criteria_operator_starts_with": "starts with",
    "smart_criteria_operator_ends_with": "ends with",
    "smart_criteria_operator_is_greater_than": "is greater than",
    "smart_criteria_operator_is_less_than": "is less than",
    "smart_criteria_operator_created_last_days": "is younger than {days} days",
    "smart_criteria_operator_created_before_days": "is older than {days} days",
    "add_new_criteria": "add new criteria",
    "category_deleted": "Category deleted",
    "product_is_visible_in_your_store": "Should the product be visible in your store?",
    "note_that_might_not_be_buyable_even_if_visible": "Note that the product might not be buyable even if it is visible, e.g. if it is out of stock, or if it is missing a price.",
    "add_sales_price": "add sales price",
    "add_another_sales_price": "Add another sales price",
    "apply_changes": "Apply changes",
    "percentage_off": "{percentage}% off",
    "percentage": "Percentage",
    "fixed_amount": "fixed amount",
    "discount_type": "discount type",
    "starts_at": "starts at",
    "starts_immediately_no_end_date": "Starts immediately, no end date",
    "ends_at": "ends at",
    "does_the_offer_have_an_end_date": "does the offer have an end date?",
    "new": "new",
    "no_end": "No end",
    "product_name_placeholder": "e.g. My awsome T-shirt",
    "eg_color_or_size": "e.g. Color or size",
    "eg_red_or_large": "e.g. Red or Large",
    "eg_main_navigation": "e.g. Main navigation",
    "search_for_a_category": "Search for a category, product, page or choose a menu item from the dropdown list",
    "back": "back",
    "menu_item_successfully_added": "Menu item was successfully added!",
    "organize_menu_info": "To organize the menu, click and hold the six small dots next to a menu item. Drag the item up or down to the desired position to move it. To create a tree structure, drag the item slightly to the right under another menu item to make it a subcategory.",
    "menu_name_for_internal_use": "For internal use",
    "menu_name_for_external_use": "Visible in the store when the menu is used in the footer",
    "edit_active_theme": "edit active theme",
    "show_title": "show title",
    "product_form_display_style": "Display style",
    "product_form_display_style_description": "Card is the current box with its own colours. Inline removes the box and inherits the product page colours. Collapsible shows a button that opens the form; it starts open when the form has required fields.",
    "product_form_display_card": "Card",
    "product_form_display_inline": "Inline",
    "product_form_display_collapsible": "Collapsible",
    "product_form_collapsible_label": "Button text for the collapsible style",
    "product_form_collapsible_label_description": "Only used when the display style is Collapsible.",
    "product_form_use_field_widths": "Use field widths from the form builder",
    "product_form_use_field_widths_description": "Fields set to half width in the form builder sit side by side. Off stacks every field.",
    "product_form_options_as_buttons": "Show choices as buttons",
    "product_form_options_as_buttons_description": "Dropdowns with few choices render as buttons, and yes/no fields as a switch.",
    "product_form_options_as_buttons_max": "Maximum choices shown as buttons",
    "product_form_additional_cost_style": "Additional cost",
    "product_form_additional_cost_line": "Own line",
    "product_form_additional_cost_badge": "Badge next to the title",
    "product_form_required_hint": "Validate before add to cart",
    "product_form_required_hint_description": "Stops \"Add to cart\" while required fields are empty, marks the fields and names the ones to fill in.",
    "show_the_title_when_viewing_this_category_in_your_store": "Show the title when viewing this category in your store",
    "display": "display",
    "products_matching_these_criteria": "active products matching these criteria",
    "organization": "organization",
    "mega_menu": "mega menu",
    "mega_menu_images_title": "Mega menu images",
    "mega_menu_images_immediate_hint": "The images appear on the right side of the mega menu. Uploads and deletions happen immediately — text, links, and settings are saved with the Save button.",
    "mega_menu_images_max_reached": "You can upload a maximum of four images.",
    "add_image": "Add image",
    "text_position": "Text position",
    "text_position_below": "Below the image",
    "text_position_overlay": "On the image",
    "mega_menu_images_tooltip": "Manage mega menu images",
    "mega_menu_images_save_first": "Save the menu before adding images",
    "image_uploaded": "The image was uploaded",
    "image_deleted": "The image was deleted",
    "image_text": "Image text",
    "uploading": "Uploading",
    "navigation_set_mega_menu": "Choose whether the main menu item should be a mega menu",
    "mega_menu_info": "A megamenu is an extended dropdown menu that displays many options or complex structures in an organized and visual manner. It is used when a main menu item contains many sub-items or needs to provide users with a quick overview of available options.",
    "no_products_shown_without_criteria": "without selecting any criteria, no products will be shown",
    "api_tokens": "API tokens",
    "google_taxonomy": "Google taxonomy",
    "refurbished": "refurbished",
    "used": "used",
    "is_product_of_an_erotic_nature": "product is of an erotic nature",
    "condition_of_product": "condition of product",
    "product_category": "product category",
    "product_categories": "Product categories",
    "google_product_category_info": "select one of Google's defined product categories, or leave the field blank for automatic categorization by Google",
    "google_erotic_nature_info": "indicates that the product includes sexually suggestive content",
    "google_product_condition_info": "the condition of your product at time of sale",
    "store_name": "store name",
    "store_description": "store description",
    "store_description_info": "Give a description that can be used for search engines. Max 320 characters",
    "google_site_verification": "google site verification",
    "google_site_verification_info": "Paste the content value from the google-site-verification meta tag that Google Search Console gives you.",
    "general.newest": "Newest",
    "general.alphabetical": "Alphabetical",
    "general.price_low_to_high": "Price low to high",
    "general.price_high_to_low": "Price high to low",
    "general.manual_order": "Store's order",
    "general.business": "Business",
    "general.personal": "Personal",
    "two_factor_authentication": "Two-factor authentication",
    "add_additional_security_to_your_account_using_two_factor_authentication": "Add additional security to your account using two-factor authentication",
    "you_have_enabled_two_factor_authentication": "You have enabled two-factor authentication",
    "finish_enabling_two_factor_authentication": "Finish enabling two-factor authentication",
    "you_have_not_enabled_two_factor_authentication": "You have not enabled two-factor authentication",
    "when_two_factor_authentication_is_enabled": "When two factor authentication is enabled, you will be prompted for a secure, random token during authentication. You may retrieve this token from your phone's Google Authenticator application.",
    "to_finish_enabling_two_factor_authentication": "To finish enabling two factor authentication, scan the following QR code using your phone's authenticator application or enter the setup key and provide the generated OTP code.",
    "two_factor_authentication_is_now_enabled": "Two factor authentication is now enabled. Scan the following QR code using your phone's authenticator application or enter the setup key.",
    "setup_key": "Setup key",
    "store_these_codes_recovery_codes_in_a_secure_password_manager": "Store these recovery codes in a secure password manager. They can be used to recover access to your account if your two factor authentication device is lost.",
    "enable": "enable",
    "confirm": "confirm",
    "regenerate_recovery_codes": "regenerate recovery codes",
    "show_recovery_codes": "show recovery codes",
    "disable": "disable",
    "for_your_security_please_confirm_your_password_to_continue": "For your security, please confirm your password to continue",
    "code": "code",
    "browser_sessions": "browser sessions",
    "manage_and_logout_your_active_sessions_on_other_browsers_and_devices": "Manage and log out your active sessions on other browsers and devices.",
    "if_necessary_you_may_log_out_of_all_of_your_other_browser_sessions": "If necessary, you may log out of all of your other browser sessions across all of your devices. Some of your recent sessions are listed below; however, this list may not be exhaustive. If you feel your account has been compromised, you should also update your password.",
    "this_device": "this device",
    "last_active": "last active",
    "log_out_of_other_browser_sessions": "Log out other browser sessions",
    "please_enter_your_password_to_confirm_you_would_like_to_log_out_of_your_other_browser_sessions_across_all_of_your_devices": "Please enter your password to confirm you would like to log out of your other browser sessions across all of your devices.",
    "google_taxonomy_is_used_for": "Google taxonomy is used for categorizing products in Google Shopping and other product-feeds. It is important to select the correct category for your products to ensure they are displayed correctly in these services.",
    "empty_state_text": "It's really empty here!",
    "add_file": "Add file",
    "choose_file": "Choose file",
    "search_files": "Search files",
    "general.date_desc": "Date (newest)",
    "general.date_asc": "Date (oldest)",
    "general.alphabetical_asc": "Alphabetically (A - Z)",
    "general.alphabetical_desc": "Alphabetically (Z - A)",
    "general.sorting": "Sorting",
    "general.relevance": "Relevance",
    "files_uploaded": "File(s) uploaded",
    "file_deleted": "File deleted",
    "something_went_wrong_during_delete": "Something went wrong during delete",
    "something_went_wrong_during_upload": "Something went wrong during upload",
    "clear_selection": "Clear selection",
    "cannot_find_any_files_where_name_contains": "Cannot find any files where the name contains",
    "add_link": "Add link",
    "filter_filetype": "Filter filetype",
    "something_went_wrong_during_theme_update": "Something went wrong during theme update",
    "theme_updated": "Theme updated",
    "alt_text": "Alt text",
    "week": "{n} week | {n} weeks",
    "product_reviews": "Product reviews",
    "product_reviews_description": "Get feedback on product experiences from actual buyers, and choose to display these on the product pages",
    "product_reviews_headline": "Product reviews – build trust and increase sales",
    "product_reviews_subline": "Genuine feedback from your customers is worth its weight in gold. With the Product Reviews app, it's easy to collect and display product reviews in your online store – completely automatically.\nWhen a customer has completed a purchase, they receive a prompt after a selectable number of weeks to leave a review and rate the product from 1 to 5 stars. This way, you get real experiences from customers who have actually bought the product – not random or fake reviews.",
    "product_reviews_why_are_reviews_important": "Why are product reviews so important?",
    "product_reviews_why_are_reviews_important_1": "Build trust: 9 out of 10 customers read product reviews before shopping. Genuine reviews provide security and help more people complete their purchase.",
    "product_reviews_why_are_reviews_important_2": "Gain insight: The feedback gives you valuable insight into what customers like – and what you can improve.",
    "product_reviews_why_are_reviews_important_3": "Increase conversions: Products with reviews sell more. Customers trust other customers.",
    "product_reviews_why_are_reviews_important_4": "Better visibility: Reviews can help improve your ranking on Google, because unique content is updated regularly.",
    "how_it_works": "How it works",
    "product_reviews_how_it_works_1": "The customer buys a product in your online store.",
    "product_reviews_how_it_works_2": "After a selectable number of weeks, they receive an email prompting them to leave a review.",
    "product_reviews_how_it_works_3": "Submitted product reviews are displayed in the admin panel and you can choose to publish or delete the review.",
    "product_reviews_how_it_works_4": "The review is visible in the webshop",
    "reviews": "Reviews",
    "rating": "Rating",
    "published": "Published",
    "not_published": "Not published",
    "not_saved_yet": "Not saved",
    "the_review": "the review",
    "unknown_error_occurred_try_again_or_contact": "Unknown error occurred. Try again, or contact our support team",
    "anonymous": "Anonymous",
    "from": "From",
    "to": "To",
    "past_twenty_four_hours": "Past 24 hours",
    "past_seven_days": "Past 7 days",
    "past_thirty_days": "Past 30 days",
    "or": "Or",
    "clear_filters": "Clear filters",
    "published_status": "Published status",
    "number_slider_filter_information": "Drag the slider or enter the numbers you want to filter by",
    "has_text": "Has text",
    "does_not_have_text": "Does not have text",
    "thank_you_for_your_purchase": "Thank you for your purchase!",
    "new_purchase_in_your_store": "New purchase in :storeName",
    "store": "Store",
    "review_email_active": "Email auto-sending active",
    "review_email_delay": "Email delay",
    "review_email_active_description": "Automatically send an email to customers after a set delay asking them to review the product they purchased",
    "review_email_delay_description": "How many weeks after the order is marked as fulfilled should the review email be sent?",
    "review_email_description": "The email address the review email will be sent from",
    "cannot_publish_review_without_text": "Cannot publish review without text",
    "all_reviews": "All reviews",
    "product_reviews_index_description": "An overview of all product reviews. You can publish or unpublish reviews directly from the table. Hover or click on the review text to read the full review.",
    "showing_single_review": "Showing a single review",
    "show_all_reviews": "Show all reviews",
    "review": "Review",
    "cannot_be_published_because_of_no_text": "Cannot be published because of no text",
    "store_status": "Open / Close the store",
    "maintenance_mode": "Maintenance mode",
    "maintenance_password": "Maintenance password",
    "maintenance_title": "Maintenance title",
    "maintenance_message": "Maintenance message",
    "add_coupon": "Add coupon",
    "coupons": "Coupons",
    "customer_club": "Customer club",
    "customer_club_description": "Let customers earn points on purchases and redeem them as discounts on later orders.",
    "customer_club_configure": "Configure",
    "customer_club_open": "Open",
    "customer_club_members": "Members",
    "customer_club_heading": "Customer Club - reward and create loyal customers with earned points",
    "customer_club_sub_heading": "The customer club is designed to strengthen customer loyalty in the store. Registered customers earn points when purchasing products, and these points can be used for discounted prices on products in the store.",
    "why_use_customer_club": "What possibilities does the customer club offer",
    "why_use_customer_club_1": "Points per krone - Decide how many points the customer earns for every krone spent in the store",
    "why_use_customer_club_2": "Point value - Decide how much each point is worth as a discount when used",
    "why_use_customer_club_3": "Welcome bonus - Decide how many points are automatically granted when the customer joins for the first time",
    "why_use_customer_club_4": "Wait time - Decide how many days after delivery before points become available to the customer",
    "customer_club_closer": "Customers get a full overview of available points on My Page. The customer club gives customers a strong motivation to register in the store and return to use their points on new purchases. On the product page, it shows how many points are earned when purchasing the product. This information is also visible to unregistered customers, serving as an incentive to register.",
    "customer_club_emails_tab": "Emails",
    "customer_club_emails_intro": "Customize the emails sent to customer club members. Toggle each email on or off and edit the subject, body, and button text.",
    "customer_club_signup_email_heading": "Signup bonus email",
    "customer_club_signup_email_description": "Sent when a customer receives the signup bonus. Requires welcome bonus points to be configured under Settings — without a bonus, no email is sent.",
    "customer_club_earned_email_heading": "Points earned",
    "customer_club_earned_email_description": "Sent when a customer earns points on an order.",
    "customer_club_email_subject": "Email subject",
    "customer_club_email_body": "Email body",
    "customer_club_email_button_text": "Button text",
    "customer_club_signup_placeholders_hint": "Use {points} to insert the number of welcome bonus points.",
    "customer_club_earned_placeholders_hint": "Use {points} for the points earned and {availableFrom} for when the points become available. If quarantine is disabled, {availableFrom} resolves to the same day the email is sent — consider removing that sentence from the body in that case.",
    "save_changes": "Save changes",
    "changes_saved": "Changes saved",
    "customer_club_active_members": "active members",
    "customer_club_points_in_circulation": "points in circulation",
    "customer_club_search_placeholder": "Search by name or email…",
    "customer_club_filter_all": "All members",
    "customer_club_filter_active": "Active",
    "customer_club_filter_former": "Former",
    "customer_club_member_since": "Member since",
    "customer_club_available": "Available",
    "customer_club_pending": "Pending",
    "customer_club_status_active": "Active member",
    "customer_club_status_former": "Former",
    "customer_club_no_members_yet": "No members yet.",
    "customer_club_landing_headline": "Build customer loyalty with club points.",
    "customer_club_landing_subline": "Customers earn points on every purchase and redeem them as discounts on later orders. You control the earn and redemption rates.",
    "customer_club_landing_advantages_title": "Advantages of the customer club",
    "customer_club_landing_advantage_1": "Increased repeat purchases and lifetime value per customer.",
    "customer_club_landing_advantage_2": "Full control over earn and redemption rates — adjust whenever you need.",
    "customer_club_landing_advantage_3": "Signup bonus, quarantine, and cancellation flow built in.",
    "customer_club_landing_advantage_4": "VAT-correct discount model — no output VAT on issued points.",
    "customer_club_landing_how_q": "How does it work?",
    "customer_club_landing_how_a": "Customers join the club at registration or in the cart. After purchase, points are earned based on item value (excluding shipping). Points have an optional quarantine before they can be redeemed. When redeemed, the discount is distributed across the line items and correctly reduces the VAT base.",
    "customer_club_landing_vat_q": "How does it affect VAT accounting?",
    "customer_club_landing_vat_a": "Club points are treated as a discount (price reduction), not a means of payment. This aligns with the CJEU ruling in C-436/24 Lyko and Norwegian VAT §4-2. VAT is calculated on the actual reduced consideration; no additional VAT consequence at point issuance.",
    "customer_club_settings": "Settings",
    "customer_club_enable": "Enable customer club",
    "customer_club_enable_hint": "When enabled, customers can earn and spend club points in this store.",
    "customer_club_line_adjustment": "Customer club (:points points used)",
    "customer_club_order_discount_row": "Customer club discount ({points} points used)",
    "customer_club_order_email": "Order email (Kustom)",
    "customer_club_account": "Club account",
    "customer_club_disabled_notice": "Enable the customer club first to configure these settings.",
    "customer_club_inactive_cta_title": "Customer club is disabled",
    "customer_club_texts_tab": "Texts",
    "customer_club_texts_intro": "Customise the texts and appearance of the customer-club box shown on the product page. The points calculation is controlled by the settings and can't be changed here.",
    "customer_club_design_heading": "Appearance",
    "customer_club_design_description": "Show or hide the boxes on the product page and tweak the colours.",
    "customer_club_product_show_register_box_title": "Show register box",
    "customer_club_product_show_register_box_help": "Shown to visitors who are not members.",
    "customer_club_product_show_member_box_title": "Show member box",
    "customer_club_product_show_member_box_help": "Shown to logged-in members.",
    "customer_club_product_box_bg_color_title": "Background colour",
    "customer_club_product_box_text_color_title": "Text colour",
    "customer_club_texts_register_heading": "Non-member — product page",
    "customer_club_texts_register_intro": "These texts are shown to visitors who are not yet members. Use {points} for the points the customer earns on this product and {value} for what the points are worth.",
    "customer_club_texts_member_heading": "Member — product page",
    "customer_club_texts_member_intro": "Customise the title and add an optional description. Use {points} in the title to show how many points the customer earns.",
    "customer_club_product_register_title_label": "Title",
    "customer_club_product_register_description_title": "Description",
    "customer_club_product_register_button_title": "Button text",
    "customer_club_product_member_title_label": "Title",
    "customer_club_product_member_description_title": "Description (optional)",
    "customer_club_product_title_points_hint": "Use {points} for the points the customer earns on this product.",
    "customer_club_product_value_points_hint": "Use {points} and {value} for points and currency value.",
    "customer_club_texts_preview_not_member": "Preview — not a member",
    "customer_club_texts_preview_member": "Preview — member",
    "customer_club_box_hidden": "Box is hidden",
    "customer_club_former_members_on_page": "Former on page",
    "customer_club_members_empty_title": "No members yet",
    "customer_club_members_empty_hint": "Members will appear here once customers join.",
    "customer_club_quarantine_preset_immediate": "Immediate",
    "customer_club_quarantine_preset_recommended": "14 days",
    "customer_club_quarantine_preset_strict": "30 days",
    "customer_club_signup_bonus_disabled_hint": "Set to 0 to disable the welcome bonus and welcome email.",
    "customer_club_signup_bonus_value_hint": "Worth {value} at the current redemption rate.",
    "customer_club_signup_email_trigger": "Sent when a new customer receives the welcome bonus.",
    "customer_club_earned_email_trigger": "Sent after fulfillment, when quarantine days in Settings > 0.",
    "customer_club_email_preview_greeting": "Hi, {firstname}",
    "view_details": "View details",
    "customer_club_presets_title": "Presets",
    "customer_club_presets_hint": "Pick a starting point — you can fine-tune the rates below.",
    "customer_club_preset_simple_name": "Simple",
    "customer_club_preset_simple_desc": "1 kr back per 100 kr",
    "customer_club_preset_standard_name": "Standard",
    "customer_club_preset_standard_desc": "3 kr back per 100 kr",
    "customer_club_preset_generous_name": "Generous",
    "customer_club_preset_generous_desc": "5 kr back per 100 kr",
    "customer_club_earn_rate": "Earn rate",
    "customer_club_earn_rate_hint": "How many points the customer earns for the amount spent. Example: 1 point per 100 kr gives 5 points on a 500 kr purchase.",
    "customer_club_earn_rate_tooltip": "Controls how quickly customers accumulate points. Combined with the redemption rate, this determines the effective cashback percentage — change one and the cashback shifts.",
    "customer_club_earn_rate_points": "Points",
    "customer_club_earn_rate_amount": "kr spent",
    "customer_club_redemption_rate": "Redemption rate",
    "customer_club_redemption_multiplier": "Value of 1 point (kr)",
    "customer_club_redemption_rate_hint": "Discount value when points are redeemed. Example: 10 points = 1 kr discount means 100 points gives a 10 kr discount.",
    "customer_club_redemption_rate_tooltip": "Controls how much each point is worth when the customer spends it. Note: changing this later changes the value of all points already in circulation.",
    "customer_club_redemption_rate_points": "Points",
    "customer_club_redemption_rate_amount": "kr discount",
    "customer_club_rate_summary_earn": "Means: earn {points} points for every {kr} the customer spends.",
    "customer_club_rate_summary_redemption": "Means: {points} points = {kr} discount.",
    "customer_club_quarantine_days": "Wait time before points can be used",
    "customer_club_quarantine_days_hint": "Choose a short delay before earned points become available.",
    "customer_club_quarantine_days_tooltip": "How many days after the order is fulfilled before the points become available to the customer. Recommendation: at least the return-policy window (14 days) plus typical delivery time, to avoid awarding points on returned orders.",
    "customer_club_signup_bonus": "Welcome bonus (points)",
    "customer_club_signup_bonus_hint": "Number of points awarded when a customer joins the club for the first time, none if 0.",
    "customer_club_signup_bonus_tooltip": "One-time bonus in points awarded automatically when a customer joins the club for the first time. Set to 0 to disable the welcome bonus entirely.",
    "customer_club_calculator_title": "Calculator",
    "customer_club_calculator_hint": "See how the current rates work in practice.",
    "customer_club_calculator_example_line": "A purchase of kr 500",
    "customer_club_calculator_points_earned": "Customer earns",
    "customer_club_calculator_discount_next_order": "Giving discount on next order",
    "customer_club_calculator_effective": "Effective cashback",
    "customer_club_calculator_cashback_exceeds_title": "Effective cashback is over 100%.",
    "customer_club_calculator_cashback_exceeds": "The customer gets more back in discount than they pay. Adjust the rates.",
    "customer_club_rate_change_before": "Before:",
    "customer_club_rate_change_after": "After:",
    "customer_club_rate_change_delta": "Change:",
    "customer_club_rate_change_warning_title": "Warning: rate change",
    "customer_club_rate_change_warning_body": "Changing the redemption rate changes the value of all points currently in circulation.",
    "customer_club_status_former_long": "Former member",
    "customer_club_status_not_member": "Not a member",
    "customer_club_event_type_signup_bonus": "Welcome bonus",
    "customer_club_event_type_earned": "Earned",
    "customer_club_event_type_redeemed": "Redeemed",
    "customer_club_event_type_earning_reversed": "Earning withdrawn",
    "customer_club_event_type_redemption_restored": "Redemption returned",
    "customer_club_event_type_admin_adjusted": "Admin adjustment",
    "customer_club_event_type_membership_joined": "Joined",
    "customer_club_event_type_membership_cancelled": "Cancelled",
    "customer_club_event_signup_bonus_description": "Signup bonus",
    "customer_club_event_order_reference": "Order #{id}",
    "customer_club_event_order_refunded": "Order #{id} was refunded",
    "customer_club_event_order_reduced": "Order #{id} was reduced",
    "customer_club_event_member_joined": "Joined",
    "customer_club_event_cancelled_by_customer": "Cancelled by customer",
    "customer_club_event_cancelled_by_admin": "Cancelled by admin",
    "customer_club_event_cancelled_by_admin_with_reason": "Cancelled by admin: {reason}",
    "customer_club_total_earned": "Total earned",
    "customer_club_total_redeemed": "Total redeemed",
    "customer_club_adjust_points": "Adjust points",
    "customer_club_cancel_membership_button": "Cancel membership",
    "customer_club_history_heading": "History",
    "customer_club_history_col_time": "Time",
    "customer_club_history_col_type": "Type",
    "customer_club_history_col_description": "Description",
    "customer_club_history_col_change": "Change",
    "customer_club_history_empty": "No events",
    "customer_club_settings_intro_description": "Let customers earn points on every purchase and redeem them as discounts on later orders. Customers see the customer club on the order receipt and on the My Page area of the storefront.",
    "customer_club_group_activation": "Activation & welcome",
    "customer_club_group_activation_description": "Switch the customer club on and decide the welcome bonus for new members.",
    "customer_club_group_earning": "Earning",
    "customer_club_group_earning_description": "How customers earn points, with an optional quarantine before points can be redeemed.",
    "customer_club_group_redemption": "Redemption",
    "customer_club_group_redemption_description": "How much each point is worth when customers redeem it as a discount.",
    "customer_club_for_every": "For every",
    "customer_club_ratio_give": "give the customer",
    "customer_club_ratio_equals_discount": "= discount of",
    "customer_club_kr_label": "kr",
    "customer_club_kr_discount": "kr discount",
    "customer_club_points_label": "points",
    "customer_club_product_register_description_help": "The text shown below the points line on the product page for visitors who are not yet members.",
    "customer_club_product_register_bonus_title": "Welcome bonus (optional)",
    "customer_club_product_register_bonus_help": "Shown below the description for visitors who are not yet members, and only when the welcome bonus in the settings is above zero. Use {bonus} for the points and {bonus_value} for their value. Clear the field to hide the line.",
    "customer_club_product_register_button_help": "Label of the button that prompts visitors to join the club.",
    "customer_club_product_member_description_help": "Optional text shown below the points line for logged-in members.",
    "customer_club_product_member_description_placeholder": "E.g. Use your points at checkout for a discount on your next purchase.",
    "customer_club_product_box_bg_color_help": "Background colour of the customer-club box on the product page.",
    "customer_club_product_box_text_color_help": "Text colour of the customer-club box on the product page.",
    "more_info": "More info",
    "quick_start": "Quick start",
    "quick_start_description": "Pick a starter pack to fill in common values.",
    "discard": "Discard",
    "customer_club_preview_title": "How your customer club works",
    "customer_club_preview_description": "Summary based on the current settings. Updates as you edit the fields.",
    "customer_club_journey_title": "Example customer journey",
    "customer_club_journey_step_join_title": "The customer joins the club",
    "customer_club_journey_step_shop_title": "The customer spends {amount} kr",
    "customer_club_journey_step_wait_title": "Points become available",
    "customer_club_journey_step_wait_metric": "After {days} days",
    "customer_club_journey_step_redeem_title": "The customer redeems {points} points at checkout",
    "customer_club_active_state_title": "Customer club is active",
    "customer_club_active_state_hint": "Customers can earn and spend points.",
    "customer_club_inactive_state_title": "Customer club is inactive",
    "customer_club_inactive_state_hint": "Toggle the switch on the right to activate the customer club.",
    "customer_club_inactive_flash": "The customer club is not active.",
    "customer_club_join_welcome_with_bonus": "Welcome! You received :points points as a sign-up bonus.",
    "customer_club_join_welcome_back": "Welcome back! Your balance has been restored.",
    "customer_club_join_welcome": "Welcome to the customer club!",
    "customer_club_join_error_already_member": "You are already a member of the customer club.",
    "customer_club_join_error_b2b_only": "The customer club is only available for consumer customers.",
    "customer_club_join_error_default": "Sign-up failed. Please try again or contact us.",
    "customer_club_leave_error_not_member": "You are not a member of the customer club.",
    "customer_club_leave_error_default": "Cancellation failed. Please try again or contact us.",
    "customer_club_leave_success": "You have left the customer club.",
    "customer_club_adjustment_registered": "Adjustment recorded",
    "customer_club_membership_cancelled": "Membership cancelled",
    "customer_club_validation_earn_rate_invalid": "Earn rate must be a positive integer.",
    "customer_club_validation_redemption_rate_invalid": "Redemption rate must be a positive integer.",
    "customer_club_validation_quarantine_days_invalid": "Quarantine days must be ≥ 0.",
    "customer_club_validation_signup_bonus_invalid": "Signup bonus must be ≥ 0.",
    "customer_club_validation_reason_required": "Reason is required.",
    "customer_club_validation_reason_required_admin": "Reason is required for admin cancellation.",
    "customer_club_validation_delta_nonzero": "Adjustment must be non-zero.",
    "customer_club_validation_redemption_amount_not_integer_ore": "1 point must equal an integer number of øre. Try :suggestions instead.",
    "customer_club_validation_cashback_over_100": "Effective cashback is :percent% — must be ≤ 100%.",
    "create_new_coupon": "Create new coupon",
    "edit_coupon": "Edit coupon",
    "coupon_code": "Coupon code",
    "discount": "Discount",
    "discount_amount": "Discount amount",
    "apply_to": "Apply to",
    "active_dates": "Active dates",
    "start_date": "Start date",
    "has_expiry_date": "Has expiry date",
    "expiry_date": "Expiry date",
    "all_buyables": "All products",
    "selected_buyables": "Selected products",
    "all_buyables_except": "All products except selected",
    "amount_off_products": "Amount off products",
    "free_shipping": "Free shipping",
    "limits": "Limits",
    "max_shipping_price": "Max shipping price",
    "expired": "Expired",
    "start_typing_to_create_a_new_tag": "Start typing to create a new tag",
    "start_typing_to_create_a_new_badge": "Start typing to create a new badge",
    "select_products": "Select products",
    "x_products_selected": "{count} product selected | {count} products selected",
    "select_all": "Select all",
    "select_listings": "Select listings",
    "x_listings_selected": "{count} listing selected | {count} listings selected",
    "showing_all_listing_types": "Showing all listing types",
    "listings_in_category": "Listings",
    "listings_matching_smart_criteria": "Listings matching the criteria",
    "are_you_sure_you_want_to_delete_the_coupon": "Are you sure you want to delete the coupon {coupon}?",
    "coupon_deleted": "Coupon deleted",
    "edit_coupon_x": "Edit coupon {code}",
    "coupon_updated": "Coupon updated",
    "coupon_created": "Coupon created",
    "no_code_entered": "No code entered",
    "no_expiry_date": "No expiry date",
    "generate_random_code": "Generate random code",
    "scheduled": "Scheduled",
    "x_off_all_products": "{discountAmount}% off all products",
    "x_off_all_products_except_selected": "{discountAmount}% off all products except {count} selected products",
    "x_off_x_amount_of_selected_products": "{discountAmount}% off {count} selected products",
    "x_off_x_amount_of_tags": "{discountAmount}% off {count} tags",
    "cart_item_not_found": "The cart item was not found in cart.",
    "insufficient_stock_available": "Insufficient stock available",
    "desired_quantity_must_be_greater_than_0": "Desired quantity must be greater than 0",
    "coupon_code_is_invalid": "Coupon code is invalid",
    "coupon_code_cannot_be_empty": "Coupon code cannot be empty",
    "checkout_state_not_valid_for_operation": "Checkout state {state} not valid for this operation",
    "klarna_order_loading_failed": "Unable to load Klarna order",
    "klarna_checkout_already_completed": "Klarna checkout already completed",
    "klarna_order_update_failed": "Unable to update Klarna order",
    "coupon_code_percentage_off": "Coupon code -{discountPercentage} % ({code})",
    "coupon-code-helper-text": "Tip: codes using letters, numbers, hyphens, and underscores can be shared via URL and QR code.",
    "coupon-qr-button-disabled-tooltip": "This code contains characters that aren't safe to share in URLs. Use letters, numbers, hyphens, or underscores to enable QR and URL sharing.",
    "coupon-qr-button-label": "Share discount code",
    "coupon-qr-copy-link": "Copy link",
    "coupon-qr-copied": "Link copied",
    "coupon-qr-download-png": "Download PNG",
    "coupon-qr-download-svg": "Download SVG",
    "coupon-qr-modal-title": "QR code for discount",
    "discount-code-applied": "Discount code :code has been applied",
    "discount-code-not-valid": "This discount code is no longer valid",
    "invoice_number": "Invoice number",
    "internal_identifier": "Internal identifier",
    "cancellation": "Cancellation",
    "cancelled": "Cancelled",
    "no_items_left_to_fulfill": "No items left to fulfill",
    "shipping_cant_remain_with_no_items": "all items in the order would be cancelled, so shipping must be set to 0",
    "continue_shopping": "Continue shopping",
    "are_you_sure_you_want_to_delete_{count}_products": "Are you sure you want to delete {count} product? | Are you sure you want to delete {count} products?",
    "shipping_methods": "Shipping methods",
    "modify_shipping_price": "Modify shipping cost",
    "shipping__replace": "Replace shipping price",
    "shipping__modify_int": "Adjust shipping price with a fixed amount",
    "shipping__modify_percentage": "Adjust shipping price with a percentage",
    "shipping__use_list_price": "Use list price",
    "shipping__positive_percentage_hint": "You have entered a positive percentage. This means the shipping price will be increased at checkout.",
    "shipping__negative_percentage_hint": "You have entered a negative percentage. This means the shipping price will be reduced at checkout.",
    "info_shipping__replace": "Enter a custom shipping price. This means that the price you enter will replace any list price provided by third parties (e.g., Bring, Postnord).",
    "info_shipping__modify_int": "Increase or decrease the list price provided by third parties by a fixed amount. The customer will pay the list price plus/minus the adjustment entered here.",
    "info_shipping__modify_percentage": "The customer pays the list price with the percentage adjustment applied.",
    "info_shipping__use_list_price": "Make no cost adjustments for this shipping method so that the shipping price is based only on the list price from the provider (e.g., Bring, Postnord).",
    "percentage_amount": "Percentage amount",
    "replace_with_new_price": "Replace with new price",
    "shipping_method_updated": "Shipping method updated",
    "shipping_limits": "Limits",
    "shipping_limit_none": "None",
    "shipping_min_order_value": "Minimum order total (kr)",
    "shipping_min_order_value_help": "The method is not offered when the order total incl. VAT is below this.",
    "shipping_max_order_value": "Maximum order total (kr)",
    "shipping_max_order_value_help": "The method is not offered when the order total incl. VAT is above this.",
    "shipping_max_order_value_below_min": "The maximum order total cannot be lower than the minimum.",
    "shipping_delivery_at_door_max_order_value": "Delivery at door only up to order total (kr)",
    "shipping_delivery_at_door_max_order_value_help": "Above this amount the customer is not offered leaving the parcel at the door, but can still pick the method. The parcel is delivered to the mailbox as usual, and goes to a pickup point instead of outside the door if it does not fit.",
    "shipping_price_must_be_whole_kroner": "The price must be a whole number of kroner, without øre.",
    "shipping_percentage_must_be_whole_number": "The percentage must be a whole number.",
    "shipping_method_created": "Shipping method created",
    "shipping_method_deleted": "Shipping method deleted",
    "shipping_vat_description": "Turn off if your store should not charge VAT on shipping. This setting applies to every shipping method. Existing orders are not affected. For carrier-quoted methods (Posten/Bring, PostNord, 24Shipping), the customer pays only the carrier's net price.",
    "shipping_vat_label": "Apply VAT to shipping",
    "shipping_vat_section_heading": "Shipping VAT",
    "shipping_vat_setting_updated": "Shipping VAT setting updated",
    "list_price": "List price",
    "maintenance_mode_info": "When maintenance mode is enabled, your store will be temporarily unavailable to visitors. You can set a password to allow access to the store for specific users.",
    "compared_to": "Compared to",
    "revenue": "Revenue",
    "profit": "Profit",
    "order_count": "Order count",
    "average_order_value": "Average order value",
    "today": "Today",
    "this_week": "This week",
    "this_month": "This month",
    "this_year": "This year",
    "yesterday": "Yesterday",
    "last_week": "Last week",
    "last_month": "Last month",
    "last_year": "Last year",
    "current_month": "Current month",
    "previous_month": "Previous month",
    "day": "Day",
    "store_development": "Store development",
    "latest_x_unfulfilled_orders": "Latest {amount} unfulfilled orders",
    "you_have_no_unfulfilled_orders": "You have no unfulfilled orders",
    "hi_name": "Hi, {name}",
    "hi_name!": "Hi, :Name!",
    "user_invite_text_join": "You have been invited!",
    "user_invite_text_accept": "To accept the invitation and set up your account, please click the button below:",
    "user_invite_accept": "Accept invite",
    "add_widget": "Add widget",
    "current_active_users": "Current active users",
    "current_devices": "Current devices",
    "current_popular_pages": "Current popular pages",
    "short_statistics": "Key metrics",
    "remove_widget_x": "Remove widget \"{name}\"? You can add it back later",
    "show_test_data": "Show sample data",
    "remove": "Remove",
    "remove_dates": "Remove dates",
    "currently_no_active_users_in_store": "There are currently no active users in the store",
    "country": "Country",
    "active_users": "Active users",
    "device": "Device",
    "tablet": "Tablet",
    "desktop": "Desktop",
    "page": "Page",
    "search_engine_optimization": "Search engine optimization",
    "tracking_code": "Tracking code",
    "tracking_code_guide": "See the guide for finding the tracking code here",
    "property_id": "Property ID",
    "property_id_info": "The property ID is a unique identifier for your Google Analytics property. It, along with the tracking code, is required for you to be able to view Google Analytics data directly in your store. <a class='text-indigo-600 cursor-pointer' id='analytics-setup-guide'>See setup guide</a>",
    "property_id_guide": "<h2>To find your Google Analytics property ID:</h2>\n<ol class='list-decimal'>\n <li>Visit Google Analytics at <a href=\"https://analytics.google.com/\" target=\"_blank\">https://analytics.google.com/</a>.</li>\n <li>Select Admin.</li>\n <li>Click on Property details under Property.</li>\n</ol>\n<p>If Property details shows a numeric \"PROPERTY ID\" such as \"123...\", this is the ID of your Google Analytics property.</p>\n",
    "about_google_analytics_settings": "Google Analytics is a web analytics service offered by Google that tracks and reports website traffic. To enable Google Analytics on your store, you need to create a Google Analytics account and add the tracking code here.",
    "analytics_track_sales": "Track sales",
    "analytics_track_sales_description": "Sends purchases, cart activity and product views to Google Analytics as e-commerce events. Applies to GA4 codes (G-…).",
    "analytics_hand_installed_purchase_warning": "The partner “{name}” already sends purchases to Google Analytics. With sales tracking on here as well, every sale is counted twice.",
    "analytics_open_partner": "Open the partner",
    "analytics_tracking_code_is_extra_account": "This code is already added as an extra GA4 account in quick install. Remove it there first.",
    "add_analyst_user": "Add analyst user",
    "add_analyst_user_info": "In order to view live traffic data and reports from Google Analytics directly in the online store, you need to add an analyst user to your Google Analytics account. The user must have \"Analyst\" permission to be able to see the data. Below, you'll find the email address that this user must have.",
    "copy_to_clipboard": "Copy to clipboard",
    "email_copied_to_clipboard": "Email copied to clipboard",
    "google_analytics_auth_error": "Please check that the tracking code and property ID for your Google Analytics are correctly entered, as well that the analyst user has been added.",
    "go_to_analytics_page": "Go to analytics page",
    "unknown_error_has_occurred_contact_support": "An unknown error has occurred. Please contact support on phone <a href='tel:22336688' class='text-[color:var(--link-color)]'>22 33 66 88</a> or email <a href='mailto:support@24nettbutikk.no' class='text-[color:var(--link-color)]'>support@24nettbutikk.no</a>",
    "latest_unfulfilled_orders_info": "The latest unfulfilled orders are displayed here. Click on an order to view more details or to fulfill it.",
    "comparison_charts_info": "The store development charts show how your store is performing this month compared to the previous month. You can see the revenue and order count.",
    "google_current_active_users_info": "The current active users widget shows how many users are currently visiting your store. You can also see the country they are from.",
    "google_current_devices_info": "The current devices widget shows which devices the users are using to visit your store right now.",
    "google_current_popular_pages_info": "The current popular pages widget shows which pages are currently the most popular in your store.",
    "short_statistics_info": "The key metrics widget shows the most important statistics for your store. You can see the revenue, order count, average order value and newsletter subscribers.",
    "sales_report": "Sales report",
    "months_by_index": {
        "1": "January",
        "2": "February",
        "3": "March",
        "4": "April",
        "5": "May",
        "6": "June",
        "7": "July",
        "8": "August",
        "9": "September",
        "10": "October",
        "11": "November",
        "12": "December"
    },
    "month": "Month",
    "year": "Year",
    "order_status": "Order status",
    "goods_with_tax_rate": "Goods with tax rate {taxRate}%",
    "net": "Net",
    "nets_easy_checkout_name": "Nets Easy",
    "nets_easy_credentials_not_found": "Nets Easy credentials are not configured.",
    "nets_easy_does_not_support_payment_refresh": "Nets Easy does not support payment refresh.",
    "nets_easy_no_charge_id_for_refund": "Cannot refund: no chargeId recorded on this order.",
    "nets_easy_order_id_not_set": "Nets Easy payment ID is not set.",
    "tax": "Tax",
    "gross": "Gross",
    "sum_all_goods": "Sum all goods",
    "sum_shipping": "Sum shipping",
    "sum_refunds": "Sum refunds",
    "sum_total": "Sum total",
    "sales_report_tooltip": "In accounting terms, a sale is recorded at the point when the revenue from a transaction is earned, which usually occurs when a product is delivered to the customer and when the seller (you) receives payment from the customer.<br><br>In the online store, we define \"delivered\" when you click \"Send order\" with the intention of sending the package to the buyer (customer). With this action, you are also requesting payment from the payment provider, such as Vipps or Klarna, and the transaction is, by definition, complete and will therefore be included in the sales report.<br><br>\"Unfulfilled orders\" will not be included in the sales report.",
    "good_morning": "Good morning",
    "good_forenoon": "Good forenoon",
    "good_afternoon": "Good afternoon",
    "hello": "Hello",
    "key_figures_for_period": "Key figures for the period",
    "daily_reports": "Daily reports",
    "download_csv_file": "Download CSV file",
    "back_to_themes": "Back to themes",
    "payment_methods": "Payment methods",
    "payment_method_name": "Method",
    "type": "type",
    "disabled": "Disabled",
    "checkout": "Checkout",
    "checkout_providers": "Checkout providers",
    "requires_action": "Requires action",
    "vipps_serial_number": "Serial number",
    "vipps_client_id": "Client ID",
    "vipps_client_secret": "Client secret",
    "vipps_subscription_key_auth": "Subscription key authentication",
    "vipps_subscription_key_pay": "Subscription key payment",
    "klarna_merchant_id": "Merchant ID",
    "klarna_shared_secret": "Shared secret",
    "payment_method_updated": "Payment method updated",
    "selected": "selected",
    "choose_variant_title": "Choose {name}",
    "delete_files": "Delete files",
    "payment_reference": "Payment reference",
    "checkout_gateways_kco_description": "Kustom Checkout provides your online store with a complete and user-friendly checkout solution that boosts conversions and customer satisfaction by offering multiple payment options, such as invoicing and installment payments by Klarna. Klarna manages the payment risk, ensuring that you always get paid, and offers easy access to sales reports and analytics. This provides you with peace of mind and makes it easy to manage payments – a solution that can contribute to growth and strengthened customer loyalty in your online store.",
    "checkout_gateways_nets_easy_description": "With Nexi Nets Easy Checkout you can offer a wide range of payment options such as Vipps, Klarna, Google Pay, Apple Pay, and more. Order processing is integrated directly with Nets Easy, so you never have to leave the order window to process orders.",
    "nets_easy_checkout_key": "Checkout key",
    "nets_easy_secret_key": "Secret key",
    "no_widgets_available": "No widgets available",
    "no_widgets_available_description": "There are no more available widgets to choose from",
    "toggle_active": "Toggle active",
    "update_stock": "Update stock",
    "newsletter": "Newsletter",
    "register": "Register",
    "try_for_free": "Try for free",
    "newsletter_email_already_registered": "The email address is already registered for the newsletter",
    "theme_settings": "Theme settings",
    "theme_section_belongs_to_theme": "Belongs to the theme and is the same on every page. Edited from the front page shown in the shop.",
    "theme_settings_apply_shop_wide": "These settings belong to the theme and apply to the whole shop, not just the template you are editing. Changing one while an A/B test is running changes both designs the test compares.",
    "theme_editor_search_settings": "Search settings",
    "theme_editor_search_no_results": "No settings match your search",
    "theme_editor_search_opens_other_page": "Opens another page in the design builder",
    "text_content_padding": "Space around the content",
    "text_content_padding_description": "Switch off to let the content run all the way to the edges, for example an HTML section with its own background. Regular text should keep the space.",
    "theme_sliders": "Image sliders",
    "social_links": "Social links",
    "are_you_sure_you_want_to_delete_logo": "Are you sure you want to delete the logo? The change will be saved when you save the theme",
    "image_logo": "Image logo",
    "text_logo": "Text logo",
    "add_new_text": "Add new text",
    "conversion_tracking": "Convertion tracking",
    "conversion_partner": "Conversion partner",
    "conversion_partners": "Conversion partners",
    "events": "Events",
    "event": "Event",
    "add_conversion_partner": "Add conversion partner",
    "edit_conversion_partner": "Edit conversion partner",
    "add_partner": "Add partner",
    "analytics": "Analytics",
    "necessary": "Necessary",
    "name_placeholder": "I.E. Google Analytics",
    "purpose_placeholder": "I.E. analysis of the traffic on the website",
    "purpose": "Purpose",
    "type(s)": "type(s)",
    "a_description_of_what_this_partner_is_used_for": "A description of what this partner is used for",
    "data_processor_policy": "Data processor policy",
    "link_to_the_partners_data_processing_agreement": "Link to the partner's data processing agreement",
    "partner_storage_duration": "Partners storage duration",
    "hours": "hours",
    "days": "days",
    "weeks": "weeks",
    "months": "months",
    "years": "years",
    "is_required": "required",
    "is_retargeting": "retargeting",
    "is_analytics": "analytics",
    "what_is_this_partnership_used_for": "What is this partnership used for?",
    "the_conversion_partner_is_required_for_the_shop_to_operate_correctly": "The conversion partner is required for the shop to operate correctly",
    "the_conversion_partner_is_used_for_retargeting": "The conversion partner is used for retargeting",
    "the_conversion_partner_is_used_for_analytics": "The conversion partner is used for analytics",
    "how_long_does_the_partner_store_the_users_data": "How long does the partner store the user's data?",
    "are_you_sure_you_want_to_delete_partner": "Are you sure you want to delete partner {partner}?",
    "at_least_one_type_must_be_selected": "At least one type must be selected",
    "snippet": "snippet",
    "snippets": "snippets",
    "what_kind_of_event_should_trigger_the_snippet": "What kind of event should trigger the snippet?",
    "cart-item-quantity-updated": "Cart item quantity updated",
    "cart-item-removed": "Cart item removed",
    "added-to-cart": "Product was added to cart",
    "product-viewed": "Product was viewed",
    "page-visited": "Page was visited",
    "checkout-started": "Checkout was started",
    "order-placed": "Order was placed",
    "create_new_snippet": "Create new snippet",
    "code_that_should_be_triggered": "Code that should be triggered",
    "are_you_sure_you_want_to_delete_snippet": "Are you sure you want to delete snippet '{snippet}'?",
    "snippet_appears_to_be_invalid": "Snippet appears to be invalid",
    "snippet_appears_to_be_valid": "Snippet appears to be valid",
    "event_count": "Event count",
    "only_visible_for_you": "Only visible for you",
    "internal_name": "Internal name",
    "edit_snippet": "Edit snippet",
    "knowledge_base": "Knowledge base",
    "duration": "Duration",
    "add_new_cookie": "Add new cookie",
    "cookies": "Cookies",
    "edit_cookie": "Edit cookie",
    "cookie_name_placeholder": "I.E. _ga",
    "snippet_disclaimer": "This is an advanced feature that requires JavaScript knowledge. 24Nettbutikk is not responsible for your use of snippets. Compliance with applicable laws, consents, code security, troubleshooting, and updates are your responsibility.",
    "note": "Note",
    "enable_google_analytics_in_the_store": "Enable Google Analytics in the store",
    "google_analytics": "Google Analytics",
    "option_display_text": "Text",
    "option_display_color": "Color",
    "option_display_image": "Image",
    "colour_suggested_from_other_products": "Suggested from other products",
    "pick_color": "Pick a color",
    "remove_color": "Remove color",
    "remove_image": "Remove image",
    "no_images_uploaded_yet": "Upload photos under Images first, then pick them here.",
    "hi_{name}": "Hi, {name}",
    "we_will_notify_you_when_the_order_is_shipped": "We will notify you when the order is shipped",
    "credit_note": "Credit note",
    "your_order_has_been_shipped": "Your order has been processed",
    "your_order_has_been_refunded": "Your order has been refunded",
    "your_order_has_been_cancelled": "Your order has been cancelled",
    "your_order_has_been_updated": "Your order has been updated",
    "your_order_number_has_been_cancelled": "Your order #:number has been cancelled.",
    "cancelled_items": "Cancelled items",
    "notify_customer_of_cancellation": "notify customer of cancellation",
    "notify_customer_of_changes": "notify customer of changes",
    "if_you_have_any_questions_reply_or_contact_us_at": "If you have any questions, reply to this email or contact us at",
    "redirects": "Redirects",
    "add_redirect": "Add redirect",
    "create_new_redirect": "Create new redirect",
    "redirect_from": "Redirect from",
    "redirect_to": "Redirect to",
    "redirect_from_description": "The redirect you want to send visitors from. If you have an old path that you want to redirect to a new URL, enter the old path here.",
    "redirect_to_description": "The redirect you want to send visitors to. This can either be a URL or a path in your online store, or an external URL.",
    "redirect_from_must_be_a_valid_path": "Redirect from must be a valid path",
    "redirect_to_must_be_a_valid_path_or_url": "Redirect to must be a valid path or URL",
    "cannot_redirect_to_another_redirect": "Cannot redirect to another redirect",
    "edit_redirect": "Edit redirect",
    "redirect_created": "Redirect created!",
    "redirect_deleted": "Redirect deleted!",
    "are_you_sure_you_want_to_delete_the_redirect": "Are you sure you want to delete the redirect?",
    "import_csv_file": "Import CSV file",
    "download_example": "Download example CSV",
    "errors": "Errors",
    "redirect_csv_upload_error": "An error occurred during the CSV upload. Please check the file and try again, or see if the file matches the example CSV.",
    "redirect_csv_upload_success": "CSV file uploaded successfully! You will shortly receive an email with the results of the import. You can try to refresh the page to see the updated list of redirects.",
    "export_redirects": "Export redirects",
    "edit_image": "Edit image",
    "back_to_images": "Back to images",
    "image_effects": "Image effects",
    "blur": "Blur",
    "saturation": "Saturation",
    "image_effect_blur_description": "Helps text and button stand out.",
    "image_effect_saturation_description": "Lower = more muted. 100% = original image.",
    "use_theme_cta_colors": "Use theme CTA colors",
    "advanced_options": "Advanced options",
    "image_overlay_preview_note": "This preview shows the image in a smaller window. Text size matches the live storefront, but the text-to-image proportion may look different on the actual page.",
    "display_mode": "Display mode",
    "display_mode_hint": "\"Simple\" makes the image a plain link. \"With content\" lets you place a title, text and button on top of the image.",
    "overlay_device_desktop": "Desktop",
    "overlay_device_mobile": "Mobile",
    "mobile_content_override": "Custom content on mobile",
    "mobile_content_override_hint": "The text, sizes and placement below override desktop on small screens. Mobile sizes are fixed pixels.",
    "mobile_inherits_hint": "Mobile uses the same content as desktop, scaled to the image width.",
    "mobile_content_mirror_hint": "The fields below mirror desktop until you change something. Changes apply only to mobile, with fixed pixel sizes.",
    "image_content_button": "Content",
    "phone_preview_mode_editing": "Editing",
    "phone_preview_mode_page": "Actual page",
    "block_setting_section_label": "Block setting",
    "block_height_live_hint": "Applies to every image in the block and updates immediately.",
    "image_content_toggle": "Content on the image",
    "image_content_toggle_hint": "Add a title, text and button on top of the image. The link and alt text are set on the image row in the panel.",
    "mobile_image_section": "Mobile image",
    "mobile_image_inherits": "Mobile uses the same image as desktop.",
    "mobile_image_choose": "Use a separate image on mobile",
    "mobile_image_remove": "Remove – use the same as desktop",
    "image_slider_title_description": "Optional heading shown above the slider.",
    "image_slider_title_color": "Title color",
    "image_slider_title_color_description": "Applies only to the heading above the slider. Colors for text and buttons on the images are set in each image's Content editor.",
    "image_slider_background_color_description": "The background behind the slider – visible with vertical padding or when the block is not full width.",
    "image_slider_transition_effect": "Transition effect",
    "image_slider_transition_effect_description": "How the change between images is animated.",
    "image_slider_effect_slide": "Slide (default)",
    "image_slider_effect_fade": "Fade",
    "image_slider_effect_cube": "Cube",
    "image_slider_effect_coverflow": "Coverflow",
    "image_slider_effect_flip": "Flip",
    "help": "Help",
    "help_modal_title": "Help & overview",
    "help_modal_subtitle": "Get familiar with the design builder and the blocks you can use",
    "help_first_time_tooltip": "New here? Click to learn about the design builder",
    "help_more_help_question": "Didn't find what you were looking for?",
    "help_contact_support": "Contact support",
    "help_save_publish_name": "Save & publish",
    "help_save_publish_tagline": "How your changes reach customers.",
    "help_save_publish_description": "Changes you make in the design builder aren't visible to customers until you save and publish.",
    "help_save_publish_workflow_heading": "The workflow",
    "help_save_publish_step_edit": "1. You change something — move a block, swap a color, edit text.",
    "help_save_publish_step_save": "2. The changes live in the editor only (you see them in preview, customers don't).",
    "help_save_publish_step_publish": "3. You click \"Save and publish\" at the top right.",
    "help_save_publish_step_live": "4. The changes are now live — customers see the updated version on their next visit.",
    "help_save_publish_status_heading": "Draft vs published",
    "help_save_publish_status_draft": "Draft blocks are only visible in the editor — use this while you're working.",
    "help_save_publish_status_published": "Published blocks are visible to customers (after you've clicked \"Save and publish\").",
    "help_save_publish_status_change": "Switch \"Published\" on or off at the top of a block's settings. Blocks that are switched off are marked \"draft\" in the side menu.",
    "help_save_publish_buttons_heading": "When the buttons say something else",
    "help_save_publish_button_not_live": "A crossed-out eye by the buttons means the template you're editing isn't the one used by default, and the button says \"Save\". A home page template isn't shown in the shop until it's published, while products and categories that use the template see your changes straight away.",
    "help_save_publish_button_publish_home": "\"Publish as front page\" makes the home page template the one visitors see. The front page you were using stays behind as a draft.",
    "help_save_publish_button_use_template": "\"Use this template\" makes a product or category page template the default for everything that hasn't been given its own.",
    "help_save_publish_button_other_theme": "When you edit a theme that isn't active, \"Save\" saves without changing the shop, and \"Publish\" makes the theme the active one.",
    "help_save_publish_tip_draft_first": "Create new blocks as drafts, polish them, then publish when you're happy.",
    "help_save_publish_tip_test": "Always preview in mobile view before publishing.",
    "help_themes_name": "Switching themes",
    "help_themes_tagline": "You can have multiple themes and switch between them — perfect for campaigns and seasons.",
    "help_themes_description": "A theme is the shop's whole look: colours, fonts, header, footer and every page with its templates. You can have several themes, but only one is active in the shop at a time. Typically used to prepare a seasonal campaign without disturbing what customers see today.",
    "help_themes_feature_multiple": "Keep several themes — one for everyday, others for campaigns.",
    "help_themes_feature_switch": "Open the theme from the Theme menu at the top and click \"Publish\" to make it active.",
    "help_themes_feature_presets": "Start from a ready-made design with \"Add theme\" in the Theme menu — it opens Design variants, with designs for different industries.",
    "help_themes_feature_duplicate": "Duplicate a theme from the Theme menu as a starting point.",
    "help_themes_usecase_seasonal": "Seasonal themes — one for Christmas, one for summer, everyday the rest of the year.",
    "help_themes_usecase_campaign": "Prepare a Black Friday theme well ahead and publish it when the campaign starts.",
    "help_themes_usecase_backup": "A safe copy — duplicate the active theme before big changes.",
    "help_themes_gtk_only_one_live": "Only one theme is active at a time — the one marked \"Active\" in the Theme menu. The others are saved but not shown.",
    "help_themes_gtk_shared_settings": "Theme settings, header and footer belong to the theme. Switch theme and all of that switches with it.",
    "help_themes_gtk_ab_test": "Publishing another theme while an A/B test is running ends the test. The templates it tests belong to the theme that's active now.",
    "help_themes_gtk_startup": "On the Startup plan you work with one theme at a time.",
    "help_themes_tip_duplicate_before_change": "Duplicate the theme before drastic changes — then you always have something to go back to.",
    "help_ab_testing_name": "A/B testing",
    "help_ab_testing_tagline": "Test two templates against each other and see which one sells best.",
    "help_ab_testing_description": "With A/B testing your visitors are split between two templates, and sales are measured for both. You can test the front page, product pages or category pages. The variants are ordinary templates that you create and edit here in the design builder.",
    "help_ab_testing_setup_heading": "How to set up a test",
    "help_ab_testing_setup_template": "1. Make the template you want to test: duplicate today's template in the \"Page and template\" picker and change the copy.",
    "help_ab_testing_setup_save": "2. Save. The copy isn't shown in the shop until the test starts, or until you put it to use yourself.",
    "help_ab_testing_setup_start": "3. Start the test under Sales → A/B testing, or with \"Start an A/B test\" at the bottom of the picker.",
    "help_ab_testing_running_heading": "While the test runs",
    "help_ab_testing_running_dont_edit": "Leave the templates alone. The design builder warns you when the open template is in a test — change it and the result becomes useless.",
    "help_ab_testing_running_shared": "Theme settings, header and footer are shared by both templates. Change them and both change.",
    "help_ab_testing_running_same_template": "Each visitor gets the same template every time, including when they come back. A necessary cookie remembers the choice.",
    "help_ab_testing_running_one_per_page": "You can run one test per page type.",
    "help_ab_testing_running_default_locked": "You can't change the default template for that page type while the test runs.",
    "help_ab_testing_gtk_plan": "A/B testing is included in Premium and Premium Pluss.",
    "help_ab_testing_tip_one_change": "Test one clear difference at a time — for example what sits at the top — so you know what made the difference.",
    "help_menus_categories_name": "Menus & categories",
    "help_menus_categories_tagline": "Where you actually configure the menus and product categories the blocks reference.",
    "help_menus_categories_description": "The header, the product blocks and the category buttons pull data from menus and categories — but those aren't set up here in the design builder. They're configured in the admin and then used by the blocks.",
    "help_menus_categories_menus_heading": "Menus",
    "help_menus_categories_menu_where": "Configure menus under Admin → Navigation → Main menu and Other menus.",
    "help_menus_categories_menu_used_by": "The header pulls the menu it displays in the navigation.",
    "help_menus_categories_menu_multiple": "You can have multiple menus — e.g. a main menu and a mobile menu.",
    "help_menus_categories_categories_heading": "Categories",
    "help_menus_categories_cat_where": "Configure categories under Admin → Products → Categories.",
    "help_menus_categories_cat_used_by": "Product grids, product sliders and category buttons pull products from your categories.",
    "help_menus_categories_cat_auto": "When you add new products to a category, all blocks that use it update automatically.",
    "help_common_questions_name": "Common questions",
    "help_common_questions_tagline": "Quick answers to the things people often ask.",
    "help_common_questions_description": "Small things that aren't bugs — but are easy to miss or misunderstand the first time.",
    "help_cq_changes_heading": "My changes don't show up",
    "help_cq_changes_not_visible": "Did you click \"Save and publish\"? Changes only live in the design builder until you publish. If there's a crossed-out eye by the buttons, you're editing a template that isn't shown in the shop.",
    "help_cq_draft_vs_published": "Is \"Published\" switched off on the block? Then it's a draft that only shows in the design builder, not to customers.",
    "help_cq_color_not_changing": "Changed a colour in the theme settings and nothing happens? Check whether the block has its own colour setting that overrides it.",
    "help_cq_blocks_heading": "Working with blocks",
    "help_cq_duplicate_block": "Hover a block in the side panel — a green duplicate button appears on the right.",
    "help_cq_delete_block": "Right next to duplicate: a red delete button. Deleted blocks can't be restored — be sure.",
    "help_cq_reorder": "Change the order by dragging and dropping blocks up or down in the side panel.",
    "help_cq_locked_header": "Can't select the header or footer? They're locked on product pages, category pages, content pages and home page templates that aren't shown in the shop. You edit them on the front page the shop shows.",
    "help_cq_hidden_block": "Blocks with \"Published\" switched off aren't shown to customers until you switch it on and save.",
    "help_cq_media_heading": "Images & media",
    "help_cq_blurry_image": "Image looking blurry? Upload a larger/higher-resolution version — at least 1600 px wide for hero blocks.",
    "help_cq_image_formats": "Supported formats: JPG, PNG, WebP.",
    "help_cq_image_size": "Keep file size under 500 KB per image — large files slow the page.",
    "help_cq_themes_heading": "Themes & templates",
    "help_cq_multiple_themes": "Yes, you can have multiple themes — only one is active at a time. Each page can also have several templates.",
    "help_cq_switching_themes": "Open the theme from the Theme menu at the top and click \"Publish\". The change is immediate.",
    "help_cq_revert_changes": "You can't automatically \"undo\" past changes — that's why it's smart to duplicate the theme or template before big changes.",
    "help_search_placeholder": "Search help …",
    "help_no_results": "No matches. Try a different keyword.",
    "help_section_features": "What you can do",
    "help_section_use_cases": "Common scenarios",
    "help_section_good_to_know": "Good to know",
    "help_section_tips": "Tips",
    "help_category_intro": "Get started",
    "help_category_essentials": "Page regions",
    "help_category_product_page": "Product page",
    "help_product_page_intro_name": "How the product page works",
    "help_product_page_intro_tagline": "The product page is built from a product template — design the template once, and every product using it gets the same layout.",
    "help_product_page_intro_description": "When you edit the product page, you're editing a product page template — not a single product. Pick the template in the \"Page and template\" picker at the top, and the product to preview it with under \"Preview with\" on the right. The content (name, price, images, description) always comes from each product.",
    "help_product_page_intro_concepts_heading": "Key concepts",
    "help_product_page_intro_concept_template": "A product template defines the layout: which elements show, in what order, and in which zones.",
    "help_product_page_intro_concept_editing_one": "You edit one template at a time. The \"Page and template\" picker at the top shows which — switch template there to edit another.",
    "help_product_page_intro_concept_preview_product": "The preview product under \"Preview with\" is only for viewing in the design builder. Switch product to see how the template suits different products.",
    "help_product_page_intro_concept_publish_scope": "When you publish, the changes apply to every product using the template — not just the one you are previewing.",
    "help_concept_locked_header_footer": "Header and footer are locked here. You edit them on the front page the shop shows.",
    "help_product_page_intro_workflow_heading": "Typical workflow",
    "help_product_page_intro_workflow_pick": "Pick a template in the \"Page and template\" picker — or create a new one with \"Create product page template\".",
    "help_product_page_intro_workflow_edit": "Adjust the product layout and content blocks, and check the result in the preview.",
    "help_product_page_intro_workflow_assign": "Assign the template to products from the product page in the admin (the \"Page template\" field).",
    "help_product_templates_name": "Product templates",
    "help_product_templates_tagline": "Create multiple product page layouts and pick one per product.",
    "help_product_templates_description": "Product page templates let different products have different page layouts. The default template is used by every product that hasn't been given its own. Templates are managed in the \"Page and template\" picker at the top of the design builder.",
    "help_product_templates_feature_create": "Create a new template with the plus button next to the template picker — it starts from the standard layout.",
    "help_product_templates_feature_duplicate": "Duplicate an existing template from the list to build on a layout you like.",
    "help_product_templates_feature_default": "The default template (marked with a star) applies to all products without their own.",
    "help_templates_feature_make_default": "Make another template the default with \"Use this template\" at the top right.",
    "help_product_templates_feature_assign": "Assign per product: open the product in the admin and pick a template in the \"Page template\" box.",
    "help_product_templates_feature_delete": "Delete templates you no longer need — the default template cannot be deleted.",
    "help_product_templates_usecase_campaign": "Campaign products with their own layout — for example related products right below the buy button.",
    "help_product_templates_usecase_premium": "Premium products with a larger gallery and more editorial content.",
    "help_product_templates_usecase_seasonal": "Seasonal variants you can switch to without rebuilding the standard layout.",
    "help_product_templates_gtk_default_fallback": "New products always use the default template until you actively choose another.",
    "help_product_templates_gtk_delete_reassign": "If you delete a template, the products using it fall back to the default template.",
    "help_product_templates_gtk_duplicate_independent": "A duplicated template is fully independent — changes to the original do not affect the copy.",
    "help_product_templates_gtk_ab": "Want to test two product page templates against each other? Start an A/B test — see \"A/B testing\".",
    "help_product_templates_tip_duplicate_first": "Want to experiment? Duplicate the default template first, then it is safe to try things out.",
    "help_product_templates_tip_few": "Keep the number of templates low. Two or three considered templates are easier to maintain than ten near-identical ones.",
    "help_category_category_page": "Category page",
    "help_category_page_intro_name": "How the category page works",
    "help_category_page_intro_tagline": "One layout for every category page, driven by settings rather than blocks.",
    "help_category_page_intro_description": "The category page is not built from blocks like the front page. It is divided into regions – title, toolbar, filtering, product grid, pagination and so on – and each region has its own settings group in the menu on the left. The top and bottom come from the theme's header and footer and are edited on the front page.",
    "help_category_page_intro_concepts_heading": "How it fits together",
    "help_category_page_intro_concept_regions": "Each settings group controls one region of the page. Click the group in the menu – or click the region directly in the preview – to open its settings.",
    "help_category_page_intro_concept_shared": "The settings apply to every category using the same template. The preview category is for display only – switch category to see how the layout suits different content.",
    "help_category_page_intro_concept_templates": "If some categories need a different layout, create a category template and assign it per category.",
    "help_category_page_intro_concept_header_footer": "Header and footer are locked here. You edit them on the front page the shop shows, and they follow along to every page.",
    "help_category_page_intro_workflow_heading": "Typical workflow",
    "help_category_page_intro_workflow_pick": "Choose a category to preview under \"Preview with\" – search the list.",
    "help_category_page_intro_workflow_edit": "Click the region you want to change, adjust its settings and watch the result live.",
    "help_category_page_intro_workflow_publish": "Click \"Save and publish\" when the category page looks right. On a category page template that isn't the default, the button says \"Save\".",
    "help_category_templates_name": "Category templates",
    "help_category_templates_tagline": "Several layouts for category pages – choose a template per category.",
    "help_category_templates_description": "A category template is a set of category page settings. The default template uses the theme's own settings and applies to every category without a template of its own. Named templates store their own values, so campaign categories, for example, can get a different layout without touching the rest.",
    "help_category_templates_feature_create": "Create a new template with the plus button in the template picker – it starts as a copy of what you are editing now.",
    "help_category_templates_feature_duplicate": "Duplicate a template from the list to build on a layout you like.",
    "help_category_templates_feature_default": "The default template (marked with a star) applies to every category without its own template and cannot be deleted.",
    "help_category_templates_feature_assign": "Assign a template per category: open the category in the admin and choose the template in its settings.",
    "help_category_templates_feature_delete": "Delete templates you no longer need. Categories that used one fall back to the default template, and the editor tells you how many were affected.",
    "help_category_templates_usecase_campaign": "Campaign categories with larger product cards and infinite scrolling.",
    "help_category_templates_usecase_brand": "Brand categories with image cards for their subcategories and calmer colours.",
    "help_category_templates_usecase_landing": "Top-level categories that show their subcategories as cards instead of products.",
    "help_category_templates_gtk_default_reads_theme": "The original default template has no values of its own – it reads the theme's settings directly. Change it and you change the theme.",
    "help_category_templates_gtk_editing_scope": "The \"Page and template\" picker shows which template you're editing. The changes apply to every category with that template – not just the one you're previewing.",
    "help_category_templates_gtk_independent": "A duplicated template is independent – later changes to the original do not affect the copy.",
    "help_category_templates_tip_duplicate_first": "Want to experiment? Duplicate first, and the default template stays safe.",
    "help_category_templates_tip_few": "Keep the number of templates low. A few clear layouts are easier to maintain than many near-identical ones.",
    "help_category_regions_name": "The regions of the page",
    "help_category_regions_tagline": "Title, product grid, pagination, colours and content – one settings group per region.",
    "help_category_regions_description": "The page reads from the top: breadcrumbs and title, an optional description, the toolbar, the filtering and the product grid with pagination below. The colour group covers the whole surface. Each group in the menu on the left corresponds to one of these regions, and the selected region gets a green outline in the preview.",
    "help_category_regions_zones_heading": "The regions",
    "help_category_regions_zone_title": "Title: size, alignment and space above and below the category name.",
    "help_category_regions_zone_grid": "Product grid: products per row on desktop and mobile, spacing between the cards and an optional animation as they load in.",
    "help_category_regions_zone_pagination": "Pagination: page numbers, a Show more button, or infinite scrolling that loads the next page as the customer nears the bottom.",
    "help_category_regions_zone_colors": "Colours: background, headings and text for the category page. With automatic contrast, text colours adjust to the background you choose.",
    "help_category_regions_zone_content": "Content: breadcrumbs, whether the category description shows above or below the products, and how subcategories are navigated.",
    "help_category_regions_cards_heading": "The product cards",
    "help_category_regions_cards_global": "The product card itself – image, price, badges and swatches – is controlled by Product card under global settings, because the same cards are used on the front page and in search.",
    "help_category_regions_cards_preview": "Changes to the product card show immediately in the category page preview.",
    "help_category_toolbar_name": "Toolbar and filters",
    "help_category_toolbar_tagline": "Default view, sorting, control style and where the filters live.",
    "help_category_toolbar_description": "The toolbar sits right above the products and controls how the customer views and sorts. Filtering can live in a sidebar, as a horizontal row above the products, in a drawer opened by a button, or be hidden entirely. These settings apply to category pages and search results alike.",
    "help_category_toolbar_feature_view": "Default product view: grid or list when the customer arrives. Customers can switch themselves when the toggle is on.",
    "help_category_toolbar_feature_sorting": "Default sorting: newest, name or price. Manual categories always follow the order you set in the admin, so the choice has no effect there – the editor says so.",
    "help_category_toolbar_feature_controls": "Control style and which controls show: the grid/list toggle, sorting and the product count.",
    "help_category_toolbar_feature_layout": "Filter placement: sidebar, horizontal row, drawer or hidden.",
    "help_category_toolbar_feature_values": "How many filter values and filter groups show before Show more, search within filters, and whether groups start collapsed.",
    "help_category_toolbar_feature_quick": "Dedicated On sale and In stock filters, and the option to keep the filter pinned as the customer scrolls.",
    "help_category_toolbar_gtk_counts": "Filter counts show how many products remain with each choice and update as the customer filters.",
    "help_category_toolbar_gtk_hidden": "Hiding the filtering spares the page the work of counting filters – that can mean faster pages for large categories.",
    "help_category_toolbar_gtk_search": "The search results page uses the same toolbar and filter placement.",
    "help_category_toolbar_tip_defaults": "Start from the defaults and change one thing at a time – the preview shows the effect right away.",
    "help_category_subcategories_name": "Subcategories and display mode",
    "help_category_subcategories_tagline": "Navigation to the subcategories above the products, or category cards instead of products.",
    "help_category_subcategories_description": "A category can show its products, its subcategories, or decide automatically: with subcategories but no products of its own, it shows the category cards. Display mode is set per category in the admin. Whatever the mode, subcategories can be navigated above the products – as a sidebar, chips, a dropdown or image cards.",
    "help_category_subcategories_modes_heading": "Display mode",
    "help_category_subcategories_mode_auto": "Automatic: products when the category has products of its own, category cards when it only has subcategories.",
    "help_category_subcategories_mode_products": "Products: always the product list. A category with subcategories can then gather the products from them.",
    "help_category_subcategories_mode_cards": "Subcategories: always the category cards, with no product list.",
    "help_category_subcategories_mode_preview": "In the editor you can force either variant from the preview, so you can style the cards even when the category you are viewing shows products.",
    "help_category_subcategories_groups_heading": "Two settings groups",
    "help_category_subcategories_group_image_cards": "When the category shows products: how the subcategories are navigated – sidebar, buttons, dropdown or a row of category cards.",
    "help_category_subcategories_group_category_cards": "When the category shows subcategories: the grid that replaces the products – columns, aspect ratio, card style and hover effect.",
    "help_category_subcategories_group_images": "The cards look the same in both places: image fit, text placement and text style are shared. A card uses the category image, otherwise the first product image in the category, then one from a subcategory.",
    "help_category_preview_name": "Preview and choosing a category",
    "help_category_preview_tagline": "Switch category, click the regions and follow along as you navigate the preview.",
    "help_category_preview_description": "The preview shows one real category from your shop. The \"Preview with\" picker at the top right searches your categories, and everything you change is redrawn without reloading the page.",
    "help_category_preview_feature_search": "Search for a category in the picker – the list is fetched as you type, so large catalogues stay just as fast.",
    "help_category_preview_feature_click": "Point at a region in the preview for a dotted outline, click to open its settings. The selected region gets a solid outline.",
    "help_category_preview_feature_follow": "Click through to another category inside the preview and the editor follows, showing the settings for that one.",
    "help_category_preview_feature_device": "Switch device in the Device menu to see desktop, tablet and mobile.",
    "help_category_preview_gtk_locked": "The top and bottom cannot be selected here – they are edited on the front page.",
    "help_category_preview_gtk_manual_sorting": "When previewing a manual category, Default sorting is greyed out: manual categories follow the order from the admin.",
    "help_category_preview_gtk_display_mode": "The settings you see follow the category's display mode. Use the forced view in the preview to reach the other variant.",
    "help_category_preview_tip_test_both": "Test with both a large and a small category – pagination and filters behave differently.",
    "help_product_zones_name": "Zones and layout",
    "help_product_zones_tagline": "The product layout is split into zones — left column, right column and below the main content.",
    "help_product_zones_description": "The elements on the product page live in three zones. On large screens the left and right columns sit side by side; on mobile everything stacks into one column in the same order.",
    "help_product_zones_zones_heading": "The zones",
    "help_product_zones_zone_left": "Left column: the image gallery. It follows along as the customer scrolls, keeping the images visible.",
    "help_product_zones_zone_right": "Right column: product info and purchase details — title, price, variants, stock status and the buy button.",
    "help_product_zones_zone_below": "Below main content: full-width elements under the columns — for example product reviews.",
    "help_product_zones_arrange_heading": "Moving and showing/hiding",
    "help_product_zones_arrange_drag": "Drag elements in the side panel to reorder — including between zones where allowed.",
    "help_product_zones_arrange_visibility": "Use the eye icon to hide an element without losing its settings. Struck through means hidden.",
    "help_product_zones_arrange_locked": "Some elements are locked (padlock) because the page needs them — for example title, price and the buy button.",
    "help_product_subblocks_name": "The product layout elements",
    "help_product_subblocks_tagline": "What each element on the product page does — from gallery to reviews.",
    "help_product_subblocks_description": "The product layout is made of elements that each show one part of the product. The content is pulled automatically from the product — here you control the presentation.",
    "help_product_subblocks_media_heading": "Images and info",
    "help_product_subblocks_gallery": "Image gallery: the product images with thumbnails. Choose the layout (slider or editorial grid), the mobile view (standard, thumbnails or filmstrip), zoom on hover and whether the image text shows under the image. In full screen, customers can pinch to zoom on mobile. The image order is set on the product in the admin.",
    "help_product_subblocks_title_lead": "Product title and lead paragraph: the name and the short introduction text from the product.",
    "help_product_subblocks_reviews_summary": "Review summary: the star rating average, shown when the product has reviews.",
    "help_product_subblocks_buy_heading": "Purchase details",
    "help_product_subblocks_price": "Product price: price, compare-at price and discount — follows your campaigns automatically.",
    "help_product_subblocks_options_form": "Product options and product form: variants (size, color) and any extra fields the customer fills in. Option values can be shown as swatches or thumbnails, with variant prices, low-stock hints and a choice of size and shape.",
    "help_product_subblocks_stock": "Stock status and stock notification: shows availability, and lets customers ask to be notified when restocked.",
    "help_product_subblocks_add_to_cart_vipps": "Add to cart and Vipps Express: the buy buttons. The Vipps button only shows when Vipps Express is enabled.",
    "help_product_subblocks_promo_badges_payment": "Customer club, trust strip and payment methods: trust elements around the purchase — show or hide as needed. The customer club box shows what the points are worth and the welcome bonus, and its texts are set in the Customer club app.",
    "help_product_subblocks_below_heading": "Below the main content",
    "help_product_subblocks_description_block": "Product description: the long description from the product, with separate sections if you have several.",
    "help_product_subblocks_related": "Related products: shows the products you have connected to this product. See its own help topic.",
    "help_product_subblocks_reviews": "Product reviews: customer reviews in full width at the bottom.",
    "help_product_related_name": "Related products",
    "help_product_related_tagline": "Show hand-picked products on the product page — right where you want them.",
    "help_product_related_description": "Related products are connected per product in the admin. Where they appear on the page is controlled by the product template — for example right below the buy button, or below the main content.",
    "help_product_related_how_heading": "How it works",
    "help_product_related_how_connect": "Connect products: open the product in the admin and add related products in the \"Connected products\" list.",
    "help_product_related_how_placement": "Placement: move the \"Related products\" element in the product layout — in the right column it renders compact, below the main content it renders full width.",
    "help_product_related_how_display": "Display: choose grid or slider, product count and columns in the element's settings.",
    "help_product_related_vs_heading": "Related products vs. \"Others also bought\"",
    "help_product_related_vs_manual": "Related products are picked by you — full control over what gets recommended.",
    "help_product_related_vs_auto": "\"Others also bought\" is a separate block filled automatically based on actual orders.",
    "help_product_related_tip_template": "Want recommendations right below the buy button for only some products? Create a template with that placement and assign it to those products.",
    "help_product_related_tip_reciprocal": "Use reciprocal connections when products naturally belong together — both point at each other without double work.",
    "help_product_content_blocks_name": "Content blocks on the product page",
    "help_product_content_blocks_tagline": "Extend the product template with blocks below the product layout.",
    "help_product_content_blocks_description": "Below the product layout you can add regular content blocks — image grid, image slider, hero sections and text. They belong to the template, so they show on every product using it.",
    "help_product_content_blocks_feature_allowed": "Available blocks: image grid, image slider, hero with image and text, hero with background image, before/after image, FAQ, and text content.",
    "help_product_content_blocks_feature_position": "The blocks live in the \"Content\" section and can be reordered freely below the product layout.",
    "help_product_content_blocks_feature_settings": "Each block has the same settings as on the front page — colors, images, links and text.",
    "help_product_content_blocks_gtk_per_template": "Content blocks belong to the template, not the product. Every product with the same template shows the same blocks.",
    "help_product_content_blocks_gtk_whitelist": "Only content blocks fit on product pages — blocks like forms and blog teasers belong on the front page.",
    "help_product_content_blocks_tip_usp": "Use a text block for things that apply to all products in the template — shipping info, guarantees or a size guide.",
    "help_category_global": "Global",
    "help_category_hero": "Hero & banners",
    "help_category_content": "Content blocks",
    "help_category_products": "Product blocks",
    "help_category_engagement": "Engagement",
    "help_section_content_area_name": "Content area",
    "help_section_content_area_tagline": "The middle of the page where all your content blocks live.",
    "help_section_content_area_description": "Between the header and footer sits the content area — where you build the rest of the page by adding, ordering and removing blocks. This is where hero banners, product grids, text blocks and everything else live.",
    "help_section_content_area_feature_add": "Add blocks from the \"Add block\" menu.",
    "help_section_content_area_feature_reorder": "Drag blocks to change the order.",
    "help_section_content_area_feature_draft": "Set blocks to draft while you work — customers won't see them.",
    "help_section_content_area_feature_duplicate": "Duplicate a block if you want to start from a copy.",
    "help_section_content_area_tip_order": "Order shapes how customers experience the page — most important blocks first.",
    "help_section_content_area_tip_draft_first": "Create new blocks as drafts first. Publish them once they're ready.",
    "help_home_templates_name": "Home page templates",
    "help_home_templates_tagline": "Several versions of the front page in one theme — one is shown in the shop, the others you can keep working on or test.",
    "help_home_templates_description": "A home page template is the blocks in the front page's content area. A theme can have several home page templates, but visitors only see one. The others are marked with a crossed-out eye and aren't shown in the shop until you publish them as the front page or use them in an A/B test.",
    "help_home_templates_feature_create": "Create one with \"Create home page template\" in the \"Page and template\" picker. It starts as a copy of the front page the shop shows. If you have another home page template open, you can copy that instead.",
    "help_home_templates_feature_manage": "Duplicate or delete templates from the list in the picker. The front page the shop shows is marked with a star and can't be deleted.",
    "help_home_templates_feature_ab": "Want to know which front page sells best? Start an A/B test with the link at the bottom of the picker.",
    "help_home_templates_gtk_header_footer": "Header and footer belong to the theme and are the same on every home page template. You edit them on the front page the shop shows — on the others they're locked.",
    "help_home_templates_gtk_theme_settings": "Theme settings apply to the whole shop, not just the template you have open.",
    "help_home_templates_gtk_ab_running": "If the template is in a running A/B test, the design builder tells you at the top. Change it then and you change what the test is measuring.",
    "help_home_templates_tip_prepare": "Build a new front page in its own template and publish it when it's ready — customers see nothing until then.",
    "help_global_overview_name": "What are global settings?",
    "help_global_overview_tagline": "Settings that control the whole site — not just a single block.",
    "help_global_overview_description": "Global settings are the foundation of your theme. Change the CTA color here and every button across the whole store updates at once. It saves you from changing the same thing in 20 different places.",
    "help_global_overview_difference_heading": "Global vs per-block",
    "help_global_overview_diff_global": "Global = changes the whole site at once. Used for things that should stay consistent: fonts, main colors, button style.",
    "help_global_overview_diff_block": "Per-block = only the specific block changes. Used for content, layout and one-off details.",
    "help_global_overview_diff_when_global": "Use global for the \"common thread\" of your design. Use per-block for unique details specific to each section or campaign.",
    "help_global_overview_where_heading": "Where to find the settings",
    "help_global_overview_where_settings_tab": "Click \"Theme settings\" under Global in the side menu.",
    "help_global_overview_where_categories": "Theme settings are split into Layout, Typography, Colours and Mobile. Product cards have their own item, \"Product card\", under Global.",
    "help_global_overview_where_scope": "Theme settings apply to the whole shop — every page and every template, not just what you see now. If an A/B test is running, both templates it compares change.",
    "help_global_typography_name": "Typography (fonts)",
    "help_global_typography_tagline": "Choose the fonts used for all headings and body text in your store.",
    "help_global_typography_description": "Fonts set the tone of the whole store. You have one font for headings and one for body text — these two apply everywhere.",
    "help_global_typography_feature_heading_font": "Dedicated heading font.",
    "help_global_typography_feature_body_font": "Dedicated body font.",
    "help_global_typography_feature_line_height": "Line height for text — lower = more compact.",
    "help_global_typography_feature_letter_spacing": "Letter spacing for headings.",
    "help_global_typography_feature_transform": "Should headings be uppercased?",
    "help_global_typography_tip_pairing": "A serif heading with a sans-serif body is a classic and safe combination.",
    "help_global_typography_tip_readability": "Stick to two fonts max — more becomes messy.",
    "help_global_colors_name": "Colors",
    "help_global_colors_tagline": "Main colors used across the site — buttons, headings, links.",
    "help_global_colors_description": "Defines the palette your whole store uses. Change the CTA color and every buy button, link and highlight updates at once.",
    "help_global_colors_feature_cta": "CTA colour (Call To Action) with its own text colour — for buttons like \"Buy\", \"Add to cart\" etc.",
    "help_global_colors_feature_headlines": "Color of page headings.",
    "help_global_colors_feature_sale_price": "A separate colour for sale prices.",
    "help_global_colors_feature_breadcrumbs": "Breadcrumb colors (navigation at the top of pages).",
    "help_global_colors_feature_social": "Colour of the social media icons in the footer and mobile menu — or let them follow the text colour.",
    "help_global_colors_tip_limit": "Stick to 2–3 main colors. A CTA color + an accent + neutral tones is enough.",
    "help_global_colors_tip_contrast": "Make sure the CTA color has good contrast against the background — otherwise it's hard to see.",
    "help_global_layout_name": "Layout & rounding",
    "help_global_layout_tagline": "How wide the page is and how rounded the corners are.",
    "help_global_layout_description": "Controls the global content width and how rounded the corners of buttons, cards and images are. Small tweaks here completely change the store's feel.",
    "help_global_layout_feature_max_width": "Max content width (1280px / 1440px / 1600px).",
    "help_global_layout_feature_border_radius": "Corner rounding — 0 = sharp, high value = very soft and rounded.",
    "help_global_layout_tip_radius": "Rounding gives the store a modern look. Pick one value and use it consistently.",
    "help_global_product_card_name": "Product card style",
    "help_global_product_card_tagline": "How products are presented in categories, search and product blocks.",
    "help_global_product_card_description": "The product card is the little \"box\" around each product — with image, name, price and buy button. The settings live under \"Product card\" in the side menu, and the style applies everywhere products are shown.",
    "help_global_product_card_feature_border": "Should the card have a border or appear \"floating\"?",
    "help_global_product_card_feature_aspect": "Shape of the product image (square, landscape, portrait etc.).",
    "help_global_product_card_feature_fit": "Should the whole image be visible (with padding) or fill the frame?",
    "help_global_product_card_feature_hover": "Swap image on hover — show the product's second image when the customer points at the card.",
    "help_global_product_card_feature_badge": "Style and size of sale badges.",
    "help_global_product_card_feature_positions": "Choose where the discount badge, labels and favourite button sit.",
    "help_global_product_card_feature_text": "Show lead text, bold title, centered text etc.",
    "help_global_product_card_feature_variants": "Show variant options on the card, with size, shape and placement.",
    "help_global_product_card_tip_consistency": "Pick one aspect ratio (e.g. square) and upload product photos in the same format — that gives the cleanest result.",
    "help_global_mobile_name": "Mobile",
    "help_global_mobile_tagline": "Settings that only apply on mobile screens.",
    "help_global_mobile_description": "Mobile has different rules than desktop. Here you can customize navigation and whether the menu stays put while scrolling.",
    "help_global_mobile_feature_nav_colors": "Custom colors for the mobile menu.",
    "help_global_mobile_feature_nav_style": "Choose the mobile menu: a drawer that slides in from the left, or a full-screen overlay.",
    "help_global_mobile_feature_font_size": "Mobile menu font size: small, normal or large.",
    "help_global_mobile_feature_contact": "Show the shop's email and phone at the bottom of the mobile menu, alongside social media.",
    "help_global_mobile_feature_sticky": "Should the menu follow as the customer scrolls?",
    "help_global_mobile_tip_test": "Always test the mobile view — more than half of customers visit from mobile.",
    "help_intro_title": "Welcome to the design builder",
    "help_intro_tagline": "Build your online store by assembling pre-made blocks. No coding required.",
    "help_intro_description": "The design builder lets you assemble pages from ready-made blocks — like hero banners, product grids, newsletter forms and more. Drag blocks to reorder them, adjust settings in the side panel, and check the result in the preview before publishing.",
    "help_intro_concepts_heading": "Concepts to know",
    "help_intro_concept_blocks": "Blocks are the building blocks. Each has its own settings — colors, text, images, columns. Add, remove and reorder freely.",
    "help_intro_concept_theme_page_template": "At the top you choose theme, page and template. The theme is the shop's whole look, the page is what you're editing — the front page, product page, category page or a content page — and the template is the layout for that page.",
    "help_intro_concept_theme": "Theme settings apply across the whole shop — colours, fonts and button style. Change the CTA colour and every button updates at once.",
    "help_intro_concept_preview": "The preview shows the page as it looks right now. Choose mobile, tablet or desktop in the Device menu at the top right to check different screen sizes.",
    "help_intro_concept_publish": "Nothing changes in the shop until you save. \"Save and publish\" sends your changes out. Blocks with \"Published\" switched off are drafts and only show for you in the design builder.",
    "help_intro_tips_heading": "Smart tips",
    "help_intro_tip_drafts": "Switch off \"Published\" at the top of a block's settings while you're working on it. It's then a draft customers can't see.",
    "help_intro_tip_preview_device": "Always check the mobile view before publishing. Text that looks fine on desktop can get clipped on mobile.",
    "help_intro_tip_search": "The \"Search settings\" field at the top (⌘K or Ctrl K) finds a setting and opens it — even when it lives on another page.",
    "help_intro_tip_keyboard": "Esc closes modals and menus. You can also click outside a modal to close it.",
    "help_block_header_name": "Header",
    "help_block_header_tagline": "Logo, menu, search and cart icons at the top of every page.",
    "help_block_header_description": "The header is one of the first things customers see and must clearly communicate who you are and what you sell. Choose among several variants and control what's visible (search, account icon, cart).",
    "help_block_header_feature_variants": "Several pre-made variants with different logo and menu placements.",
    "help_block_header_feature_logo": "Upload an image logo, or use your store name as a text logo. Separate controls for logo width and height.",
    "help_block_header_feature_search": "Custom placeholder text in the search field.",
    "help_block_header_feature_sticky": "Should the header follow the customer as they scroll (sticky)?",
    "help_block_header_feature_colors": "Custom colors for header background, menu, search and icons.",
    "help_block_header_tip_logo": "Use a PNG or WebP logo with a transparent background so it looks clean against any header color.",
    "help_block_header_tip_sticky": "The header follows the customer as they scroll — make sure the logo isn't too tall.",
    "help_block_header_tip_search": "A visible search field boosts conversion noticeably — show it if you have more than 20 products.",
    "help_block_header_usecase_simple": "Small store with a simple menu and focus on logo + cart.",
    "help_block_header_usecase_mega": "Store with many categories needing a large (mega-)menu.",
    "help_block_header_usecase_premium": "Premium brand that prefers a text logo over a graphic one.",
    "help_block_header_gtk_sticky": "When sticky-header is enabled, it follows as the customer scrolls — large logos can then eat a lot of space.",
    "help_block_header_gtk_one_per_theme": "There can only be one header per theme, and it's the same on every page. You edit it on the front page the shop shows.",
    "help_block_header_gtk_mobile": "On mobile the menu hides behind a hamburger button automatically.",
    "help_section_content_area_usecase_home": "The home page — typically hero, product blocks, campaigns and newsletter.",
    "help_section_content_area_usecase_campaign": "A separate home page template for campaigns, for example Black Friday, that you publish when the campaign starts.",
    "help_section_content_area_usecase_seasonal": "Seasonal home page templates with different blocks for Christmas, summer and so on.",
    "help_section_content_area_gtk_separate_themes": "The content area belongs to the home page template. If the theme has several home page templates, each has its own layout — see \"Home page templates\".",
    "help_section_content_area_gtk_draft_safe": "Draft blocks are safe — customers don't see them until you publish.",
    "help_block_footer_tip_contact": "A phone number in the footer builds trust — customers want to see there's a real business behind it.",
    "help_block_footer_usecase_minimal": "Minimal footer with just a logo and a few links — for premium brands.",
    "help_block_footer_usecase_multi_column": "Multi-column with customer service, info, links and social.",
    "help_block_footer_usecase_newsletter": "Footer with built-in newsletter form to capture visitors.",
    "help_block_footer_gtk_legal_required": "Privacy, terms and return policy must be easily reachable from the footer — required by law.",
    "help_block_footer_gtk_one_per_theme": "There can only be one footer per theme, and it's the same on every page. You edit it on the front page the shop shows.",
    "help_block_footer_gtk_contact_expected": "Customers expect contact info in the footer — phone, email, opening hours.",
    "help_global_typography_gtk_loading": "Pick fonts that pair well — the heading font can have personality, but the body font must be easy to read.",
    "help_global_typography_gtk_brand": "Fonts are one of the first things customers notice — they should match your brand.",
    "help_global_colors_gtk_cascading": "Changing the CTA color updates EVERY button immediately — that can be a large visual change.",
    "help_global_colors_gtk_accessibility": "Make sure there's enough contrast between text and background — helps low-vision customers and search engines.",
    "help_global_layout_gtk_width": "1280px is safe for most stores. 1600px gives more breathing room on large screens, but needs enough content to fill the width.",
    "help_global_layout_gtk_radius_buttons": "Rounding also affects buttons — high values give \"pill\" buttons.",
    "help_global_product_card_gtk_all_pages": "The style is used on category pages, search, recommendations and all product blocks.",
    "help_global_product_card_gtk_image_consistency": "If product images come in different sizes, the cards become uneven — upload in the same format.",
    "help_global_mobile_gtk_majority": "Over 70% of online-store traffic comes from mobile — often the most important screen.",
    "help_global_mobile_gtk_test_real": "Test on a real phone — the preview in the design builder doesn't show exactly the same.",
    "help_block_hero_image_text_tip_short_text": "Keep the title short (3–6 words). Long titles get clipped on mobile.",
    "help_block_hero_image_text_usecase_intro": "Tells visitors who you are and what you sell — for first-time visitors.",
    "help_block_hero_image_text_usecase_campaign": "Campaign with a big product image and a clear buy button.",
    "help_block_hero_image_text_usecase_value_prop": "Value props — \"Free shipping over 999 kr\" or \"Delivery in 1–2 days\".",
    "help_block_hero_image_text_gtk_mobile_stack": "On mobile, image and text stack on top of each other — you can pick the order.",
    "help_block_hero_image_text_gtk_image_quality": "Use a high-res image (at least 1600px wide) so it looks crisp on desktop.",
    "help_block_hero_background_tip_calm_area": "Pick images with a calm area (sky, plain background) where the text can sit.",
    "help_block_hero_background_usecase_brand": "Lifestyle or mood imagery that tells your brand story.",
    "help_block_hero_background_usecase_seasonal": "Seasonal campaigns with atmospheric imagery — Christmas, summer, autumn.",
    "help_block_hero_background_usecase_lifestyle": "Show how the product is used in a real situation, not just in a studio.",
    "help_block_hero_background_gtk_text_readability": "Darken the image with an overlay if text becomes hard to read.",
    "help_block_hero_background_gtk_mobile_focal": "Images often get cropped on mobile — make sure the focal point isn't lost.",
    "help_block_hero_background_gtk_size": "Large background images can be heavy — compress before uploading.",
    "help_block_video_hero_tip_silent": "Does the video need sound to make sense? Turn on the video controls, but put the message in text too — most people watch without sound.",
    "help_block_video_hero_usecase_product_demo": "Show the product in use — motion catches attention better than stills.",
    "help_block_video_hero_usecase_lifestyle": "Mood video of the store, atmosphere or lifestyle the brand represents.",
    "help_block_video_hero_usecase_brand_story": "Short films telling the brand story — quality, process, people.",
    "help_block_video_hero_gtk_no_sound": "The video always starts muted. Turn on the video controls and customers can switch the sound on themselves.",
    "help_block_video_hero_gtk_url_only": "The video is hosted on YouTube or Vimeo — you paste the URL, you don't upload the file.",
    "help_block_video_hero_gtk_unlisted": "Vimeo videos can be \"unlisted\" — works fine as long as the URL is valid.",
    "help_block_campaign_bar_tip_contrast": "Pick a color that stands out from the rest of the header — otherwise it gets ignored.",
    "help_block_campaign_bar_usecase_shipping": "\"Free shipping over 999 kr\" — communicates the shipping promise immediately.",
    "help_block_campaign_bar_usecase_sale": "\"Summer sale — up to 50% off\" with a link to the campaign page.",
    "help_block_campaign_bar_usecase_announcement": "Important messages — holiday closures, delivery changes, launches.",
    "help_block_campaign_bar_gtk_top_of_all_pages": "Shows on every page. You pick the placement — header, main content, or footer.",
    "help_block_campaign_bar_gtk_dismiss_remember": "Add links directly in the text — customers can jump to the campaign page in one click.",
    "help_block_image_grid_tip_apply_all": "\"Apply style to all\" in the image editor copies colours, sizes, placement and button style to every image in the block. Titles, text, button labels and links stay per image.",
    "help_block_image_grid_usecase_categories": "Show categories visually — customers click images more often than text links.",
    "help_block_image_grid_usecase_collection": "Whole collections — \"Spring dresses\", \"The furniture collection\".",
    "help_block_image_grid_usecase_inspiration": "Inspirational imagery — how the product looks in context.",
    "help_block_image_grid_gtk_same_size": "Images look cleaner with the same aspect ratio (all square, all portrait etc.).",
    "help_block_image_grid_gtk_overlay_readability": "Overlay text on busy images becomes unreadable — use the darken effect.",
    "help_block_image_grid_gtk_mobile_columns": "Use fewer columns on mobile than desktop — images become too small otherwise.",
    "help_block_image_slider_tip_first_seen": "The first slide is the only one many customers see — put your most important content there.",
    "help_block_image_slider_usecase_campaigns": "Multiple campaigns that rotate — saves space at the top of the page.",
    "help_block_image_slider_usecase_hero_rotation": "Alternative to a static hero — show multiple images over time.",
    "help_block_image_slider_usecase_lookbook": "Lookbook or photo series — multiple photos from the same shoot.",
    "help_block_image_slider_gtk_first_slide": "The first image gets the most attention — fewer than 20% of customers see past slide 3.",
    "help_block_image_slider_gtk_speed": "Set the interval to at least 5 seconds — customers need time to read.",
    "help_block_image_slider_gtk_dropoff": "Studies show slider effectiveness drops sharply with more slides — stick to 3–5.",
    "help_block_text_content_tip_personality": "Write like a human — customers buy from people they like, not robots.",
    "help_block_text_content_usecase_about": "About us page — history, values, the team behind the store.",
    "help_block_text_content_usecase_info": "Info pages — shipping, returns, delivery terms.",
    "help_block_text_content_usecase_story": "Longer narratives — product stories, interviews, guides.",
    "help_block_text_content_gtk_seo_heading_levels": "Use H1 for the main title, H2/H3 for sub-sections — Google understands the structure better.",
    "help_block_text_content_gtk_line_length": "Text in a narrow column (~60 chars per line) reads faster than full-width.",
    "help_block_faq_tip_order_by_importance": "Put the most important questions first — \"When will my order arrive?\" before \"Which payment methods?\".",
    "help_block_faq_usecase_shipping": "Shipping and delivery — questions about timing, cost, areas.",
    "help_block_faq_usecase_sizing": "Sizes and fit — especially important for clothing and footwear.",
    "help_block_faq_usecase_product_care": "Product care — washing, maintenance, warranties.",
    "help_block_faq_gtk_seo_schema": "FAQ blocks can appear as rich snippets in Google search if the questions are well written.",
    "help_block_faq_gtk_keep_updated": "Keep the FAQ updated when customer service keeps getting the same questions.",
    "help_block_featured_blog_tip_thumbnail": "Make sure each blog post has a good featured image — it shows as the thumbnail here.",
    "help_block_featured_blog_usecase_news": "News — product launches, campaigns, updates.",
    "help_block_featured_blog_usecase_guides": "Guides and advice — \"How to pick the right size\", \"Caring for X\".",
    "help_block_featured_blog_usecase_content_marketing": "SEO content — blog posts that rank in Google and drive organic traffic.",
    "help_block_featured_blog_gtk_auto_update": "Automatically pulls the latest posts — you don't have to edit the block.",
    "help_block_featured_blog_gtk_blog_needed": "Requires an active blog with posts — settings are managed in the blog module.",
    "help_block_product_grid_tip_below_hero": "Put products right under the hero — that's where the eyes naturally go next.",
    "help_block_product_grid_usecase_category": "Show the products in a specific category — \"Winter clothes\", \"Garden and outdoor\".",
    "help_block_product_grid_usecase_new_arrivals": "Create a \"New arrivals\" category and sort by newest first.",
    "help_block_product_grid_usecase_campaign": "Create a campaign category (e.g. \"Summer deals\") and feature it on the home page.",
    "help_block_product_grid_gtk_card_style": "The product card style is set globally under \"Product card\" in the side menu.",
    "help_block_product_grid_gtk_auto_update": "Content updates automatically when you add, remove or hide products in the category.",
    "help_block_product_grid_gtk_empty_state": "If the category is empty, nothing shows — the block effectively disappears.",
    "help_block_product_slider_tip_minimum": "Needs at least 4 products to make the slider meaningful.",
    "help_block_product_slider_usecase_recommendations": "\"Recommended for you\" or \"Customers also bought\" sections.",
    "help_block_product_slider_usecase_related": "Related products — complementary items for what they're looking at.",
    "help_block_product_slider_usecase_compact": "When space is limited and you want to show more than a grid allows.",
    "help_block_product_slider_gtk_swipe": "On mobile two cards show at a time, with a thin line underneath showing how far the customer has swiped. Arrows only show on larger screens.",
    "help_block_product_slider_gtk_hidden_products": "Hidden and out-of-stock products are skipped automatically — no manual filtering.",
    "help_block_single_product_tip_with_hero": "Often combined with a hero block above as \"context\" — the story around the product.",
    "help_block_single_product_usecase_launch": "Launch — feature the newest product with a big, exclusive look.",
    "help_block_single_product_usecase_signature": "Signature product — what your brand is known for, or the bestseller.",
    "help_block_single_product_usecase_campaign_pair": "Campaign product — \"Deal of the week\", \"Holiday special\".",
    "help_block_single_product_gtk_pulls_live": "Pulls price, stock and images directly from the product — changes there update here automatically.",
    "help_block_single_product_gtk_high_res": "Used in a large format — make sure the product images are high resolution.",
    "help_block_category_buttons_tip_max_six": "Max 6 buttons. More becomes overwhelming — customers give up and scroll past.",
    "help_block_category_buttons_usecase_main_nav": "Main navigation on the home page — direct links to the most important categories.",
    "help_block_category_buttons_usecase_seasonal": "Seasonal categories — \"Birthday gifts\", \"Summer sale\", \"Back to school\".",
    "help_block_category_buttons_usecase_below_hero": "Right below the hero to guide the customer from \"welcome\" to shopping.",
    "help_block_category_buttons_gtk_text_only": "The buttons show the category name only — no images or icons. Use Image grid if you want visual category navigation.",
    "help_block_category_buttons_gtk_scroll_mobile": "Scroll layout works well on mobile when you have many categories — customers swipe sideways.",
    "help_block_newsletter_tip_placement": "Place the newsletter after customers have seen some products — not as the first thing they meet.",
    "help_block_newsletter_usecase_lead_gen": "Build an email list for future marketing and campaigns.",
    "help_block_newsletter_usecase_launch_list": "\"Waitlist\" for upcoming products or store openings.",
    "help_block_newsletter_usecase_discount_offer": "Get subscribers by offering a discount code — the classic \"10% off your first order\".",
    "help_block_newsletter_gtk_subscribers_stored": "Sign-ups are collected in the admin under subscribers — export the list from there.",
    "help_block_newsletter_gtk_gdpr_legal": "Remember GDPR — you must have permission to send marketing emails to people who sign up.",
    "help_block_newsletter_gtk_value_exchange": "People give up their email when they get something in return — discount, guide, exclusive access.",
    "help_block_form_tip_email_notify": "Enable email notifications — you don't want to miss a customer inquiry.",
    "help_block_form_usecase_contact": "Contact form for questions, complaints, inquiries.",
    "help_block_form_usecase_custom_order": "Special orders — customers ask for something outside the regular catalog.",
    "help_block_form_usecase_return": "Return request — a structured way to handle returns.",
    "help_block_form_usecase_survey": "Customer survey — feedback on the experience.",
    "help_block_form_gtk_required_email": "Make email collection required — without it you can't reply to the customer.",
    "help_block_form_gtk_short_wins": "Three fields = 80% completion. Ten fields = 20%. Short always wins.",
    "help_block_form_gtk_thank_you_critical": "Show a thank-you message after submission — without it the customer wonders if it worked.",
    "help_block_footer_name": "Footer",
    "help_block_footer_tagline": "The bottom of the page — contact info, links, social media and payment icons.",
    "help_block_footer_description": "The footer is where customers go to find your contact phone, delivery info or opening hours. You can pick from several variants and customize the column content.",
    "help_block_footer_feature_columns": "Multiple columns with custom links.",
    "help_block_footer_feature_social": "Icons for Instagram, Facebook, TikTok etc. You pick their colour under Theme settings → Colours.",
    "help_block_footer_feature_payment": "Display the payment methods you accept.",
    "help_block_footer_feature_newsletter": "Built-in newsletter form (optional).",
    "help_block_footer_feature_shape": "Footer 2 can have a shape along the top — curved, wave, diagonal or sawtooth — that can overlap the block above.",
    "help_block_footer_tip_legal": "Don't forget links to privacy, terms and return policy — they're legally required.",
    "help_block_campaign_bar_name": "Campaign bar",
    "help_block_campaign_bar_tagline": "Thin bar with offers, promo codes or important messages.",
    "help_block_campaign_bar_description": "Use the campaign bar to shout about offers or share shipping info. It shows on every page, and you choose whether to place it in the header, main content, or footer.",
    "help_block_campaign_bar_feature_visibility": "Toggle on/off without deleting the content.",
    "help_block_campaign_bar_feature_link": "Up to 3 messages that auto-rotate on mobile.",
    "help_block_campaign_bar_feature_dismiss": "Custom background and text colors to make the bar stand out.",
    "help_block_campaign_bar_tip_short": "Keep the text short — one sentence works best.",
    "help_block_hero_image_text_name": "Image with text",
    "help_block_hero_image_text_tagline": "Large banner with an image on one side and text + button on the other.",
    "help_block_hero_image_text_description": "Classic hero block typically placed at the top of the home page. Image on one side, title + text + one or more buttons on the other.",
    "help_block_hero_image_text_feature_layout": "Choose if the image goes on the left or right.",
    "help_block_hero_image_text_feature_cta": "Big call-to-action button with custom color.",
    "help_block_hero_image_text_feature_alignment": "Place the text above, middle, or below the image.",
    "help_block_hero_image_text_tip_first_block": "Works well as an intro block when you want to set the mood first. If customers know what they're looking for, leading with a product block can drive faster purchases.",
    "help_block_hero_background_name": "Text with background image",
    "help_block_hero_background_tagline": "Full-width background image with text and button on top.",
    "help_block_hero_background_description": "Visually striking variant where the image covers the whole block and the text sits on top as an overlay. Control text placement and add a color overlay for readability.",
    "help_block_hero_background_feature_overlay": "Darken the image with a color overlay so the text stays readable.",
    "help_block_hero_background_feature_parallax": "Optional parallax effect as the customer scrolls.",
    "help_block_hero_background_feature_placement": "Place text anywhere — top, middle, bottom, left, right.",
    "help_block_button_styles": "The button can be filled, outlined or text only, with an optional arrow or cart icon.",
    "help_block_hero_background_tip_readability": "Pick an image with a calm, mostly-solid area where the text can sit — or use the overlay for darkening.",
    "help_block_video_hero_name": "Video hero",
    "help_block_video_hero_tagline": "Hero banner with a YouTube or Vimeo video in the background.",
    "help_block_video_hero_description": "Like a regular hero, but with a video in the background instead of an image. You paste a YouTube or Vimeo URL — the video plays automatically, on loop, and muted. Great for showing the product or store in motion.",
    "help_block_video_hero_feature_autoplay": "Plays automatically — without sound.",
    "help_block_video_hero_feature_loop": "Plays on loop.",
    "help_block_video_hero_feature_overlay": "Overlay with title, text and button.",
    "help_block_video_hero_feature_controls": "Optional video controls: play/pause, restart and sound on/off, in a corner you choose and in three sizes.",
    "help_block_video_hero_feature_height": "Choose the block height — small, medium, large, extra large or full screen — and a separate height on mobile.",
    "help_block_video_hero_tip_size": "Keep the video short (15–30 seconds) so the loop doesn't become annoying.",
    "help_block_image_grid_name": "Image grid",
    "help_block_image_grid_tagline": "Grid of images with optional text and button on each.",
    "help_block_image_grid_description": "Great for categories, collections, or inspirational imagery. Pick the number of columns and add overlay text + button per image.",
    "help_block_image_grid_feature_columns": "1–6 columns — separate values for desktop and mobile.",
    "help_block_image_grid_feature_overlay": "Add title, text and button to each image.",
    "help_block_image_grid_feature_link": "The whole image can be a link.",
    "help_block_image_grid_tip_overlay": "Keep overlay text short — 2–4 words works best. Long copy competes with the image for attention.",
    "help_block_image_slider_name": "Image slider",
    "help_block_image_slider_tagline": "Rotating images that play automatically or manually.",
    "help_block_image_slider_description": "Show multiple campaigns or images without taking up much space. Same overlay options as the image grid, plus auto-rotation.",
    "help_block_image_slider_feature_autoplay": "Choose the interval between slides.",
    "help_block_image_slider_feature_arrows": "Show arrows and dots for navigation.",
    "help_block_image_slider_feature_overlay": "Overlay text, button and color layer per image.",
    "help_block_carousel_second_button": "Add a second button next to the first — for example \"Shop now\" and \"Read more\".",
    "help_block_image_slider_feature_effects": "Choose the transition effect — slide, fade, cube, coverflow or flip.",
    "help_block_image_slider_feature_pagination": "Four pagination styles: dots, bars, counter or thumbnails.",
    "help_block_image_slider_feature_mobile_image": "Separate mobile image per slide — show a portrait crop on small screens.",
    "help_block_bento_grid_name": "Bento grid",
    "help_block_bento_grid_tagline": "Magazine-style collage where images get different sizes.",
    "help_block_bento_grid_description": "A grid with fixed layout variants where some images get more space than others — like a collage. Same overlay options as the image grid, with title, text and button per image.",
    "help_block_bento_grid_feature_variants": "Six layout variants — including feature left/right, mosaic, hero and showcase.",
    "help_block_bento_grid_feature_row_height": "Adjust the row height to make the whole collage shorter or taller.",
    "help_block_bento_grid_feature_overlay": "Add title, text and button to each image.",
    "help_block_bento_grid_feature_hover": "Hover effects on the tiles — for example zoom.",
    "help_block_bento_grid_usecase_categories": "Category showcase where the main category gets the big tile.",
    "help_block_bento_grid_usecase_campaign": "Campaign collage — one big campaign surrounded by smaller offers.",
    "help_block_bento_grid_usecase_lifestyle": "Magazine-style lifestyle imagery showing products in use.",
    "help_block_bento_grid_gtk_crop": "Images are cropped automatically to fill the tiles — keep important details near the center.",
    "help_block_bento_grid_gtk_mobile": "On mobile the tiles are arranged automatically in two columns.",
    "help_block_bento_grid_gtk_image_count": "Each variant is designed for a specific number of images (3–5) — the pattern repeats if you add more.",
    "help_block_bento_grid_tip_hero_image": "Give your best image the big tile — that's where the eye goes first.",
    "help_block_bento_grid_tip_consistent": "Use images with a consistent style and color tone — the collage reads as one whole.",
    "help_block_image_grid_slider_name": "Image grid slider",
    "help_block_image_grid_slider_tagline": "An image grid that slides sideways — show more images in the same space.",
    "help_block_image_grid_slider_description": "Like the image grid, but the images sit in a slider instead of a fixed grid. Choose how many columns are visible at once and let customers browse through the rest.",
    "help_block_image_grid_slider_feature_columns": "Choose the number of visible columns — separate values for desktop and mobile.",
    "help_block_image_grid_slider_feature_arrows": "Arrows and dots for navigation — choose arrow style and position.",
    "help_block_image_grid_slider_feature_overlay": "Add title, text and button to each image.",
    "help_block_image_grid_slider_usecase_categories": "Many categories in little space — show a few and keep the rest in the slider.",
    "help_block_image_grid_slider_usecase_collections": "Collections or brands customers can browse through.",
    "help_block_image_grid_slider_usecase_compact": "A compact alternative when the image grid takes up too much height.",
    "help_block_image_grid_slider_gtk_swipe": "On mobile customers swipe — arrows are most useful on desktop.",
    "help_block_image_grid_slider_gtk_same_size": "Images look better when they share the same aspect ratio.",
    "help_block_image_grid_slider_tip_columns": "Add more images than visible columns — otherwise there is nothing to browse to.",
    "help_block_logo_slider_name": "Logo slider",
    "help_block_logo_slider_tagline": "A rolling row of logos — brands, partners or press mentions.",
    "help_block_logo_slider_description": "Show the logos of the brands you carry, partners or press mentions. Choose between continuous scrolling or paged browsing.",
    "help_block_logo_slider_feature_movement": "Two movement styles: continuous scrolling with adjustable speed, or paged browsing with autoplay.",
    "help_block_logo_slider_feature_per_view": "Choose how many logos are visible at once — separate values for desktop and mobile.",
    "help_block_logo_slider_feature_height": "Adjust the logo height — all logos are displayed at the same height.",
    "help_block_logo_slider_usecase_brands": "\"Brands we carry\" — recognizable logos build trust instantly.",
    "help_block_logo_slider_usecase_partners": "Partners or certifications.",
    "help_block_logo_slider_usecase_press": "\"Featured in\" — press logos add credibility.",
    "help_block_logo_slider_gtk_same_height": "Since all logos share the same height, wide logos appear larger than square ones — check that the row looks balanced.",
    "help_block_logo_slider_gtk_transparent": "Use logo files with transparent backgrounds (PNG/SVG) — white boxes around logos look unfinished.",
    "help_block_logo_slider_tip_marquee": "Continuous scrolling at a calm speed feels elegant — set the speed low and enable pause on hover.",
    "help_block_logo_slider_tip_link": "Each logo can be linked — send customers to the brand's product list.",
    "help_block_before_after_name": "Before/after image",
    "help_block_before_after_tagline": "Two images with a draggable divider — show the transformation.",
    "help_block_before_after_description": "The customer drags the handle sideways to compare the before and after image. Perfect when your product delivers a visible result.",
    "help_block_before_after_feature_handle": "Interactive handle the customer drags — choose the divider's starting position.",
    "help_block_before_after_feature_labels": "Custom labels on both images — for example \"Before\" and \"After\".",
    "help_block_before_after_feature_layout": "Choose the aspect ratio, and add a title and text next to the image.",
    "help_block_before_after_usecase_results": "Visible results — skincare, cleaning, hair products.",
    "help_block_before_after_usecase_renovation": "Renovation and restoration — furniture, interiors, cars.",
    "help_block_before_after_usecase_effect": "Product effect — with and without the product.",
    "help_block_before_after_gtk_same_framing": "Both images must have identical framing and angle — use a tripod or the same camera position.",
    "help_block_before_after_gtk_product_page": "The block can also be used in the product page design — show the result right next to the buy button.",
    "help_block_before_after_tip_position": "Set the starting position slightly off-center — a visible sliver of the after image tempts the customer to drag.",
    "help_block_before_after_tip_honest": "Use real, unedited results — exaggerated before/after images erode trust.",
    "help_block_image_slider_tip_amount": "Stick to 3–5 slides — more rarely get seen by customers.",
    "help_block_text_content_name": "Text content",
    "help_block_text_content_tagline": "Free-form text with formatting for \"About us\", info pages or stories.",
    "help_block_text_content_description": "Full rich-text editor for longer content. Use headings, lists, links and images. Great for the About us page, info pages or the blog.",
    "help_block_text_content_feature_richtext": "Headings, bold/italic, lists, links.",
    "help_block_text_content_feature_alignment": "Left, center or right.",
    "help_block_text_content_feature_width": "Narrow or wide column.",
    "help_block_text_content_feature_padding": "Switch off \"Space around the content\" to let an HTML section run to the edges. Together with \"Full width\" it covers the whole screen width.",
    "help_block_text_content_tip_seo": "This content matters for SEO — use relevant keywords and headings (H1/H2).",
    "help_block_faq_name": "FAQ",
    "help_block_faq_tagline": "Collapsible list of frequently asked questions.",
    "help_block_faq_description": "Cuts down on customer-support questions. Each question is collapsible — customers click to expand the answer. The questions themselves are managed in the admin under FAQ, and this block picks which FAQ list to show.",
    "help_block_faq_feature_collapsible": "Answers expand on click.",
    "help_block_faq_feature_pick_list": "Choose which FAQ list to display — managed separately in the admin.",
    "help_block_faq_feature_title_toggle": "Show or hide the block title.",
    "help_block_faq_feature_layout": "Answers can open below the question or in a drawer from the right, with a plus/minus or arrow icon, and you choose which questions start open.",
    "help_block_faq_feature_width_typography": "Full width or boxed, content width, spacing above and below, and separate font size and weight for questions and answers.",
    "help_block_faq_tip_questions": "Write questions the way customers actually ask them (not the way you would internally).",
    "help_block_featured_blog_name": "Featured blog posts",
    "help_block_featured_blog_tagline": "Shows the latest blog posts as short summaries.",
    "help_block_featured_blog_description": "Great for SEO and customer engagement. Choose how many posts to show and optionally filter by tags.",
    "help_block_featured_blog_feature_count": "1–12 posts.",
    "help_block_featured_blog_feature_tag_filter": "Only show posts with specific tags.",
    "help_block_featured_blog_tip_seo": "Blog posts are gold for SEO — write well and use relevant keywords.",
    "help_block_product_grid_name": "Product grid",
    "help_block_product_grid_tagline": "Grid of products from a chosen category.",
    "help_block_product_grid_description": "The main way to show products on your home page. Pick a category, the number of products to show, the number of columns, and whether out-of-stock items appear.",
    "help_block_product_grid_feature_source": "Pull products from a chosen category.",
    "help_block_product_grid_feature_count": "Choose how many products to show.",
    "help_block_product_grid_feature_sort": "Sort newest first, oldest first or in the category's order.",
    "help_block_product_grid_feature_columns": "Choose the number of columns.",
    "help_block_product_grid_feature_out_of_stock": "Show or hide out-of-stock products.",
    "help_block_product_grid_feature_stock_status": "Show or hide stock status in the product cards.",
    "help_block_product_grid_tip_category": "The category updates automatically as you add new products to it — you don't have to edit the block.",
    "help_block_product_slider_name": "Product slider",
    "help_block_product_slider_tagline": "Horizontal slider of products, rotated with arrows.",
    "help_block_product_slider_description": "Like the product grid but in slider form — saves space and lets you show more products without filling the screen.",
    "help_block_product_slider_feature_source": "Pull products from a chosen category (same as product grid).",
    "help_block_product_slider_feature_navigation": "Customers navigate manually with arrows on desktop or swipe on mobile.",
    "help_block_product_slider_feature_gap": "Choose the gap between product cards.",
    "help_block_product_slider_feature_stock_status": "Show or hide stock status in the product cards.",
    "help_block_product_slider_tip_recommendations": "Great for \"Customers also bought\" and \"Recommended for you\" sections.",
    "help_block_single_product_name": "Single product",
    "help_block_single_product_tagline": "Highlight a single product with a big image and buy button.",
    "help_block_single_product_description": "Use this when you want to spotlight one specific product — typically a new launch, campaign item or signature product.",
    "help_block_single_product_feature_layout": "Image + description + price + buy button.",
    "help_block_single_product_feature_promote": "Typically placed mid-page between other blocks.",
    "help_block_single_product_tip_feature_product": "Great for product launches — often combined with a hero above.",
    "help_block_category_buttons_name": "Categories (buttons)",
    "help_block_category_buttons_tagline": "Text buttons linking directly to your categories.",
    "help_block_category_buttons_description": "Help customers find your most important categories quickly. Pick which categories to show, the button size, and whether they wrap to a new line or scroll horizontally.",
    "help_block_category_buttons_feature_categories": "Pick which categories to display as buttons.",
    "help_block_category_buttons_feature_layout": "Wrap (buttons break to a new line) or scroll (horizontal scrolling).",
    "help_block_category_buttons_feature_size": "Pick the button size: small, medium, large.",
    "help_block_category_buttons_feature_styling": "Custom colors for button, text, border and rounding. Optional hover effect.",
    "help_block_category_buttons_tip_below_hero": "Often placed right under the hero block to guide the customer further.",
    "help_block_newsletter_name": "Newsletter form (signup)",
    "help_block_customer_club_name": "Customer club",
    "help_block_customer_club_tagline": "Recruit members and show members their points.",
    "help_block_customer_club_description": "The block takes its numbers from the customer club settings: welcome bonus, point rate and quarantine. Guests and non-members get the sign-up text and button, logged-in members get their balance and a link to My Page.",
    "help_block_customer_club_feature_layouts": "Four layouts: banner, benefit cards, steps from joining to discount, and a calculator with a slider.",
    "help_block_customer_club_feature_live_numbers": "Bonus, rate and quarantine update automatically when the settings change.",
    "help_block_customer_club_feature_members": "Members see their balance, its value and points on the way instead of the sign-up text.",
    "help_block_customer_club_usecase_home": "High on the home page to catch new customers.",
    "help_block_customer_club_usecase_reminder": "Below the product sections as a reminder before the customer heads to checkout.",
    "help_block_customer_club_usecase_members": "As a permanent element so members see their points grow.",
    "help_block_customer_club_gtk_app_required": "The block requires the customer club app to be purchased and active. Turn the app off and the block disappears from the store.",
    "help_block_customer_club_gtk_quarantine": "Earned points are locked during the quarantine, while the welcome bonus is available immediately. The block says both.",
    "help_block_customer_club_gtk_consent": "Joining requires marketing consent. The button sends the customer to the club page where consent is given.",
    "help_block_customer_club_tip_bonus": "Set a welcome bonus that is worth something. Its value is shown next to the bonus field in the settings.",
    "help_block_customer_club_tip_layout": "Use the benefits layout when you want to explain the club, and the banner when you just want the button visible.",
    "help_block_newsletter_tagline": "Get customers to subscribe to your newsletter.",
    "help_block_newsletter_description": "Build your own email list. Several variants with different designs — from a simple inline form to a full-width section with a background image.",
    "help_block_newsletter_feature_variants": "Six pre-made variants with different layouts and image support.",
    "help_block_newsletter_feature_content": "Custom title and rich-text body copy.",
    "help_block_newsletter_feature_image": "Image support in the variants that include one.",
    "help_block_newsletter_tip_value": "Offer something in return — 10% off the first order is the classic.",
    "help_block_form_name": "Form",
    "help_block_form_tagline": "Contact form or survey.",
    "help_block_form_description": "Show a form you've configured in the admin under Forms. The form itself — fields, thank-you message, email notifications — is set up there, and this block picks which form to display.",
    "help_block_form_feature_pick_form": "Pick which form to show (created in the admin under Forms).",
    "help_block_form_feature_width": "Pick form width and vertical padding.",
    "help_block_form_feature_styling": "Custom background and text color for the block.",
    "help_block_form_tip_contact": "Keep the form short — fewer fields means more replies.",
    "changes_wont_be_finalized_until_theme_saved": "Changes aren't kept until you save in the design builder",
    "open_in_new_tab": "Open in new tab",
    "badge_text_color": "Badge text color",
    "badge_background_color": "Badge background color",
    "discount_badge_background_color": "Discount badge background color",
    "discount_badge_text_color": "Discount badge text color",
    "discount_badge_size": {
        "label": "Discount badge size",
        "description": "Adjusts the font size of the discount badge"
    },
    "badge_size": {
        "label": "Badge size",
        "description": "Adjusts the font size of product badges such as \"New\" or \"Bestseller\""
    },
    "discount_badge_shape": {
        "label": "Discount badge shape",
        "description": "Choose the shape of the discount badge",
        "rounded": "Rounded",
        "circle": "Circle",
        "starburst": "Starburst",
        "ribbon": "Ribbon",
        "tag": "Tag"
    },
    "search_or_select_from_dropdown": "Search or select from dropdown",
    "loading": "Loading",
    "no_results": "No results found",
    "campaign_bar_description": "The campaign bar is a great way to inform your customers about ongoing campaigns, discounts, or other important information. The bar is displayed at the top of the store and can be customized with text, links, and colors",
    "text_logo_description": "If you are missing a logo, you can create a text logo",
    "search_placeholder": "Search placeholder",
    "search_placeholder_description": "The text shown in the search field before the customer starts typing",
    "menu_description": "Menus help your customers navigate through your store. You can add categories, products, pages, and links to other parts of your store. <a target='_blank' href='/admin/menus' class='text-[color:var(--link-color)]'>You can create and manage menus here</a>",
    "theme_block_variant_description": "Different variants have different layout and design. You can choose the variant that best suits your store",
    "newsletter_signup_image_description": "Only available on variant 3 and 4",
    "theme_editor_category_description": "Choose the category you want to get products from and display in this block. <a target='_blank' href='/admin/categories' class='text-[color:var(--link-color)]'>You can create and manage categories here</a>",
    "color_of_title": "Color of title",
    "delete_image": "Delete image",
    "crop_image": "Crop image",
    "crop_and_save": "Crop & save",
    "image_cropped_successfully": "Image cropped successfully",
    "see_store": "See store",
    "preview_mobile": "Preview mobile",
    "preview_tablet": "Preview tablet",
    "preview_desktop": "Preview desktop",
    "preview_product": "Preview product",
    "payment_operation_failed": "Unable to continue, communication with the payment provider failed.",
    "reference_code": "Reference code :code",
    "cancellations": "Cancellations",
    "show_orders": "Show orders",
    "webhook_deleted": "The webhook was deleted.",
    "webhook_updated": "The webhook was updated.",
    "webhook_created": "Webhook created successfully.",
    "webhook_information": "This page allows you to create webhooks that can be used to send information about events that have occurred in your store to other systems. For example, you can create a webhook that sends information about new orders to your accounting system.",
    "webhook_topics": "topics",
    "webhook_select_topics": "Select topics",
    "existing_webhooks": "Existing webhooks",
    "webhooks": "Webhooks",
    "webhook_verification_key": "Verification key",
    "order_created": "Order created",
    "order_fulfilment_created": "Order fulfilment created",
    "order_refund_created": "Order refund created",
    "order_updated": "Order updated",
    "order_cancelled_created": "Order cancelled",
    "product_created": "Product created",
    "product_updated": "Product updated",
    "product_deleted": "Product deleted",
    "please_select_at_least_one_topic": "Please select at least one topic",
    "copied_to_clipboard": "Copied to clipboard",
    "webhook_verification_key_tooltip": "The verification key is used to verify that the webhook is sent from 24Nettbutikk. The key is sent in the header of the request and can be used to verify the authenticity of the request.",
    "create_new_webhook": "Create new webhook",
    "updated_at": "Updated",
    "add_webhook": "Add webhook",
    "update_webhook": "Update webhook",
    "category_internal_name_placeholder": "Clothing / Men / Pants ",
    "category_internal_name_description": "Optional, this is useful if you have a complex category structures where multiple categories have the same name, for example: 'Clothing / Men / Pants' vs 'Clothing / Women / Pants', this then allows you to see which category you're dealing with, at a glance.",
    "category_image": "Category image",
    "category_image_description": "Shown on subcategory cards when a parent category displays its subcategories.",
    "category_display_mode": "What this category shows",
    "category_mode_status": "This category is set to \"{mode}\".",
    "category_mode_showing_cards": "Showing category cards right now.",
    "category_mode_showing_products": "Showing products right now.",
    "category_mode_smart": "Smart category",
    "category_mode_change": "Change",
    "display_mode_auto": "Automatic",
    "display_mode_auto_description": "Shows products with filters when the category has products of its own, otherwise the subcategories are shown as clickable category cards.",
    "display_mode_products": "Products",
    "display_mode_products_description": "Shows products from this category and all subcategories.",
    "display_mode_subcategories": "Category cards",
    "display_mode_subcategories_description": "Shows the subcategories of this category as clickable category cards.",
    "category_new_listing_position": "Place new products",
    "new_listing_position_bottom": "At the bottom",
    "new_listing_position_top": "At the top",
    "move_to_top": "Move to top",
    "moved_to_top_of_category": "Moved to the top of the category",
    "main_navigation": "Main navigation",
    "product_not_in_any_manual_categories": "Product is not in any manual categories",
    "product_is_in_the_following_manual_categories": "Product is in the following manual categories",
    "this_category_is_included_in_the_stores_main_menu": "Category is not in the main menu",
    "there_also_exists_{count}_smart_categories_that_are_dynamic_and_might_contain_the_product": "There exists {count} smart categories that are dynamic and might contain the product",
    "read_more": "Read more",
    "categories_help_organize_products_into_groups_...": "Categories help organize products into groups, making it easier for customers to find what they're looking for. A product that is not part of any category can still be accessed in the store, via search or direct link, but will be much harder to find.",
    "add_to_category": "Attach to new category",
    "this_category_is_not_included_in_the_stores_main_menu_and_might_not_be_visible_to_customers": "This category is not included in the store's main menu and might not be visible to customers",
    "are_you_sure_you_want_to_remove_this_product_from_the_category": "Are you sure you want to remove this product from the category?",
    "category": "Category",
    "add_product_to_categories": "Add product to categories",
    "product_added_to_x_categories": "Product added to :count category|Product added to :count categories",
    "menu_view": "Main-menu view",
    "table_view": "Table view",
    "from_here_you_can_view_a_table_of_all_categories_not_already_attached_to_this_product": "From here you can view a table of all categories not already attached to this product",
    "from_here_you_can_see_a_list_of_all_categories_as_listed_in_the_main_menu": "From here you can see a list of all categories as listed in the main menu",
    "smart_category_cannot_be_added": "Smart categories cannot be added",
    "main_menu": "Main menu",
    "other_menus": "Other menus",
    "delete_webhook_confirmation": "Are you sure you want to delete the webhook?",
    "logistics": "Logistics",
    "logistics_providers": "Logistics providers",
    "logistics_updated": "Logistics provider updated",
    "shipping_mapping_saved": "Shipping mapping saved.",
    "shipping_mapping_pickup_locked_error": "This shipping method requires a pickup point and is locked to the correct carrier service.",
    "replace": "Replace",
    "conditional_shipping_price_enabled": "Alternative price adjustment when the order total exceeds amount",
    "condition_modify_type": "Adjust shipping cost",
    "replace_with_with_price": "Replace with price",
    "when_order_total_exceeds": "When order total exceeds",
    "editing": "Editing",
    "close_block_settings": "Close block settings",
    "theme_header_section": "Header",
    "theme_main_section": "Main",
    "theme_footer_section": "Footer",
    "add_block": "Add block",
    "block_is_draft": "Block is a draft, and will not be visible in the store until the theme is saved",
    "block_contains_draft_images": "The block contains draft images, and they won't be visible in the store until you save",
    "invalid_color_value": "Invalid color value {color}",
    "unknown_setting": "Unknown setting",
    "invalid_setting_type": "Invalid setting type",
    "invalid_selection": "Invalid selection",
    "could_not_set_custom_properties_for_media": "Could not set custom properties for media",
    "only_draft_blocks_can_be_deleted": "Only draft blocks can be deleted",
    "shipping_provider": "Logistics provider",
    "shipping_providers": "Shipping providers",
    "shipping_providers_desc": "Enable and configure methods from each provider.",
    "pricing_and_info": "Pricing & info",
    "24Shipping": "24Shipping",
    "store_info_missing_fields": "Store information is missing required fields, please check \"Settings / Store information\", and try again.",
    "edi_client_error": "An error occurred while communicating with the logistics provider. Please try again later.",
    "shipping_product": "Shipping product",
    "label": "Label",
    "link": "Link",
    "an_error_occurred_please_try_again": "An error occurred. Please try again",
    "social_media": "Social media",
    "invalid_url": "Invalid URL",
    "theme_screen_width_warning": "Your screen width is too small for the best experience.",
    "partner_logos": "Partner logos",
    "folder": "Folder",
    "create_new_folder": "Create new folder",
    "no_current_folder": "No current folder",
    "no_folder": "No folder",
    "are_you_sure_you_want_to_delete_folder": "Are you sure you want to delete the folder {folder}? This will also delete all files in the folder.",
    "move_to_folder": "Move to folder",
    "files_moved_to_folder": "Files moved to {folder}",
    "something_went_wrong_during_move": "Something went wrong during move",
    "something_went_wrong_when_creating_folder": "Something went wrong when creating folder",
    "folder_created": "Folder created",
    "folder_deleted": "Folder deleted",
    "something_went_wrong_when_deleting_folder": "Something went wrong when deleting folder",
    "url_copied_to_clipboard": "URL copied to clipboard",
    "showing_x_files_of_y": "Showing {count} of {total} files",
    "showing_x_of_y": "Showing {count} of {total}",
    "add_logos": "Add logos",
    "partner_logos_contains_draft_images": "Partner logos contains draft images, and they will not be visible in the store until the theme is saved",
    "edit_category": "Edit category",
    "create_category": "Create category",
    "search_product_name_or_tags": "Search for product name or tags",
    "edit_product": "Edit product",
    "create_product": "Create product",
    "menus": "Menus",
    "edit_menu": "Edit menu",
    "create_menu": "Create menu",
    "add_menu_item": "Add menu item",
    "products_matching_smart_criteria": "Products matching smart criteria",
    "x_variants_selected": "{count} variant selected | {count} variants selected",
    "set_new_quantity_in_stock_to_x_variants": "Set new quantity in stock to {count} variant | Set new quantity in stock to {count} variants",
    "set_new_price_to_x_variants": "Set new price to {count} variant | Set new price to {count} variants",
    "clear_all_filters": "Clear all filters",
    "no_tags_exists": "No tags exists",
    "manual_categories_filter_description": "Only applies to manual categories",
    "publish": "Publish",
    "unpublish": "Unpublish",
    "publish_products_action_description": "Make the selected products visible to the public",
    "delete_products_action_description": "Delete the selected products, this is irreversible",
    "unpublish_products_action_description": "Make the selected products hidden from the public",
    "add_tags": "Add tags",
    "add_tags_products_action_description": "Add tags to the selected products",
    "set_page_template": "Set page template",
    "set_page_template_action_description": "Assign a page template to the selected products",
    "set_page_template_for_x_amount_of_products": "Set page template for {count} products",
    "set_page_template_modal_description": "Choose a page template for the selected products. \"Default\" resets them to the theme default.",
    "set_google_category": "Set Google category",
    "set_google_category_action_description": "Assign a Google product category to the selected products",
    "set_google_category_for_x_amount_of_products": "Set Google category for {count} products",
    "set_google_category_modal_description": "Search for the category these products belong in. The value is used by the Google Shopping feed.",
    "google_category": "Google category",
    "without_google_category": "Products without a Google category",
    "without_tags": "Products without tags",
    "without_categories": "Products without a category",
    "without_brand": "Products without a brand",
    "without_badges": "Products without badges",
    "set_google_category_preview_blank": "{count} products have no Google category and will get {category}.",
    "set_google_category_preview_existing": "{count} products already have a Google category. Choose whether they keep it or get the new one.",
    "set_google_category_update_all": "Update all {count}",
    "set_google_category_update_blank_only": "Update only the {count} blank ones",
    "set_google_category_checking": "Checking the selected products",
    "search_google_category": "Search for a Google category",
    "searching": "Searching",
    "add_tags_to_x_amount_of_products": "Add tags to {count} product | Add tags to {count} products",
    "add_x_tags": "Add {count} tag | Add {count} tags",
    "add_tags_modal_description": "Any products that already have the selected tags will not have them added again",
    "remove_tags": "Remove tags",
    "remove_tags_products_action_description": "Remove tags from the selected products",
    "remove_tags_from_x_amount_of_products": "Remove tags from {count} product | Remove tags from {count} products",
    "remove_x_tags": "Remove {count} tag | Remove {count} tags",
    "number_of_products": "Number of products",
    "are_you_sure_you_want_to_remove_tag_from_x_products": "Are you sure you want to remove the tag from {count} product? | Are you sure you want to remove the tag from {count} products?",
    "remove_tag_from_products_action_description": "Remove the tag from the selected products",
    "products_with_tag": "Products with tag",
    "smart_categories_using_tag": "Smart categories using tag",
    "delete_tag": "Delete tag",
    "delete_tag_modal_description": "This will remove the tag {name} from {count} product | This will remove the tag {name} from {count} products",
    "tag_deleted": "Tag deleted",
    "are_you_sure_you_want_to_delete_x_tags": "Are you sure you want to delete {count} tag? | Are you sure you want to delete {count} tags?",
    "attribute_values": "Values",
    "delete_attribute": "Delete attribute",
    "delete_attribute_modal_description": "This will remove the attribute {name} and all its values from {count} product. Filtering on the attribute disappears from category pages. | This will remove the attribute {name} and all its values from {count} products. Filtering on the attribute disappears from category pages.",
    "attribute_deleted": "Attribute deleted",
    "are_you_sure_you_want_to_delete_x_attributes": "Are you sure you want to delete {count} attribute? | Are you sure you want to delete {count} attributes?",
    "delete_attributes_action_description": "Delete the selected attributes from all products",
    "edit_attribute_name": "Edit attribute name",
    "edit_attribute_value_name": "Edit attribute value",
    "attribute_rename_consequence": "The name changes everywhere: on {count} product and in category filters. | The name changes everywhere: on {count} products and in category filters.",
    "attribute_value_name_already_in_use": "The attribute already has a value with this name.",
    "products_with_attribute": "Products with {name}",
    "delete_attribute_value": "Delete value",
    "delete_attribute_value_modal_description": "This will remove the value {name} from {count} product. | This will remove the value {name} from {count} products.",
    "attribute_value_deleted": "Value deleted",
    "attribute_values_delete_note": "Attributes are used for filtering on category pages. Deleting a value removes it from every product that has it – and from the category filters.",
    "all_values": "All values",
    "no_attributes_yet": "No attributes yet",
    "no_descriptions_yet": "No descriptions yet",
    "attributes_empty_state_description": "Attributes define fixed characteristics of a product – like color, size or material – and are used for filtering on category pages. You add them while editing a product.",
    "badges": "Badges",
    "delete_badge": "Delete badge",
    "delete_badge_modal_description": "This will remove the badge {name} from {count} product | This will remove the badge {name} from {count} products",
    "badge_deleted": "Badge deleted",
    "delete_badges_action_description": "Delete the selected badges",
    "are_you_sure_you_want_to_delete_x_badges": "Are you sure you want to delete {count} badge? | Are you sure you want to delete {count} badges?",
    "products_with_badge": "Products with badge",
    "remove_badge": "remove badge",
    "remove_badge_from_products_action_description": "Remove the badge from the selected products",
    "are_you_sure_you_want_to_remove_badge_from_x_products": "Are you sure you want to remove the badge from {count} product? | Are you sure you want to remove the badge from {count} products?",
    "edit_menu_item": "Edit menu item {name}",
    "maintenance": "Maintenance",
    "coupon": "coupon",
    "report": "reports",
    "redirect": "redirects",
    "permissions": {
        "users": {
            "view": "can view users",
            "store": "can add users",
            "update": "can update users",
            "destroy": "can delete users",
            "roles": {
                "view": "can view roles",
                "store": "can add roles",
                "update": "can update roles",
                "destroy": "can delete roles"
            }
        },
        "order": {
            "view": "can view orders",
            "edit": "can edit unfulfilled order items",
            "fulfill": "can fulfill orders",
            "refund": "can issue refunds on orders"
        },
        "product": {
            "view": "can view products",
            "create": "can create products",
            "update": "can update products",
            "delete": "can delete products",
            "category": {
                "view": "can view categories",
                "create": "can create categories",
                "update": "can update categories",
                "delete": "can delete categories"
            }
        },
        "blog": {
            "view": "can view blog posts",
            "create": "can create blog posts",
            "update": "can update blog posts",
            "delete": "can delete blog posts"
        },
        "form": {
            "view": "can view forms",
            "create": "can create forms",
            "update": "can edit forms",
            "delete": "can delete forms and their submissions",
            "submission": {
                "view": "can read submissions",
                "manage": "can take, finish and reopen submissions",
                "delete": "can delete submissions"
            }
        },
        "customer": {
            "view": "can view customers",
            "create": "can create customers",
            "update": "can update customers",
            "delete": "can delete customers"
        },
        "coupon": {
            "view": "can view discount codes",
            "create": "can create discount codes",
            "update": "can update discount codes",
            "delete": "can delete discount codes"
        },
        "marketing": {
            "newsletter": {
                "subscriber": {
                    "view": "can view newsletter subscribers",
                    "export": "can export newsletter subscribers"
                }
            },
            "page": {
                "view": "can view marketing pages",
                "create": "can create marketing pages",
                "update": "can edit marketing pages",
                "delete": "can delete marketing pages"
            },
            "review": {
                "view": "can view reviews",
                "publish": "can toggle if a review is published",
                "settings": {
                    "update": "can update review settings"
                }
            }
        },
        "design": {
            "update": "can edit the store's design",
            "menu": {
                "update": "can edit the main menu"
            }
        },
        "report": {
            "view": "can view reports",
            "sales": {
                "view": "can view sales reports",
                "export": "can export sales reports"
            },
            "search": {
                "view": "can view search statistics, such as popular searches and searches without results"
            }
        },
        "redirect": {
            "view": "can view and export redirects",
            "create": "can create redirects manually or via an import",
            "update": "can update redirects manually or via an import",
            "delete": "can delete redirects"
        },
        "webhook": {
            "view": "can view webhooks",
            "create": "can create webhooks",
            "update": "can update webhooks",
            "delete": "can delete webhooks"
        },
        "app-store": {
            "install": "can order and install new apps from the app store",
            "view": "can view installed apps, and any settings / credentials associated with them",
            "update": "can update settings in all existing apps"
        },
        "settings": {
            "view": "can view settings",
            "shipping": {
                "edit": "can change shipping settings"
            },
            "logistics": {
                "edit": "can change logistics settings"
            },
            "payment": {
                "edit": "can change payment settings"
            },
            "store": {
                "status": {
                    "change": "can pull the store in and out of maintenance mode"
                }
            },
            "invoice": {
                "edit": "can edit invoice settings that 24nettbutikk use for billing."
            },
            "analytics": "can manage analysis settings (Google Analytics, Facebook Pixel, etc.)",
            "contact_info.edit": {
                "edit": "can manage the stores contact information, such as phone number and email"
            }
        },
        "category": {
            "view": "can view categories",
            "create": "can create categories",
            "update": "can update categories",
            "delete": "can delete categories"
        },
        "customer_group": {
            "view": "can view customer groups",
            "create": "can create customer groups",
            "update": "can update customer groups",
            "delete": "can delete customer groups",
            "application": {
                "manage": "can approve and reject applications to join a customer group"
            }
        },
        "listings": {
            "view": "can view listings",
            "create": "can create listings",
            "update": "can update listings",
            "delete": "can delete listings"
        },
        "booking": {
            "view": "can view bookings",
            "create": "can create bookings",
            "update": "can update bookings",
            "delete": "can delete bookings"
        },
        "customer_club": {
            "export": "can export the customer club member list"
        },
        "gift_certificate": {
            "view": "can view issued gift cards",
            "manage": "can issue and import gift cards"
        },
        "v1import": {
            "access": "can use the import tool"
        },
        "accounting": {
            "transfer": "can transfer orders and credit notes to Tripletex"
        },
        "ai": {
            "wallet": {
                "manage": "can top up the AI balance and change automatic top-up"
            }
        },
        "experiment": {
            "view": "can view A/B tests and their results",
            "manage": "can create, start and stop A/B tests"
        }
    },
    "you_cant_edit_this_role": "this role cant be edited",
    "you_cant_delete_this_role": "this role cant be deleted",
    "you_cant_edit_this_user": "this user can't be edited",
    "create_role": "Add role",
    "delete_role": "Delete role",
    "update_role": "Update role",
    "payment_not_initiated": "Something went wrong, please try again",
    "order_already_exists": "This order has already been placed.",
    "shipping_method_not_found": "The selected shipping method is no longer available.",
    "total_amount_mismatch": "Payment amount does not match the order total.",
    "roles": "Roles",
    "role": "Role",
    "invite_user": "Invite user",
    "edit_user": "Edit user",
    "delete_user_confirmation": "Are you sure you want to delete the user {name}?",
    "delete_user": "Delete user",
    "delete_role_confirmation": "Warning: If you delete a role, all users with this role will lose access to the associated functions. Are you sure you want to delete this role?",
    "create_api_token": "API Key",
    "add_renew_api_token_explanation": "Here you can generate API keys to provide access to third-party applications. If you believe your key has been compromised, you can generate a new key to replace the old one. Note that this key is linked to your user and only grants third parties the accesses that you have.",
    "personal_access_token": "Personal access token. The key is only shown once. After that, it will never be shown again. Copy and store it securely.",
    "personal_access_token_encrypted": "The key is encrypted. Delete and create a new one.",
    "no_personal_access_token": "No Personal Access Token",
    "images_uploaded_successfully": "images uploaded successfully",
    "images_deleted": "images deleted",
    "image_alt_text_updated": "Image text was updated",
    "warning_removing_your_admin_rights": "Warning: You are about to remove your own admin rights. If you continue, you might not be able to restore your admin rights.",
    "changes_could_not_be_saved": "Changes could not be saved. Please try again.",
    "profile_saved_but_roles_were_not": "The profile was saved, but the roles were not. Please try again.",
    "warning_add_at_least_one_role": "Warning: You must add at least one role to the user",
    "role_names": {
        "admin": "admin",
        "accountant": "accountant",
        "writer": "writer",
        "designer": "designer",
        "order expediter": "order expediter"
    },
    "my_new_role_placeholder": "My new role",
    "multiple_sales_prices_error": "You cannot set multiple sales prices if one does not have an end date.",
    "edit_order_recipient": "Edit order recipient",
    "order_recipient": "Order recipient",
    "first_name": "First name",
    "last_name": "Last name",
    "organization_number": "Organization number",
    "purchase_order_number": "Purchase order number",
    "zip_code": "Zip code",
    "zip": "zip code",
    "street": "Street",
    "klarna_checkout": "Klarna Checkout",
    "vipps_express": "Vipps Express",
    "app_store.purchase_success": "The app was successfully purchased!",
    "app_store.name": "App Store",
    "apps": "Apps",
    "my_apps": "My apps",
    "vipps_express_app_description": "The customer can pay with Vipps Express directly from the product page, so they don't have to go through the checkout in the online store. It doesn't get easier than this!",
    "integration": "Integration",
    "free": "Free",
    "beta": "Beta",
    "reset": "Reset",
    "frequently_asked_questions": "Frequently asked questions",
    "vipps_express_landing_order_now": "Order now",
    "vipps_express_landing_why_choose_vipps_express": "Why choose Vipps Express?",
    "vipps_express_landing_a_faster_way_for_your_customers_to_pay": "A faster and frictionless way for your customers to pay for your products",
    "vipps_express_landing_more_than_3_million_norwegians_already_have_vipps": "More than 3 million Norwegians already have Vipps, and enjoy using it",
    "vipps_express_landing_faq_q_is_the_order_management_integrated": "Is the order management integrated?",
    "vipps_express_landing_faq_a_is_the_order_management_integrated": "Yes, just like with regular vipps orders, the order managment is fully integrated, so you never have to leave the 24Nettbutikk admin to manage your orders.",
    "vipps_express_landing_faq_q_what_is_the_expected_payment_time": "What is the expected payment time?",
    "vipps_express_landing_faq_a_what_is_the_expected_payment_time": "Usually the payment from vipps is done on a daily basis, but in some cases it can take up to 48 hours. No payments are made during the weekends.",
    "vipps_express_landing_faq_q_how_much_does_vipps_cost": "How much does it cost?",
    "vipps_express_landing_faq_a_how_much_does_vipps_cost": "Vipps Express is free to use, but you will still have to pay the regular vipps fees.",
    "vipps_express_landing_faq_q_im_stuck_what_do_i_do": "I'm stuck, what do I do?",
    "vipps_express_landing_faq_a_im_stuck_what_do_i_do": "We'd love to help you, feel free to contact us via either phone (22 33 66 88) free of charge.",
    "vipps_express_landing_faq_q_can_i_use_vipps_express_without_vipps": "Can I use Vipps Express without regular Vipps?",
    "vipps_express_landing_faq_a_can_i_use_vipps_express_without_vipps": "No, you need to have regular Vipps configured in order to use Vipps Express. The credentials are shared between the two apps.",
    "vipps_express_settings": {
        "note": "Note",
        "vipps_credentials_must_be_defined_by_24nb": "Vipps credentials must be defined by 24Nettbutikk. If you have ordered Vipps, but have not received these, please contact support.",
        "the_vipps_credentials_are_shared_between_all_vipps_payment_methods": "The Vipps credentials are shared between all Vipps payment methods, its not possible to have different credentials for vipps express and regular vipps payments."
    },
    "ie": "I.E.",
    "unable_to_configure_vipps_express_without_vipps_credentials": "Unable to activate Vipps Express without Vipps first configured. Check that vipps is enabled and configured, and try again.",
    "toggle_the_app_on_or_off": "Toggle the app on or off",
    "customer_details_update_failed": "Could not update the customer details; communication with the payment provider failed.",
    "header_icon_color_description": "Color of the header icons that signal important notices like the cart item count. Match it to your store's style.",
    "header_icon_size_description": "Changes the size of the header icons. Applies to all screen sizes.",
    "header_icon_weight_description": "Changes the thickness of the header icons. Applies to all screen sizes.",
    "icon_stroke_width": "Icon stroke width",
    "sticky_header": "Sticky header",
    "sticky_header_description": "When this option is enabled, the top menu of the shop will remain visible at the top of the screen as the user scrolls down the page.",
    "main_navigation_style": "Navigation style",
    "main_navigation_style_description": "Choose how the main menu is shown on desktop. \"Row\" shows the top-level items in a row with a mega menu or drop-down. \"All categories\" puts a button first in the menu that opens a panel with the whole category tree: top-level items in a list on the left and their subcategories in columns on the right. Suits stores with many menu items.",
    "main_navigation_style_row": "Row",
    "main_navigation_style_categories": "All categories",
    "gap_between_images": "Gap between images",
    "image_mode": "Image mode",
    "url": "URL",
    "attributes": "Attributer",
    "add_an_attribute": "Add an attribute",
    "add_another_attribute": "Add another attribute",
    "attribute_value": "Attribute value",
    "attribute_input_info": "Create a new one by typing, or pick a value from the list",
    "add_attribute_info": "Pick an existing value from the list, or create a new one by typing the name of the value. The list also includes variant options not used on this product, since those cannot be combined with attributes.",
    "attributes_tooltip_text": "Attributes let you define fixed properties of a product – such as colour, size or material – used for filtering on the category pages. They are not shown on the product page and cannot be chosen by customers. <br><br> Use attributes when the product has only one value per property.<br><br>Note: you cannot add an attribute with a name (such as “Colour”) if the product already uses that name as a variant option. Attribute names must be unique per product and cannot overlap with variant names.",
    "incorrect_password": "Incorrect password",
    "wishlist": "Favorites",
    "wishlist_description": "Let the customer add products to a favorites list, so they can easily find and compare them later.",
    "wishlist_landing_let_your_customer_easily_create_a_list_of_their_favourite_products": "Let the customer easily create a list of their favorite products, for simple retrieval and comparison.",
    "wishlist_landing_does_it_cost_anything": "Does it cost anything?",
    "wishlist_landing_no_its_free": "No, it's free.",
    "wishlist_landing_can_the_user_share_their_favourites": "Can the user share their favorites?",
    "wishlist_landing_no_this_is_a_simple_list_to_allow_the_user_to_more_easily_find_and_compare_their_favourite_products": "No, this is a simple list to allow the user to more easily find and compare their favorite products. It contains no sharing or saving functionality.",
    "order_now": "Order now",
    "theme_editor_border_radius": {
        "label": "Border radius",
        "description": "Adjusts the border radius of elements in the webshop",
        "0px": "None (0px)",
        "4px": "Small (4px)",
        "6px": "Medium (6px)",
        "8px": "Large (8px)"
    },
    "theme_editor_font_heading": {
        "label": "Heading Font",
        "description": "Choose the font family that will be applied to all heading levels. This determines how your section titles and page headlines look"
    },
    "theme_editor_font_body": {
        "label": "Body text Font",
        "description": "Select the font family that will be used for all regular body text (paragraphs, lists, captions, and any non-heading content)"
    },
    "theme_editor_body_line_height": {
        "label": "Body line height",
        "description": "How much space there is between lines of body text. Affects readability of longer text like product descriptions, blog posts, and FAQ answers"
    },
    "theme_editor_heading_transform": {
        "label": "Heading text case",
        "description": "Force all headings to uppercase or capitalized form. Commonly used in fashion, beauty, and luxury branding"
    },
    "theme_editor_heading_letter_spacing": {
        "label": "Heading letter spacing",
        "description": "Tighten or loosen the space between letters in headings. Tight for modern/tech feel, wide for luxury/elegant feel"
    },
    "compact": "compact",
    "comfortable": "comfortable",
    "relaxed": "relaxed",
    "capitalize": "Capitalize",
    "letter_spacing_tight": "tight",
    "letter_spacing_wide": "wide",
    "letter_spacing_wider": "extra wide",
    "theme_editor_content_max_width": {
        "label": "Content max width",
        "description": "Sets the maximum width of the content area in your webshop. This affects how wide the text and images can be displayed"
    },
    "theme_editor_is_full_width": {
        "label": "Full-width",
        "description": "Determines whether the block spans the full width of the screen or stays within the content width from the theme settings"
    },
    "theme_editor_full_width_overridden_by_global": "The whole store is set to full width in the global layout, so this option has no effect right now.",
    "theme_editor_go_to_global_layout": "change in global layout",
    "theme_editor_stock_status_overridden_by_global": "Stock status is turned off in the global settings, so this option has no effect right now.",
    "theme_editor_go_to_global_settings": "change in global settings",
    "change_image_on_hover": {
        "label": "Change image on hover",
        "description": "Enable/disable swapping to the 2nd image on hover"
    },
    "theme_editor_product_box_border": {
        "label": "Product box border",
        "description": "Determines whether the product boxes should have a border around them",
        "default": "Default",
        "thick": "Thick border",
        "none": "None"
    },
    "overlay_active": "Overlay",
    "overlay_active_description": "Applies a coloured layer over the video to improve contrast behind the title, text or button. Recommended only when you have content over the video.",
    "parallax_effect": "Parallax effect",
    "hero_background_image_text": "Text with background image",
    "theme_editor_image_edited_successfully": "Image edited. The changes become visible when you save",
    "apply_overlay_to_all_images": "Apply style to all",
    "apply_style_to_all_images_tooltip": "Copy colors, sizes, placement and button styling to every image in the block. Titles, text, button labels and button links stay per image.",
    "confirm_apply_style_to_all_images": "This will copy the style (colors, sizes, placement, button styling) to every other image in this block. Titles, text, button labels and button links stay per image. Continue?",
    "theme_editor_overlay_applied_to_all": "Style applied to all images. The changes become visible when you save",
    "content_full_width": "Content is full width",
    "hide_all_menu_items": "Hide all menu items",
    "show_all_menu_items": "Show all menu items",
    "add_menu_item_child_tooltip": "Add sub menu item",
    "edit_menu_item_tooltip": "Edit menu item",
    "delete_menu_item_tooltip": "Delete menu item",
    "disable_menu_item_tooltip": "Hide menu item in the store",
    "enable_menu_item_tooltip": "Show menu item in the store",
    "menu_depth_exceeds_three_levels_exception_message": "Menu depth cannot exceed three levels",
    "i_have_more_questions_or_feedback": "I have more questions or feedback",
    "we_would_love_to_talk_to_you_find_more_information_about_where_to_reach_us_here": "We'd love to answer any questions you might have, find more information about how to contact us <a class='link' href='https://www.24nettbutikk.no/kontakt' target='_blank'>here.</a>",
    "feel_free_to_contact_support_at": "Please contact support by phone 22 33 66 88, chat via 24nettbutikk.no, or at email {email}",
    "stock_notifications": "Stock notifications",
    "stock_notification": "Stock notification",
    "stock_notification_description_label": "Description",
    "stock_notification_button_text": "Button text",
    "stock_notification_description": "Hard du determine what products to order into stock? Let your customers register their interrest, and alert them when the product is back in stock!",
    "stock_notification_delete_confirmation": "The notification is deleted",
    "count_of_recipients": "Number of recipients",
    "variant_options": "Variant",
    "send_notifications": "Send notifications",
    "stock_notification_email_greeting": "Hi 👋!",
    "stock_notification_email_message": "Good news! The product you have shown interest in – %s – is now back in stock. 🎉 Be quick! There is high demand, and we cannot guarantee how long it will be available.",
    "stock_notification_button": "Go to product",
    "stock_notification_email_farewell": "If you have any questions, reply to this email or contact us at",
    "allow_stock_notifications": "Allow back-in-stock notifications",
    "allow_users_to_sign_up_for_notification_when_product_comes_back_in_stock": "Allow users to sign up for a email notification when a product comes back in stock. This adds a form on the product page where users can sign up.",
    "stock_notification_already_subscribed": "You'll receive an email when the product is back in stock",
    "stock_notification_subscription_success": "You'll receive an email when the product is back in stock",
    "stock_notification_back_in_stock": "Back in stock",
    "stock_notification_success_sent": "Notifications sent",
    "stock_notification_error_sent": "Something went wrong when sending notifications. Contact support.",
    "stock_notification_view_subscribers": "View subscribers",
    "stock_notification_subscribers_title": "Subscribers – {product}",
    "stock_notification_back_to_report": "Back to stock notifications",
    "stock_notification_variant_buyable": "Available to buy",
    "stock_notification_variant_sold_out": "Not available yet",
    "stock_notification_waiting_count": "{count} waiting to be notified",
    "stock_notification_open_product": "Open product",
    "stock_notification_subscriber_email": "Email",
    "stock_notification_subscriber_customer": "Customer",
    "stock_notification_subscriber_phone": "Phone",
    "stock_notification_subscribed_at": "Subscribed",
    "stock_notification_view_customer": "View customer",
    "stock_notification_guest": "Guest",
    "stock_notification_no_subscribers": "No one is waiting to be notified about this variant right now.",
    "stock_notification_send_confirm_title": "Send notifications now?",
    "stock_notification_send_confirm_text": "Everyone on the list ({count}) will get an email saying the product is back in stock. This can't be undone.",
    "stock_notification_send_disabled_hint": "Clear the selection to notify everyone who is waiting.",
    "stock_notification_remove_subscribers": "Remove from list",
    "stock_notification_remove_subscribers_description": "Without sending an email",
    "stock_notification_remove_confirm_title": "Remove {count} from the list?",
    "stock_notification_remove_confirm_text": "They won't get an email when the product is back in stock. This can't be undone.",
    "stock_notification_subscribers_removed": "Removed from the list",
    "new_product": "New product",
    "create_new": "Create new",
    "copy": "Copy",
    "copy_this_product": "Copy this product",
    "copy_product": "Copy product",
    "product_copy": {
        "title": "Copy product",
        "description": "Copy the product into an entirely new product and edit the new product with the same properties as the existing one",
        "copyable_lead_paragraph": "Lead paragraph",
        "copyable_descriptions": "Product description/tabs",
        "copyable_categories": "Categories",
        "copyable_variants": "Variants and options",
        "copyable_attributes": "Attributes",
        "copyable_price": "Price",
        "copyable_offers": "Sale prices",
        "copyable_images": "Images",
        "copyable_tags": "Tags",
        "copyable_stock": "Stock",
        "copyable_stock_notifications": "Stock notifications",
        "copyable_shipping": "Shipping",
        "copyable_google_product_category": "Google product category",
        "copyable_meta_title_and_description": "Search engine optimization",
        "offers_disabled": "Price must be enabled for sale prices to be copied"
    },
    "product_copy_exception_message": "Product copy failed",
    "product_copy_success_message": "Product copied successfully",
    "nothing_is_broken_but_i_have_some_feedback": "Nothing is broken, but I have some feedback",
    "something_is_not_working": "Something is not working",
    "product-box-image-object-fit": "Image fit",
    "contain": "Contain",
    "cover": "Cover",
    "product-box-image-aspect-ratio": "Image aspect ratio",
    "product_box_image_fit_title": "How should the product image be shown?",
    "product_box_image_fit_description": "Choose whether the full image should be visible, or whether the image should fill the frame (and possibly be cropped).",
    "product_box_image_fit_contain": "Show the whole image",
    "product_box_image_fit_cover": "Fill the frame",
    "product_box_image_shape_title": "Product image shape",
    "product_box_image_shape_description": "Sets the shape of the image area in the product card. Pick the one that best fits your product photos.",
    "product_box_aspect_square": "Square (1:1)",
    "product_box_aspect_landscape": "Landscape (4:3)",
    "product_box_aspect_landscape_wide": "Wide landscape (3:2)",
    "product_box_aspect_widescreen": "Widescreen (16:9)",
    "product_box_aspect_portrait": "Portrait (3:4)",
    "product_box_aspect_portrait_tall": "Tall portrait (9:16)",
    "title_of_list": "Title of list",
    "you_also_need_this": "You also need this",
    "related_products_placement_moved_description": "The placement of related products is now configured in the product design editor.",
    "related_products_placement_moved_description_short": "Placement is set per template in the design builder, on the product page.",
    "related_products_placement_moved_cta": "Open product design editor",
    "grid": "Grid",
    "slider": "Slider",
    "drag_between_zones_hint": "Drag between the right column and full-width zones",
    "both_ways": "Both ways",
    "product_connections": "Connected products",
    "no_products_connected": "No products connected",
    "connection_list_max_listings_exceeded": "You can connect at most :max products. Remove some to be able to save.",
    "connection_list_limit_reached": "The limit of {max} connected products has been reached. Remove some to add more.",
    "connection_list_title_required": "The list needs a title before the connected products can be saved.",
    "connection_list_title_too_short": "The list title must be at least :min characters.",
    "connection_list_title_required_hint": "The title is shown above the list on the product page, and is required once you have added products.",
    "listing_picker_remaining_slots": "You can select {count} more",
    "listing_picker_limit_reached": "You cannot select more. Remove some from the list to add more.",
    "connection_list_remove_reciprocal_modal": {
        "title": "Confirm removal",
        "description": "<strong>«{reciprocalProductName}»</strong> is currently mutually connected to <strong>«{currentProductName}»</strong>.<br><br>Do you want to:<ul class='list-disc pl-3'><li>Only remove «{reciprocalProductName}» from this list</li><li>Or also remove «{currentProductName}» from «{reciprocalProductName}»’s connection list?</li></ul>",
        "remove_single": "Remove from this list",
        "remove_both": "Remove from both lists"
    },
    "add_filter": "Add filter",
    "connect_to_a_product": "Connect to a product",
    "connect_to_a_product_action_description": "Connect the selected products to another product",
    "product_connection_action_modal": {
        "connecting_x_amount_to_product_y": "Connecting {n} product to product {productName} | Connecting {n} products to product {productName}",
        "existing_connection_list": "We already found a list of connected products on {productName}.<br>The products you have selected will be added to this list.<br>If you wish to change the title and placement of this list, you can do so above.<br>Note: we have pre-filled the title and placement with the values from the existing list."
    },
    "products_were_connected": "Products were connected!",
    "product_bulk_connection_catch_all_exception_message": "Something went wrong while connecting products",
    "product_bulk_connection_too_few_products_exception_message": "You must select at least two products to connect",
    "connect_products_to_each_other": "Connect to each other",
    "connect_many_to_many_action_description": "Connect the selected products to each other so they appear in each other's connected products lists",
    "overwrite_product_list_data": {
        "label": "Overwrite any existing lists’ title and placement",
        "description": "When enabled, the title and placement of all already created connected product lists will be overwritten with the new values you specify. If one or more products do not have a list, a new list will be created for them with the values you set."
    },
    "product_connections_app_description": "Create custom product lists—set title and placement, choose one- or two-way connections for automatic mirroring, and display them directly on the product page",
    "report_a_bug": "Report a bug",
    "send": "Send",
    "required": "Required",
    "describe_the_bug": "Describe the bug",
    "give_feedback": "Give feedback",
    "your_feedback": "Your feedback",
    "add_a_screenshot": "Add a screenshot",
    "remove_screenshot": "Remove screenshot",
    "google_analytics_disabled": "Google Analytics is disabled",
    "location": "Stock location",
    "hide": "Hide",
    "search_for_products": "Search for products",
    "search_query": "Search query",
    "question": "Question",
    "answer": "Answer",
    "faq": "FAQ",
    "faqs": "FAQs",
    "add_faq": "Add FAQ",
    "edit_faq": "Edit FAQ",
    "delete_faq": "Delete FAQ",
    "are_you_sure_delete_faq": "Are you sure you want to delete the FAQ?",
    "faq_answer_layout": "Answer display",
    "faq_answer_layout_description": "\"Drawer from the right\" opens the answer in a panel sliding in from the side instead of below the question.",
    "faq_answer_layout_accordion": "Below the question",
    "faq_answer_layout_drawer": "Drawer from the right",
    "faq_is_full_width_description": "Whether the coloured surface spans the full screen width or sits as a box within the content width from the theme settings.",
    "faq_content_width": "Content width",
    "faq_vertical_padding": "Space above and below",
    "faq_question_size": "Question font size",
    "faq_question_weight": "Question font weight",
    "faq_answer_size": "Answer font size",
    "option_button_background_color": "Button background color",
    "option_button_text_color": "Button text color",
    "option_button_colors_description": "Applies to unselected buttons. The selected button follows the theme's call-to-action colors.",
    "accordion_initial_state": "Sections open on load",
    "accordion_initial_state_first": "Only the first",
    "accordion_initial_state_all": "All",
    "accordion_initial_state_none": "None",
    "accordion_icon_style": "Icon",
    "accordion_icon_style_plus_minus": "Plus and minus",
    "accordion_icon_style_chevron": "Arrow up/down",
    "faq_description": "Show an FAQ page on the front page of the store",
    "faq_answer_created": "Answer created",
    "faq_answer_deleted": "Answer deleted",
    "faq_app_description": "FAQ pages allows you to describe products and other things to reduce customer service tickets.",
    "faq_why_use_description": "FAQ pages.",
    "faq_description_first": "FAQ pages can reduce the number of inquiries to customer service by providing clear and accessible answers to common questions.",
    "faq_description_second": "FAQ pages can be displayed on the front page of the online store and added as menu items in various menus throughout the store.",
    "faq_is_now_installed": "FAQ is now enabled and ready to use!",
    "click_here_to_begin": "Click here to begin",
    "original_order_total": "Original order total",
    "view_order_(sincos)": "View payment gateway order (sincos)",
    "preposition_from": "from",
    "preposition_of": "of",
    "quantity_will_be_restocked": "{quantity} item(s) will be restocked",
    "sort_products_by": "Sort products by this order",
    "latest_first": "newest first",
    "oldest_first": "oldest first",
    "category_order": "category order",
    "lowest_price_first": "lowest price first",
    "highest_price_first": "highest price first",
    "alphabetical_a_to_z": "alphabetical (A–Z)",
    "shuffle_products": "Show in random order",
    "shuffle_products_description": "The products are shuffled on every visit. The sorting decides which products are shown.",
    "show_out_of_stock": "Include products that are out of stock",
    "otherwise_show_products_in_stock_or_not_tracking_stock_or_that_allow_backorder": "Otherwise, show products that are either in stock, not tracking stock, or that allow backorders",
    "are_you_sure_you_want_to_publish_{count}_products": "Are you sure you want to publish {count} product and make it visible in the store? | Are you sure you want to publish {count} products and make them visible in the store?",
    "are_you_sure_you_want_to_unpublish_{count}_products": "Are you sure you want to unpublish {count} product and make it hidden from the store? | Are you sure you want to unpublish {count} products and make them hidden from the store?",
    "cost_per_unit": "Cost per unit excluding VAT",
    "remove_selection": "Remove selection",
    "export_fulfilled_orders": "Export fulfilled orders (CSV)",
    "export_fulfilled_order_lines": "Export fulfilled order lines (CSV)",
    "export_products": "Export products",
    "export_products_action_description": "Export products and variants to a CSV file",
    "recheck_hs_codes": "Re-check HS codes",
    "recheck_hs_codes_action_description": "Compare the saved HS codes of the selected products with a new AI suggestion",
    "export_unfulfilled_orders": "Export unfulfilled orders (CSV)",
    "export_unfulfilled_order_lines": "Export unfulfilled order lines (CSV)",
    "item_:name_changed_:changes": "item \":name\" changed :changes",
    "unit_price_from_:old_to_:new": "Unit price from :old to :new",
    "order_total_changed_from_:old_to_:new.": "Order total was changed from :old to :new.",
    "shipping_was_cancelled": "Shipping was cancelled",
    ":count_items_were_cancelled_:items": ":count item(s) were cancelled",
    ":count_items_were_cancelled_including_shipping_:items": ":count item(s) were cancelled (:items), including shipping",
    ":count_items_were_cancelled_returning_stock_:items": ":count item(s) were cancelled (:items), returning their quantity to stock",
    ":count_items_were_cancelled_including_shipping_returning_stock_:items": ":count item(s) were cancelled (:items), returning their quantity to stock, shipping was also cancelled.",
    "order_was_placed_by_:name_totaling_:total": "Order was placed by :name, totaling :total.",
    "canceling_a_total_of_:sum": "Canceling a total of :sum",
    "_was_changed_from_:from_to_:to": " was changed from :from to :to",
    "shipped_with": "shipped with",
    "the_customer_was_notified": "the customer was notified",
    "fulfillment_:fulfillmentId_was_made": "Fulfillment :fulfillmentId was made",
    "refund_:refundId_was_made": "Refund :refundId was made",
    "fulfillment_was_made": "Fulfillment was made",
    "order_was_placed": "Order was placed",
    "order_recipient_was_updated": "Order recipient was updated",
    "customer_requested_cancellation": "Customer requested cancellation",
    "customer_requested_credit_or_return": "Customer requested credit / return",
    "customer_:email_submitted_request_from_mypage": "Customer :email submitted the request from MyPage.",
    "customer_cancellation_request_subject": "Cancellation request registered",
    "customer_credit_request_subject": "Credit request registered",
    "merchant_cancellation_request_subject": "Customer requested cancellation — order #:orderId",
    "merchant_credit_request_subject": "Customer requested credit — order #:orderId",
    "customer_cancellation_request_body": "Hi! Your cancellation request has been registered and will be processed as soon as possible. A confirmation has been sent to your email address.",
    "customer_credit_request_body": "We have registered your request to return one or more products.\n\nYou have received an email with information about how to return the items. The same email also contains the cancellation form (right of withdrawal), which must be filled out and included with the returned items.\n\nWe recommend that you read our terms of sale and return policy before sending the items back.",
    "read_our_terms_and_return_policy": "Read our terms of sale and return policy",
    "merchant_cancellation_request_body": "Customer :customerName (:customerEmail) has requested cancellation of order #:orderId via MyPage. Please handle this request in the admin interface.",
    "merchant_credit_request_body": "Customer :customerName (:customerEmail) has requested credit / return of order #:orderId via MyPage. The order has shipped — await the return before crediting.",
    "hi": "Hi",
    "item": "Item",
    "requested_items": "Requested items",
    "contact_us_at": "Questions? Contact us at",
    "unknown_order_item": "Unknown order item.",
    "item_already_fully_requested": "Every unit of \":title\" has already been requested.",
    "item_quantity_exceeds_remaining": "You can request at most :remaining of \":title\".",
    "please_select_at_least_one_item": "Select at least one item to submit a request.",
    "order_items_were_cancelled": "Order items were cancelled",
    "order_items_were_updated": "Order items were updated",
    "orders_with_customer_details": "Orders with customer details",
    "order_lines": "Order lines",
    "items_were_restocked": "items were restocked",
    "refund_was_made": "Refund was made",
    "gift_certificate_payment_refunded": "Gift certificate amount restored",
    "gift_certificate_payment_refunded_:amount_to_:code": ":amount restored to gift certificate :code",
    "gift_certificate_coverage_released": "Gift certificate restored",
    "gift_certificate_coverage_released_:amount_to_:code": ":amount restored to gift certificate :code",
    "reason": "Reason",
    "shipping_price_was_updated": "Shipping price was updated",
    "pickup_point_was_updated": "Pickup point updated",
    "pickup_point_was_set_to_:point": "Pickup point set to :point",
    "pickup_point_was_auto_assigned": "Pickup point auto-assigned",
    "pickup_point_was_auto_assigned_to_:point": "Nearest pickup point was auto-assigned: :point",
    "shipping_price_was_updated_from_:old_to_:new": "Shipping price was changed from :old to :new",
    ":name(:email)_wrote": ":name (:email) wrote comment:",
    "comment_was_added": "Comment was added",
    "changes_made": "Changes made: ",
    "quantity_from_:old_to_:new": "Quantity changed from :old to :new",
    "select_country": "Select country",
    "no_access_to_this_page": "You do not have access to this page",
    "customer.accountNumber": "Customer account number",
    "customer.account": "Customer Account",
    "customer.edit": "Edit customer account",
    "customer.billing.first_name": "First Name",
    "customer.billing.last_name": "Last Name",
    "customer.billing.company": "Company",
    "customer.billing.street": "Street Address",
    "customer.billing.postal_code": "Postal Code",
    "customer.billing.city": "City",
    "customer.billing.country": "Country",
    "customer.billing.email": "Email Address",
    "customer.billing.phone_number": "Phone Number",
    "customer.billing.company_name": "Company Name",
    "customer.billing.organization_number": "Organization Number",
    "customer.billing.company_project": "Project",
    "customer.billing.company_department": "Department",
    "customer.shipping.first_name": "First Name",
    "customer.shipping.last_name": "Last Name",
    "customer.shipping.company": "Company",
    "customer.shipping.street": "Street Address",
    "customer.shipping.postal_code": "Postal Code",
    "customer.shipping.city": "City",
    "customer.shipping.country": "Country",
    "customer.shipping.email": "Email Address",
    "customer.shipping.phone_number": "Phone Number",
    "customer.shipping.company_name": "Company Name",
    "customer.shipping.organization_number": "Organization Number",
    "customer.shipping.company_project": "Project",
    "customer.shipping.company_department": "Department",
    "customer.customers_active_address": "Customer’s default address",
    "customer.is_the_customer_a_business": "Is the customer a business?",
    "customer.uses_shipping_address": "Does the customer use a shipping address?",
    "customer.shipping_address": "Shipping Address",
    "customer.customer_type": "Customer Type",
    "customer.number": "Customer Number",
    "customer.customer_created": "Customer was created",
    "customer.customer_updated": "Customer was updated",
    "customer.customer_deleted": "Customer was deleted",
    "customer.are_you_sure_you_want_to_delete_this_customer": "Are you sure you want to delete this customer's account?",
    "customer.select_country": "Select country",
    "customer.impersonate_customer_tooltip": "By clicking here, you will be logged in as this customer, and you will see the webshop exactly as they see it. You can also add products to the cart and complete an order as this customer.",
    "admin_login_failed": "Login failed",
    "admin_password_reset_link_sent": "Password reset email sent. Please check your inbox.",
    "admin_password_reset_link_failed": "Password reset email could not be sent. This is usually because you have tried this too many times in a short period. Please try again in a few minutes.",
    "admin_password_reset_success": "Your password has been changed. You can now log in with the new password.",
    "admin_password_reset_failed": "Your password could not be changed. This may be because you have tried this too many times in a short period. Please try again in a few minutes.",
    "reset_your_password": "Reset your password",
    "you_recently_requested_to_reset_your_account_password": "You recently requested to reset your account password.",
    "if_you_ignore_this_message_your_password_will_not_be_changed": "If you ignore this message, your password will not be changed.",
    "click_here_to_reset_your_password": "Click here to reset your password",
    "if_you_didnt_request_a_password_reset": "If you didn't request a password reset, ",
    "please_contact_us": "please let us know",
    "please_verify_your_email": "Please verify your email",
    "verify_email_address": "Verify email address",
    "welcome_to_our_store": "Welcome to :storeName 👋",
    "youve_created_an_account_in_our_store": "You've created an account in our store.",
    "verification_email_info_text": "The last step before you can utilize the account, is to verify your email address.",
    "password_reset_mail": "Reset password",
    "note_about_passwords": "Note about passwords.",
    "when_you_have_created_the_customer_on_behalf_of_the_user_they_must_select_their_own_password_using_the_lost_password_functionality": "When you have create the account on behalf of the user, they must create their own password, using the Forgotten password function.",
    "you_recently_requested_to_reset_your_storename_account_password": "Someone recently requested to reset your :storeName account password, if this was not you, you can disregard this email.",
    "this_will_be_the_customers_default_address_when_creating_new_orders": "This will be the customers default address when they create new orders",
    "it_will_not_change_the_address_on_existing_orders": "It will not change the address selected on existing orders",
    "customer_has_no_account": "Customer has not created an account",
    "a_customer_account_with_this_email_address_already_exists": "A customer account with this email address already exists",
    "account_details": "Account details",
    "order_history": "Order history",
    "key_figures": "Key figures",
    "no": "no",
    "yes": "yes",
    "has_created_account": "has created account",
    "has_account": "Has account",
    "click_here_to_show_orders": "click here to show orders",
    "has_the_customer_registered_for_an_account_in_the_store_or_have_they_just_completed_a_purchase_without_doing_so": "Has the customer registered for an account in the store, or have they just completed a purchase without doing so?",
    "Billing-/_Shipping_address": "Billing- /Shipping address",
    "first_order_placed": "First order placed",
    "last_order_placed": "Latest order placed",
    "total_income": "Total income",
    "total_ordered": "Total ordered",
    "total_cancelled": "Total cancelled",
    "total_refunded": "Totalt refunded",
    "if_multiple_names_appear_here_that_means_that_the_same_customer_(identified_via_email)_has_ordered_with_multiple_names": "If multiple names appear here, that means that the same customer (identified via the same email address) has ordered under multiple names.",
    "key_figures_income_tooltip": "The amount of income you've had from this customer, subtracting any refunds and cancellations that have been made.",
    "key_figures_ordered_tooltip": "The total amount this customer has ordered from the store, not subtracting any refunds or cancellations.",
    "vipps_login_no_user_found": "It does not appear that you have an account in this store, please register one.",
    "vipps_login": "Vipps login",
    "vipps_login_description": "Let your users skip usernames and passwords, Vipps login allows your returning customers to easily log in to your store via the vipps app on their phone. With Vipps's more than 11 million users in the nordics, pretty much everyone can use it.",
    "vipps_login_does_it_cost_anything": "Does this cost anything?",
    "vipps_login_no_its_free": "No, this feature is free, while not usually a free feature in Vipps, trough 24Nettbutikk's collaboration with Vipps, we're pleased to bring it to your webshop, free of charge :)",
    "vipps_login_does_it_require_the_store_to_have_vipps_as_a_payment_method": "Does it require my webshop to use vipps payment methods?",
    "company_type": "Company type",
    "company_product_category": "Product category",
    "desired_domain": "Desired domain",
    "billing_interval": "Billing interval",
    "bought_by": "Bought by",
    "not_shipped": "Not shipped",
    "date_bought": "Date bought",
    "customer_number": "Customer no.",
    "name/company": "Name/company",
    "date_shipped": "Date shipped",
    "stock_notification_landing_header_text": "Stock notification – win back customers when the item is back in stock",
    "stock_notification_subheading": "Sold out products don't have to mean lost sales. With Stock Notification, your customers can easily sign up on a list and be notified as soon as the item is back in stock.",
    "stock_notification_how_it_works_1": "<strong>Easy sign-up</strong> – customers register directly on the product page if the item is sold out.",
    "stock_notification_how_it_works_2": "Stock notification is also activated if you sell multiple variants of the product. For example, the stock notification will appear if the customer selects a size that is sold out.",
    "stock_notification_how_it_works_3": "<strong>Full control</strong> – you choose which products should have the stock notification feature.",
    "stock_notification_how_it_works_4": "<strong>Overview in the admin panel</strong> – see who is waiting for the items and how much interest there is.",
    "stock_notification_how_it_works_5": "<strong>Choose who to notify</strong> – send emails to everyone on the list, or only to selected customers.",
    "mailmojo_connection_success": "Your Mailmojo account is now connected to your webshop!",
    "mailmojo_connection_failed": "Could not connect to your Mailmojo account. Please try again, or contact support if the problem persists.",
    "mailmojo_configure_settings_label": "Click here to link your webshop to your Mailmojo account.",
    "mailmojo_configure_settings_button": "Link to Mailmojo",
    "mailmojo": "Mailmojo",
    "mailmojo_description": "Easily send newsletters and e-mail campaigns to your customers using Mailmojo.",
    "mailmojo_landing_header_text": "Mailmojo – simple newsletters straight from your online store. Do you want to stay in touch with your customers, build loyalty, and increase sales? With Mailmojo, you can send professional newsletters directly to your customers—integrated with your online store. Mailmojo is a Norwegian tool that makes it incredibly easy to succeed with newsletters and SMS, whether you want to do everything yourself or get help from experts.",
    "mailmojo_why_choose": "Why choose Mailmojo?",
    "mailmojo_why_choose_1": "<strong>Easy to use</strong> – you don't need any technical knowledge to create great newsletters.",
    "mailmojo_why_choose_2": "<strong>Modern templates</strong> – customize the design so your newsletters match your brand.",
    "mailmojo_why_choose_3": "<strong>Full insight</strong> – see who opens, clicks, and buys, so you can tailor your content.",
    "mailmojo_why_choose_4": "<strong>GDPR-compliant</strong> – built and operated in Norway, with privacy and security in focus.",
    "mailmojo_why_choose_5": "<strong>Automatic integration</strong> – fetch customer data and email addresses directly from your online store.",
    "mailmojo_advantages": "Benefits for your online store",
    "mailmojo_advantage_1": "As a 24Nettbutikk customer, you also get a discount at Mailmojo.",
    "mailmojo_advantage_2": "Stay in touch with your customers and build loyal relationships.",
    "mailmojo_advantage_3": "Increase sales by marketing campaigns, news, and offers directly in the inbox.",
    "mailmojo_advantage_4": "Use insights and statistics to improve your marketing over time.",
    "mailmojo_punchline": "With Mailmojo, you get a powerful yet simple tool for email marketing – in Norwegian, for Norwegian online stores.",
    "mailmojo_question_1": "Do i need an account with Mailmojo to use this app?",
    "mailmojo_answer_1": "Yes, but as a 24Nettbutikk customer, you'll receive a 25% discount on all yearly mailmojo subscriptions.",
    "mailmojo_question_2": "How do i use this app?",
    "mailmojo_answer_2": "Open this page, and follow the instructions, if anything is unclear, please dont hesitate to contact support.",
    "as_a_customer_you_get_discounted_mailmojo": "As a customer of 24nettbutikk, you'll receive a 25% discount on all yearly mailmojo subscriptions.",
    "mailmojo_feature_free_up_to_50_recipients": "Free for up to 50 active recipients",
    "mailmojo_feature_unlimited_sends": "Unlimited email sends per month.",
    "mailmojo_feature_servers_in_norway": "Your data securely stored on servers in Norway.",
    "mailmojo_feature_top_delivery_quality": "Top-tier delivery quality.",
    "mailmojo_feature_popups_and_signup_forms": "Popups and signup forms.",
    "mailmojo_feature_design_templates": "30+ professional design templates included.",
    "mailmojo_feature_flexible_automation": "Flexible automation of campaigns.",
    "mailmojo_feature_norwegian_support": "Free Norwegian support via email and chat.",
    "mailmojo_feature_personal_advisor": "For you with more than 4,000 contacts: close follow-up and guidance from your own advisor who will help you succeed with email marketing — a value of 9,000 NOK.",
    "mailmojo_calculate_price_over_50": "Calculate the price for more than 50 active recipients",
    "mailmojo_whats_included": "What's included?",
    "google_shopping": "Google Shopping",
    "google_shopping_description": "Add your products to Google Merchant Center, so they can be displayed in Google Shopping. This is an easy way to increase the visibility and sales of your products.",
    "google_shopping_landing_header_text": "This app allows you to connect your webshop to Google Merchant Center, so you can display your products in Google Shopping.",
    "google_shopping_question_1": "Do I need to manually describe each product to, use Google Shopping?",
    "google_shopping_answer_1": "Yes, on each product page you can set up a Google product description, which will be used in Google Shopping. This is a requirement from Google.",
    "enable_the_google_shopping_feed_and_enable_google_taxonomy_data_on_products": "Enable the google shopping feed at /google-shopping-feed, and add google taxonomy input on your products in admin",
    "new_contact_us_message": "New message from contact us form",
    "name_of_the_sender": "Name of the sender",
    "email_of_the_sender": "Senders email",
    "message": "Message",
    "contact_form": "Contact form",
    "select_shortcode": "Select shortcode",
    "q_what_are_shortcodes": "What are shortcodes?",
    "a_what_are_shortcodes": "Shortcodes are small code snippets that you can insert into text fields to display dynamic content or special features, such as forms, product sliders, or other interactive elements. They make it easy to add advanced functionality without needing to write custom code.",
    "shortcode_editor_disclaimer": "Shortcodes are not transformed or previewed inside the editor. They will only be rendered as dynamic content when the page is displayed to users.",
    "dynamic_content": "Dynamic content",
    "insert_dynamic_content": "Insert dynamic content",
    "create_form": "Create form",
    "forms": "Forms",
    "this_is_only_a_simplified_preview_of_the_form_and_might_not_reflect_its_design_shape_or_colors_when_used": "This is only a simplified preview of the form and its fields, it might not accurately reflect the forms design, shape or colors when used in the store.",
    "back_to_appstore": "Back to Appstore",
    "back_to_app": "Back to the app",
    "form": "Form",
    "fields": "Fields",
    "add_field": "Add Field",
    "email_on_submit": "Send email here on submission",
    "email_on_submit_description": "Regardless, all submissions are stored in the store, and can be accessed via the these pages, optionally, you can have the store forward the submissions to an email address.",
    "submit_button_text": "Submit button text",
    "submission_thank_you_text": "Text shown the user after they submit the form",
    "select_type": "Select type",
    "select-multiple_form_description": "Select one or more",
    "select-one_form_description": "Select one",
    "text_form_description": "Short text",
    "textarea_form_description": "Longer text",
    "number_form_description": "Number",
    "boolean_form_description": "Checkbox",
    "email_form_description": "Email address",
    "phone_form_description": "Phone number",
    "date_form_description": "Date",
    "datetime_form_description": "Date and Time",
    "half_width": "Half width",
    "half_width_fields_pair_up": "Two consecutive half-width fields sit side by side.",
    "help_text": "Help text",
    "field": "Field",
    "duplicate_field": "Duplicate field",
    "shown_below_the_field": "Shown below the field. Optional.",
    "remove_the_field": "Remove the field",
    "the_form_needs_a_title": "The form needs a title before it can be saved",
    "the_field_x_needs_options": "The field “{name}” needs at least one option",
    "all_fields_need_a_label": "Every field needs a label",
    "click_a_field_type_to_add_it_to_the_form": "Click a field type on the left to add it to the form",
    "form_canvas_note": "This is how the form looks to your customers — click a field to edit it",
    "add_option": "Add option",
    "unique_id": "Unique id",
    "no_fields_in_form": "The form does not contain any fields.",
    "edit_field": "Edit field",
    "edit_form": "Edit form",
    "submissions": "Submissions",
    "submission": "Submission",
    "is_this_field_required_for_the_user_to_be_able_to_submit_the_form": "Is this field required for the user to be able the submit the form?",
    "the_field_must_have_at_least_one_option": "The field \":field\" must have at least one option",
    "view_form_submissions": "View form submissions",
    "delete_form_and_submissions": "Delete form and all its submissions",
    "all_options_must_have_value_and_label": "Each option must have both a value and a label",
    "please_add_at_least_one_option": "Please add at least one type of option",
    "handled_by": "Handled by",
    "assigned_to_you": "Submission was assigned to you.",
    "assign_submission": "Assign submission to me",
    "view_submission": "View submission",
    "submission_unassigned": "Submission assignment cleared",
    "unassign_submission": "Unassign submission",
    "latest_submission": "Latest submission",
    "submission_inbox_count": "{count} submission | {count} submissions",
    "submission_inbox_last_7_days": "{count} in the last 7 days",
    "submission_inbox_state_all": "All",
    "submission_inbox_state_unhandled": "Unassigned",
    "submission_inbox_state_mine": "Mine",
    "submission_inbox_search_placeholder": "Search name, email and text",
    "submission_inbox_sort_label": "Sort order",
    "submission_inbox_sort_newest": "Newest first",
    "submission_inbox_sort_oldest": "Oldest first",
    "submission_inbox_sort_unhandled_first": "Unassigned first",
    "submission_inbox_sort_sender": "Sender A–Z",
    "submission_inbox_show_more": "Show more ({count} left)",
    "submission_inbox_empty_title": "No submissions yet",
    "submission_inbox_no_matches": "No submissions match your search",
    "submission_inbox_reset_filters": "Clear search and filter",
    "submission_inbox_select_prompt": "Select a submission from the list",
    "submission_inbox_anonymous": "No name",
    "submission_inbox_you": "You",
    "submission_inbox_handled_by_you": "You are handling this",
    "submission_inbox_handled_by": "Handled by {name}",
    "submission_inbox_take": "Take it",
    "submission_inbox_take_over": "Take over",
    "submission_inbox_release": "Unassign",
    "submission_inbox_reply": "Reply by email",
    "submission_inbox_reply_subject": "Re: {form}",
    "submission_inbox_copy_email": "Copy email address",
    "submission_inbox_copied": "Copied",
    "submission_inbox_received": "Received {date}",
    "submission_inbox_date_at_time": "{date} at {time}",
    "submission_inbox_related": "Other submissions from this sender ({count})",
    "submission_inbox_state_unread": "Unread",
    "submission_inbox_unread_count": "{count} unread",
    "submission_inbox_sort_unread_first": "Unread first",
    "submission_inbox_mark_read": "Mark as read",
    "submission_inbox_mark_unread": "Mark as unread",
    "forms_inbox_all_caught_up": "No unread or unhandled submissions",
    "forms_latest_submission": "Latest {time}",
    "forms_product_form_hint": "Filled in on the product page",
    "forms_inbox_show_all_forms": "Show all forms",
    "forms_inbox_empty_text": "When someone submits a form, it shows up here.",
    "forms_card_more_actions": "More actions",
    "forms_delete_form": "Delete form",
    "forms_show_all": "Show all {count} forms",
    "forms_show_fewer": "Show fewer",
    "submission_inbox_state_open": "Open",
    "submission_inbox_state_done": "Done",
    "submission_inbox_open_count": "{count} open",
    "submission_inbox_complete": "Mark as done",
    "submission_inbox_reopen": "Reopen",
    "submission_inbox_completed_by": "Done by {name}",
    "submission_inbox_completed": "Done",
    "submission_inbox_done_short": "Done",
    "submission_inbox_more_actions": "More actions",
    "submission_inbox_delete": "Delete submission",
    "submission_inbox_delete_name": "the submission from {name}",
    "submission_inbox_select_all": "Select all {count}",
    "submission_inbox_select_row": "Select the submission from {name}",
    "x_submissions_selected": "{count} submission selected | {count} submissions selected",
    "bulk_group_status": "status",
    "bulk_group_handling": "assignment",
    "submission_bulk_assign": "Assign to me",
    "submission_bulk_unassign": "Unassign",
    "submission_bulk_delete": "Delete submissions",
    "submission_completed": "The submission is marked as done.",
    "submission_reopened": "The submission is open again.",
    "submissions_updated": ":count submission updated|:count submissions updated",
    "submissions_deleted": ":count submission deleted|:count submissions deleted",
    "duplicate_option_values_are_not_allowed_within_the_same_input": "Options cant have identical id's or labels.",
    "invalid_email": "Invalid email",
    "submission_created": "Submission sent!",
    "invalid_phone_number": "Invalid phone number",
    "invalid_option": "Invalid option",
    "options_are_only_supported_for_select_input_fields": "Options are only supported for select one / select multiple input fields",
    "purchase_the_app_to_enable_more_forms": "Purchase the form builder app, to enable multiple forms",
    "purchase_the_form_builder_to_enable_this_feature": "Purchase the form builder app, to enable this feature",
    "if_you_purchase_the_form_builder_you_can_have_multiple_forms_and_edit_them": "If you purchase the form-builder app, the store can have as many different forms as you like, and you can modify them to contain many different types of fields.",
    "did_you_know": "Did you know",
    "read_more_here": "<a href=\"{url}\" target=\"_blank\">Read more here</a>",
    "no_submissions_yet": "No submissions yet",
    "form_builder_app_name": "Form Builder",
    "form_builder_app_short_description": "Easily collect information from your customers with contact forms and product forms.",
    "form_builder_app_default_features": "By default, you can use a simple contact form to receive messages and inquiries directly in your admin dashboard, with optional email notifications.",
    "form_builder_app_upgrade_title": "Upgrade to unlock advanced features:",
    "form_builder_app_upgrade_features": "Create unlimited custom forms for any purpose—contact, feedback, registration, product-specific information, and more.",
    "form_builder_app_field_types": "Add a variety of field types:",
    "form_builder_app_field_type_short_text": "Short text",
    "form_builder_app_field_type_long_text": "Long text",
    "form_builder_app_field_type_select_one": "Select one",
    "form_builder_app_field_type_select_multiple": "Select multiple",
    "form_builder_app_field_type_email": "Email",
    "form_builder_app_field_type_phone": "Phone",
    "form_builder_app_field_type_number": "Number",
    "form_builder_app_field_type_boolean": "Yes/No (checkbox)",
    "form_builder_app_field_type_date": "Date",
    "form_builder_app_field_type_datetime": "Time and date",
    "form_builder_app_customize_forms": "Customize each form to fit your business needs.",
    "form_builder_app_manage_submissions": "View and manage all submissions in your admin panel.",
    "form_builder_app_email_forwarding": "Send submissions to any email address you choose.",
    "form_builder_app_product_forms": "Attach forms to products to collect custom information like engraving text, gift messages, or measurements – saved with the order.",
    "form_builder_app_cta": "Empower your store with flexible forms and seamless data collection. Upgrade now to unlock the full potential of Form Builder!",
    "form_builder_app_pricing_info": "The Form Builder app is <strong>free</strong> for all plans except <strong>startup</strong>. If you are on the Startup plan, the app costs <strong>{price} pr. month</strong>.",
    "plan": "Plan",
    "price_per_month": "Price per month",
    "upgrade_your_plan_to_get_app_and_other_apps_for_free": "Upgrade your plan to get {app} and other apps for free.",
    "pricing": "Pricing",
    "can_i_use_forms_without_buying_the_app": "Can i use forms without buying the app?",
    "yes_but_you_can_have_one_one_form_active_and_will_have_restricted_functionality": "Yes! but you can have only one form, and will have restricted functionality",
    "select...": "Select ...",
    "select_form": "Select form",
    "num.sold": "Num. sold",
    "updated": "Updated",
    "hero_image_text": "Image with text",
    "hero_image_text_content_order": "Content order",
    "hero_image_text_content_order_description": "Choose the order of the image and text in the block",
    "hero_image_text_content_order_option_1": "Image / Text",
    "hero_image_text_content_order_option_2": "Text / Image",
    "premium": "Premium",
    "premium_pluss": "Premium Pluss",
    "subscriptions": "Subscriptions",
    "subscription": "Subscription",
    "monthly": "Monthly",
    "per_month": "Per month",
    "popular": "Popular",
    "please_set_contact_email": "To continue, you must enter a contact email address. Please enter your email address here and try again.",
    "stripe": {
        "set_default_payment_method_tooltip": "Click here to set this as the default payment method",
        "delete_payment_method_tooltip": "Delete payment method",
        "no_card_attached": "For å kjøpe noe må du legge inn et kort. Legg inn kortet deres her."
    },
    "no_stripe_customer_found": "No customer found. Please contact support for assistance.",
    "error_occurred_updating_stripe_customer_source": "An error occurred while updating your payment method. Please try again later, or contact support.",
    "cant_remove_the_last_card_please_register_another_first": "Can't remove the last card, please register another first.",
    "customer_source_updated": "Your card has been successfully updated",
    "vipps_app_name": "The name you want to show in the Vipps app",
    "days_left_of_your_trial": "Trial days remaining",
    "order_your_24estore": "Order your 24estore",
    "please_fill_the_fields_below": "Please fill the fields below",
    "company_information": "Company information",
    "select_your_company_from_the_list_below": "Select your company from the list below",
    "organization_number_does_not_appear_to_be_valid": "Organization number appears to be invalid",
    "help_us_find_your_company_information": "Help us find your company's information",
    "fields_marked_with_asterisk_required": "Fields marked with an asterix are required",
    "all_required_fields_are_filled": "All required fields are filled",
    "please_fill_all_required_fields": "Please fill all required fields",
    "information_pre_filled": "We have attempted to prefill these fields based on what we know about you. This information will be used when 24nettbutikk needs to reach you. Please correct any mistakes!",
    "enter_your_contact_details": "Enter your contact information",
    "lookup_by_organization_number": "Lookup by Organization number",
    "lookup_by_company_name": "Lookup by Company name",
    "manual_entry": "Manual entry",
    "search_for_your_company_by_name": "Find your company by name",
    "company_search_help_text": "You dont need to know exactly how the company is registered, just being by typing the first few letters in the name, and a list will appear.",
    "enter_company_name": "Enter company name",
    "enter_9_digit_organization_number_for_automatic_lookup": "Enter your 9 digit organization number for a automatic lookup",
    "organization_number_must_be_9_digits": "Organization number must be 9 digits",
    "enter_organization_number": "Enter organization number",
    "organization_number_help_text": "An organization number is an official identifier representing your company in the norwegian company registry (brønnøysundregisteret), it always consists of 9 digits.",
    "enter_company_information_manually": "Enter company information manually",
    "organization_form": "Organization form",
    "please_enter_valid_email": "please enter a valid email",
    "i_accept_the": "I accept the",
    "terms_and_conditions": "Terms and conditions",
    "completed": "Completed",
    "incomplete": "Incomplete",
    "comment": "Comment",
    "i.e.": "i.e.",
    "select_organization_form": "Select organization form",
    "continue": "Continue",
    "terms_of_service": "Terms of service",
    "privacy_policy": "Privacy policy",
    "please_fill_all_required_fields_above": "Please fill all required fields above",
    "postal_code_must_be_4_digits": "Postal code must be 4 digits",
    "no_companies_found_for_search_term": "No companies found for your search",
    "try_different_search_term_or_use_manual_entry": "Check for any errors in your search term, or use organization number or manual input instead.",
    "loading_company_details": "Searching for company details",
    "home&garden": "Home & Garden",
    "leisure_sports_&_hobbies": "Leisure, Sports & Hobbies",
    "health_&_beauty": "Health & Beauty",
    "childrens_products": "Children's Products",
    "clothing_&_shoes": "Clothing & Shoes",
    "jewelry_&_accessories": "Jewelry & Accessories",
    "automotive_supplies_parts_&_accessories": "Automotive Supplies, Parts & Accessories",
    "electronics": "Electronics",
    "food_&_drink": "Food & Drink",
    "digital_products_events_&_tickets": "Digital Products, Events & Tickets",
    "other": "Other",
    "semi_annually": "Semi annually",
    "semi-annually": "Semi annually",
    "thank_you_for_using_24estore": "Thank you for ordering a 24estore!",
    "here_is_what_happens_now": "Here is what happens now:",
    "price_pr_month": "Price pr. month",
    "read_more_about_our_plans_here": "Read more about our plans here.",
    "please_note_that_startup_requires_you_to_register_a_payment_card": "Please note, that startup, or premium with monthly billing interval requires you to register a payment card (credit or debit), before you can use the store.",
    "finish_order": "Finish order",
    "licensing": "Licensing",
    "your_license_has_been_upgraded": "Your license has been upgraded",
    "your_store_is_now_ordered": "Your store has now been ordered!",
    "in_order_to_start_using_your_store_we_need_to_onboard_you_with_our_payment_provider": "In order to start using your store, we need to onboard you with our payment partner",
    "theme_presets": {
        "title": "Presets",
        "description": "See how your store can look with different header and footer variations, and different theme settings. This is only a preview, and the changes won't take effect until you save.",
        "industries": {
            "fashion": "Fashion",
            "sport": "Sports",
            "gadgets": "Tech",
            "jewelry": "Jewelry",
            "beauty": "Beauty",
            "home": "Home",
            "toys": "Toys"
        },
        "industry_descriptions": {
            "fashion": "Designed for clothing, fashion and accessory stores. Big hero imagery and clean product grids let the garments do the talking.",
            "sport": "For sports brands, training gear and the outdoors. Strong contrasts and dynamic composition signal energy and performance.",
            "gadgets": "For consumer electronics and smart-home products. Clean product photography with a focus on specs.",
            "jewelry": "For jewelry and watches. Macro photography and refined typography let each piece shine.",
            "beauty": "For beauty, skincare and perfumery. Light, colour and typography emphasise rituals and ingredients.",
            "home": "For interior, furniture and home goods. Styled vignettes give customers inspiration — products placed in context.",
            "toys": "For toy and kids stores. Warm colours and photos of children at play convey safety and joy."
        },
        "presets": {
            "fashion": {
                "name": "Classic",
                "description": "Timeless starting point for fashion stores — build on it in your own direction."
            },
            "sport": {
                "name": "Classic",
                "description": "Timeless starting point for sports stores — build on it in your own direction."
            },
            "gadgets": {
                "name": "Classic",
                "description": "Timeless starting point for tech stores — build on it in your own direction."
            },
            "jewelry": {
                "name": "Classic",
                "description": "Timeless starting point for jewelry stores — build on it in your own direction."
            },
            "beauty": {
                "name": "Classic",
                "description": "Timeless starting point for beauty stores — build on it in your own direction."
            },
            "home": {
                "name": "Classic",
                "description": "Timeless starting point for interior and home stores — build on it in your own direction."
            },
            "toys": {
                "name": "Classic",
                "description": "Timeless starting point for toy and kids stores — build on it in your own direction."
            }
        },
        "no_preset": "No design",
        "no_preset_description": "Start with a completely blank theme and build your design from scratch"
    },
    "theme_description": {
        "glow": "Glow is a modern, sleek theme that gives your online store a fresh and professional touch. With customization options for product layouts, feature modules, promotional banners and content, you can tailor the shopping experience on a responsive layout that highlights your products"
    },
    "menu_item_font_size": "Menu item font size",
    "extra_small": "Extra small",
    "small": "Small",
    "normal": "Normal",
    "large": "Large",
    "extra_large": "Extra large",
    "menu_item_font_weight": "Menu item font weight",
    "font_weight": "Font weight",
    "font_weight_light": "Light",
    "font_weight_normal": "Normal",
    "font_weight_medium": "Medium",
    "font_weight_semibold": "Semibold",
    "font_weight_bold": "Bold",
    "block_status_description": "When enabled, the block is visible to customers. When disabled, it’s only visible to you while editing the theme",
    "interval": "Interval",
    "theme_editor_slider_interval_description": "Time in seconds between each slide. Default is 5 seconds",
    "show_arrows": "Show navigation arrows",
    "theme_editor_show_arrows_description": "Choose whether to display arrows for navigating between slides. Arrows appear only if there’s more than one slide",
    "slider_content_glide": "Content glide",
    "slider_content_glide_description": "The title, text and button glide into place at their own pace when the slide changes.",
    "slider_autoplay": "Autoplay",
    "slider_autoplay_description": "Advances the slides automatically. When off, customers browse with the arrows, dots or by swiping.",
    "show_arrows_mobile": "Show arrows on mobile",
    "show_arrows_mobile_description": "Turn off to hide the arrows on small screens – customers can still swipe.",
    "show_dots": "Show navigation dots",
    "pagination_style": "Indicator style",
    "pagination_style_description": "How the slide indicator is shown at the bottom of the image.",
    "pagination_style_dots": "Dots",
    "pagination_style_bars": "Bars",
    "pagination_style_fraction": "Counter (1 / 5)",
    "pagination_style_thumbnails": "Thumbnails",
    "theme_editor_show_dots_description": "Choose whether to display dots for navigating between slides. Dots appear only if there’s more than one slide",
    "image_aspect_ratio": "Image aspect ratio",
    "image_aspect_ratio_description": "Force all images to the same aspect ratio with edge cropping. Useful when uploaded images have varying sizes.",
    "image_aspect_native": "Keep original",
    "arrow_position": "Arrow position",
    "arrow_position_inside": "Inside",
    "arrow_position_outside": "Outside",
    "arrow_position_above": "Above",
    "arrow_position_below": "Below",
    "arrow_style": "Arrow style",
    "arrow_style_round": "Round",
    "arrow_style_square": "Square",
    "arrow_style_minimal": "Minimal",
    "see_demo": "See demo",
    "theme_preset_selector_modal": {
        "step_welcome": {
            "title": "Congratulations on your new online store!",
            "subtitle": "Your 14-day trial period starts now.",
            "description": "Here is important information about your new online store. Please save this information so you can return to it later.",
            "store_url": "The address of your online store:",
            "store_username": "Your username:",
            "store_password_text": "The password is the one you chose when you created the online store.",
            "button_text": "Let's get started!"
        },
        "step_select": {
            "title": "Welcome to your 24Nettbutikk!",
            "subtitle": "Choose a design that fits your store",
            "description": "We have created several professional design variations, tailored for different industries and product categories. Choose the one that best matches your style. Remember that you can change the variant, customize colors, fonts, and layout later.",
            "select_preset_text": "Click on the design you like best, and we’ll set up your store with this as a starting point."
        },
        "step_confirm": {
            "you_have_selected_this_preset": "You have selected the following variant",
            "select_another_preset": "Choose another variant",
            "confirm_preset": "Continue with selected variant",
            "design_editor_description": "With the design builder, you have full control over the look of your store – without needing to code.",
            "list_of_features": ["Change <strong>colors, fonts, header, and footer</strong> so they match your brand.", "Build your pages with the elements you want – flexible and simple.", "Adjust details or change the entire look with just a few clicks."],
            "this_gives_you_a_professional_store": "This gives you a professional online store that both looks unique and provides your customers with a better shopping experience.",
            "design_editor_location": "You can find the design builder under the menu item \"Design\"."
        },
        "step_thank_you": {
            "title": "Congratulations with your new store",
            "congratulations": "Congratulations on choosing your first design!",
            "next_steps": "The next step is to fill your store with products and prepare it for sales.",
            "tutorial_info": "<p>We recommend that you follow the checklist, which shows you what to do and in what order this should be done. Here you will also get help in the form of short support videos that take you through a step-by-step explanation.<br /><br />Remember that you can also click on the “Help Center” option in the menu on the left and go to our <a href='https://support.24nettbutikk.no/knowledge' target='_blank' class='link'>support pages</a> for guides and help with the different options.<br /><br />Also keep in mind that we at the 24Nettbutikk team are ready to help you by phone, email, or chat if you get stuck 😊</p>"
        }
    },
    "design_builder": "Design Builder",
    "design_variants": "Design variants",
    "edit_active_design": "Edit active design",
    "see_demo_store": "See demo store",
    "see_in_design_builder": "See in design builder",
    "design_variants_hero_title": "Lots of ready-made designs to choose from",
    "design_variants_hero_description": "We've made designs for all kinds of stores — clothing, sports, jewelry, home and more. Try as many as you like before deciding, and change everything afterwards however you want.",
    "design_variants_info": {
        "preview_description": "Browse available themes for your store. Visit a demo store to see each theme in action, and add the ones you want to use.",
        "note_title": "What does a theme include?",
        "note_description": "Content you've added yourself — image sliders, products, etc. — is independent of the theme and will not be affected. Each theme defines:",
        "list_global_settings": "Global settings — Color, font, corner rounding, etc.",
        "list_header": "Header — Placement of logo and search field",
        "list_footer": "Footer — Placement of company information, partner logos, etc."
    },
    "product_search_log": "Search history",
    "product_searches": "Search history",
    "see_products": "See products",
    "query": "Search word(s)",
    "count": "Count",
    "searched_at": "Date searched",
    "search_with_no_matches": "Searches with no matches",
    "no_matches": "No matches",
    "text_alignment": "Text alignment",
    "placement": "Placement",
    "left": "Left",
    "center": "Center",
    "center_title": "Center title",
    "right": "Right",
    "top": "Top",
    "bottom": "Bottom",
    "color": "Color",
    "size": "Size",
    "button_text": "Button text",
    "outlined": "Outlined",
    "shadow": "Shadow",
    "opacity": "Opacity",
    "overlay_color": "Overlay color",
    "URL": "URL",
    "simple": "Simple",
    "image_alt_text_description": "Image text is a short description of the image. It helps search engines understand the image and is read aloud by screen readers for visually impaired users",
    "theme_block_image_simple_mode_description": "Use Simple mode when you only need an image with an optional link",
    "button_url_overrides_image_link": "Overrides the image link. Leave empty to have the button use the link from the Link section.",
    "second_button": "Second button",
    "second_button_description": "Leave the text empty to show only one button. The second one sits to the right of the first.",
    "button_style": "Button style",
    "button_style_filled": "Filled",
    "button_style_outlined": "Outlined",
    "button_style_plain": "Text only",
    "button_style_inverted": "Text colour as background",
    "button_icon": "Icon after the text",
    "button_icon_arrow": "Arrow",
    "button_icon_cart": "Cart",
    "theme_block_image_content_link_description": "Makes the whole image clickable. If you add a button to the content, the button carries the link instead — using its own URL when set.",
    "theme_block_image_content_mode_description": "Use Content mode to add overlay content on top of the image, such as title, text, and a button with a link",
    "vertical_placement": "Vertical placement",
    "horizontal_placement": "Horizontal placement",
    "vertical_placement_slider_description": "0 is the top, 50 is centered and 100 is the bottom.",
    "horizontal_placement_slider_description": "0 is far left, 50 is centered and 100 is far right.",
    "help_articles": "Help articles",
    "item_is_a_menu_item_delete_warning": "<strong>{name}</strong> is a menu item. If you delete this element, it will be removed from all menus where it is used, along with any submenu items.",
    "tutorial_videos": "Tutorial videos",
    "are_you_sure": "Are you sure?",
    "see_all_tutorial_videos_here": "See all tutorial videos here",
    "step_by_step_support_guides": "Step-by-step support article",
    "next": "Next",
    "start_tour": "Start tour",
    "skip_tour": "Skip tour",
    "tours": {
        "initial": {
            "step_one": {
                "title": "Product categories",
                "description": "We recommend that you first create your product categories and link these to the main menu. The help videos below will show you how.",
                "link_one_text": "The connection between products, categories, and menus",
                "link_two_text": "How to build a product category",
                "link_three_text": "How to link product categories to the Main menu"
            },
            "step_two": {
                "title": "Products",
                "description": "Create products and then link these to the product categories. The help videos will show you how.",
                "link_one_text": "How to add products and link them to product categories",
                "link_two_text": "Add properties (attributes) to the products"
            }
        }
    },
    "tour_done_button_text": "Done",
    "you_cant_disable_maintenance_mode_without_an_active_license": "You cant disable maintenance mode,without first signing a license agreement for the webshop.",
    "included_for_free_with": "Included for free with",
    "available_for_plans": "Available for purchase with",
    "startup": "Startup",
    "all_prices_are_pr_month_and_excluding_vat": "All prices are pr. month, and excluding VAT",
    "cant_order_apps_without_first_owning_a_license": "You cant order apps until you have acquired a license for the webshop",
    "app_requires_license": "This app requires {licenses}.",
    "app_not_buyable_with_current_license": "This app is not available on your current license.",
    "connected_products_heading": "Connected products – increase your upselling in your online store",
    "connected_products_sub_heading": "Connected products let you display a tailored list of items on the product page.\nThis makes it easy for customers to discover more products they might like! With connected products, you can show a customized list of recommended items directly on the product page.",
    "connected_products_how_it_works_1": "<strong>Your own title</strong> – name the list whatever you want, e.g. “You also need these” or “Other colors you might like”.",
    "connected_products_how_it_works_2": "<strong>Choose placement</strong> – show the list below the product content, below the buy button – or just as images to highlight alternatives.",
    "connected_products_how_it_works_3": "<strong>Full control</strong> – decide which products to display, and drag-and-drop to set the order.",
    "why_use_connected_products": "Why enable connected products?",
    "connected_products_why_use_1": "<strong>Increase upselling</strong> – suggest complementary items or alternative variants.",
    "connected_products_why_use_2": "<strong>Better shopping experience</strong> – customers get inspiration and help to find the right products.",
    "connected_products_why_use_3": "<strong>More control</strong> – you decide which products to highlight, exactly as you want.",
    "connected_products_upsell": "With connected products, you give customers more reasons to shop – and increase the value of every purchase.",
    "google_shopping_heading": "Google Shopping – reach customers when they are searching for you",
    "google_shopping_sub_heading": "Do you want your products to appear right in front of customers when they search on Google? With our integration to Google Shopping, you can easily get your online store to show up in Google’s product ads – exactly where potential customers are ready to buy.",
    "q_what_is_google_shopping": "What is Google Shopping?",
    "a_what_is_google_shopping": "Google Shopping is a service from Google that lets users search for, compare, and click through to your products directly via Google’s platform. Your products are displayed with image, price, and your store’s name – providing a clear and attractive presentation right in the search results.",
    "why_use_google_shopping": "Why use Google Shopping?",
    "why_use_google_shopping_1": "<strong>Reach ready-to-buy customers</strong> – connect with people actively searching for the products you sell.",
    "why_use_google_shopping_2": "<strong>Increase visibility</strong> – your products are shown with images and prices on Google searches.",
    "why_use_google_shopping_3": "<strong>More sales</strong> – customers can click directly into your store from Google.",
    "why_use_google_shopping_4": "<strong>Automatic updates</strong> – the integration ensures your product information is always up to date.\n",
    "simple_integration_with_24estore": "Simple integration with 24Nettbutikk",
    "with_our_google_shopping_integration_everything_is_prepared_for_you": "With our Google Shopping app, everything is set up for you:",
    "google_shopping_prepared_1": "Connect your products seamlessly to Google Shopping.",
    "google_shopping_prepared_2": "Price, stock status, and product information are updated automatically.",
    "google_shopping_prepared_3": "No heavy technical work – we make the job simple and clear.",
    "form_builder_heading": "Form Builder – collect valuable information easily and efficiently",
    "form_builder_sub_heading": "Want better control over customer inquiries and data? With Form Builder, you can create professional forms tailored to your needs – from simple contact forms to product forms that collect custom information at checkout.",
    "get_started_with_the_standard_functions": "This is included for all stores",
    "form_builder_function_1": "<strong>Simple contact form</strong> – receive messages and inquiries directly in the admin panel.",
    "form_builder_function_2": "<strong>Email notifications</strong> – get notified when someone submits a form.",
    "form_builder_function_3": "<strong>Full overview</strong> – view and manage all submissions in one place.",
    "form_builder_function_4": "<strong>Flexible forwarding</strong> – send submissions to any email address you want.",
    "this_is_what_you_get": "This is what you get when you purchase the app",
    "form_builder_what_you_get_1": "<strong>Unlimited number of forms</strong> – create forms for contact, feedback, registrations, campaigns, and much more.",
    "form_builder_what_you_get_2": "<strong>Customize each form</strong> – tailor the appearance and content to your business needs.\n",
    "form_builder_what_you_get_3": "<strong>Many field types</strong> – choose between:\nshort/long text,\ncheckboxes,\nemail,\nphone,\nnumbers,\ndate,\ntime,\nand more.\n",
    "form_builder_what_you_get_4": "<strong>Seamless data collection</strong> – make it easy for customers to provide the information you need.",
    "form_builder_what_you_get_5": "<strong>Product forms</strong> – attach forms to products to collect custom details like engraving, gift messages, or special measurements. Data is saved with the order, and you can add an additional cost for the service.",
    "form_builder_why_use": "Why use Form Builder?",
    "form_builder_why_use_1": "Make your store more professional and user-friendly.",
    "form_builder_why_use_2": "Collect leads, feedback, and registrations without extra systems.",
    "form_builder_why_use_3": "Gain better insight into your customers and use data to make smarter decisions.",
    "form_builder_sub_text": "With Form Builder you get flexibility, overview, and an easier workday – directly integrated into your online store.",
    "faq_heading": "FAQ – give customers the answers before they ask",
    "faq_sub_heading": "FAQ – give customers the answers before they ask\nWith the FAQ app, you can easily create a clear question-and-answer section in your online store. This gives customers quick access to the information they need – without having to contact you.",
    "advantages_with_faq": "Advantages of FAQ",
    "advantages_with_faq_1": "<strong>Less customer service</strong> – fewer inquiries because customers find the answers themselves.",
    "advantages_with_faq_2": "<strong>Better shopping experience</strong> – when customers get quick answers, they are more likely to complete their purchase.",
    "advantages_with_faq_3": "<strong>Flexible placement</strong> – place the FAQ directly on the front page, on product pages, or as a menu item in your store.",
    "faq_sub_text": "With FAQ, your store becomes more professional, your customers more satisfied – and you save time on support.",
    "wishlist_headline": "Let customers save the products they love",
    "wishlist_subline": "Make it easy for your customers to come back and complete their purchase! With Favorites, they can click the heart next to a product and add it to their own favorites list.",
    "this_allows_customers_to": "This allows customers to:",
    "this_allows_customers_to_1": "<strong>Plan purchases</strong> – save the products they like and shop later.",
    "this_allows_customers_to_2": "<strong>Find again</strong> – avoid searching again for items they've already shown interest in.",
    "this_allows_customers_to_3": "<strong>Buy more</strong> – a favorites list makes it easier to add more products to the cart.",
    "why_use_wishlist": "Why enable Favorites?",
    "why_use_wishlist_1": "Increases the likelihood that customers will return.",
    "why_use_wishlist_2": "Creates a better shopping experience with more control and inspiration.",
    "why_use_wishlist_3": "Helps increase sales when customers can easily access their list and add items to the cart.\n",
    "wishlist_closer": "With favorites, you build loyalty and make the customer journey smoother – something both you and your customers benefit from.",
    "vipps_express_headline": "Vipps Express Checkout – the fastest way to more sales",
    "vipps_express_subline": "Make the shopping experience easier for your customers – and increase sales! With Vipps Express Checkout, customers can pay with Vipps in just a few clicks, either directly from the product page or in the cart.",
    "advantages_with_vipps_express": "Advantages of Vipps Express Checkout",
    "advantages_with_vipps_express_1": "<strong>Super fast payment</strong> – the easiest and quickest way to get paid in your online store.",
    "advantages_with_vipps_express_2": "<strong>Reduce abandoned carts</strong> – a shorter payment process means more completed purchases.",
    "advantages_with_vipps_express_3": "<strong>Higher conversion</strong> – our customers experience record-high conversion rates with Vipps Express Checkout, especially for those with a relatively low average order value.",
    "advantages_with_vipps_express_4": "<strong>Seamless order processing</strong> – handled just like regular Vipps orders, directly in your store's order management.",
    "advantages_with_vipps_express_5": "<strong>No extra costs</strong> – the transaction price is the same as for regular Vipps orders <a class='link' href='https://www.24nettbutikk.no/priser' target='_blank'>(see prices here).</a>",
    "can_i_use_vipps_express_without_vipps_q": "Can I use Vipps Express Checkout without having Vipps?",
    "can_i_use_vipps_express_without_vipps_a": "No, you must already have Vipps configured in your store to order Vipps Express Checkout.",
    "how_much_does_it_cost_to_use_vipps_express_q": "How much does it cost to use Vipps Express Checkout?",
    "how_much_does_it_cost_to_use_vipps_express_a": "Vipps Express Checkout is free to use, but you pay the regular Vipps fees (just like a regular Vipps order).",
    "vipps_express_tagline": "With Vipps Express Checkout you get more sales, happier customers – and an even easier day-to-day in your online store.",
    "product_tags_tooltip": "Use product tags to place products in smart categories. Example: \"Women\" and \"Shoes\" tags will make a women’s shoe automatically appear in both categories (if they have been created with these criteria).",
    "product_badges_tooltip": "Badges are small labels displayed on the product image in product listings. Example: \"Clearance\" or \"Eco-Friendly\"",
    "active_shipping_methods": "Active shipping methods",
    "what_is_24_shipping_desc": "The shipping agreement we've named 24Shipping, is tailored to give you, as a 24Nettbutikk customer the same advantages in shipping prices, that were traditionally reserved for the volume of major sites, with Norway's biggest shipping providers Bring and PostNord",
    "what_is_24_shipping_1": "Simplified order processing with shipping seamlessly integrated.",
    "what_is_24_shipping_2": "Coming soon: Automated printing of shipping labels and other documents during order processing",
    "what_is_24_shipping_3": "The best and easiest deliveries for Mailboxes, Automated Delivery points, Pickup Points, and at the door.",
    "24_shipping_is_included_for_free_in_your_license_and_you_only_pay_for_the_shipments_you_make": "24Shipping is included in your license, and you only pay for the shipments you make",
    "incident_form_24_shipping": "Incident form 24Shipping",
    "currently_using": "Currently using",
    "use_this_card": "Use this card",
    "cards": "Cards",
    "card": "Card",
    "card_registered": "Card registered",
    "to_use_the_appstore_we_need_to_have_a_payment_card_on_file": "To use the appstore we need to have a payment card on file.",
    "to_use_24shipping_we_need_to_have_a_payment_card_on_file": "To be able to book shipping with 24Shipping, we need to have a payment card on file.",
    "how_are_card_details_saved_q": "How are my card details saved?",
    "how_are_card_details_saved_a": "Cards are not saved in the webshop, but are instead stored securely with our payment partner <a class=\"link\" href=\"https://stripe.com\" target=\"_blank\">stripe</a>.",
    "how_can_i_cancel_an_app_q": "How can I cancel an app?",
    "how_can_i_cancel_an_app_a": "You can cancel at any time via support.",
    "how_the_appstore_works": "How the Appstore works",
    "add_card_here": "Add card here",
    "what_is_24shipping_q": "What is 24Shipping?",
    "what_is_24shipping_a": "This shipping deal, which we call 24Shipping, is designed to give you as a 24Nettbutikk customer the bulk shipping advantages traditionally reserved for large sites, with Norway’s largest shipping providers Posten Bring and PostNord. Read more about it <a class=\"link\" href=\"https://www.24nettbutikk.no/24shipping\" target=_\"blank\">here</a>.",
    "i_dont_want_to_use_24_shipping_how_can_i_hide_this_q": "I dont want to use 24Shipping, how can i hide this window?",
    "i_dont_want_to_use_24_shipping_how_can_i_hide_this_a": "To hide this window permanently, disable 24Shipping as a logistics provider <a class=\"link\" href=\"/admin/logistics\">here.</a>",
    "blog": "Blog",
    "blog_app_description": "Easily share valuable content through a blog directly in your online store. Perfect for news, guides, and inspiration that strengthen your brand and increase engagement.",
    "blog_app_headline": "Blog – share content that engages your customers",
    "blog_app_sub_heading": "With the blog app, you can easily publish articles, guides, and news directly in your online store. Provide your customers with valuable content that builds trust, inspires, and helps boost sales.",
    "blog_app_advantages": "Benefits of blog",
    "blog_app_advantage_1": "<strong>Strengthen your brand</strong> – share knowledge and stories that highlight your expertise.",
    "blog_app_advantage_2": "<strong>Increase visibility</strong> – blog posts can improve your ranking in search engines.",
    "blog_app_advantage_3": "<strong>Engage customers</strong> – offer valuable content that keeps customers coming back.",
    "blog_app_closer": "With the blog app, your store becomes more than just a place to shop – it becomes a source of inspiration and knowledge for your customers.",
    "blog_posts": "Blog posts",
    "blog_post": "Blog post",
    "add_blog_post": "Add blog post",
    "edit_blog_post": "Edit blog post",
    "blog_index_page": "Blog main page",
    "unpublished": "Unpublished",
    "date_published": "Date published",
    "show_image_in_post": "Show image in post",
    "blog_post_image": "blog post image",
    "see_blog_in_store": "See blog in store",
    "blog_post_tags_description": "Use blog tags to categorize your posts. Example: \"News\", \"Guides\", or \"Inspiration\". These are also used to display related posts within the blog post.",
    "blog_post_image_description": "This image is displayed as the cover image in the blog overview. You can also choose to display it at the top of the actual blog post.",
    "other_shipping_methods": "Other shipping methods",
    "upload_a_favicon_for_your_store": "Upload a favicon for your store. The icon must be in PNG format and have a size of 16x16, 32x32, or 64x64 pixels. The file size cannot exceed 128 kB. Please note that changes to the favicon may take up to 30 minutes to become visible in the browser.",
    "favicon_updated": "Favicon updated",
    "favicon_deleted": "Favicon deleted",
    "payment_onboarding_text": "Ordering payment methods is available for customers with an active 24Next subscription.",
    "payment_click_here_to_onboard_saas": "Click here to get started.",
    "payment_order": "Order",
    "vipps_continue": "Continue at Vipps",
    "vipps_reorder": "Order again",
    "vipps_trial_disabled_hint": "You can order Vipps once your store has an active plan.",
    "vipps_state_submitted": "Submitted – being processed by Vipps",
    "vipps_state_completed": "Approved! Check your email from Vipps and forward the API keys to us, and we'll activate Vipps.",
    "manage_attributes_action_description": "Manage product attributes. Either by creating new ones or removing existing ones",
    "manage_attributes_to_x_amount_of_products": "Manage attributes to 1 product | Manage attributes to {count} products",
    "attributes_that_will_be_added": "Attributes that will be added",
    "manage_attributes_modal_description": "Manage product attributes for the selected products. Use “Add” to assign new attributes, or “Remove” to delete existing ones.",
    "you_have_already_added_this_attribute": "You have already added this attribute",
    "customer.first_name.required": "First name is required.",
    "customer.first_name.string": "First name must be a string.",
    "customer.first_name.max": "First name may not be longer than 255 characters.",
    "customer.last_name.required": "Last name is required.",
    "customer.last_name.string": "Last name must be a string.",
    "customer.last_name.max": "Last name may not be longer than 255 characters.",
    "customer.customer_type.required": "Customer type is required.",
    "customer.customer_type.string": "Customer type must be a string.",
    "customer.customer_type.in": "Customer type must be either individual or business.",
    "customer.company_name.required_if": "Company name is required for businesses.",
    "customer.company_name.string": "Company name must be a string.",
    "customer.company_name.max": "Company name may not be longer than 255 characters.",
    "customer.company_vat_number.required_if": "Organization number is required for businesses.",
    "customer.company_vat_number.string": "Organization number must be a string.",
    "customer.company_vat_number.max": "Organization number may not be longer than 255 characters.",
    "customer.company_department.string": "Department must be a string.",
    "customer.company_department.max": "Department may not be longer than 255 characters.",
    "customer.company_project.string": "Project must be a string.",
    "customer.company_project.max": "Project may not be longer than 255 characters.",
    "customer.email.required": "Email address is required.",
    "customer.email.string": "Email address must be a string.",
    "customer.email.email": "Email address must be valid.",
    "customer.email.max": "Email address may not be longer than 255 characters.",
    "customer.email.unique": "Email address is already registered.",
    "customer.password.required": "Password is required.",
    "customer.password.string": "Password must be a string.",
    "customer.password.min": "Password must be at least 8 characters.",
    "customer.password.confirmed": "Passwords do not match.",
    "check_shipping_methods": "Get shipping methods",
    "create_shipment": "Create shipment",
    "internal_reference": "Internal reference",
    "logistics_provider": "Logistics provider",
    "manual_shipment_description": "From here you can manually book a shipment",
    "manual_shipments": "Manual shipments",
    "select_shipping_method": "Select shipping method",
    "fill_form_to_get_shipping_methods": "Fill out the form to fetch available shipping methods",
    "recipient": "Recipient",
    "package": "Package",
    "last_x_days": "Last {days} days",
    "search_by_recipient_name": "Search by recipient name...",
    "no_shipments_yet": "No shipments have been created yet",
    "view_label": "View",
    "print": "Print",
    "in gram": "in gram",
    "in cm": "in cm",
    "pickup_points": "Pickup points",
    "pickup_point": "Pickup point",
    "requested_delivery_date": "Requested delivery day",
    "requested_delivery_booking_notice": "The customer chose delivery {delivery}. The date is included in the booking when the product is Pakke levert hjem (5600).",
    "url_to_label": "Label",
    "link_to_label": "Label",
    "dimensions": "Dimensions",
    "choose_pickup_point": "Choose pickup point",
    "manual_shipment_created_successfully": "Manual shipment created successfully",
    "could_not_book_manual_shipment": "Could not create manual shipment. Please try again or contact customer service",
    "no_shipping_methods_found": "No shipping methods found for the specified address, dimensions, and weight.",
    "could_not_book_shipment": "Could not book shipment. Please try again or contact customer service",
    "product_pricing_has_variants_description": "This product has product variants. You can set one price for all of them in the field below, or set individual prices in the <a class='text-[color:var(--link-color)]' href='#variants-table'>Product variants</a> table.",
    "hide_form": "Hide form",
    "new_start_date_overlaps_with_an_existing_period": "New start date overlaps with an existing period",
    "discounted_price_cannot_be_0": "Discounted price cannot be 0",
    "discount_price_cannot_be_higher_than_original_price": "Discount price cannot be higher than original price",
    "start_date_is_required": "Start date is required",
    "end_date_is_required": "End date is required",
    "end_date_cannot_be_before_start_date": "End date cannot be before start date",
    "mobile_navigation_background_color": "Mobile menu background color",
    "mobile_navigation_text_color": "Mobile menu text color",
    "mobile_navigation_style": "Mobile navigation style",
    "mobile_navigation_style_description": "Choose between a slide-in drawer or a full-screen overlay for the mobile menu",
    "mobile_navigation_style_drawer": "Drawer (slide from left)",
    "mobile_navigation_style_overlay": "Full-screen overlay",
    "mobile_navigation_font_size": "Mobile menu font size",
    "mobile_navigation_font_size_description": "Scales the text in the mobile menu, both the drawer and the full-screen overlay",
    "mobile_navigation_font_size_small": "Small",
    "mobile_navigation_font_size_normal": "Normal",
    "mobile_navigation_font_size_large": "Large",
    "mobile_navigation_show_contact": "Show contact info in the mobile menu",
    "mobile_navigation_show_contact_description": "Shows the store email and phone at the bottom of the mobile menu, next to the social media icons",
    "mobile_sticky_menu": "Sticky mobile menu",
    "mobile_sticky_menu_description": "Show a fixed navigation bar at the bottom of the screen on mobile",
    "user_invited_success_message": "The person you invited has now received an email with instructions to complete the registration.",
    "store_id_copied_to_clipboard": "Store ID copied to clipboard",
    "from_here_you_can_book_a_manual_shipment": "From here you can manually book a shipment via 24Shipping",
    "book_manual_shipment": "Book manual shipment",
    "fulfillment_items_required": "Fulfillment items are required",
    "fulfillment_items_must_be_array": "Fulfillment items must be an array",
    "fulfillment_carrier_required_with_tracking": "Carrier is required when tracking number is provided",
    "fulfillment_carrier_must_be_string": "Carrier must be a string",
    "fulfillment_tracking_number_must_be_string": "Tracking number must be a string",
    "fulfillment_tracking_number_required_with_carrier": "Tracking number is required when carrier is provided",
    "fulfillment_tracking_url_must_be_valid": "Tracking URL must be valid",
    "fulfillment_notify_customer_required": "Customer notification is required",
    "fulfillment_notify_customer_must_be_boolean": "Customer notification must be true/false",
    "fulfillment_logistics_provider_required": "Logistics provider is required",
    "fulfillment_logistics_provider_must_be_string": "Logistics provider must be a string",
    "fulfillment_logistics_provider_not_found": "Logistics provider not found",
    "fulfillment_product_required_for_provider": "Product is required for this provider",
    "fulfillment_product_must_be_string": "Product must be a string",
    "fulfillment_dimensions_must_be_array": "Dimensions must be an array",
    "fulfillment_dimensions_required_for_provider": "Dimensions are required for this provider",
    "fulfillment_dimensions_length_required": "Length is required",
    "fulfillment_dimensions_length_must_be_numeric": "Length must be numeric",
    "fulfillment_dimensions_width_required": "Width is required",
    "fulfillment_dimensions_width_must_be_numeric": "Width must be numeric",
    "fulfillment_dimensions_height_required": "Height is required",
    "fulfillment_dimensions_height_must_be_numeric": "Height must be numeric",
    "fulfillment_dimensions_weight_required": "Weight is required",
    "fulfillment_dimensions_weight_must_be_numeric": "Weight must be numeric",
    "fulfillment_pickup_point_required": "This shipping method requires a pickup point. Select one before fulfilling.",
    "could_not_refresh_widgets": "Could not add the requested widget. Try refreshing the page.",
    "(disconnected)": "(Disconnected)",
    "payment_method_was_updated": "Payment method was updated",
    "payment_method_was_updated_from:from_to_:to": "Payment method was updated from :from to :to",
    "are_you_sure_you_want_to_disconnect_this_order_from_its_current_payment_gateway": "Are you certain you want to disconnect this order from its current payment gateway?",
    "manage_prices_for_x_amount_of_products": "Manage prices for 1 product | Manage prices for {count} products",
    "manage_prices_modal_description": "Manage prices for the selected products. You can set a new price for all products, or adjust prices by a fixed amount or percentage. You can also set and remove sale prices.",
    "base_prices": "Base prices",
    "base_price": "Base price",
    "sales_prices": "Sales prices",
    "sales_price": "Sales price",
    "manage_prices_product_preview_description": "This is a preview of how the prices will look for the product or its variants after the changes are saved. If you remove the checkmark for a product or variant, it will not be updated and will remain unchanged.",
    "managing": "Managing",
    "action": "Action",
    "adjust_type": "Adjust type",
    "current_sale": "Current sale",
    "current_sale_description": "Remove the current sale price for the product or variants",
    "current_stock": "Current stock",
    "scheduled_sales": "Scheduled sales",
    "scheduled_sales_description": "Remove scheduled sales for the product or variants",
    "all_sales": "All sales",
    "all_sales_description": "Remove both current and scheduled sales for the product or variants",
    "add_sale": "Add sale",
    "remove_sale": "Remove sale",
    "adjust_by_amount": "Adjust by amount",
    "adjust_by_percentage": "Adjust by percentage",
    "increase_price_by_percentage": "Increase price by {value}%",
    "decrease_price_by_percentage": "Decrease price by {value}%",
    "increase_price_by_amount": "Increase price by {value}",
    "decrease_price_by_amount": "Decrease price by {value}",
    "replace_price_with_amount": "Replace price with {value}",
    "increase": "Increase",
    "decrease": "Reduce",
    "prices": "Prices",
    "manage_prices_action_description": "You can set a new price for all products, or set and remove sale prices",
    "add_sales_price_by_percentage": "Add sales price with {value}% discount from base price",
    "add_sales_price_by_amount": "Add sales price with a {value} discount from base price",
    "add_sales_price_fixed": "Set fixed sale price of {value}",
    "fixed": "Fixed",
    "fixed_sale_price_including_vat": "Fixed sale price (incl. VAT)",
    "overwrite_existing_sales_prices": "Overwrite existing sales prices",
    "sales_price_exceeds_base_price": "The sales price exceeds or equals the base price.",
    "remove_sales_price_option": "Remove {option}",
    "base_price_will_exceed_current_sales_price": "Cannot adjust the base price because it will exceed the current sales price",
    "conflicting_sales_prices": "Conflicting sales prices exist in the specified date range.",
    "sales_price_zero_or_less": "Will not update since resulting sales price is zero or less.",
    "original_price": "Original price",
    "new_price": "New price",
    "current_price": "Current price",
    "one_active_sale_will_be_removed": "One active sale will be removed",
    "x_scheduled_sales_will_be_removed": "One scheduled sale will be removed | {count} scheduled sales will be removed",
    "no_current_sale_to_remove": "No current sale to remove",
    "no_scheduled_sales_to_remove": "No scheduled sales to remove",
    "amount": "Amount",
    "amount_excluding_vat": "Amount excl. VAT",
    "amount_including_vat": "Amount incl. VAT",
    "are_you_sure_you_want_to_apply_these_price_changes_to_the_selected_products": "Are you sure you want to apply these price changes to the selected products/variants?",
    "will_not_be_updated": "Will not be updated",
    "sales_price_percentage_modification_example": "With an adjustment of {percentage}%, a product with a base price of {originalPriceExample} NOK will, for example, receive a sales price of {salesPricePercentageModificationExample} NOK",
    "sales_price_amount_modification_example": "With an adjustment of {amount} NOK, a product with a base price of {originalPriceExample} NOK will, for example, receive a sales price of {salesPriceAmountModificationExample} NOK",
    "add_theme": "Add theme",
    "add_theme_x": "Add theme {name}",
    "theme_x_added": "Theme {name} added",
    "go_to_theme": "Go to theme",
    "theme_added_description": "The theme has been added to your store. You can now go to the design builder and customise it the way you want.",
    "theme": "Theme",
    "save_and_publish": "Save and publish",
    "add_new_theme": "Add new theme",
    "publish_theme_modal_title": "Publish theme",
    "publish_theme_modal_description": "Are you sure you want to publish this theme? This will make it the active theme for your store",
    "theme_saved_and_published_successfully": "Theme saved and published",
    "checklist": {
        "steps": {
            "add_company_information": {
                "label": "Add basic store information",
                "description": "Address, contact details and registration number.",
                "help_text": "Norwegian regulations require stores to display their company registration number, address, and contact info. It also builds trust with customers who want to verify who they're buying from.",
                "bullets": ["Company registration number and legal name", "Postal address and contact email"],
                "cta_label": "Go to settings"
            },
            "change_design": {
                "label": "Add a logo and work on your store design",
                "description": "Give your store a professional look that builds trust and your brand.",
                "help_text": "A good first impression makes it easier for customers to trust you and make a purchase. In the designer you can upload your logo, adjust colors and typography, and preview the store before publishing.",
                "bullets": ["Upload your logo (PNG recommended)", "Pick colors that match your brand", "Preview on desktop and mobile"],
                "cta_label": "Open designer"
            },
            "add_category": {
                "label": "Add a product category",
                "description": "Organise your products into categories so customers can find their way.",
                "help_text": "Categories help customers navigate your store. A clear structure makes it faster for customers to find what they're looking for, which typically leads to more sales.",
                "bullets": ["Set up top-level categories first (e.g. \"Clothing\", \"Shoes\")", "Place products in multiple categories if it makes sense", "Can be attached to the main menu — see the video above for how"],
                "cta_label": "Create category"
            }
        }
    },
    "duplicate_theme": "Duplicate theme",
    "duplicate_theme_x": "Duplicate theme {name}",
    "theme_duplicated": "Theme duplicated",
    "duplicate": "Duplicate",
    "delete_theme": "Delete theme",
    "theme_deleted": "Theme deleted",
    "edit_internal_name": "Edit internal name",
    "edit_internal_name_of_x": "Edit internal name for {name}",
    "theme_deleted_successfully": "Theme deleted",
    "cannot_delete_active_theme": "You can't delete the active theme",
    "are_you_sure_you_want_to_delete_theme_x": "Are you sure you want to delete theme {name}?",
    "get_started": "Get started",
    "theme_limit_reached_error": "You have reached the limit for the number of themes in your store. Delete a theme before adding a new one.",
    "theme_limit_reached_notification": "Limit for number of themes reached",
    "startup_can_only_work_on_one_theme": "The Startup plan lets you work with one theme at a time",
    "startup_order_warning_heading": "Features you've used will be disabled",
    "startup_order_warning_intro": "With StartUp you lose access to these features you've used during the trial:",
    "startup_order_warning_addon_note": "Available as an add-on for {price} per month excl. VAT.",
    "startup_order_warning_usage_form_builder": "You've created {count} form | You've created {count} forms",
    "startup_order_warning_usage_faq": "{count} FAQ entry created | {count} FAQ entries created",
    "startup_order_warning_usage_product_reviews": "{count} product review received | {count} product reviews received",
    "startup_order_warning_usage_stock_notification": "{count} customer waiting for stock alerts | {count} customers waiting for stock alerts",
    "startup_order_warning_usage_product_connections": "{count} product connection created | {count} product connections created",
    "startup_order_warning_usage_themes": "You have {count} themes — only the one active when you order stays available",
    "startup_order_warning_themes_hint": "Make sure the theme you want to keep is active before completing the order.",
    "upgrade_plan": "Upgrade plan",
    "unsaved_changes_warning": "You have unsaved changes. Are you sure you want to leave?",
    "order_webshop": "Order webshop",
    "create_manual_shipment": "Create manual shipment",
    "store_documents": "Documents",
    "invoice": "Invoice",
    "invoice_payment_shipping_email_note": "The customer pays by invoice, so the invoice is not attached to the shipping email. You will find it under Invoice on the order once the shipment is created.",
    "invoice_payment_method_note": "Customers who pay by invoice do not get our invoice in the shipping email. You will find it under Invoice on the order if you want to send it yourself.",
    "invoice_due_days": "Payment terms (days)",
    "invoice_due_days_hint": "Number of days the customer has to pay. Shown as the due date on the invoice.",
    "invoice_account_number": "Account number",
    "invoice_account_number_hint": "The account the customer pays to. Shown on the invoice.",
    "invoice_account_number_missing": "Account number missing",
    "invoice_account_number_missing_hint": "Fill in the account the customer pays to, so it is shown on the invoice.",
    "picklist": "Pick list",
    "picklist_columns_settings": "Select columns and customize names",
    "pickCheckboxName": "Checkbox if item is picked",
    "packCheckboxName": "Checkbox if item is packed",
    "product_name_with_variants": "Product name",
    "make_brand": "Brand/Make",
    "b2c": "Private",
    "b2b": "Company",
    "checkout_gateways_spennd_description": "With the Spennd checkout, you get a modern and flexible payment solution that gives you full control and makes it easy for your customers to shop. Vipps Login provides fast and secure identification, and customers don't have to fill in unnecessary information. You choose the order and visibility of payment options yourself. Support for the most popular payment methods: Vipps, Visa, Mastercard and Klarna in the Vipps app",
    "use_checkout": "Use checkout",
    "order_payment_methods": "Order payment methods here",
    "checkout_updated_successfully": "Checkout updated successfully",
    "only_one_checkout_at_a_time": "Notice: Only one checkout can be active at a time.",
    "included": "Included",
    "checkout_description_paragraph_1": "A checkout provider is the engine that handles your payments. Payment methods are what your customers use to pay. One checkout provider can offer multiple payment methods, and the same payment method can be available from multiple providers.",
    "checkout_description_paragraph_2": "The differences lie in the transaction fee (% of revenue), settlement time (days until payout), and which payment methods the provider offers.",
    "available_providers": "Available providers",
    "contact_qliro_to_order": "Contact Qliro to order",
    "contact_nets_to_order": "Set up Nets Easy here",
    "go_to_nets_portal": "Go to the Nets portal",
    "demo_mode": "Demo",
    "demo_mode_description": "This checkout is running against the sandbox environment — no real transactions.",
    "compare_checkout_providers": "Compare checkout providers",
    "payment_options": "Payment options",
    "settlement_model": "Settlement model",
    "settlement_multiple": "Multiple payouts",
    "settlement_single": "Single combined payout",
    "price_level": "Price level",
    "price_level_low": "Low",
    "price_level_medium": "Medium",
    "transaction_prices": "Transaction prices",
    "view_prices": "View prices",
    "settlement_time": "Settlement time",
    "b2c_b2b": "B2C / B2B",
    "best_for": "Best for",
    "best_for_kco": "Flexible settlements",
    "best_for_spennd": "Combined B2C and B2B",
    "best_for_qliro": "Single settlement",
    "best_for_nets_easy": "Integrated order processing",
    "best_for_vipps": "Simple solution",
    "best_for_demo": "New provider (test)",
    "checkout_gateways_demo_description": "A new payment provider with direct payouts and low fees. Supports the most common payment methods with fast settlement times.",
    "coming_soon": "Coming soon",
    "vipps_standalone_description": "Vipps as a standalone checkout with Vipps and Klarna.",
    "show_more": "Show more",
    "view_payment_options": "Edit payment options",
    "hide_payment_options": "Hide payment options",
    "show_less": "Show less",
    "registration_form_title": "Kustom Checkout Order Form",
    "registration_form_description": "In order for you to accept payments from your customers, the payment provider (Kustom) must complete an approval of your online store. The application process is simple and only takes a few minutes to complete. Once approved, you can start accepting payments in your online store.",
    "norway": "Norway",
    "business_information": "Business Information",
    "organization_name": "Organization Name",
    "organization_is_registered": "Organization is registered",
    "subject_to_vat": "Subject to VAT",
    "organization_category": "Organization Category",
    "choose_category": "Choose category",
    "support_email": "Support email",
    "support_phone": "Support phone",
    "stakeholder_information": "Stakeholder / Owner / Main Shareholder",
    "person": "Person",
    "date_of_birth": "Date of birth",
    "owner": "Owner",
    "material_influencer": "Material influencer",
    "street_address": "Street address",
    "region": "Region/State",
    "political_exposed_person": "Politically exposed person",
    "pep_role": "Politically exposed person role",
    "pep_relationship": "Relationship to politically exposed person",
    "add_person": "Add more people",
    "bank_account_information": "Bank account information",
    "currency_code": "Currency code",
    "nok": "NOK",
    "account_holder": "Account holder (name)",
    "iban_number": "IBAN number",
    "iban_help_text": "Fill in your IBAN NUMBER. You can find this number for example from your bank statement or in your online banking. Example of IBAN NUMBER is NO71 4482 0550 045",
    "form_submitted_successfully": "Your order has been registered, you will be contacted shortly",
    "kustom_accept_terms": "I accept the",
    "kustom_terms_link_text": "terms and conditions",
    "pep_head_of_state": "Head of state",
    "pep_head_of_gov": "Head of government",
    "pep_executive_gov_member": "High-ranking government member",
    "pep_deputy_minister": "Deputy minister",
    "pep_parliament_member": "Parliament leader",
    "pep_supreme_court_judge": "Supreme court judge",
    "pep_const_court_judge": "Court of appeal judge",
    "pep_auditing_auth_officer": "Audit authority officer",
    "pep_central_bank_boards_membr": "Central bank board member",
    "pep_ambassador": "Ambassador",
    "pep_international_org_leader": "International organization leader",
    "pep_armed_forces_officer": "Military leader",
    "pep_state_owned_enterprise_bodies_member": "State-owned enterprise leader",
    "pep_relationship_close_associate": "Close associate/assistant",
    "pep_relationship_spouse": "Spouse",
    "pep_relationship_partner": "Partner",
    "pep_relationship_children": "Children",
    "pep_relationship_children_spouses_or_partners": "Children, spouses or partners",
    "category_automotive_products": "Automotive Products",
    "category_automotive_parts_and_accessories": "Automotive Parts & Accessories",
    "category_wheels_and_tires": "Wheels & Tires",
    "category_children_products": "Children Products",
    "category_children_clothes_and_nurturing_products": "Children Clothes & Nurturing products",
    "category_children_toys": "Children toys",
    "category_diversified_children_products": "Diversified children products",
    "category_clothing_and_shoes": "Clothing & Shoes",
    "category_adult_shoes_and_clothing": "Adult Shoes & Clothing",
    "category_general_shoes_and_clothing": "General Shoes & Clothing",
    "category_underwear": "Underwear",
    "category_youthful_shoes_and_clothing": "Youthful Shoes & Clothing",
    "category_electronics": "Electronics",
    "category_car_electronics": "Car electronics",
    "category_diversified_electronics": "Diversified electronics",
    "category_electronic_equipment_and_related_accessories": "Electronic equipment & Related accessories",
    "category_household_electronics": "Household electronics (whitegoods/appliances)",
    "category_office_machines_and_related_accessories": "Office machines & Related accessories (excl. computers)",
    "category_book_and_magazines": "Books & Magazines",
    "category_diversified_entertainment": "Diversified entertainment",
    "category_music_and_movies": "Music & Movies",
    "category_video_games_and_related_accessories": "Video Games & Related accessories",
    "category_erotic_materials": "Erotic Materials",
    "category_diversified_erotic_material": "Diversified erotic material",
    "category_erotic_clothing_and_accessories": "Erotic Clothing & Accessories",
    "category_sex_toys": "Sex toys",
    "category_food_and_beverage": "Food & Beverage",
    "category_candy": "Candy",
    "category_tobacco": "Tobacco",
    "category_wine_beer_and_liquor": "Wine, Beer & Liquor",
    "category_health_and_beauty": "Health & Beauty",
    "category_body_and_hair_care": "Body & Hair Care",
    "category_cosmetics": "Cosmetics",
    "category_dietary_supplements": "Dietary supplements",
    "category_diversified_health_and_beauty_products": "Diversified Health & Beauty products",
    "category_fragrances": "Fragrances",
    "category_personal_care_and_body_improvement": "Personal care & Body improvement",
    "category_pharmaceutical_products": "Pharmaceutical products",
    "category_prescription_optics": "Prescription optics",
    "category_home_and_garden": "Home & Garden",
    "category_cleaning_and_sanitary": "Cleaning & Sanitary",
    "category_decoration_and_art": "Decoration & Art",
    "category_diversified_home_and_garden_products": "Diversified Home & Garden products",
    "category_furniture": "Furniture",
    "category_kitchenware": "Kitchenware",
    "category_pet_supplies": "Pet supplies",
    "category_plants_and_flowers": "Plants & Flowers",
    "category_safety_products": "Safety products",
    "category_tools_and_home_improvement": "Tools & Home improvement",
    "category_intangible_products": "Intangible products",
    "category_dating_services": "Dating services",
    "category_digital_services": "Digital services",
    "category_education": "Education",
    "category_event_tickets": "Event tickets",
    "category_marketplaces": "Marketplaces",
    "category_other_services": "Other services",
    "category_travel_services": "Travel services",
    "category_jewelry_and_accessories": "Jewelry & Accessories",
    "category_bags_and_wallets": "Bags & Wallets",
    "category_diversified_jewelry_and_accessories": "Diversified Jewelry & Accessories",
    "category_jewelry_and_watches": "Jewelry & Watches",
    "category_non_prescription_sunglasses_and_lenses": "Non-prescription sunglasses and lenses",
    "category_leisure_sport_and_hobby": "Leisure, Sport & Hobby",
    "category_collectibles": "Collectibles",
    "category_concept_stores_and_miscellaneous": "Concept stores & Miscellaneous",
    "category_costumes_and_party_supplies": "Costumes & Party supplies",
    "category_hobby_articles": "Hobby articles",
    "category_musical_instruments_and_equipment": "Musical Instruments & Equipment",
    "category_prints_and_photos": "Prints & Photos",
    "category_sports_gear_and_outdoor": "Sports gear & Outdoor",
    "email_text": "Extra text that is shown in the email to the customer after purcahse. Here you can for example include information on how the user should pay.",
    "receipt_page_text": "Extra text that is shown on the receipt page after purchase. Here you can for example include information on how the user should pay.",
    "email_text_label": "Extra text in email",
    "receipt_page_text_label": "Extra text on receipt page",
    "shipping_max_weight": "max weight",
    "shipping_max_weight_help": "The shipping method is hidden at checkout when the cart's total weight exceeds this limit. Leave empty or 0 for no limit.",
    "shipping_order_confirmation_text": "Extra text shown in the order-confirmation email, based on the chosen shipping method. E.g. pickup location and opening hours.",
    "shipping_fulfillment_text": "Extra text shown in the email when the order is ready or shipped, based on the chosen shipping method. E.g. that the customer brings the order number when picking up.",
    "customer_invalid_data": "Invalid customer data.",
    "customer_type_must_be_string": "Customer type must be a string.",
    "customer_first_name_must_be_string": "First name must be a string.",
    "customer_last_name_must_be_string": "Last name must be a string.",
    "customer_email_must_be_valid": "Email must be a valid email address.",
    "customer_phone_must_be_string": "Phone must be a string.",
    "delivery_address_invalid_data": "Invalid delivery address data.",
    "delivery_address_street_must_be_string": "Delivery address street must be a string.",
    "delivery_address_postal_code_must_be_numeric": "Delivery address postal code must be numeric.",
    "delivery_address_postal_code_must_be_4_digits": "Delivery address postal code must be 4 digits.",
    "delivery_address_city_must_be_string": "Delivery address city must be a string.",
    "delivery_address_country_must_be_string": "Delivery address country must be a string.",
    "shipping_method_identifier_must_be_string": "Shipping method identifier must be a string.",
    "pickup_point_invalid_data": "Invalid pickup point data.",
    "pickup_point_city_must_be_string": "Pickup point city must be a string.",
    "pickup_point_identifier_must_be_string": "Pickup point identifier must be a string.",
    "pickup_point_name_must_be_string": "Pickup point name must be a string.",
    "pickup_point_postal_code_must_be_string": "Pickup point postal code must be a string.",
    "pickup_point_street_must_be_string": "Pickup point street must be a string.",
    "payment_invalid_data": "Invalid payment data.",
    "payment_selected_identifier_must_be_string": "Payment selected identifier must be a string.",
    "promo_code_must_be_string": "Promo code must be a string.",
    "promo_code_does_not_exist": "Promo code does not exist.",
    "insight": "Insight",
    "payment_method_distribution": "Distribution of payment methods",
    "shipping_method_distribution": "Distribution of shipping methods",
    "orders_per_day": "Orders per day",
    "profit_per_day": "Profit per day",
    "revenue_per_day": "Revenue per day",
    "cost_of_goods_sold": "Cost of goods sold",
    "cogs_per_day": "Cost of goods sold per day",
    "profit_margin": "Profit margin",
    "total_revenue": "Total revenue",
    "customer_type_distribution": "Customer type distribution",
    "shipping_per_day": "Shipping per day",
    "number_of_orders": "Number of orders",
    "gross_income": "Gross income",
    "profitability_percentage": "Profitability",
    "db": "Coverage %",
    "january": "January",
    "february": "February",
    "march": "March",
    "april": "April",
    "may": "May",
    "june": "June",
    "july": "July",
    "august": "August",
    "september": "September",
    "october": "October",
    "november": "November",
    "december": "December",
    "same_month_last_year": "Same month last year",
    "compare_period": "Compare period",
    "compare_last_month": "Compare last month",
    "compare_last_year": "Compare last year",
    "period": "Period",
    "product_revenue": "Product revenue",
    "preorder_text": "Pre order text",
    "preorder_text_description": "Text displayed on the product when it is available for pre-order",
    "preorder_text_placeholder": "Expected in stock",
    "date_expected_in_stock": "Date expected in stock",
    "date_expected_in_stock_description": "Specify a date for when out-of-stock products with \"Allow backorder\" enabled are expected to be back in stock. Note: This will set the status of the product to \"Pre-order\" when the product is out of stock.",
    "qty_expected": "Quantity expected",
    "qty_expected_description": "Number of items expected to be back in stock on the specified date.",
    "date_and_qty_expected_set_per_variant": "Expected date and quantity are set per product variant in the Product variants table.",
    "more": "More",
    "empty": "Empty",
    "do_you_want_to_manage_the_offer_period": "Do you want to manage the offer period?",
    "if_turned_off_the_offer_starts_today": "If turned off, the offer starts today and has no end date",
    "show": "Show",
    "no_options_available": "No options available",
    "type_to_add_option": "Type to start creating an option",
    "variant_price_discrepancy_warning": "One or more variants have a different price than the others. If you enter a new price in the field below, it will apply to all variants.",
    "all_variants": "All variants",
    "product_is_on_sale": "Product is on sale",
    "send_email_to_customer": "Send email to customer",
    ":name(:email)_sent_email_to_customer": ":name (:email) sent email to customer:",
    "subject": "Subject",
    "body": "Body",
    "customer_message_description": "<strong>From:</strong> :fromEmail<br><strong>To:</strong> :toEmail<br><strong>Subject:</strong> :subject<br><br><strong>Message:</strong><br> :body :attachments",
    "email_sent": "Email sent",
    "send_email": "Send email",
    "order_confirmation": "Order confirmation",
    "cancellation_form": "Cancellation form",
    "attachments": "Attachments",
    "refund": "Refund",
    "theme_block_is_new_description": "The block is new and will automatically become visible when the template is published, unless publishing is disabled for the block",
    "edit_internal_name_of_block": "Edit internal name of block",
    "customer_text_label_placeholder": "Print on t-shirt",
    "extra_cost": "Extra cost",
    "customer_text": "Customer text",
    "customer_text_description": "Allows the customer to add custom text to the product, such as printed or engraved text, for example on a t-shirt",
    "field_heading": "Field heading",
    "form_type": "Form type",
    "form_type_description": "Contact forms are used for general inquiries, while product forms collect product-specific information and save it with the order",
    "contact": "Contact",
    "product_form": "Product form",
    "product_contact_form": "Contact form",
    "product_contact_form_admin_title": "Contact form on the product page",
    "product_contact_form_admin_description": "Choose a contact form customers can submit from this product. The product name is sent with the enquiry. The form is only shown on products where it is chosen here, and the «Contact form» sub-block must be enabled in the product page template in the design editor.",
    "product_contact_form_tooltip_text": "Lets customers send an enquiry straight from the product page without adding the product to the cart.<br><br>The product name is added to the submission automatically, so you can see which product the enquiry is about both in the email and under Forms → Submissions.",
    "create_contact_form_link": "Create a contact form",
    "product_contact_form_app": "Contact form on products",
    "product_contact_form_app_description": "Let customers send an enquiry straight from the product page. You choose which products get a form, and the product name is sent with the enquiry automatically.",
    "product_contact_form_app_heading": "Contact form on products – get enquiries about exactly that product",
    "product_contact_form_app_sub_heading": "Some products need a conversation before the purchase: price requests, custom measurements, adjustments or large orders. With this app you put a contact form on exactly those products, and the customer never has to explain which product it concerns.",
    "product_contact_form_app_how_it_works_1": "Create a contact form in the form builder, or use one you already have.",
    "product_contact_form_app_how_it_works_2": "Choose the form on each product that should have it, under «Contact form on the product page» in the product editor.",
    "product_contact_form_app_how_it_works_3": "Enable the «Contact form» sub-block in the product page template in the design editor, and decide whether the form is visible or sits behind a button.",
    "product_contact_form_app_how_it_works_4": "Every enquiry is stored under Forms → Submissions and sent by email, with the product name as the first line.",
    "product_contact_form_app_how_it_works_5": "The app is free and included with Form builder. Order it and switch it on under the app settings, and the box appears in the product editor and the sub-block in the design editor.",
    "product_contact_form_app_requires_form_builder": "Requires the Form builder app to be active, since the forms are created there. The switch for this app can only be turned on once Form builder is on.",
    "product_contact_form_display_style": "Display",
    "product_contact_form_display_always": "Always visible",
    "product_contact_form_display_collapsible": "Behind a button",
    "product_contact_form_button_label": "Button text",
    "product_contact_form_button_label_description": "The text on the button that opens the form.",
    "no_form": "No form",
    "invalid_value_for": "Invalid value for :name",
    "product_form_must_be_completed": "This product requires a form to be filled out. Go to the product page to complete your purchase.",
    "buyable_not_available": "The product is not available for purchase",
    "buyable_id_and_type_not_valid": "The product could not be added to the cart",
    "product_form_tooltip_text": "Product forms let you collect custom information from customers when they add a product to their cart – such as engraving text, gift messages, or custom measurements.<br><br>The form fields are displayed on the product page and the submitted data is saved with the order.<br><br>You can also set an additional cost that is added to the product price when a form is attached.",
    "additional_cost": "Additional cost",
    "additional_cost_placeholder": "0.00",
    "additional_cost_help": "Additional cost added to the product price when this form is selected",
    "create_product_form_link": "Create a product form",
    "b2b_app_description": "Enable B2B checkout and show prices excl. VAT for business customers",
    "b2b_app_headline": "B2B for business customers",
    "b2b_app_subline": "Let business customers check out with their organization number and see prices excl. VAT.",
    "b2b_app_advantages_heading": "Advantages of B2B",
    "b2b_app_advantage_1": "Show prices excl. VAT for business customers",
    "b2b_app_advantage_2": "Dedicated fields for organization number, project, and department at checkout",
    "b2b_app_advantage_3": "Let customers choose whether they are private or business customers",
    "b2b_app_advantage_4": "Set business as default customer type for B2B-focused stores",
    "b2b_enabled": "Enable B2B",
    "b2b_enabled_description": "Enables B2B checkout and the option to show prices excl. VAT",
    "b2b_is_b2b_by_default": "B2B by default",
    "b2b_is_b2b_by_default_description": "New visitors see prices excl. VAT and are treated as business customers by default",
    "b2b_show_customer_type_modal": "Show customer type modal",
    "b2b_show_customer_type_modal_description": "Show a modal asking the customer if they are a business or private customer on first visit",
    "b2b_customer_type_question": "What type of customer are you?",
    "b2b_customer_type_description": "Business customers see prices excl. VAT",
    "b2b_private_customer": "Private customer",
    "b2b_business_customer": "Business customer",
    "b2b_requires_compatible_checkout": "B2B requires at least one payment method for :checkout.",
    "b2b_checkout_default": "Default checkout for B2B",
    "b2b_checkout_default_description": "Select which checkout to use for B2B customers",
    "b2b_checkout_checkout_gateways_spennd": "Spennd",
    "b2b_checkout_checkout_gateways_kco": "Kustom Checkout",
    "b2b_checkout_checkout_gateways_qliro": "Qliro Checkout",
    "b2b_checkout_checkout_gateways_nets_easy": "Nets Easy",
    "b2b_checkout_settings": "B2B settings",
    "validation.organization_number_invalid": "Invalid organization number",
    "validation.phone_invalid": "Invalid phone number",
    "validation.phone_required": "Phone number is required",
    "validation.company_name_required": "Company name is required",
    "validation.organization_number_required": "Organization number is required",
    "filtering": "Filtering",
    "filtering_description": "filters appear on category and search pages, allowing customers to narrow down products by specific properties such as size, color, or price range. Filter groups are automatically generated from product options (variants) and attributes. The ordering is global and applies to all pages where products can be filtered. Drag and drop to reorder groups and their values.",
    "filtering_sale_filter_row": "On sale",
    "filtering_stock_filter_row": "In stock",
    "filtering_theme_managed_badge": "Design builder",
    "filtering_theme_managed_note": "Toggled in the design builder under Category page → Filters",
    "filtering_design_builder_hint": "The placement and appearance of the filters is controlled in the design builder.",
    "open_design_builder": "Open the design builder",
    "category_filters_admin_hint": "Which filters appear, and their order, is managed on the Filtering page under Products.",
    "open_filtering_page": "Open Filtering",
    "filtering_empty_state_title": "No filter groups yet",
    "filtering_empty_state_description": "Filter groups are automatically created from product options and attributes. Add options (like Size or Color) or attributes to your products and they will appear here.",
    "filtering_go_to_products": "Go to products",
    "filtering_source_option": "Variant",
    "filtering_source_attribute": "Attribute",
    "filtering_source_both": "Variant + Attribute",
    "filter_visibility": "Filter visibility",
    "filter_visibility_description": "Choose which filters are shown on category and search pages in your store.",
    "price_filter": "Price filter",
    "facet_filters": "Filter groups",
    "inherit": "Inherit",
    "filter_visibility_inherit_description": "\"Inherit\" uses the global default setting. You can change the defaults under",
    "filter_visibility_global_link": "filtering",
    "unsaved_changes": "you have unsaved changes",
    "updating_preview": "Updating preview ...",
    "reset_to_default": "Reset",
    "pi_column_gap": "Column gap",
    "pi_sub_block_spacing": "Spacing between elements",
    "pi_vertical_padding": "Top and bottom padding",
    "unsaved_changes_confirm": "You have unsaved changes. Are you sure you want to leave?",
    "expand_all": "expand all",
    "collapse_all": "collapse all",
    "group": "group",
    "groups": "groups",
    "value": "value",
    "values": "values",
    "search_blocks": "Search blocks",
    "no_blocks_found": "No blocks found",
    "block_category_products": "Products",
    "block_category_media": "Media",
    "block_category_content": "Content",
    "block_category_marketing": "Marketing",
    "block_description_product_grid": "Display products in a grid layout",
    "block_description_product_slider": "Showcase products in a horizontal slider",
    "block_description_single_product": "Highlight a single product with details",
    "block_description_image_grid": "Display images in a grid layout",
    "block_description_bento_grid": "Display images in an asymmetric bento grid",
    "block_description_image_grid_slider": "Show multiple images in a horizontal slider",
    "block_description_image_slider": "Show images in a horizontal slider",
    "block_description_before_after_image": "Compare two images with a draggable slider — the customer drags to reveal the after image",
    "before_image": "Before image",
    "after_image": "After image",
    "before_label": "Before label",
    "after_label": "After label",
    "initial_slider_position": "Initial slider position",
    "initial_slider_position_description": "Where the slider handle sits on page load (0 = far left, 100 = far right).",
    "block_description_hero_image_text": "Large image with text overlay",
    "block_description_hero_background_image_text": "Full-width background image with text",
    "block_description_text_content": "Rich text content section",
    "block_description_faq": "Frequently asked questions with expandable answers",
    "block_description_form": "Customizable contact or inquiry form",
    "block_description_campaign_bar": "Promotional banner for campaigns and offers",
    "block_description_newsletter_signup": "Email signup form for newsletters",
    "customer_club_block": "Customer club",
    "block_description_customer_club": "Recruit club members with the welcome bonus and point rate, and show members their balance.",
    "customer_club_block_layout_banner": "Banner",
    "customer_club_block_layout_benefits": "Benefits",
    "customer_club_block_layout_steps": "How it works",
    "customer_club_block_layout_calculator": "Calculator",
    "customer_club_block_calculator_max": "Calculator maximum amount (kr)",
    "customer_club_block_calculator_max_description": "Upper end of the slider. The starting value is one fifth of this.",
    "customer_club_block_layout_description": "Banner is a single surface with text and a button. Benefits shows three cards. How it works shows the steps from joining to discount. Calculator lets the customer drag an amount and see points and value.",
    "customer_club_block_show_bonus": "Show welcome bonus",
    "customer_club_block_show_bonus_description": "Shown to non-members only, and only when the welcome bonus in the customer club settings is above zero.",
    "customer_club_block_show_rate": "Show point rate",
    "customer_club_block_show_rate_description": "Applies to the banner layout. The benefits layout always shows the rate in its cards.",
    "customer_club_block_member_title": "Title for members",
    "customer_club_block_member_title_description": "Shown to logged-in members together with their balance.",
    "customer_club_block_member_button_text": "Button text for members",
    "customer_club_block_button_style_description": "“Filled” uses the theme's button colour. On a dark surface “Text colour as background” or “Outlined” usually reads better.",
    "block_description_category_buttons": "Display categories as clickable buttons",
    "block_description_featured_blog_posts": "Display featured blog posts in a slider",
    "featured_blog_posts": "Featured blog posts",
    "featured_blog_posts_select_tag": "Select a tag to filter blog posts. Leave empty to show the latest.",
    "blog_tag": "Blog tag",
    "number_of_posts": "Number of posts",
    "show_date": "Show date",
    "show_tags": "Show tags",
    "block_title_color": "Block title color",
    "global": "global",
    "search_for_menu": "Search for menu",
    "confirm_delete_campaign_text": "Are you sure you want to delete the campaign text?",
    "unsupported_file_type": "Unsupported file type",
    "file_too_large": "File {name} is too large, max file size is {size}MB",
    "theme_block_media_too_large": "The image is too large. Maximum file size is :size MB.",
    "theme_block_media_required": "No file was received. Please choose a file and try again.",
    "uploaded_file_too_large_for_server": "The file is too large to upload. Please use a smaller file.",
    "block_duplicated": "Block duplicated",
    "fullscreen_preview": "Fullscreen preview",
    "exit_fullscreen": "Exit fullscreen",
    "dark_mode": "Dark mode",
    "light_mode": "Light mode",
    "some_variants_have_different_prices": "Some variants have different prices",
    "video_hero": "Video hero",
    "background_video": "Background video",
    "video_url": "Video URL",
    "video_controls": "Video controls",
    "video_show_controls": "Show video controls",
    "video_show_controls_description": "Adds play/pause, restart and sound on/off on top of the video. The video still starts on its own without sound.",
    "block_height_mobile": "Height on mobile",
    "follow_desktop": "Follow desktop",
    "video_controls_placement": "Placement of the controls",
    "video_controls_size": "Size of the controls",
    "bottom_right": "Bottom right",
    "bottom_left": "Bottom left",
    "top_right": "Top right",
    "top_left": "Top left",
    "video_play": "Play video",
    "video_pause": "Pause video",
    "video_restart": "Restart video",
    "video_mute": "Mute",
    "video_unmute": "Unmute",
    "video_url_description": "Paste a YouTube or Vimeo link, e.g. https://www.youtube.com/watch?v=…, https://youtu.be/… or https://vimeo.com/…. The video plays automatically, muted and on loop.",
    "video_url_youtube_detected": "YouTube video detected",
    "video_url_vimeo_detected": "Vimeo video detected",
    "video_url_unrecognized": "This URL wasn't recognized. Supported services are YouTube and Vimeo.",
    "title_color": "Title color",
    "title_size": "Title size",
    "text_size": "Text size",
    "button_text_color": "Button text color",
    "button_size": "Button size",
    "button_background_color": "Button background color",
    "button_border_radius": "Button border radius",
    "category_buttons": "Categories (buttons)",
    "category_buttons_select_categories": "Select categories to display as buttons",
    "gap_between_buttons": "Gap between buttons",
    "hover_effect": "Hover effect",
    "hover_effect_description": "Choose how the images should respond when the user hovers over them",
    "hover_effect_scale": "Scale up",
    "hover_effect_shadow": "Shadow",
    "hover_effect_blur": "Blur",
    "hover_effect_grayscale": "Grayscale",
    "scale": "Scale",
    "underline": "Underline",
    "fill": "Brighten",
    "button_layout": "Button layout",
    "wrap": "Wrap",
    "scroll": "Scroll",
    "button": "Button",
    "video": "Video",
    "overlay": "Overlay",
    "medium": "Medium",
    "full_screen": "Full screen",
    "block_height": "Height",
    "video_hero_app_description": "Add a full-width video hero section to your storefront for an engaging, cinematic first impression.",
    "video_hero_heading": "Video Hero – captivate visitors from the first second",
    "video_hero_sub_heading": "With the Video Hero app you can add a stunning full-width background video section to your store's front page. Overlay text, buttons and calls-to-action on top of the video to guide visitors exactly where you want them.",
    "advantages_with_video_hero": "Advantages of Video Hero",
    "advantages_with_video_hero_1": "<strong>Instant attention</strong> – a moving hero section grabs visitors' attention far more effectively than a static image.",
    "advantages_with_video_hero_2": "<strong>Stronger branding</strong> – showcase your products, story or campaign in a cinematic way that builds trust.",
    "advantages_with_video_hero_3": "<strong>Fully customisable</strong> – control text, colours, button styles, overlay and placement directly from the theme editor.",
    "video_hero_sub_text": "With Video Hero your storefront stands out, engages visitors and drives more conversions.",
    "video_hero_file_limit": "Supported formats: MP4 and WebM. Maximum file size: 30 MB.",
    "show_contact_phone_number": "Show contact phone number",
    "footer_block_show_phone_number_description": "Choose whether to display the contact phone number",
    "show_contact_email": "Show contact email",
    "footer_block_show_email_description": "Choose whether to display the contact email address",
    "show_contact_address": "Show address",
    "footer_block_show_address_description": "Choose whether to display the store address",
    "show_org_number": "Show org. number",
    "footer_block_show_org_number_description": "Choose whether to display the company registration number",
    "footer_section_order": "Content order",
    "footer_section_order_description": "Drag to change the order of the footer content.",
    "footer_menu_order_description": "Drag to change the order of the menus in the footer.",
    "footer_section_company": "Company information",
    "footer_section_contact": "Contact information",
    "footer_section_newsletter": "Newsletter",
    "footer_top_shape": "Top edge shape",
    "footer_top_shape_description": "Decorative shape at the top of the footer. Only applies to variant 2.",
    "footer_top_shape_dip": "Curved",
    "footer_top_shape_wave": "Wave",
    "footer_top_shape_diagonal": "Diagonal",
    "footer_top_shape_sawtooth": "Saw tooth",
    "footer_top_shape_overlap": "Overlap the block above",
    "footer_top_shape_overlap_description": "On: the shape cuts into the bottom of the block above, so the footer blends into that block's background colour. Make sure the block above has enough bottom padding. Off: a gap in the page background colour is shown before the shape.",
    "footer_top_gap_color": "Colour above the shape",
    "footer_top_gap_color_description": "Colour of the area between the block above and the shape. The page background is white, so white keeps the previous look.",
    "footer_variant_1": "Variant 1",
    "footer_variant_2": "Variant 2",
    "footer_variant_3": "Variant 3",
    "footer_variant_4": "Variant 4",
    "footer_variant_5": "Variant 5",
    "footer_variant_6": "Variant 6",
    "header_variant_1": "Variant 1",
    "header_variant_2": "Variant 2",
    "header_variant_3": "Variant 3",
    "header_variant_4": "Variant 4",
    "header_variant_5": "Variant 5",
    "header_variant_6": "Variant 6",
    "including_unfulfilled_orders": "Including unfulfilled orders",
    "ship_without_edi": "Ship without EDI",
    "license_page_order_title": "Order your 24Nettbutikk",
    "license_page_grow_title": "The store that grows with you",
    "license_page_subtitle": "Complete platform with the best shipping deals, trusted payment solutions and free Norwegian support.",
    "license_page_social_proof": "Used by over 1,000 Norwegian online stores",
    "license_page_no_startup_costs": "No startup costs",
    "license_page_free_support": "Free Norwegian support",
    "license_page_no_commitment": "No commitment",
    "license_page_six_month_commitment": "6 month commitment",
    "license_page_best_price": "best price",
    "license_page_startup_credit_card_note": "For Startup a registered credit card is required.",
    "license_page_startup_desc": "Perfect for getting started quickly with a professional online store.",
    "license_page_premium_desc": "Norway's most popular e-commerce package — everything you need to grow, with better prices and powerful sales tools.",
    "license_page_premium_pluss_desc": "For ambitious online stores that want it all — the lowest prices, most apps and personal support.",
    "license_page_most_chosen": "Most chosen",
    "license_page_current_plan": "Your current plan",
    "license_page_get_started": "Get started",
    "license_page_choose_premium": "Choose Premium",
    "license_page_choose_premium_pluss": "Choose Premium Pluss",
    "license_page_upgrade_to_premium": "Upgrade to Premium",
    "license_page_upgrade_to_premium_pluss": "Upgrade to Premium Pluss",
    "license_page_see_all_features": "See all features",
    "license_page_included_apps": "Apps included:",
    "license_page_all_from_startup_plus": "Everything in Startup, plus:",
    "license_page_all_from_premium_plus": "Everything in Premium, plus:",
    "license_page_3x_more_products": "3x more products",
    "license_page_up_to_products": "up to {count}",
    "license_page_lower_klarna_price": "Lower Kustom price",
    "license_page_lower_shipping": "Lower shipping prices",
    "license_page_via_24shipping": "via 24Shipping",
    "license_page_marketing_tools": "Marketing tools",
    "license_page_upsell_crosssell": "for upselling and cross-selling",
    "license_page_b2b": "B2B sales",
    "license_page_b2b_desc": "custom pricing and login for business customers",
    "license_page_unlimited_products": "Unlimited products",
    "license_page_lowest_klarna": "Lowest Kustom price",
    "license_page_best_shipping": "Our best shipping prices",
    "license_page_all_apps_included": "Most apps included in the price",
    "license_page_no_extra_cost": "our best prices",
    "license_page_priority_support": "Priority support",
    "license_page_faster_response": "faster response",
    "license_page_personal_designer": "Personal web designer",
    "license_page_designer_desc": "customizes your store",
    "license_page_24shipping": "24Shipping — ready shipping agreement with Bring and PostNord",
    "license_page_vipps_klarna": "Payment with Vipps and Klarna",
    "license_page_up_to_2000_products": "Up to 2,000 products",
    "license_page_unlimited_orders": "Unlimited orders",
    "license_page_ssl": "SSL certificate (Rating A+)",
    "license_page_design_builder": "Modern design builder — customize your store without code",
    "license_page_seo": "SEO optimization",
    "license_page_label_printer_discount": "50% discount on label printer",
    "license_page_free_norwegian_support": "Free Norwegian support",
    "app_store_featured": "Recommended apps",
    "app_store_included_with": "Included with {app}",
    "included_with_app": "Included with",
    "app_requires_app_active": "This app requires {app} to be active.",
    "app_dependency_not_active": "{app} is not active. Switch it on first, then this app can be switched on.",
    "app_store_included": "Included",
    "app_store_requires_upgrade": "Requires a higher license",
    "app_store_from_price": "from {price} kr/mo",
    "app_store_installed": "Installed",
    "app_store_see_more": "See more",
    "app_store_all": "All",
    "app_store_price_filter": "Price",
    "app_store_free": "Free",
    "app_store_third_party": "Third-party",
    "app_store_related": "Related apps",
    "app_store_not_included_trial": "Not included in trial",
    "app_store_search": "Search for apps...",
    "app_store_prices_your_plan": "Your plan",
    "app_store_prices_you_get_apps": "With {plan} you get {count} more apps included than on {currentPlan}",
    "app_store_prices_you_save_hint": "The amount is what the {count} apps cost bought separately as add-ons on {currentPlan}. You only save on the apps you actually use.",
    "app_store_prices_you_pay_today": "You pay for these add-on apps today: {names}",
    "app_store_prices_trial_chip": "Trial",
    "app_store_prices_trial_banner_body": "The store has the apps included with {plan} for as long as the trial lasts. The prices below apply once you choose a plan.",
    "app_store_prices_trial_choose_plan": "Choose a plan",
    "app_store_prices_apps_included": "apps included",
    "app_store_prices_see_plan": "More about {plan}",
    "app_store_prices_third_party_heading": "{count} third-party apps",
    "app_store_prices_top_plan": "You're on the plan with the most apps included",
    "app_store_prices_third_party_note": "Third-party apps are priced and billed by the provider, not by us. Apps with a price in the table above are billed by us.",
    "app_store_prices_not_included_filter": "Not included",
    "app_store_prices_difference": "{amount}/mo more than {currentPlan}",
    "app_store_prices_not_available": "Not available",
    "app_store_prices_no_add_ons": "You pay for no add-on apps today",
    "app_store_prices_net_saving": "If you switch, you pay {amount}/mo less in total than today",
    "app_store_prices_net_even": "If you switch, you pay the same in total and get {count} more apps",
    "app_store_prices_already_yours": "You pay for this app as an add-on today",
    "app_store_prices_default_sort": "Reset sorting",
    "app_store_prices_compare": "Compare prices",
    "app_store_prices_recommended": "We recommend",
    "app_store_prices_show_more_apps": "+{count} more",
    "app_store_prices_show_fewer_apps": "Show fewer",
    "app_store_prices_paid_today_short": "You pay for this today",
    "app_store_prices_included_in_all_plans": "Included in every plan",
    "app_store_prices_you_save": "You save",
    "app_store_prices_you_save_sub": "on the {count} apps bought one by one on {currentPlan}",
    "app_store_prices_heading": "Apps and prices per plan",
    "app_store_prices_intro": "See which apps are included in your plan, which become included on a higher plan, and what each app costs as an add-on.",
    "app_store_prices_with_commitment": "with a six-month commitment",
    "app_store_prices_license_price_note": "Licence prices are per month with a six-month commitment.",
    "postnord": "PostNord",
    "postnord_app_description": "This app manages the webshop's access to your PostNord account for shipping calculations.",
    "client_id": "Client ID",
    "client_id_description": "Client ID is used in third party systems to identify your webshop",
    "client_secret": "Client Secret",
    "client_secret_description": "Client Secret is used together with Client ID to authenticate your webshop with third party systems",
    "postnord_heading": "PostNord",
    "postnord_sub_heading_1": "You use this app if you have your own shipping agreement with PostNord. Note that we deliver PostNord via our own shipping deal - 24Shipping which is already ready to use, and which most likely gives you better prices than what you can achieve with a direct agreement with PostNord.",
    "postnord_sub_heading_2": "Note that you must have integration with a TA partner if you want automatic printing of address labels.",
    "postnord_sub_heading_3": "Activate PostNord's shipping options here",
    "postnord_sub_heading_4": "With PostNord, you get one of the Nordics most reliable and flexible logistics partners – right into your online store.",
    "why_use_postnord": "Why choose PostNord?",
    "why_use_postnord_1": "<strong>Covers the entire Nordic region</strong> – delivers to both individuals and businesses.",
    "why_use_postnord_2": "<strong>Flexible delivery options</strong> – home delivery, pick-up point or parcel lockers.",
    "why_use_postnord_3": "<strong>Reliable tracking</strong> – customers can follow the shipment from store to delivery.",
    "why_use_postnord_4": "<strong>Strong in B2B and B2C</strong> – scales whether you send small packages or large volumes.",
    "important": "Important",
    "postnord_customer_id": "Customer ID",
    "postnord_customer_id_description": "Your Customer ID with PostNord",
    "helthjem_helthjem": "HeltHjem",
    "helthjem_helthjem_app_description": "Integrate your webshop with HeltHjem for seamless shipping and delivery.",
    "helthjem_helthjem_landing_description": "Connect your webshop to HeltHjem to streamline your shipping process and offer your customers reliable delivery options.",
    "helthjem_helthjem_app_description_1": "Easily manage your shipments directly from your webshop.",
    "helthjem_helthjem_app_description_2": "Provide your customers with flexible delivery options through HeltHjem's extensive network.",
    "helthjem_shop_id": "Shop ID",
    "helthjem_shop_id_description": "Your unique identifier for your webshop in HeltHjem's system.",
    "helthjem_transport_solution_id": "Transport Solution ID",
    "helthjem_transport_solution_id_description": "The ID of the transport solution you want to use for your shipments.",
    "helthjem_client_id": "Client ID",
    "helthjem_client_id_description": "Client ID is used in third-party systems to identify your webshop.",
    "helthjem_client_secret": "Client Secret",
    "helthjem_client_secret_description": "Client Secret is used together with Client ID to authenticate your webshop with third-party systems.",
    "helthjem_invalid_credentials": "Could not connect to HeltHjem. Please verify that the Shop ID, Client ID and Client Secret are correct.",
    "helthjem_heading": "HeltHjem",
    "helthjem_sub_heading_1": "With the <strong>HeltHjem integration</strong>, you make it easy for your customers to have their goods delivered directly to their home – quickly, safely and flexibly. HeltHjem delivers to all of Norway, also early in the morning, and has one of the market's most user-friendly delivery options.",
    "helthjem_sub_heading_2": "Note that you must have integration with a TA partner if you want automatic printing of address labels.",
    "why_use_helthjem": "Why choose HeltHjem?",
    "why_use_helthjem_1": "<strong>Fast delivery</strong> – often overnight, so the customer gets their package already the next morning.",
    "why_use_helthjem_2": "<strong>Directly in the mailbox or on the doorstep</strong> – customers avoid having to go to a pick-up point.",
    "why_use_helthjem_3": "<strong>Delivery at the door</strong> – also early morning</strong> – the package is ready when the customer wakes up.",
    "why_use_helthjem_4": "<strong>Covers all of Norway</strong> – from city to rural areas, with a high delivery rate.",
    "helthjem_pricing_notice_title": "Prices must be set manually",
    "helthjem_pricing_notice_body": "HeltHjem does not calculate shipping prices automatically based on weight or dimensions. You must set the price for each shipping method in your <strong>Shipping</strong> settings after the app is activated.",
    "shipping_method_requires_configuration_1": "This shipping method requires configuration.",
    "shipping_method_requires_configuration_2": "Go to apps",
    "shipping_method_requires_configuration_3": "to activate and configure this shipping method.",
    "checkout_gateways_qliro_description": "Qliro Checkout provides your online store with a modern and user-friendly checkout solution designed to increase conversion rates and improve the customer experience. It offers multiple popular payment options, including invoice, instalments, and card payments, tailored for Nordic markets. Qliro manages the payment flow and credit risk, ensuring secure and reliable payouts. With clear sales reports and insights, you gain full control of your payments – a flexible checkout solution that supports growth and long-term customer loyalty. <br><br> Qliro manages all payment methods internally. Contact Qliro to add or edit the available payment methods in the checkout.",
    "edit_credentials": "Edit credentials",
    "credentials_updated": "Credentials updated",
    "credentials_already_saved_placeholder": "•••••••• (saved — leave blank to keep)",
    "credentials_currently_saved": "saved",
    "checkout_gateway_does_not_support_credential_editing": "This checkout has no editable credentials.",
    "qliro_api_key": "API-key",
    "qliro_api_secret": "API-secret",
    "qliro_no_shipping_method_selected": "No shipping methods available. Contact us for help.",
    "qliro_checkout_newsletter_text": "Be the first to receive information about our products and promotions",
    "no_data_for_period": "No data for the selected period",
    "missing_name": "Missing name",
    "deleted_product_with_id": "Deleted product (ID {id})",
    "no_checkout_or_payment_methods_configured": "No checkout is fully configured. Customers will not be able to complete purchases.",
    "go_to_payment_settings": "Go to payment settings",
    "spennd_enabled_without_payment_methods": "Spennd is enabled but has no payment methods activated. Enable at least one payment method for Spennd to work.",
    "attribute_name_already_in_use": "The name is already in use as a variant option or an attribute.",
    "option_name_already_in_use": "The name is already in use as an attribute or a variant option.",
    "attribute_name_cannot_be_same_as_option_name": "An attribute cannot have the same name as a variant option.",
    "dashboard.vs_yesterday": "vs. yesterday",
    "dashboard.vs_last_week": "vs. last week",
    "dashboard.vs_last_month": "vs. last month",
    "dashboard.vs_last_year": "vs. last year",
    "dashboard.period_today": "Today",
    "dashboard.period_this_week": "This week",
    "dashboard.period_this_month": "This month",
    "dashboard.period_this_year": "This year",
    "dashboard.section_kpis": "Key financial metrics",
    "dashboard.section_operational": "Operational",
    "dashboard.section_financial": "Financial analysis",
    "dashboard.section_products": "Products & sales",
    "dashboard.section_customers": "Customers",
    "dashboard.section_logistics": "Operations & logistics",
    "dashboard.section_search": "Search",
    "dashboard.monthly_status": "Monthly status",
    "dashboard.monthly_status_tooltip": "Sales so far this month vs. same period last month",
    "dashboard.this_month_so_far": "This month so far",
    "dashboard.same_period_last_month": "Same period last month",
    "dashboard.n_orders": "1 order | {count} orders",
    "dashboard.no_sales_this_month": "No sales this month",
    "dashboard.sales_data_after_first_order": "No orders have been placed this month.",
    "dashboard.sales_distribution": "Sales distribution",
    "dashboard.sales_distribution_tooltip": "Sales distributed by weekday or time of day, based on the last 90 days.",
    "dashboard.weekday": "Weekday",
    "dashboard.time_of_day": "Time of day",
    "dashboard.avg_revenue": "Average revenue",
    "dashboard.not_enough_data": "Not enough data",
    "dashboard.sales_distribution_empty": "No orders have been placed in this period.",
    "dashboard.refunds": "Refunds",
    "dashboard.refunds_tooltip": "Refunded and cancelled orders",
    "dashboard.refunded": "Refunded",
    "dashboard.cancelled": "Cancelled",
    "dashboard.total_lost": "Total lost",
    "dashboard.loss_rate": "Loss rate",
    "dashboard.no_refunds": "No refunds",
    "dashboard.no_refunds_in_period": "No refunds or cancellations in the period.",
    "dashboard.top_products": "Best selling products",
    "dashboard.top_products_tooltip": "Products with the highest sales",
    "dashboard.quantity": "Quantity",
    "dashboard.amount": "Amount",
    "dashboard.no_sales_data": "No sales data",
    "dashboard.product_data_after_first_sale": "No products have been sold in this period.",
    "dashboard.top_refunded": "Most refunded",
    "dashboard.top_refunded_tooltip": "Products with a high refund rate may indicate quality issues, incorrect product descriptions, or sizing discrepancies.",
    "dashboard.product": "Product",
    "dashboard.return_pct": "Return %",
    "dashboard.no_refunded_products": "No refunded products",
    "dashboard.no_refunded_in_period": "No products have been refunded in this period.",
    "dashboard.low_stock": "Low stock",
    "dashboard.low_stock_tooltip": "Shows the 20 products with less than 30 days of stock remaining, based on sales over the last 3 months.",
    "dashboard.sku": "SKU",
    "dashboard.in_stock": "In stock",
    "dashboard.days_remaining": "Days left",
    "dashboard.n_days": "1 day | {count} days",
    "dashboard.no_stock_alerts": "No stock alerts",
    "dashboard.all_products_sufficient_stock": "All products have sufficient stock.",
    "dashboard.pending_orders": "Pending orders",
    "dashboard.pending_orders_tooltip": "Orders awaiting processing",
    "dashboard.date": "Date",
    "dashboard.customer": "Customer",
    "dashboard.total": "Total",
    "dashboard.no_pending_orders": "No pending orders",
    "dashboard.all_orders_processed": "All orders have been processed.",
    "dashboard.unmoderated_reviews": "Customer reviews",
    "dashboard.unmoderated_reviews_tooltip": "Reviews awaiting approval",
    "dashboard.activate_in_app_store": "Activate in App Store",
    "dashboard.no_unmoderated_reviews": "No unmoderated reviews",
    "dashboard.all_reviews_approved": "All reviews have been approved.",
    "dashboard.new_vs_returning": "New vs returning",
    "dashboard.new_vs_returning_tooltip": "Distribution of new and repeat customers",
    "dashboard.new": "New",
    "dashboard.returning": "Returning",
    "dashboard.returning_lc": "returning",
    "dashboard.n_customers": "1 customer | {count} customers",
    "dashboard.total_customers": "Total customers",
    "dashboard.no_customer_data": "No customer data",
    "dashboard.customer_data_after_first_sale": "No customers have been registered in this period.",
    "dashboard.clv_title": "Repurchase & CLV",
    "dashboard.clv_tooltip": "CLV (Customer Lifetime Value) is the total amount a customer has spent since their first order. Repurchase rate shows the percentage of customers who have placed more than one order.",
    "dashboard.club_members": "Customer club",
    "dashboard.club_members_tooltip": "Active club members, how many joined in the period, the share of consumer customers who are members, and outstanding points.",
    "dashboard.club_active_members": "Active members",
    "dashboard.club_share_of_customers": "Share of customers",
    "dashboard.club_pending_points": "Points on the way",
    "dashboard.club_available_points": "Available points",
    "dashboard.club_points_worth": "worth {value}",
    "dashboard.club_see_members": "See members",
    "dashboard.club_no_members": "No members yet",
    "dashboard.club_no_members_description": "Members show up here once customers join.",
    "dashboard.all_time": "All-time",
    "dashboard.avg_clv": "Avg CLV",
    "dashboard.repurchase_rate": "Repurchase rate",
    "dashboard.avg_orders_per_customer": "Avg orders / customer",
    "dashboard.order_status": "Order status",
    "dashboard.order_status_tooltip": "Distribution of order statuses",
    "dashboard.n_requires_action": "1 requires action | {count} require action",
    "dashboard.pending": "Pending",
    "dashboard.partial": "Partial",
    "dashboard.fulfilled": "Fulfilled",
    "dashboard.totalt": "total",
    "dashboard.no_orders": "No orders",
    "dashboard.order_status_empty": "No orders have been placed yet.",
    "dashboard.processing_time": "Processing time",
    "dashboard.processing_time_tooltip": "Average time from order to fulfillment",
    "dashboard.avg_processing_time": "Average processing time",
    "dashboard.fastest": "Fastest",
    "dashboard.slowest": "Slowest",
    "dashboard.hour_suffix": "h",
    "dashboard.under_24h": "Under 24h",
    "dashboard.no_fulfilled_orders": "No fulfilled orders",
    "dashboard.processing_time_empty": "No orders have been fulfilled in this period.",
    "dashboard.shipping_methods": "Shipping methods",
    "dashboard.shipping_methods_tooltip": "Distribution of shipping methods",
    "dashboard.no_shipping_data": "No shipping data",
    "dashboard.shipping_methods_empty": "No orders with shipping in this period.",
    "dashboard.payment_methods": "Payment methods",
    "dashboard.payment_methods_tooltip": "Distribution of payment methods",
    "dashboard.no_payment_data": "No payment data",
    "dashboard.payment_methods_empty": "No orders with payments in this period.",
    "dashboard.popular_searches": "Popular searches",
    "dashboard.popular_searches_tooltip": "The most popular searches in the period",
    "dashboard.search_term": "Search term",
    "dashboard.searches": "Searches",
    "dashboard.with_results": "With results",
    "dashboard.no_searches_yet": "No searches recorded yet",
    "dashboard.search_data_empty": "No searches have been recorded yet.",
    "dashboard.no_results": "no results",
    "dashboard.zero_result_searches": "Zero result searches",
    "dashboard.zero_result_searches_tooltip": "Searches that returned no results",
    "dashboard.no_zero_result_searches": "No zero result searches",
    "dashboard.all_searches_had_results": "All searches in the period returned results.",
    "dashboard.total_sales": "Total sales",
    "dashboard.total_sales_tooltip": "Total sales in the period",
    "dashboard.no_sales_yet": "No sales yet",
    "dashboard.sales_after_first_order": "No sales have been recorded in this period.",
    "dashboard.order_count": "Order count",
    "dashboard.order_count_tooltip": "Number of orders in the selected period",
    "dashboard.no_orders_yet": "No orders yet",
    "dashboard.order_count_empty": "Order count will appear after the first order.",
    "dashboard.avg_order_value": "Avg order value",
    "dashboard.avg_order_value_tooltip": "Average order value (AOV)",
    "dashboard.no_data": "No data",
    "dashboard.avg_order_value_empty": "No orders have been placed in this period.",
    "dashboard.units_sold": "Units sold",
    "dashboard.units_sold_tooltip": "Total number of units sold",
    "dashboard.no_units_sold": "No units sold",
    "dashboard.units_sold_empty": "Number of units sold will appear here.",
    "dashboard.newsletter": "Newsletter",
    "dashboard.newsletter_tooltip": "Number of active subscribers",
    "dashboard.no_subscribers": "No subscribers",
    "dashboard.newsletter_empty": "Subscribers will appear when someone signs up.",
    "dashboard.total_subscribers": "total subscribers",
    "dashboard.n_new": "+{count} new",
    "dashboard.test_data": "Test data",
    "dashboard.test_data_active": "Test data is active.",
    "dashboard.test_data_description": "Widgets are showing sample data — not real store data.",
    "dashboard.reset": "Reset",
    "dashboard.done": "Done",
    "dashboard.customize": "Customize",
    "dashboard.show": "Show",
    "dashboard.n_orders_suffix": "1 order | {count} orders",
    "criteria_cannot_be_empty": "Criteria cannot be empty",
    "susoft_app_name": "Susoft POS",
    "susoft_app_description": "Synchronize stock between Susoft POS and your webshop. Keep inventory in sync across all sales channels.",
    "susoft_shop_url_key": "Shop URL Key",
    "susoft_shop_url_key_description": "Your Susoft shop URL key (e.g. 'mysuperstore'). Found in GlobalOne Web UI or your Susoft webshop URL.",
    "susoft_login": "Login",
    "susoft_login_description": "Your Susoft API login email or username.",
    "susoft_password": "Password",
    "susoft_password_description": "Your Susoft API password.",
    "susoft_landing_headline": "Susoft POS Integration",
    "susoft_landing_description": "Connect your Susoft POS system to automatically sync product stock between your physical store and webshop. When a sale happens at the register, your webshop stock updates instantly — and vice versa.",
    "susoft_product_mapping": "Product Mapping",
    "susoft_register_webhooks": "Register Webhooks",
    "susoft_search_products": "Search store products...",
    "susoft_no_products_found": "No products found in Susoft.",
    "susoft_mapped": "Mapped",
    "susoft_unmapped": "Unmapped",
    "susoft_auto_matched": "Auto-matched",
    "susoft_save_mappings": "Save Mappings",
    "susoft_sync_queued": "Stock sync has been queued and will run in the background.",
    "susoft_push_all_queued": "Webstore stock has been pushed to Susoft.",
    "susoft_sync_pos_to_store": "POS → Webstore",
    "susoft_sync_store_to_pos": "Webstore → POS",
    "susoft_landing_features_title": "Features",
    "susoft_landing_feature_1": "<strong>Automatic stock sync</strong> — when a sale happens at the POS register, your webshop stock updates instantly.",
    "susoft_landing_feature_2": "<strong>Bidirectional sync</strong> — stock changes in your webshop are pushed back to Susoft automatically.",
    "susoft_landing_feature_3": "<strong>Product mapping</strong> — easily map POS products to webshop variants by barcode, with smart auto-matching.",
    "susoft_landing_feature_4": "<strong>Full stock reconciliation</strong> — sync all product stock from Susoft with one click at any time.",
    "susoft_landing_how_it_works_title": "How does it work?",
    "susoft_landing_how_it_works_description": "The integration connects to your Susoft POS system via their API. After entering your credentials and mapping products, stock levels are kept in sync through webhooks. When Susoft notifies us of a change, we update your webshop — and when your webshop stock changes, we push it back to Susoft.",
    "susoft_landing_requirements_title": "What do I need?",
    "susoft_landing_requirements_description": "You need an active Susoft account with API access. You will need your Shop URL Key, login email, and password to configure the integration.",
    "susoft_invalid_credentials": "Could not connect to Susoft. Please verify your Shop URL Key, login, and password.",
    "susoft_hidden": "Hidden",
    "susoft_show_hidden": "Show hidden",
    "susoft_hidden_products": "Hidden products",
    "susoft_unhide": "Show again",
    "susoft_hide": "Hide",
    "susoft_unsaved": "Unsaved",
    "susoft_refresh_products": "Refresh from Susoft",
    "susoft_products_refreshed": "Product list refreshed from Susoft.",
    "susoft_search_susoft_products": "Search Susoft products...",
    "susoft_filter_all": "All",
    "susoft_filter_mapped": "Mapped",
    "susoft_filter_unmapped": "Unmapped",
    "susoft_susoft_product": "Susoft product",
    "susoft_barcode": "Barcode (GTIN)",
    "susoft_stock": "Stock (Susoft)",
    "susoft_store_stock": "Stock (Store)",
    "susoft_stock_mismatch": "Stock mismatch",
    "susoft_update_stock": "Update",
    "susoft_push_stock_to_susoft": "Push stock to Susoft",
    "susoft_set_to": "Set to {value}",
    "susoft_vanaheim_product": "Store product",
    "susoft_status": "Status",
    "susoft_no_hidden_products": "No hidden products.",
    "susoft_show_help": "Show help",
    "susoft_help_intro": "This page maps Susoft POS products to your webshop product variants. Use the filter buttons to switch between mapped and unmapped products.",
    "susoft_help_search": "Use the <strong>search field in each row</strong> to find the matching webshop product by name, SKU, or GTIN.",
    "susoft_help_auto_match": "Products with a <strong>barcode matching a variant GTIN</strong> are auto-matched automatically.",
    "susoft_help_hide": "Use the <strong>hide button</strong> (eye icon) to hide irrelevant Susoft products. View and unhide them via the \"Show hidden\" button.",
    "susoft_help_sync_pos_to_store": "Use <strong>POS → Webstore</strong> to update webstore stock for all mapped products with the current stock values from Susoft.",
    "susoft_help_sync_store_to_pos": "Use <strong>Webstore → POS</strong> to push webstore stock for all mapped products to Susoft.",
    "susoft_help_refresh": "Use <strong>Refresh from Susoft</strong> to update the local product list from the Susoft API. This only fetches product data and does not change any mappings.",
    "susoft_help_save": "Click <strong>Save Mappings</strong> when you're done. Mapped products will sync stock bidirectionally.",
    "susoft_per_page": "Per page",
    "susoft_product_hidden": ":count product hidden.|:count products hidden.",
    "susoft_product_unhidden": ":count product shown again.|:count products shown again.",
    "susoft_pos": "Susoft POS",
    "point_of_sale": "POS",
    "printer_format_label": "Label",
    "printer_format_document": "Document",
    "default_label_printer": "Default label printer",
    "default_document_printer": "Default document printer",
    "printer_format_description": "Labels are printed at booking. Documents (order confirmation, delivery confirmation, cancellation form) are printed as A4.",
    "auto_print_at_booking": "Auto-print at booking",
    "auto_print_label": "Label",
    "auto_print_order_confirmation": "Order confirmation",
    "auto_print_delivery_confirmation": "Delivery confirmation",
    "auto_print_cancellation_form": "Cancellation form",
    "only_owner_can_delete_printer": "Only the owner can delete this printer",
    "only_owner_can_edit_printer": "Only the owner can edit this printer",
    "username": "Username",
    "format": "Format",
    "shared": "Shared",
    "try_again": "Try again",
    "smartprint.stepper.account": "Account",
    "smartprint.stepper.install": "Install",
    "smartprint.stepper.connection": "Connection",
    "smartprint.setup_title": "SmartPrint setup",
    "smartprint.create_account.heading": "Get started with SmartPrint",
    "smartprint.create_account.intro": "SmartPrint connects your webshop to your printers. You'll need an account and the client software installed on your machine.",
    "smartprint.create_account.tip_label": "Tip:",
    "smartprint.create_account.tip_body": "Do this on the machine that's connected to the printers you want to use.",
    "smartprint.create_account.error": "Couldn't create an account. Please try again.",
    "smartprint.create_account.creating": "Creating...",
    "smartprint.create_account.submit": "Create SmartPrint account",
    "smartprint.create_account.switch_to_email": "I'd rather add an email printer instead",
    "smartprint.install_client.heading": "Install the SmartPrint client",
    "smartprint.install_client.intro": "Download and install the client on the machine you want to print from. Sign in with the username and password below.",
    "smartprint.install_client.download_exe": "Download .exe",
    "smartprint.install_client.download_dmg": "Download .dmg",
    "smartprint.install_client.credentials": "Login credentials",
    "smartprint.install_client.confirm": "I've installed the client",
    "smartprint.install_client.modal_title": "Install client on a new machine",
    "smartprint.install_client.modal_error": "Couldn't load login credentials. Please try again later.",
    "smartprint.wait.connecting_heading": "Waiting for connection...",
    "smartprint.wait.connecting_body": "Open the SmartPrint client and sign in. This dialog updates automatically.",
    "smartprint.wait.timeout_heading": "Couldn't detect the machine",
    "smartprint.wait.timeout_body": "Check that the SmartPrint client is running and that you're signed in.",
    "add_printer.edit_title": "Edit printer",
    "add_printer.add_title": "Add printer",
    "add_printer.type_smartprint": "SmartPrint (physical printer)",
    "add_printer.type_smartprint_trial_help": "Available with a paid subscription",
    "add_printer.type_smartprint_help": "Print via a connected printer",
    "add_printer.type_email_help": "Send the document to an email address",
    "add_printer.name_placeholder": "e.g. Warehouse printer",
    "add_printer.physical_printer_label": "Physical printer",
    "add_printer.choose_printer_placeholder": "Choose printer...",
    "add_printer.email_placeholder": "name@example.com",
    "add_printer.shared_label": "Share with other users",
    "add_printer.shared_help": "Other users in this store can use the printer.",
    "add_printer.shared_smartprint_warning": "Your machine must be online and connected to the printer every time you print.",
    "add_printer.checking": "Checking...",
    "delete_printer.title": "Delete printer",
    "delete_printer.confirm": "Are you sure? The printer will be permanently removed.",
    "delete_printer.default_warning_label": "Note:",
    "delete_printer.default_warning_body": "This printer is set as a default — the default will be cleared when you delete it.",
    "printer_list.install_on_new_machine": "+ Install client on a new machine",
    "printer_list.col_attachment": "Attached to",
    "printer_list.not_connected": "Not connected",
    "printer_list.empty": "No printers added yet.",
    "printer_list.settings_load_error": "Couldn't load settings from 24Shipping. Please try again in a moment.",
    "printer_settings.user_only_note": "These settings apply to your user only.",
    "printer_settings.shared_printer_warning": "The machine sharing the printer must be online and connected to it every time you print.",
    "printer_settings.no_printer_option": "None",
    "printer_settings.shared_suffix": "(shared)",
    "printer_settings.save": "Save settings",
    "printers_page_title": "Settings — Logistics",
    "picklist_intro": "The pick list is used when preparing orders, and appears on each individual order under unprocessed order lines.",
    "manual_shipment.fill_form_first": "Fill in the form above to fetch available shipping methods.",
    "partial_fulfillment_not_supported": "Due to limitations from this orders payment gateway, partial fulfillment is not supported",
    "add_discount_rules": "Add discount rules",
    "add_rules": "Add rules",
    "add_x_rules_with_y_percent": "Add {count} rules with {percent} % discount",
    "added": "Added",
    "bulk_change_discount_description": "Change discount for {count} selected rules.",
    "bulk_delete_rules_confirmation": "Are you sure you want to delete {count} selected rules? Products will fall back to the group default discount.",
    "change_discount": "Change discount",
    "clear_all": "Clear all",
    "create_group": "Create group",
    "customer_group": "Customer group",
    "customer_group_created": "Customer group created",
    "customer_group_deleted": "Customer group deleted",
    "customer_group_updated": "Customer group updated",
    "internal_note": "Internal note",
    "internal_note_placeholder": "Notes about this customer, only visible to staff…",
    "internal_note_help": "Only visible to you and other staff. The customer never sees this.",
    "member_added": "Customer added to group",
    "member_removed": "Customer removed from group",
    "discount_rule_saved": "Discount rule saved",
    "discount_rule_deleted": "Discount rule deleted",
    "customer_groups_subtitle": "Manage customer groups and discounts",
    "customer_group_applications_heading": "Membership applications",
    "customer_group_applications_subtitle": "Review membership applications from customers.",
    "customer_group_applications_approved": ":count applications approved.",
    "customer_group_applications_rejected": ":count applications rejected.",
    "application_show_discount": "Show discount info before applying",
    "application_show_discount_help": "Lets the customer see what discount they'll get if approved. If off, the discount is only revealed after they become a member.",
    "customer_group_applications_approve_bulk_confirm": "Approve {count} applications?",
    "customer_group_applications_reject_bulk_confirm": "Reject {count} applications?",
    "pending_applications": "Pending review",
    "search_applications_placeholder": "Search by name, email or company …",
    "view_full_note": "View full note",
    "bulk_approve_selected": "Approve selected",
    "bulk_reject_selected": "Reject selected",
    "submitted_on": "submitted {date}",
    "apply_for_membership": "Apply for membership",
    "your_application_was_received": "Your application was received",
    "you_are_a_member": "You are a member of this customer group",
    "your_application_was_rejected": "Your application was rejected",
    "total_groups": "Total groups",
    "active_groups": "Active groups",
    "total_members": "Total members",
    "open": "open",
    "search_members_placeholder": "Search by name, email or company …",
    "remove_member": "Remove member",
    "remove_member_confirmation": "Are you sure you want to remove {customer} from the group?",
    "no_members_match_search": "No members match your search.",
    "add_customers": "Add customers",
    "add_customers_description": "Search for customers to add to this group.",
    "no_customers_match_search": "No customers match your search.",
    "no_customers_available": "No customers available to add.",
    "add_discount_rules_description": "Pick products that should get this discount in the group.",
    "no_products_selected_yet": "No products selected yet.",
    "how_discounts_work": "How discounts work",
    "discounts_with_default_explanation": "Every product in this group gets a default discount of <strong>{percent} %</strong>. Add a rule here if a specific product should have a different discount — the rule overrides the default for those products.",
    "discounts_without_default_explanation": "This group has no default discount. Add rules here to discount specific products — or set a default discount on the <strong>General</strong> tab to discount the whole catalogue.",
    "rule_overrides_default": "This rule overrides the default discount for the products you pick.",
    "default_discount": "Default discount",
    "default_discount_help": "The discount that applies to all products unless overridden by a product-specific rule.",
    "default_discount_override_help": "This discount applies to all products. You can override it per product under Discount rules.",
    "delete_customer_group": "Delete customer group",
    "delete_discount_rule": "Delete discount rule",
    "delete_group": "Delete group",
    "delete_group_confirmation": "Are you sure you want to delete the customer group \"{name}\"? All members will lose their group discounts.",
    "delete_rule": "Delete rule",
    "delete_rule_confirmation": "Are you sure you want to delete the rule for \"{product}\"? The product will fall back to the default discount of {defaultDiscount} %.",
    "delete_selected": "Delete selected",
    "delete_selected_rules": "Delete selected rules",
    "description_help": "An internal description to identify this group.",
    "discount_rules": "Discount rules",
    "group_name": "Group name",
    "group_name_help": "The name is displayed to customers who are members of the group.",
    "group_name_placeholder": "E.g. Wholesalers, VIP customers",
    "inactive_group_help": "Inactive groups do not give discounts to members.",
    "internal_description": "Internal description",
    "members_count_label": "customers in this group.",
    "new_customer_group": "New customer group",
    "new_discount": "New discount",
    "no_customer_groups": "No customer groups created yet.",
    "no_discount_rules": "No product-specific discount rules.",
    "no_members": "No customers have been added to this group.",
    "no_products_found": "No products found.",
    "percent_on_all_products": "% on all products",
    "product_specific_rules_info": "product-specific rules override the default discount of",
    "products_found": "products found",
    "search_customer_placeholder": "Search for customer — name, email or company...",
    "search_product_name_or_sku": "Search by product name, SKU or tag...",
    "search_rules_placeholder": "Search rules — product name or SKU...",
    "search_to_find_products": "Search to find products",
    "select_all_x_results": "Select all {count} results",
    "scroll_for_more": "more — scroll for more",
    "transfer_customer_group": "Transfer customer to new group",
    "transfer_customer_group_confirmation": "{customer} is already a member of the group \"{from}\". Do you want to transfer the customer to \"{to}\"? The customer will be removed from \"{from}\".",
    "transfer_customer": "Transfer customer",
    "add_x_rules": "Add {count} rules",
    "set_discount_percent_required": "Set a discount percentage before adding rules.",
    "customer_groups_app_headline": "Customer groups",
    "customer_groups_app_description": "Give groups of customers automatic discounts, for example wholesalers, VIPs or partners.",
    "customer_groups_app_sub_heading": "Define groups of customers and give them automatic discounts. Useful for wholesalers, VIPs, partners, or any segment that should see different prices.",
    "customer_groups_app_advantages": "Advantages of customer groups",
    "customer_groups_app_advantage_1": "Set a default discount that applies to every product for members of the group",
    "customer_groups_app_advantage_2": "Override the default per-product with discount rules for individual products",
    "customer_groups_app_advantage_3": "Logged-in members see their group price on category, product, and checkout pages",
    "customer_groups_app_advantage_4": "Group membership is stored on the order, so historical pricing is preserved",
    "customer_groups_app_closer": "Activate customer groups to start segmenting your customers and rewarding loyalty.",
    "get_started_heading": "Getting started",
    "basic_information": "Basic information",
    "basic_information_description": "Name and description show up in the admin and on the members list.",
    "default_discount_section_description": "Applies to every product in the group — can be overridden with per-product rules.",
    "group_status_description": "Inactive groups don't apply discounts or accept members.",
    "applications_section": "Applications",
    "applications_section_description": "Let customers request to join this group — you approve them manually.",
    "customer_groups_get_started_step_1": "Create a customer group and set a default discount — for example 15 % for wholesalers.",
    "customer_groups_get_started_step_2": "Add customers to the group from your customer base.",
    "customer_groups_get_started_step_3": "Override individual products with specific discount rules if you need to.",
    "manage_customer_groups": "Manage customer groups",
    "from_price": "From",
    "not_configured": "Not configured",
    "shipping_mode_flat": "Flat price",
    "shipping_mode_weight": "By weight",
    "shipping_mode_zone": "By zone",
    "shipping_mode_matrix": "Weight + zone",
    "shipping_mode_description_flat": "A single price applies to every cart.",
    "shipping_mode_description_weight": "The price is determined by the cart's total weight. Carts outside the defined weight ranges will not see this shipping method.",
    "shipping_mode_description_zone": "The price is determined by the delivery zone (postal code). Carts with a postal code outside the zones will not see this shipping method.",
    "shipping_mode_description_matrix": "The price is determined by the combination of cart weight and delivery zone.",
    "pricing_rules_card_title": "Pricing rules",
    "pricing_rules_card_description": "Variable price based on weight and/or delivery zone.",
    "custom_shipping.flat_price_required": "Flat price is required",
    "custom_shipping.flat_price_forbidden_with_tables": "Flat price cannot be used with weight or zone tables",
    "custom_shipping.weight_range_from_gt_to": "From weight must be less than or equal to to weight",
    "custom_shipping.overlapping_weight_ranges": "Weight ranges overlap",
    "custom_shipping.range_from_gt_to": "From zip code must be less than or equal to To zip code",
    "custom_shipping.overlapping_ranges": "Zip code ranges overlap",
    "custom_shipping.duplicate_zone_name": "Zone names must be unique",
    "custom_shipping.missing_price_row": "Every combination of weight tier and zone must have a price",
    "custom_shipping.duplicate_price_row": "The same price combination is listed twice",
    "custom_shipping.confirm_delete": "Are you sure you want to delete this shipping method?",
    "new_custom_shipping_method": "New custom shipping method",
    "edit_custom_shipping_method": "Edit custom shipping method",
    "flat_price": "Flat price",
    "weight_tiers": "Weight tiers",
    "weight_tier": "Weight tier",
    "add_weight_tier": "Add weight tier",
    "no_weight_tiers_yet": "No weight tiers added yet",
    "from_weight": "From",
    "to_weight": "To",
    "zones": "Zones",
    "add_zone": "Add zone",
    "no_zones_yet": "No zones added yet",
    "zone_name_placeholder": "Zone name (e.g. Northern Norway)",
    "from_zip": "From zip",
    "to_zip": "To zip",
    "remove_range": "Remove range",
    "remove_zone": "Remove zone",
    "add_range": "Add range",
    "price_grid": "Price grid",
    "unnamed_zone": "(unnamed)",
    "stock_history": "Stock history",
    "stock_log": "Stock log",
    "no_stock_history": "No stock history",
    "no_stock_changes": "No stock changes",
    "added_to_stock": "Added to stock",
    "removed_from_stock": "Removed from stock",
    "total_stock": "Total in stock",
    "locations": "Locations",
    "active_variants": "Active variants",
    "no_stock_registered": "No stock registered",
    "entry": "Entry",
    "entries": "Entries",
    "main_variant": "Main variant",
    "all_sources": "All sources",
    "source": "Source",
    "actor": "Actor",
    "by": "By",
    "showing": "Showing",
    "seconds_ago": "seconds ago",
    "minutes_ago": "minutes ago",
    "hours_ago": "hours ago",
    "days_ago": "days ago",
    "weeks_ago": "weeks ago",
    "source_admin": "Admin",
    "source_order": "Order",
    "source_refund": "Refund",
    "source_cancellation": "Cancellation",
    "source_susoft": "Susoft",
    "source_migration": "Migration",
    "source_backfill": "Auto-seed",
    "source_trial_purge": "Trial ended",
    "stock_change": "Change",
    "history_for": "History for",
    "shelf": "Stock location",
    "bin": "Stock location",
    "assigned_location": "Assigned stock location",
    "create_shelf": "Create stock location",
    "search_or_create_stock_location": "Search or create stock location",
    "clear": "Clear",
    "source_transfer": "Transfer",
    "no_stock_location_set": "No stock location set",
    "warehouse": "Warehouse",
    "search_or_create_warehouse": "Search or create warehouse",
    "enable_product_locations": "Enable stock locations",
    "enable_product_locations_description": "Assign stock locations to products to track where they are physically stored.",
    "enable_product_warehouses": "Enable multiple warehouses",
    "enable_product_warehouses_description": "Use multiple warehouses in addition to the default warehouse.",
    "warehouses_app_required": "Requires the Warehouses app.",
    "warehouses_app_description": "Manage multiple warehouses to track stock across locations.",
    "bulk_picking": "Bulk picking",
    "bulk_picking_app_description": "Pick many orders in one operation: collect all items, bring them to the packing station, and sort and pack per order.",
    "bulk_picking_method": "Picking method",
    "bulk_picking_method_description": "Choose how the store picks and packs bulk orders.",
    "bulk_picking_method_pakkestasjon": "Packing station",
    "bulk_picking_method_trillevogn": "Trolley",
    "bulk_picking_method_legacy": "Lists and labels (classic)",
    "bulk_picking_method_label": "Picking method",
    "bulk_picking_method_fit_label": "Best when",
    "bulk_picking_method_pakkestasjon_desc": "Pick all items together in one round, bring them to the packing table, and sort and pack per order there.",
    "bulk_picking_method_pakkestasjon_fit": "many orders share the same products and you have a packing table. Fewest trips through the warehouse.",
    "bulk_picking_method_trillevogn_desc": "Roll a trolley with one basket per order. Pick in one round and place each item straight into the right basket — no sorting afterwards.",
    "bulk_picking_method_trillevogn_fit": "orders differ and you want to pick on the move in one round.",
    "bulk_picking_method_legacy_title": "Fulfill + print lists",
    "bulk_picking_method_legacy_tag": "Legacy method",
    "bulk_picking_method_coming_soon": "Coming soon",
    "bulk_picking_beta_free_title": "Free during beta",
    "bulk_picking_beta_free_body": "This app is free for every store while it's in beta. Pricing may change once the beta ends.",
    "bulk_picking_method_legacy_desc": "Fulfill the orders, print lists and labels, and pick/pack manually — like the old solution.",
    "bulk_picking_method_legacy_fit": "Transitional method. Switch to packing station or trolley when you're ready.",
    "bulk_send_orders": "Send orders",
    "bulk_send_orders_description": "Fulfil the selected orders, book shipping and print lists and labels.",
    "bulk_print_pick_lists": "Print pick lists",
    "bulk_print_pick_lists_description": "Get pick lists for the selected orders without sending them.",
    "bulk_print_title": "Print pick lists",
    "bulk_print_body": "{count} order is selected. Orders already sent or cancelled are left out. | {count} orders are selected. Orders already sent or cancelled are left out.",
    "bulk_print_nothing_left": "None of the selected orders has anything left to pick.",
    "bulk_print_not_reserved": "Nothing is sent or reserved. The lists show what is left to send on each order right now.",
    "bulk_send_title": "Send orders",
    "bulk_send_booked_not_captured": "The shipment was booked and its label may have printed, but the payment failed. The order was not sent.",
    "bulk_send_row_booked": "Booked, not sent",
    "bulk_send_row_booked_detail": "Booked with {carrier}, tracking no. {tracking}",
    "bulk_send_paused_title": "Sending is paused at order #{order}",
    "bulk_send_paused_body": "The shipment was booked with {carrier} (tracking no. {tracking}), but the order was not sent.",
    "bulk_send_paused_cause": "The payment failed: {cause}",
    "bulk_send_printed_likely": "The printer has most likely printed this for the order: {things}. Take it out of the stack before you continue, so the prints stay in step with the orders.",
    "bulk_send_printed_maybe": "The printer may have printed this for the order: {things}. Check the stack and take it out before you continue, so the prints stay in step with the orders.",
    "bulk_send_printed_unknown": "The printer may have printed the label and documents for this order. Check the stack and take them out before you continue, so the prints stay in step with the orders.",
    "bulk_send_printed_nothing": "Nothing was printed for this order.",
    "bulk_send_continue": "Continue with the rest",
    "bulk_send_stop_here": "Stop here",
    "bulk_send_summary_booked": "Booked, not sent",
    "bulk_send_orders_count": "{count} order | {count} orders",
    "bulk_send_progress": "{done} of {total} processed",
    "bulk_send_done_title": "{count} order sent | {count} orders sent",
    "bulk_send_units": "{count} item | {count} items",
    "bulk_send_summary_sent": "Sent",
    "bulk_send_summary_failed": "Could not be sent",
    "bulk_send_summary_skipped": "Skipped",
    "bulk_send_too_many_orders": "Send at most :max orders at a time. Select fewer and try again.",
    "bulk_send_checking": "Checking the selected orders …",
    "bulk_send_ready": "{count} order can be sent | {count} orders can be sent",
    "bulk_send_skipped_heading": "{count} order will be skipped | {count} orders will be skipped",
    "bulk_send_carrier_hint": "Shipping is booked according to each shipping method's carrier mapping, and every remaining item on the order is fulfilled.",
    "bulk_send_start": "Send {count} order | Send {count} orders",
    "bulk_send_row_waiting": "Waiting",
    "bulk_send_row_sending": "Sending …",
    "bulk_send_row_sent": "Sent",
    "bulk_send_row_failed": "Could not be sent",
    "bulk_send_retry": "Try again",
    "bulk_send_view_label": "View label",
    "bulk_send_print_hint": "Pick and pack from the lists. Carriers that print themselves, like 24Shipping, have already sent the labels to the printer.",
    "bulk_send_print_pick_list": "Combined pick list",
    "bulk_send_print_packing_slips": "Pick list per order",
    "bulk_send_print_labels": "Labels",
    "bulk_send_close_while_sending": "Sending stops if you close now. Orders already sent stay sent.",
    "bulk_send_skip_not_found": "Order not found",
    "bulk_send_skip_not_open": "Already sent or cancelled",
    "bulk_send_skip_locked": "Locked to a picking batch",
    "bulk_send_skip_shipping": "The shipping method has no carrier mapping",
    "bulk_send_already_in_progress": "The order is already being sent.",
    "bulk_send_order_number": "Order #:order",
    "bulk_send_labels_not_merged": "These labels could not be added to the file. Print them from the order page:",
    "bulk_send_nothing_to_print": "Nothing to print.",
    "bulk_picking_feedback_title": "Does none of the flows quite fit?",
    "bulk_picking_feedback_body": "We're happy to expand. Tell us how your store picks and packs — if you have a need none of the workflows cover, we'll look at building a flow that fits.",
    "bulk_picking_auto_print_only_pakkestasjon": "Applies to the packing-station method only.",
    "bulk_picking_auto_print_picklist": "Print pick list automatically",
    "bulk_picking_auto_print_picklist_description": "Send the pick list to the printer when a batch is started. (Requires Smartprint document printer, and 24shipping as the logictics provider for the order).",
    "bulk_picking_lock_guard": "Protect locked orders",
    "bulk_picking_lock_guard_description": "Block changes to orders locked to an active picking batch until they're released. Recommended when several people pack orders at once.",
    "bulk_picking_order_locked_guard": "Order #:order is locked to active batch #B-:batch (:admin). Release it from the batch first.",
    "bulk_picking_order_locked_banner": "Locked to active batch #B-{batch} ({admin}) — release to edit.",
    "stock_shortage_banner": "This order was oversold. Stock is negative for these items:",
    "stock_shortage_line": "{name}: ordered {requested}, short by {shortfall}",
    "bulk_picking_landing_header_text": "Pick many orders at once",
    "bulk_picking_subheading": "Pick and pack many orders in one operation — with the method that fits your store.",
    "bulk_picking_how_it_works_1": "Select the orders to pick and start a batch.",
    "bulk_picking_how_it_works_2": "Get one consolidated picklist sorted by stock location.",
    "bulk_picking_how_it_works_3": "Sort and pack per order at the packing station.",
    "bulk_picking_get_started_heading": "Get started",
    "bulk_picking_get_started_step_1": "Install the app and choose a picking method.",
    "bulk_picking_get_started_step_2": "Go to the order list and choose \"Start bulk picking\".",
    "bulk_picking_get_started_step_3": "Pick, pack, and complete the orders.",
    "bulk_picking_features_heading": "Highlights",
    "bulk_picking_feature_methods_title": "Multiple picking methods",
    "bulk_picking_feature_methods_body": "Packing station and classic lists are ready now. Trolley is coming.",
    "bulk_picking_feature_bulk_title": "Fulfil many orders at once",
    "bulk_picking_feature_bulk_body": "Pick, pack, and ship many orders in one operation — not one at a time.",
    "bulk_picking_feature_location_title": "Sorted by stock location",
    "bulk_picking_feature_location_body": "Add an optional stock location to products and the picking list groups by location — fewer trips across the warehouse.",
    "bulk_picking_feature_lock_title": "Optional order locking",
    "bulk_picking_feature_lock_body": "Lock the orders in a batch while they're picked, so two staff never grab the same order.",
    "bulk_picking_how_it_works_heading": "How packing station works",
    "bulk_picking_setup_title": "Get set up",
    "bulk_picking_setup_done_title": "All set",
    "bulk_picking_setup_step_method": "Choose a picking method",
    "bulk_picking_setup_step_mapping": "Map shipping methods to a carrier service",
    "bulk_picking_setup_step_printer": "Connect a printer",
    "bulk_picking_setup_step_printer_hint": "Recommended for automatic label printing.",
    "bulk_picking_setup_configure": "Set up",
    "bulk_picking_setup_change": "Change",
    "bulk_picking_setup_recommended": "Recommended",
    "warehouses_landing_header_text": "Track stock across multiple warehouses",
    "warehouses_subheading": "Use the Warehouses app to manage multiple physical warehouses and keep track of where your products are stored.",
    "warehouses_how_it_works_1": "Create multiple warehouses and assign them to your product variants.",
    "warehouses_how_it_works_2": "Track stock per warehouse and stock location.",
    "warehouses_how_it_works_3": "Get a unified view of where your inventory lives.",
    "warehouses_how_it_works_4": "Enable or disable multi-warehouse mode at any time from the settings.",
    "warehouses_get_started_heading": "Getting started",
    "warehouses_get_started_step_1": "The app is already included in your license — no purchase needed.",
    "warehouses_get_started_step_2": "Add warehouses and locations under Settings.",
    "warehouses_get_started_step_3": "Assign products and variants to warehouses and shelves.",
    "warehouses": "Warehouses",
    "default_warehouse": "Default warehouse",
    "set_as_default": "Set as default",
    "features": "Features",
    "add_warehouse": "Add warehouse",
    "add_location": "Add location",
    "no_warehouses_yet": "No warehouses yet.",
    "stock_settings_description": "Configure how stock is tracked in your store.",
    "stock_features_description": "Turn on stock locations and multi-warehouse support.",
    "warehouses_description": "Physical locations where stock is kept.",
    "stock_locations_description": "Shelves, bins, or areas inside a warehouse.",
    "stock_locations": "Stock locations",
    "stock_location_warehouse_no_parent": "Warehouse must not have a parent.",
    "stock_location_shelf_requires_warehouse_parent": "Shelves must live under a warehouse.",
    "stock_location_bin_requires_shelf_parent": "Bins must live under a shelf.",
    "stock_location_invalid_parent": "Invalid parent for this location type.",
    "warehouse_name": "Warehouse name",
    "location_name": "Stock location name",
    "new_stock_location_name": "New stock location name",
    "no_stock_locations_yet": "No stock locations yet.",
    "rename_location": "Rename stock location",
    "confirm_delete_location": "Delete stock location?",
    "new_warehouse_name": "New warehouse name",
    "rename": "Rename",
    "rename_warehouse": "Rename warehouse",
    "confirm_delete_warehouse": "Delete warehouse? This cannot be undone.",
    "confirm_delete_warehouse_with_locations": "This warehouse has {count} stock locations. Deleting it will also remove all of those locations and their stock balances. Continue?",
    "n_locations": "{count} locations",
    "welcome_flow.page_title": "Welcome",
    "welcome_flow.trial_badge": "{total}-day free trial · Day {day} of {total}",
    "welcome_flow.trial_badge_short": "Day {day} of {total}",
    "welcome_flow.step_counter": "Step {current} of {total}",
    "welcome_flow.continue": "Continue",
    "welcome_flow.back": "Back",
    "welcome_flow.go_to_store": "Go to your store",
    "welcome_flow.steps.name.title": "Store name",
    "welcome_flow.steps.about.title": "About your store",
    "welcome_flow.steps.theme.title": "Choose a starting point",
    "welcome_flow.step1.heading_with_name": "Welcome to 24Nettbutikk, {name}!",
    "welcome_flow.step1.heading": "Welcome to 24Nettbutikk!",
    "welcome_flow.step1.intro": "Let's start with the name of your store. Then we'll ask a few short questions to get to know you — takes under a minute.",
    "welcome_flow.step1.label": "Store name",
    "welcome_flow.step2.heading": "Let's get to know each other",
    "welcome_flow.step2.sub": "Three short questions and we're nearly there.",
    "welcome_flow.step2.industry": "Which industry are you in?",
    "welcome_flow.step2.pos": "Do you need POS integration?",
    "welcome_flow.step2.pos_name": "Which POS system?",
    "welcome_flow.step2.pos_name_placeholder": "e.g. Zettle, Susoft PCKasse",
    "welcome_flow.step2.contact": "Would you like us to call you for a no-obligation chat?",
    "welcome_flow.step2.phone": "Phone number",
    "welcome_flow.step2.phone_placeholder": "+47 900 00 000",
    "welcome_flow.step3.heading": "Choose a starting point",
    "welcome_flow.step3.sub": "A ready-made setup you can keep tweaking.",
    "welcome_flow.step3.suggestion_banner": "Based on the industry you picked ({industry}), we've suggested the {theme} theme. You can pick a different one below.",
    "welcome_flow.step3.suggested_badge": "Suggested",
    "welcome_flow.step3.selected_label": "Selected: {theme}",
    "welcome_flow.industry.clothes": "Clothing and fashion",
    "welcome_flow.industry.home": "Home and interior",
    "welcome_flow.industry.food": "Food and drink",
    "welcome_flow.industry.beauty": "Beauty and wellness",
    "welcome_flow.industry.sport": "Sport and leisure",
    "welcome_flow.industry.kids": "Kids and baby",
    "welcome_flow.industry.other": "Other",
    "welcome_flow.pos.no": "No",
    "welcome_flow.pos.yes": "Yes",
    "welcome_flow.pos.maybe": "Maybe later",
    "welcome_flow.contact.yes": "Yes please",
    "welcome_flow.contact.email": "Email only",
    "welcome_flow.contact.no": "No thanks",
    "first_product_wizard.page_title": "Create your first product",
    "first_product_wizard.step_name_placeholder": "For example \"Organic cotton sweater\"",
    "first_product_wizard.name_min_chars": "At least 3 characters.",
    "first_product_wizard.simplified_note_title": "Add your first product – quick and simple",
    "first_product_wizard.simplified_note_body": "We show only what you need to create your first product and move on to the test order. You can add variants, SEO, shipping and other settings later from the product page.",
    "first_product_wizard.full_form_prompt": "Would you rather fill in everything now?",
    "first_product_wizard.use_full_form": "Go to the full product form",
    "first_product_wizard.lead_paragraph_placeholder": "A short selling line, shown above the description.",
    "first_product_wizard.description_label": "Description",
    "first_product_wizard.description_placeholder": "Materials, sizing, use, and so on.",
    "first_product_wizard.step_shipping_subtitle": "Pick a package type so shipping is calculated correctly. You can adjust later.",
    "first_product_wizard.step_images_subtitle": "A good photo sells better than good copy.",
    "first_product_wizard.step_description_subtitle": "A short intro and full description help customers decide.",
    "first_product_wizard.step_pricing_subtitle": "You can change this at any time.",
    "first_product_wizard.package_preset_group_label": "Package type",
    "first_product_wizard.package_preset.letter.label": "Letter",
    "first_product_wizard.package_preset.letter.summary": "200 g · 25×15×2 cm",
    "first_product_wizard.package_preset.small.label": "Small package",
    "first_product_wizard.package_preset.small.summary": "500 g · 25×20×10 cm",
    "first_product_wizard.package_preset.medium.label": "Package",
    "first_product_wizard.package_preset.medium.summary": "2 kg · 40×30×20 cm",
    "first_product_wizard.package_preset.large.label": "Large package",
    "first_product_wizard.package_preset.large.summary": "5 kg · 50×40×30 cm",
    "first_product_wizard.package_preset.custom.label": "Custom",
    "first_product_wizard.package_preset.custom.summary": "Enter weight and dimensions yourself.",
    "first_product_wizard.package_preset.weight_label": "Weight",
    "first_product_wizard.package_preset.length_label": "Length",
    "first_product_wizard.package_preset.width_label": "Width",
    "first_product_wizard.package_preset.height_label": "Height",
    "first_product_wizard.step_variants_title": "Does the product come in variants?",
    "first_product_wizard.step_variants_subtitle": "For example different sizes or colors. You can always add variants later.",
    "first_product_wizard.variants_no_desc": "A single product",
    "first_product_wizard.variants_yes_desc": "Multiple variants",
    "first_product_wizard.variants_explanation": "Add one row per choice the customer makes (e.g. \"Size\" with values \"S\", \"M\", \"L\"). We'll generate every combination for you.",
    "first_product_wizard.option_name_label": "Option name",
    "first_product_wizard.option_name_placeholder": "E.g. Size, Color, Material",
    "first_product_wizard.add_value_placeholder": "Add a value, e.g. Medium",
    "first_product_wizard.add_value_button": "Add",
    "first_product_wizard.add_option": "Add another option",
    "first_product_wizard.remove_option": "Remove option",
    "first_product_wizard.remove_value": "Remove value",
    "first_product_wizard.all_variants_same_price": "All variants share the same price",
    "first_product_wizard.variants_preview_count": "Variants ({count})",
    "first_product_wizard.variant_price_placeholder": "Price",
    "first_product_wizard.variant_stock_placeholder": "Stock",
    "first_product_wizard.too_many_variants_hint": "You have a lot of variants — you can set prices and stock on each one later in the product editor.",
    "first_product_wizard.upload_instruction": "Click or drag images here",
    "first_product_wizard.upload_drop_here": "Drop images to upload",
    "first_product_wizard.upload_formats": "JPG, PNG, or WebP.",
    "first_product_wizard.image_remove": "Remove image",
    "first_product_wizard.publish_visible_title": "The product will be visible in your store",
    "first_product_wizard.publish_visible_desc": "You will use it to place a test order in the next part of the setup. You can hide the product at any time from the product page.",
    "first_product_wizard.create_product": "Create product",
    "first_product_wizard.continue": "Continue",
    "first_product_wizard.create_failed": "Something went wrong. Please try again.",
    "first_product_wizard.image_upload_failed": "Couldn't upload images. The product was created without images.",
    "first_product_wizard.success_flash": "Your first product is ready!",
    "first_product_wizard.preview_hide": "Hide preview",
    "first_product_wizard.preview_show": "Show preview",
    "first_product_wizard.preview_label": "Preview",
    "first_product_wizard.preview_close": "Close",
    "first_product_wizard.preview_mobile_button": "Preview",
    "first_product_wizard.preview_image_placeholder": "Image will appear here",
    "first_product_wizard.preview_name_placeholder": "Product name",
    "first_product_wizard.preview_price_placeholder": "Price set on the next step",
    "trial_dashboard.eyebrow": "Getting started · {done} of {total} complete",
    "trial_dashboard.heading": "Three things to do first.",
    "trial_dashboard.sub": "Pick whatever feels easiest. Everything is saved as you go — you can stop whenever.",
    "trial_dashboard.trial_label": "Trial",
    "trial_dashboard.trial_day_progress": "Day {day} of {total} · {left} days left",
    "trial_dashboard.card_name.title": "Your store has a name",
    "trial_dashboard.card_name.desc_with_name": "{name} — you can change this any time.",
    "trial_dashboard.card_name.desc_no_name": "You can change the name any time.",
    "trial_dashboard.card_name.time": "Done",
    "trial_dashboard.card_product.title": "Add your first product",
    "trial_dashboard.card_product.desc": "Add a product to your store and get it ready to sell.",
    "trial_dashboard.card_product.time": "⏱ ~2 min",
    "trial_dashboard.card_test_order.default.title": "Place a test order",
    "trial_dashboard.card_test_order.default.desc": "Buy your product from your own store. See the whole journey — cart to receipt — before customers do.",
    "trial_dashboard.card_test_order.default.time": "⏱ ~2 min",
    "trial_dashboard.card_test_order.fulfill.title": "Fulfill the test order",
    "trial_dashboard.card_test_order.fulfill.desc": "The order is waiting. Confirm it and create a shipping label — exactly what you'll do with real customer orders.",
    "trial_dashboard.card_test_order.fulfill.time": "⏱ ~1 min",
    "trial_dashboard.card_test_order.needs_product_hint": "Add a product first so you have something to buy.",
    "trial_dashboard.footer.title": "A bit more to set up before your store is ready for customers.",
    "trial_dashboard.footer.see_full_checklist": "See full checklist →",
    "trial_dashboard.remaining.completed": "Done",
    "trial_dashboard.remaining.sub": "Complete the steps to open your store to customers.",
    "trial_dashboard.checklist.heading": "Get started with your 24Nettbutikk",
    "trial_dashboard.checklist.sub": "Follow the steps below to set up your store. Each step is marked as done once you complete it.",
    "trial_dashboard.checklist.progress_label": "done",
    "trial_dashboard.checklist.encouragement_title": "You're well on your way!",
    "trial_dashboard.checklist.encouragement_body": "Complete the steps to get your store ready to launch.",
    "trial_dashboard.checklist.done": "Done",
    "trial_dashboard.checklist.not_done": "Not done",
    "trial_dashboard.checklist.tips_label": "Tip",
    "trial_dashboard.checklist.tips_body": "You can come back here any time to check your progress.",
    "trial_dashboard.checklist.hide": "Hide this overview",
    "trial_dashboard.checklist.hide_hint": "You'll always find the checklist in the top bar.",
    "trial_checklist_drawer.restore_cards": "Show the overview on the dashboard again",
    "trial_dashboard.remaining.details": "More about the steps",
    "trial_dashboard.remaining.start": "Start",
    "trial_dashboard.skip_three_things": "Skip",
    "trial_checklist_chip.label": "Checklist",
    "trial_checklist_chip.aria": "Open checklist · {done} of {total} done",
    "trial_checklist_drawer.heading": "Full checklist",
    "trial_checklist_drawer.sub": "Everything you should set up before you open your store to customers.",
    "trial_checklist_drawer.progress": "{done} of {total} done",
    "trial_checklist_drawer.section_get_started": "Getting started",
    "trial_checklist_drawer.section_prepare_store": "Prepare your store",
    "trial_checklist_drawer.help_prefix": "Need help?",
    "trial_checklist_drawer.help_link": "Help center",
    "trial_checklist_drawer.close": "Close checklist",
    "trial_checklist_drawer.expand": "Show more",
    "trial_checklist_drawer.collapse": "Hide",
    "trial_checklist_drawer.completed_badge": "Done",
    "trial_checklist_drawer.video_play": "Play video",
    "trial_checklist_drawer.cta_view": "View",
    "trial_checklist_drawer.cta_step_name": "Go to settings",
    "trial_checklist_drawer.cta_step_product": "Open product wizard",
    "trial_checklist_drawer.cta_step_test_order_default": "Start test order",
    "trial_checklist_drawer.cta_step_test_order_fulfill": "Fulfill the order",
    "trial_checklist_drawer.cta_step_test_order_done": "View orders",
    "trial_checklist_drawer.cta_step_test_order_needs_product": "Add a product first",
    "trial_dashboard.card_name.help_text": "Your store name appears at checkout, on invoices, and in search results. You can change it any time from settings.",
    "trial_dashboard.card_name.bullets.0": "Shown in the storefront header",
    "trial_dashboard.card_name.bullets.1": "Used in email receipts and invoices",
    "trial_dashboard.card_name.bullets.2": "Can be changed at any time",
    "trial_dashboard.card_product.help_text": "Your first product sets the bar for the rest. We've built a simplified flow so you get something live quickly — you can fine-tune everything from the product page later.",
    "trial_dashboard.card_product.bullets.0": "Images, name and price matter most",
    "trial_dashboard.card_product.bullets.1": "Add variants (size, color) later if needed",
    "trial_dashboard.card_product.bullets.2": "Get the VAT rate right from the start",
    "trial_dashboard.card_test_order.default.help_text": "Test the buying experience before your customers do. Buy your product from your own store and see the full journey — from product page to receipt.",
    "trial_dashboard.card_test_order.default.bullets.0": "No real money is charged — payment is simulated",
    "trial_dashboard.card_test_order.default.bullets.1": "You see exactly what customers see",
    "trial_dashboard.card_test_order.default.bullets.2": "After the purchase, fulfill it like a real customer order",
    "trial_dashboard.card_test_order.fulfill.help_text": "Your test order is waiting to be fulfilled. Confirm it, create a shipping label, and see how a real customer order flows from start to package in the post.",
    "trial_dashboard.card_test_order.fulfill.bullets.0": "Confirm the order details",
    "trial_dashboard.card_test_order.fulfill.bullets.1": "Pick a shipping method and create a label",
    "trial_dashboard.card_test_order.fulfill.bullets.2": "Mark as shipped",
    "onboarding_survey.title": "Before we start - let's get to know you a bit",
    "onboarding_survey.intro": "We ask a few short questions so we can tailor 24Nettbutikk to your needs. Takes under two minutes.",
    "onboarding_survey.submit": "Submit",
    "onboarding_survey.skip_link": "Skip the questions",
    "onboarding_survey.situation.question": "Which best describes your situation?",
    "onboarding_survey.situation.options.already_has_store": "I already run an online store",
    "onboarding_survey.situation.options.physical_store": "I run a physical store and want to start an online store",
    "onboarding_survey.situation.options.starting_idea": "I'm in the start-up phase with an idea",
    "onboarding_survey.situation.options.exploring": "I'm testing / exploring options",
    "onboarding_survey.current_platform.question": "Which platform do you use today?",
    "onboarding_survey.current_platform.options.shopify": "Shopify",
    "onboarding_survey.current_platform.options.mystore": "Mystore",
    "onboarding_survey.current_platform.options.woocommerce": "WooCommerce",
    "onboarding_survey.current_platform.options.magento": "Magento",
    "onboarding_survey.current_platform.options.wix": "Wix",
    "onboarding_survey.current_platform.options.quickbutik": "Quickbutik",
    "onboarding_survey.current_platform.options.other": "Other",
    "onboarding_survey.timeline.question": "How far along are you in the process?",
    "onboarding_survey.timeline.options.within_1_month": "Ready to launch within 1 month",
    "onboarding_survey.timeline.options.within_3_months": "Planning to launch within 3 months",
    "onboarding_survey.timeline.options.uncertain": "Unsure about timing",
    "onboarding_survey.timeline.options.idea_stage": "Only at the idea stage",
    "onboarding_survey.industry.question": "Which industry are you in?",
    "onboarding_survey.industry.options.klaer_og_mote": "Clothing and fashion",
    "onboarding_survey.industry.options.sport_og_fritid": "Sports and leisure",
    "onboarding_survey.industry.options.elektronikk": "Electronics",
    "onboarding_survey.industry.options.mat_og_drikke": "Food and drink",
    "onboarding_survey.industry.options.hjem_og_interior": "Home and interior",
    "onboarding_survey.industry.options.barn_og_baby": "Kids and baby",
    "onboarding_survey.industry.options.smykker_og_klokker": "Jewelry and watches",
    "onboarding_survey.industry.options.kosmetikk_og_skjonnhet": "Cosmetics and beauty",
    "onboarding_survey.industry.options.boker_og_media": "Books and media",
    "onboarding_survey.industry.options.haandverk_og_kunst": "Crafts and art",
    "onboarding_survey.industry.options.dyr_og_dyrepleie": "Pets and pet care",
    "onboarding_survey.industry.options.hobby_og_spill": "Hobby and games",
    "onboarding_survey.industry.options.helse_og_velvaere": "Health and wellness",
    "onboarding_survey.industry.options.bil_og_mc": "Car and motorcycle",
    "onboarding_survey.industry.options.bygg_og_hage": "Building and garden",
    "onboarding_survey.industry.options.tjenester": "Services",
    "onboarding_survey.industry.options.digitale_produkter": "Digital products",
    "onboarding_survey.industry.options.annet": "Other",
    "onboarding_survey.selling_what.question": "What are you going to sell? (select more than one if applicable)",
    "onboarding_survey.selling_what.options.physical": "Physical products",
    "onboarding_survey.selling_what.options.digital": "Digital products",
    "onboarding_survey.selling_what.options.services": "Services",
    "onboarding_survey.selling_what.options.subscription": "Subscription",
    "onboarding_survey.selling_where.question": "Where do you plan to sell?",
    "onboarding_survey.selling_where.options.norway_only": "Norway only",
    "onboarding_survey.selling_where.options.norway_plus_international": "Norway + International",
    "onboarding_survey.needs_pos.question": "Do you need integration with a point-of-sale (POS) system?",
    "onboarding_survey.needs_pos.options.no": "No",
    "onboarding_survey.needs_pos.options.yes": "Yes",
    "onboarding_survey.pos_name.question": "Which POS do you use? (e.g. Zettle, Susoft PCKasse)",
    "onboarding_survey.important_features.question": "Which features are most important to you? (select multiple)",
    "onboarding_survey.important_features.options.seo": "Search engine optimization (SEO)",
    "onboarding_survey.important_features.options.b2b": "B2B / business customers",
    "onboarding_survey.important_features.options.multilingual": "Multiple languages",
    "onboarding_survey.important_features.options.multicurrency": "Multiple currencies",
    "onboarding_survey.important_features.options.subscription": "Subscription",
    "onboarding_survey.important_features.options.advanced_shipping": "Advanced shipping rules",
    "onboarding_survey.important_features.options.discounts": "Discounts and campaigns",
    "onboarding_survey.important_features.options.pos": "POS — physical checkout solution",
    "onboarding_survey.platform_priorities.question": "What matters most when choosing an online store platform? (select up to 3)",
    "onboarding_survey.platform_priorities.options.price": "Price",
    "onboarding_survey.platform_priorities.options.simplicity": "Simplicity",
    "onboarding_survey.platform_priorities.options.integrations": "Integrations",
    "onboarding_survey.platform_priorities.options.design": "Design",
    "onboarding_survey.platform_priorities.options.seo": "SEO",
    "onboarding_survey.platform_priorities.options.automation": "Automation",
    "onboarding_survey.platform_priorities.options.scaling": "Scaling",
    "onboarding_survey.platform_priorities.options.pos": "POS",
    "onboarding_survey.platform_priorities.options.free_support": "Free support",
    "onboarding_survey.platform_priorities.options.international": "International sales",
    "onboarding_survey.expected_revenue.question": "How much do you expect to turn over in the first year?",
    "onboarding_survey.expected_revenue.options.under_100k": "Under 100,000 NOK",
    "onboarding_survey.expected_revenue.options.100k_500k": "100,000 – 500,000 NOK",
    "onboarding_survey.expected_revenue.options.500k_1m": "500,000 – 1 million NOK",
    "onboarding_survey.expected_revenue.options.over_1m": "Over 1 million NOK",
    "onboarding_survey.wants_sales_call.question": "Would you like us to contact you by phone for a no-obligation chat?",
    "onboarding_survey.wants_sales_call.options.yes": "Yes",
    "onboarding_survey.wants_sales_call.options.no": "No",
    "onboarding_survey.phone.question": "Phone number",
    "MyBring Booking": "MyBring Booking",
    "mybring_uid_label": "MyBring UID (email)",
    "logistra_enabled": "Enable Logistra",
    "logistra_enabled_description": "When enabled, Logistra can be used to book shipments when processing orders.",
    "sincos_shipping_enabled": "Enable 24Shipping",
    "sincos_shipping_enabled_description": "When enabled, 24Shipping can be used to book shipments when processing orders.",
    "sincos_shipping_app_headline": "Shipping labels without your own carrier agreements",
    "sincos_shipping_app_body": "Enable the app and book shipments with Posten and PostNord directly from order processing — no separate carrier agreements needed.",
    "mybring_booking_enabled": "Enable MyBring Booking",
    "mybring_booking_enabled_description": "When enabled, MyBring can be used to book shipments when processing orders.",
    "mybring_uid_description": "The email address registered as API user in your MyBring account.",
    "mybring_api_key_description": "Your API key from mybring.com. Leave the masked value unchanged to keep the current key.",
    "mybring_default_customer_number_description": "Preselected customer when booking. Available once valid API credentials are saved.",
    "mybring_app_headline": "Book Bring shipments with your own agreement",
    "mybring_app_body": "Connect your MyBring account and book freight labels directly from order processing with your own Bring prices.",
    "mybring_api_key_label": "MyBring API Key",
    "default_customer_number": "Default customer number",
    "select_customer_number": "Select customer number...",
    "select_bring_product": "Select Bring product...",
    "select_shipping_product": "Select shipping product...",
    "mybring_credentials_validation_failed": "Could not connect to MyBring. Verify your UID and API Key.",
    "unknown_customer_number": "Unknown customer number.",
    "only_norwegian_customers": "Show only Norwegian accounts",
    "only_norwegian_customers_help": "When enabled, only MyBring accounts registered in Norway are shown. Disable to show accounts from all countries.",
    "open_options": "Open options",
    "logistics_description_sincos_shipping": "Complete shipping agreement with scale benefits and professional logistics from day one.",
    "logistics_description_mybring_booking": "Book shipping labels directly with Bring using your own MyBring account.",
    "shipping_mapping_title": "Shipping mapping",
    "shipping_mapping_intro": "Map each shipping method to a carrier service, or mark it manual.",
    "shipping_mapping_info_title": "What is shipping mapping?",
    "shipping_mapping_info_body": "Shipping mapping controls which carrier service is used automatically when you process orders in bulk (bulk picking). The customer picks a shipping method at checkout (for example Standard or Pickup point); the mapping decides which service it's booked with, so you don't choose per order. When you handle orders individually, you pick the carrier there yourself.",
    "shipping_mapping_info_hint": "In the bulk flow, shipping methods without a mapping are shipped manually without a label. Methods that require a pickup point are locked to the correct carrier. Where we have a suggestion, it appears beneath the field — click Use to apply it.",
    "shipping_mapping_method": "Shipping method",
    "shipping_mapping_target": "Mapping",
    "shipping_mapping_not_configured": "Not configured",
    "shipping_mapping_manual_option": "Manual — no label",
    "shipping_mapping_product": "Service",
    "shipping_mapping_unmapped_badge": "Not mapped",
    "shipping_mapping_auto_default": "Ships with its own carrier by default — override if needed",
    "shipping_mapping_unknown_provider": "Unknown carrier.",
    "shipping_mapping_unknown_product": "Unknown service for the selected carrier.",
    "shipping_mapping_recommended_unsaved": "Recommended — not saved",
    "shipping_mapping_recommended_label": "Recommended:",
    "shipping_mapping_use": "Use",
    "shipping_mapping_summary_unmapped": "{unmapped} of {total} shipping methods are not mapped",
    "shipping_mapping_summary_all_mapped": "All shipping methods are mapped",
    "shipping_mapping_filter_all": "All",
    "shipping_mapping_locked_badge": "Locked",
    "shipping_mapping_apply_all": "Apply all suggestions",
    "shipping_mapping_save_failed": "Could not save — try again.",
    "shipping_mapping_manual_no_label_hint": "Shipped without a label",
    "shipping_mapping_select_target_first": "Choose a mapping first",
    "shipping_mapping_other_group": "Other",
    "shipping_mapping_provider_disabled": "The carrier is deactivated — enable it in the App Store or choose another.",
    "select_logistics_provider": "Select logistics provider...",
    "select_logistics_product": "Select shipping product...",
    "shipping_methods_fetched": "{count} shipping methods found — choose one below",
    "app_disable_confirm_title": "Confirm deactivation",
    "app_disable_confirm_button": "Deactivate and save",
    "app_disable_mapped_warning": "{1}:count shipping method is mapped to :name and will be left without a mapping until the app is enabled again — or you can remap it to another carrier under Shipping mapping.|[2,*]:count shipping methods are mapped to :name and will be left without a mapping until the app is enabled again — or you can remap them to another carrier under Shipping mapping.",
    "shipping_mapping_pickup_locked": "Requires a pickup point — locked to the correct carrier",
    "shipping_mapping_link": "Shipping mapping",
    "pickup_at_store": "Pickup at store",
    "printers": "Printers",
    "mybring_not_configured": "MyBring is not available for this order.",
    "discard_changes": "Discard changes",
    "discard_unsaved_changes_question": "Discard all unsaved changes?",
    "save_failed_some_items_have_errors": "Save failed — some items have errors",
    "only_top_level_menu_items_can_be_mega_menus": "Only top-level menu items can be set as mega menus",
    "menu_save_item_not_found": "Menu item does not exist in this menu",
    "menu_save_unknown_temp_id": "A new menu item referenced another one that was not created",
    "menu_save_circular_temp_id_reference": "Circular reference between new menu items",
    "menu_is_empty": "The menu is empty",
    "add_first_menu_item_hint": "Add your first menu item to get started",
    "click_to_edit_name": "Click to edit name",
    "right_column": "Right column",
    "home": "Home",
    "default": "Default",
    "create_template": "Create template",
    "delete_template": "Delete template",
    "template_name": "Template name",
    "confirm_delete_template": "Are you sure you want to delete this template? Products using it will fall back to the default template.",
    "confirm_delete_category_template": "Are you sure you want to delete this template? Categories using it will fall back to the default template.",
    "template_deleted": "Template deleted",
    "categories_now_use_default_template": "{0} No categories used the template|{1} 1 category now uses the default template|[2,*] :count categories now use the default template",
    "product_page_template": "Product page template",
    "page_template": "Page template",
    "others_also_bought": "Others also bought",
    "product_title": "Product title",
    "product_lead_paragraph": "Product lead paragraph",
    "product_price": "Product price",
    "payment_methods_title_description": "Optional label shown above the logos, e.g. \"Fast and secure payment with:\".",
    "payment_methods_logos": "Logos",
    "payment_methods_logos_description": "Pick which payment brand logos to display on the product page.",
    "product_options": "Product options",
    "stock_status": "Stock status",
    "add_to_cart": "Add to cart",
    "product_description": "Product description",
    "related_products": "Related products",
    "column_ratio": "Column ratio",
    "image_gallery": "Image gallery",
    "sticky_left_column": "Sticky left column",
    "sticky_left_column_description": "Left column follows along when scrolling. Useful when the right column is taller than the gallery.",
    "sticky_right_column": "Sticky right column",
    "sticky_right_column_description": "Right column follows along when scrolling. Useful when the gallery is taller than the product content (e.g. a grid with many images).",
    "gallery_thumbnail_position": "Thumbnail position",
    "gallery_grid_columns": "Grid columns",
    "gallery_grid_columns_description": "Only used when thumbnail position is set to Grid.",
    "gallery_display_style": "Display style",
    "gallery_display_style_description": "Slider shows one image at a time. Editorial grid shows the main image at full width and the rest in a 2-column layout where every third image spans full width (desktop only — mobile keeps the slider). Products with a single image use the slider.",
    "gallery_display_slider": "Slider",
    "gallery_display_editorial_grid": "Editorial grid",
    "gallery_mobile_style": "Mobile display",
    "gallery_mobile_style_description": "Mobile only. Standard shows one image at a time with a counter. Thumbnails adds a row of small images below. Filmstrip shows the edge of the next image with a thin progress bar below.",
    "gallery_mobile_style_standard": "Standard",
    "gallery_mobile_style_thumbnails": "Thumbnails",
    "gallery_mobile_style_filmstrip": "Filmstrip",
    "gallery_hover_zoom": "Zoom on hover",
    "gallery_hover_zoom_description": "Magnify the main image when the customer hovers over it (desktop only). Clicking still opens fullscreen.",
    "gallery_aspect_ratio": "Main image aspect ratio",
    "gallery_aspect_ratio_description": "Pick a fixed ratio to minimize whitespace. Natural uses the image's own proportions in the slider and 16:9 for the main image in the grid.",
    "gallery_aspect_natural": "Natural",
    "gallery_image_fill": "Fill the image frame",
    "gallery_image_fill_description": "Image fills the entire frame and crops edges as needed. When off, the whole image is preserved with whitespace around it.",
    "gallery_show_image_text": "Show image text",
    "gallery_show_image_text_description": "Show the text from the Image text field below the product image. Images without image text are shown as before.",
    "gallery_image_text_filename_fallback": "Use the file name when the image text is empty",
    "gallery_image_text_filename_fallback_description": "Images without an image text show their file name, without the extension.",
    "gallery_image_text_alignment": "Image text alignment",
    "gallery_image_text_alignment_description": "Applies to the text under the image, in both the slider and the grid.",
    "gallery_image_text_align_left": "Left",
    "gallery_image_text_align_center": "Centered",
    "gallery_image_text_align_right": "Right",
    "gallery_show_thumbnails": "Show thumbnails",
    "gallery_show_thumbnails_description": "Hide to show only the main image. Useful when the product has a single image or you want a cleaner look.",
    "sticky_gallery": "Sticky gallery",
    "sticky_gallery_description": "Gallery follows along when scrolling",
    "heading_tag": "Heading level",
    "show_sale_badge": "Show sale badge",
    "show_discount_badge": "Show discount badge",
    "show_discount_badge_description": "Show the discount percentage as a badge in the corner of the main image when the product is on sale.",
    "display_style": "Display style",
    "product_options_display_style_description": "Whether values show as text, colors or images is controlled per option under Variants on the product in admin. This setting only controls the button layout.",
    "product_options_size": "Button size",
    "product_options_size_s": "Small",
    "product_options_size_m": "Medium",
    "product_options_size_l": "Large",
    "product_options_size_xl": "Extra large",
    "product_options_swatch_shape": "Swatch shape",
    "product_options_swatch_shape_theme": "Follow theme corners",
    "product_options_swatch_shape_rounded": "Rounded",
    "product_options_swatch_shape_circle": "Circle",
    "product_options_show_selected_value": "Show selected value in the label",
    "product_options_show_selected_value_description": "Shows the selected value next to the option name, e.g. “Color: White”. Applies to options with color or image swatches.",
    "clear_variant_image_on_x_variants": "Remove the gallery image from {count} product variants",
    "clear_variant_image_explanation": "Without a gallery image the gallery stays on the main image when the customer chooses the product variant.",
    "set_variant_image": "Set gallery image",
    "set_variant_image_action_description": "Pick the photo the gallery shows when the customer chooses these product variants",
    "clear_variant_image_action_description": "Remove the gallery image from the selected product variants",
    "adjust_stock_variants_action_description": "Increase or decrease the stock level of the selected variants",
    "toggle_active_variants_action_description": "Enable or disable the selected variants",
    "variant_bulk_hint": "Tick product variants, or select them by option, to set the gallery image, stock or status on several at once.",
    "set_variant_image_on_x_variants": "Set the gallery image on {count} product variants",
    "variant_image_clear": "Remove the gallery image",
    "image_used_by_gallery_only": "Gallery only",
    "main_image": "Main image",
    "show_all_images": "Show all images",
    "show_fewer_images": "Show fewer images",
    "images_reorder_hint": "Drag to reorder – the first image is the main image.",
    "product_options_show_variant_prices": "Show variant price",
    "product_options_show_variant_prices_description": "Shows the variant's price next to each value in the dropdown, drawer and full-width rows. With multiple options the price appears once the other selections are made, since the price belongs to the variant.",
    "product_options_low_stock_hint": "Low stock hint",
    "product_options_low_stock_hint_description": "Shows “Only X left” below the variant options when the selected variant has fewer than the limit in stock. Applies to stock-managed products without backorder.",
    "product_options_low_stock_off": "Off",
    "product_options_low_stock_3": "Below 3",
    "product_options_low_stock_5": "Below 5",
    "product_options_low_stock_10": "Below 10",
    "product_options_unavailable_values": "Unavailable values",
    "product_options_unavailable_strikethrough": "Show struck through",
    "product_options_unavailable_hide": "Hide",
    "show_quantity_selector": "Show quantity selector",
    "buy_button_text": "Buy button text",
    "preorder_button_text": "Preorder button text",
    "club_promo": "Customer Club box",
    "club_promo_bg_color": "Background color",
    "club_promo_text_color": "Text color",
    "club_promo_icon": "Icon",
    "club_promo_icon_star": "Star",
    "club_promo_icon_gift": "Gift",
    "club_promo_icon_sparkles": "Sparkles",
    "club_promo_icon_heart": "Heart",
    "club_promo_icon_badge": "Badge",
    "club_promo_icon_none": "None",
    "vipps_express_button": "Vipps Express button",
    "vipps_express_button_width": "Width",
    "club_promo_texts_in_app_settings": "Activation and texts are managed in the Customer Club app settings",
    "customer_club_design_moved_to_theme_editor": "Colors and icon are managed in the theme editor on the ClubPromo block.",
    "open_theme_editor": "Open theme editor",
    "reviews_per_page": "Reviews per page",
    "reviews_list_loading": "Loading",
    "reviews_list_loading_description": "Scroll shows every review in a box with its own scrollbar, as today. \"Show more\" button shows a number at a time and loads more on click.",
    "reviews_list_loading_scroll": "Scrollbar",
    "reviews_list_loading_button": "\"Show more\" button",
    "reviews_per_page_description": "Number of reviews shown before the \"Show more\" button.",
    "reviews_density": "Density",
    "reviews_density_normal": "Normal",
    "reviews_density_compact": "Compact",
    "reviews_clickable_histogram": "Clickable histogram",
    "reviews_clickable_histogram_description": "Customers can click a star row to see only reviews with that rating.",
    "reviews_slides_per_view": "Cards per view on desktop",
    "reviews_show_histogram": "Show histogram",
    "reviews_show_histogram_description": "Shows the star distribution next to the heading.",
    "reviews_autoplay": "Autoplay",
    "reviews_show_pagination": "Show dots",
    "reviews_show_pagination_description": "The navigation dots below the cards.",
    "reviews_autoplay_description": "The carousel advances by itself every five seconds and pauses on hover.",
    "reviews_heading": "Heading",
    "reviews_sort_order": "Sorting",
    "reviews_sort_newest": "Newest first",
    "reviews_sort_highest": "Highest rating first",
    "reviews_sort_lowest": "Lowest rating first",
    "reviews_show_verified_badge": "Show \"Verified purchase\"",
    "reviews_show_verified_badge_description": "Marks reviews written after a purchase in the store.",
    "reviews_hide_empty": "Hide reviews without text",
    "reviews_hide_empty_description": "Star-only reviews still count towards the average, but are not listed.",
    "reviews_date_format": "Date format",
    "reviews_date_format_date": "Date",
    "reviews_date_format_relative": "Relative (\"2 weeks ago\")",
    "reviews_star_color": "Star colour",
    "reviews_summary_show_count": "Show review count",
    "reviews_summary_show_count_description": "Off shows only the stars and the average rating.",
    "no_settings": "No settings",
    "template": "Template",
    "select_product": "Select product",
    "select_category": "Select category",
    "search_categories": "Search categories",
    "product_templates": "Product templates",
    "product_template": "Product template",
    "product_template_hint": "New: Create multiple product page templates and choose one per product",
    "show_me": "Show me",
    "preview_short": "Preview",
    "theme_editor_zone_left_column": "Left column",
    "theme_editor_zone_right_column": "Right column",
    "theme_editor_zone_full_width": "Below main content",
    "page_template_description": "Choose which page template to use for this product.",
    "font_size": "Font size",
    "alignment": "Alignment",
    "show_savings": "Show savings",
    "show_savings_description": "Show how much the customer saves when the product is on sale",
    "show_stock_status": "Show stock status",
    "show_stock_status_description": "Show stock status to the right of the price. Only visible on products with stock tracking enabled.",
    "show_product_badges": "Show badges",
    "show_product_badges_description": "Show the product's badges above the title.",
    "trust_badges": "Trust badges",
    "trust_badges_title_size": "Title font size",
    "trust_badges_subtitle_size": "Subtitle font size",
    "trust_badges_item_1_enabled": "Show item 1",
    "trust_badges_item_1_icon": "Icon 1",
    "trust_badges_item_1_title": "Title 1",
    "trust_badges_item_1_subtitle": "Subtitle 1",
    "trust_badges_item_2_enabled": "Show item 2",
    "trust_badges_item_2_icon": "Icon 2",
    "trust_badges_item_2_title": "Title 2",
    "trust_badges_item_2_subtitle": "Subtitle 2",
    "trust_badges_item_3_enabled": "Show item 3",
    "trust_badges_item_3_icon": "Icon 3",
    "trust_badges_item_3_title": "Title 3",
    "trust_badges_item_3_subtitle": "Subtitle 3",
    "trust_badges_icon_truck": "Truck",
    "trust_badges_icon_return": "Return",
    "trust_badges_icon_shield": "Shield",
    "trust_badges_icon_card": "Card",
    "trust_badges_icon_clock": "Clock",
    "trust_badges_icon_badge": "Badge",
    "trust_badges_icon_chat": "Chat",
    "trust_badges_icon_gift": "Gift",
    "trust_badges_icon_lock": "Lock",
    "trust_badges_icon_heart": "Heart",
    "trust_badges_icon_sparkles": "Sparkles",
    "orientation": "Orientation",
    "horizontal": "Horizontal",
    "vertical": "Vertical",
    "reviews_summary": "Reviews summary",
    "reviews_summary_show_count": "Show review count",
    "reviews_summary_link_to_reviews": "Click scrolls to reviews",
    "reviews_summary_link_to_reviews_description": "When the user clicks the count, the page scrolls to the reviews section.",
    "below": "Below",
    "accordion": "Accordion",
    "tabs": "Tabs",
    "inline": "Inline",
    "pills": "Pills",
    "pills_full_width": "Full-width pills",
    "dropdown": "Dropdown",
    "drawer": "Side drawer",
    "product_layout_background_color_description": "Sets the background colour for the entire product page.",
    "auto_text_contrast": "Auto-adjust text colours",
    "auto_text_contrast_description": "Text colours adjust automatically against the background for good readability. Turn off to pick colours manually.",
    "auto_contrast_controls_color": "Auto-adjust text colours is on and controls this colour.",
    "heading_color": "Heading colour",
    "heading_color_description": "Used for the product title, price and other prominent text elements.",
    "text_color_description": "Used for body text, lead paragraph and product description.",
    "muted_text_color": "Secondary text colour",
    "muted_text_color_description": "Used for less prominent text such as \"excl. VAT\" and helper text.",
    "duplicate_template": "Duplicate template",
    "copy_of": "Copy of",
    "front_page": "Front page",
    "product_page": "Product page",
    "category_page": "Category page",
    "page_content": "page content",
    "block_description_page_content": "The text from the page in Pages admin. Move it among the other blocks.",
    "content_pages": "Content pages",
    "content_page_label": "Page",
    "edit_page_text": "Edit text",
    "search_pages": "Search pages",
    "no_pages_found": "No pages match your search",
    "no_content_pages_yet": "The store has no content pages yet.",
    "create_page_in_admin": "Create a page under Content",
    "page_content_edit_hint": "The text is edited in Pages admin. Here you only control placement and appearance.",
    "page_design_button": "Design page",
    "page_design_editor_hint": "The text appears as the \"Page content\" block in the design builder. There you can place images, FAQ, forms and other blocks around the text and move it where you want, for this page only.",
    "page_open_design_editor": "Open in the design builder",
    "pages_index_design_hint": "This is where you write the text of your pages. How each page looks is designed under Content pages in the design builder.",
    "pages_open_design_editor": "Open the design builder",
    "designed": "Designed",
    "help_category_content_page": "Content pages",
    "help_content_page_intro_name": "How content pages work",
    "help_content_page_intro_tagline": "Pages are created and written in Pages admin. Here you decide how each page looks, with blocks around the text.",
    "help_content_page_intro_description": "Choose the page you want to work on under Content pages in the \"Page and template\" picker at the top. The text from the Pages admin shows as the \"Page content\" block, which you can move freely. Add images, FAQs, forms and other blocks above or below.",
    "help_content_page_intro_concepts_heading": "Key concepts",
    "help_content_page_intro_concept_text_block": "\"Page content\" is the text from Pages admin. It can be moved but not deleted, and the text itself is still edited in Pages admin.",
    "help_content_page_intro_concept_per_page": "Every page has its own layout. Blocks you add to one page never affect another.",
    "help_content_page_intro_concept_fallback": "A page you have never opened here renders as before, with the text alone.",
    "help_content_page_intro_concept_blocks": "The block picker offers content and media blocks. Product blocks belong on the front page.",
    "help_content_page_intro_workflow_heading": "Typical workflow",
    "help_content_page_intro_workflow_pick": "Open the \"Page and template\" picker, choose Content pages and \"Open content pages\". Search pages when the shop has many. Pages you have designed are marked \"Designed\".",
    "help_content_page_intro_workflow_arrange": "Drag \"Page content\" where you want it and add blocks above and below.",
    "help_content_page_intro_workflow_edit_text": "To change the text, use the \"Edit text\" link that opens the page in Pages admin.",
    "help_content_page_intro_workflow_save": "Click \"Save and publish\". Only the page you're on changes.",
    "category_page_settings_intro": "One global layout applied to every category page and search results.",
    "category_page_title": "Title",
    "category_page_filters": "Filtering",
    "category_page_grid": "Product grid",
    "category_page_pagination": "Pagination",
    "category_pagination_style": "Pagination",
    "category_pagination_style_description": "\"Numbered pages\" shows page numbers with a 25/50/100 picker for the customer. \"Load more\" lets the customer fetch the next page with a click. \"Infinite scroll\" loads more products automatically as the customer scrolls.",
    "category_pagination_style_pages": "Numbered pages (with 25/50/100 picker)",
    "category_pagination_style_load_more": "\"Load more\" button",
    "category_pagination_style_infinite": "Infinite scroll",
    "category_page_colors": "Colours",
    "category_align_left": "Left",
    "category_align_center": "Centered",
    "category_show_title": "Show category title",
    "category_show_title_description": "The heading at the top of the category page. The description is shown regardless, and is controlled by \"Description position\".",
    "category_title_hidden_hint": "Turn on \"Show category title\" to change this.",
    "category_title_align": "Title alignment",
    "category_title_spacing": "Space above/below title",
    "category_title_spacing_normal": "Normal",
    "category_title_spacing_roomy": "Roomy",
    "category_title_spacing_spacious": "Spacious",
    "category_heading_size": "Title size",
    "category_heading_size_small": "Small",
    "category_heading_size_medium": "Medium",
    "category_heading_size_large": "Large",
    "category_filter_values_visible": "Filter values before \"Show more\"",
    "category_filter_values_visible_description": "How many values a filter group shows before a \"Show more\" button appears.",
    "category_filter_values_visible_all": "All",
    "category_filter_group_limit": "Filter groups before \"Show more\"",
    "category_filter_group_limit_description": "How many filter groups the sidebar shows before a \"Show more filters\" button appears. Groups with active selections always show.",
    "category_filter_groups_collapsed": "Start with collapsed filter groups",
    "category_filter_groups_collapsed_description": "Every filter group in the filter panel starts closed when the customer opens the category. The subcategory list is not affected.",
    "category_filter_toggle_all": "Show \"Open/close all filters\" button",
    "category_filter_toggle_all_description": "A button at the top of the filter panel that opens or closes every filter group at once.",
    "category_filter_search": "Search in filters",
    "category_filter_search_description": "Shows search boxes in the filter sidebar: one at the top searching across all filter groups, and one inside groups with many values. The boxes only appear past ten filter groups, or ten values in a group. Applies to every filter placement except the horizontal row.",
    "category_show_sale_filter": "Show \"On sale\" filter",
    "category_show_sale_filter_description": "Gives customers a checkbox in the filter that shows only discounted products.",
    "category_control_style": "Control style",
    "category_control_style_description": "The look of sorting, filter pills and other controls on the category page.",
    "category_control_style_border": "Border",
    "category_control_style_underline": "Underline",
    "category_control_style_ghost": "No border",
    "category_show_stock_filter": "Show \"In stock\" filter",
    "category_show_stock_filter_description": "Gives customers a checkbox in the filter that shows only products in stock.",
    "category_filter_sticky": "Sticky filter on scroll",
    "category_filter_sticky_description": "The filter sidebar follows along as the customer scrolls. Sidebar layout on desktop only.",
    "category_filter_sticky_sidebar_only": "Only applies when the filter is shown in the sidebar. Pick \"Sidebar\" under Filter placement to use this.",
    "category_filter_setting_panel_only": "Only applies when the filter is shown in the sidebar or the side menu. Pick \"Sidebar\" or \"Filter in side menu\" under Filter placement to use this.",
    "category_filter_setting_layout_hidden": "The filter is hidden, so this setting has no effect. Pick another placement under Filter placement to use it.",
    "category_section_spacing": "Spacing around the products",
    "category_card_animation": "Load-in animation",
    "category_card_animation_description": "Product cards fade in gently as they scroll into view (where the browser supports it).",
    "category_card_animation_none": "None",
    "category_card_animation_fade": "Fade in on scroll",
    "category_page_toolbar": "Toolbar",
    "category_page_content": "Content",
    "category_template": "Category template",
    "category_template_description": "Which category page design this category uses. Templates are created and edited in the design builder under Category page.",
    "category_page_category_cards": "Subcategories",
    "category_cards_when_products": "When the category shows products",
    "category_cards_when_subcategories": "When the category shows subcategories",
    "category_cards_appearance": "How the cards look",
    "category_cards_when_products_inactive": "The previewed category shows subcategories, so this navigation is not on it. Other categories in the store use it.",
    "category_cards_when_subcategories_inactive": "The previewed category shows products, so this grid is not on it. Other categories in the store use it.",
    "subcategory_nav_disabled_hint": "Only applies when the navigation is set to \"Category cards at the top\".",
    "subcategory_image_fit_title": "How is the image displayed?",
    "subcategory_text_size": "Text size",
    "subcategory_columns_mobile": "Cards per row – mobile",
    "subcategory_grid_gap": "Space between cards",
    "subcategory_card_style": "Card style",
    "subcategory_card_style_plain": "Plain",
    "subcategory_card_style_border": "Border",
    "subcategory_text_weight": "Text weight",
    "subcategory_text_align": "Text alignment",
    "subcategory_text_uppercase": "Uppercase text",
    "text_position": "Text position",
    "text_position_below": "Below the image",
    "text_position_overlay": "On the image",
    "category_group_products_only_notice": "The previewed category shows category cards, not products. These settings apply to category pages that show products. What a category shows is controlled by \"What this category shows\" in the category’s own settings.",
    "category_preview_force_cards": "Preview category cards anyway",
    "category_preview_force_products": "Preview the product view anyway",
    "category_preview_forced_cards_notice": "The preview is forced to show category cards.",
    "category_preview_forced_products_notice": "The preview is forced to show the product view.",
    "category_preview_force_reset": "Reset",
    "category_preview_drawer_notice": "The filter drawer shows only when a shopper opens it, and buttons are switched off in the preview. Open it from here to see the settings.",
    "category_preview_open_drawer": "Open the filter drawer in the preview",
    "category_preview_close_drawer": "Close the filter drawer",
    "category_preview_dropdown_notice": "The subcategory dropdown shows only when a shopper opens it. Open it from here to see it in the preview.",
    "category_preview_open_dropdown": "Open the dropdown in the preview",
    "category_preview_close_dropdown": "Close the dropdown",
    "display_mode_design_editor_hint": "The look of the category cards is adjusted in the design builder.",
    "display_mode_design_editor_link": "Open the design builder",
    "category_background_color_description": "Background colour for the whole category page (behind the title, filters and products).",
    "category_show_breadcrumbs": "Show breadcrumbs",
    "category_show_breadcrumbs_description": "The trail at the top (\"Home / … / Category\"). Hides it on category and search pages only. Colours are controlled by the global breadcrumb settings.",
    "category_filter_layout": "Filter placement",
    "category_filter_layout_description": "Mobile always uses a filter button with a side menu, regardless of this choice.",
    "category_filter_layout_sidebar": "Sidebar",
    "category_filter_layout_horizontal": "Horizontal row",
    "category_filter_layout_drawer": "Filters in a side menu",
    "category_filter_layout_hidden": "Hidden",
    "category_columns_desktop": "Products per row – desktop",
    "category_columns_desktop_description": "\"Automatic\" adapts the count to the screen width, as today.",
    "category_columns_auto": "Automatic",
    "category_columns_mobile": "Products per row – mobile",
    "category_grid_gap": "Product card spacing",
    "category_grid_gap_compact": "Compact",
    "category_grid_gap_normal": "Normal",
    "category_grid_gap_airy": "Airy",
    "category_default_sorting": "Default sorting",
    "category_default_sorting_description": "The sorting products are shown with when the customer opens a category. Categories with manual ordering keep it. The customer can always switch in the sorting picker.",
    "category_default_sorting_manual_order_hint": "This category uses manual ordering, so the default sorting does not apply here.",
    "category_default_sorting_newest": "Newest",
    "category_default_sorting_alphabetical": "Alphabetical",
    "category_default_sorting_price_asc": "Price low to high",
    "category_default_sorting_price_desc": "Price high to low",
    "category_default_product_view": "Default product view",
    "category_default_product_view_description": "Which view the customer sees first. They can switch if the grid/list toggle is shown, and the choice is remembered in their browser.",
    "category_default_product_view_grid": "Grid",
    "category_default_product_view_list": "List",
    "category_show_view_toggle": "Show grid/list toggle",
    "category_show_view_toggle_description": "The buttons that let the customer switch between grid and list view.",
    "category_show_sorting": "Show sorting",
    "category_show_product_count": "Show product count",
    "category_description_position": "Category description",
    "category_description_position_description": "\"Below the products\" suits longer SEO text that shouldn't push the products down.",
    "category_description_position_top": "Above the products",
    "category_description_position_bottom": "Below the products",
    "category_description_position_hidden": "Hidden",
    "category_subcategory_display": "Subcategory navigation",
    "category_subcategory_display_description": "Applies to every category page. \"In the sidebar\" follows the filter – shown alongside the filters in the sidebar or side menu. With a horizontal or hidden filter they show as buttons at the top instead.",
    "category_subcategory_display_sidebar": "In the sidebar",
    "category_subcategory_display_chips": "Buttons at the top",
    "category_subcategory_display_dropdown": "Dropdown at the top",
    "category_subcategory_display_image_cards": "Category cards at the top",
    "subcategory_nav_format": "Format",
    "subcategory_nav_format_description": "The shape of the cards in the row at the top of the category page.",
    "subcategory_nav_format_square": "Square",
    "subcategory_nav_format_landscape": "Landscape",
    "subcategory_nav_format_portrait": "Portrait",
    "subcategory_nav_format_circle": "Round",
    "subcategory_nav_size": "Size",
    "subcategory_nav_size_description": "How large the cards in the row are. Small shows more cards per row.",
    "subcategory_nav_size_small": "Small",
    "subcategory_nav_size_medium": "Medium",
    "subcategory_nav_size_large": "Large",
    "subcategory_nav_text_size": "Text size",
    "category_subcategory_display_hidden": "Hidden",
    "list": "List",
    "carousel": "Carousel",
    "compare_at_price_color": "Compare-at price colour",
    "compare_at_price_color_description": "Colour of the strikethrough compare-at price during a sale.",
    "api_clients": "API Clients",
    "api_clients_description": "Manage machine-to-machine API clients using OAuth2 client credentials.",
    "create_api_client": "Create API Client",
    "edit_api_client": "Edit API Client",
    "client_secret_created": "API client created successfully. Copy the client secret below — it will not be shown again.",
    "client_secret_regenerated": "Client secret regenerated. Copy the new secret below — it will not be shown again.",
    "client_secret_label": "Client Secret",
    "client_expiration": "Client expiration",
    "currently_expires": "Currently expires",
    "keep_current_expiration": "Keep current",
    "never": "Never",
    "n_days": "{n} days",
    "n_permissions": "{n} permissions",
    "danger_zone": "Danger Zone",
    "regenerate_secret": "Regenerate Secret",
    "revoke_client": "Delete Client",
    "confirm_regenerate_secret": "Are you sure? The current secret will be invalidated immediately.",
    "confirm_revoke_client": "Are you sure you want to delete this API client? All tokens will be invalidated.",
    "delete_api_client_confirmation": "Are you sure you want to delete this API client?",
    "secret_shown_once": "The client secret will only be shown once after creation.",
    "search_permissions": "Search permissions...",
    "api_clients_m2m_warning": "API clients use OAuth2 client credentials for machine-to-machine access. For personal API tokens, go to",
    "your_profile": "your profile",
    "permissions_label": "Permissions",
    "permission_groups.app-store": "App store",
    "permission_groups.blog": "Blog",
    "permission_groups.form": "Forms",
    "permission_groups.form.submission": "Submissions",
    "permission_groups.coupon": "Coupons",
    "permission_groups.customer": "Customers",
    "permission_groups.design": "Design",
    "permission_groups.design.menu": "Menus",
    "permission_groups.marketing.newsletter.subscriber": "Newsletter subscribers",
    "permission_groups.marketing.page": "Pages",
    "permission_groups.marketing.review": "Reviews",
    "permission_groups.marketing.review.settings": "Review settings",
    "permission_groups.order": "Orders",
    "permission_groups.product": "Products",
    "permission_groups.product.category": "Product categories",
    "permission_groups.redirect": "Redirects",
    "permission_groups.report.sales": "Sales reports",
    "permission_groups.settings": "Settings",
    "permission_groups.settings.contact_info": "Contact info",
    "permission_groups.settings.shipping": "Shipping",
    "permission_groups.settings.logistics": "Logistics",
    "permission_groups.settings.payment": "Payment",
    "permission_groups.settings.store.status": "Store status",
    "permission_groups.settings.invoice": "Invoices",
    "permission_groups.users": "Users",
    "permission_groups.users.roles": "Roles",
    "permission_groups.webhook": "Webhooks",
    "permission_groups.api-client": "API clients",
    "permissions.users.view": "View users",
    "permissions.users.store": "Create users",
    "permissions.users.update": "Update users",
    "permissions.users.destroy": "Delete users",
    "permissions.users.roles.view": "View roles",
    "permissions.users.roles.store": "Create roles",
    "permissions.users.roles.update": "Update roles",
    "permissions.users.roles.destroy": "Delete roles",
    "permissions.order.view": "View orders",
    "permissions.order.edit": "Edit orders",
    "permissions.order.fulfill": "Fulfill orders",
    "permissions.order.refund": "Refund orders",
    "permissions.product.view": "View products",
    "permissions.product.create": "Create products",
    "permissions.product.update": "Update products",
    "permissions.product.delete": "Delete products",
    "permissions.product.category.view": "View categories",
    "permissions.product.category.create": "Create categories",
    "permissions.product.category.update": "Update categories",
    "permissions.product.category.delete": "Delete categories",
    "permissions.coupon.view": "View coupons",
    "permissions.coupon.create": "Create coupons",
    "permissions.coupon.update": "Update coupons",
    "permissions.coupon.delete": "Delete coupons",
    "permissions.customer.view": "View customers",
    "permissions.customer.create": "Create customers",
    "permissions.customer.update": "Update customers",
    "permissions.customer.delete": "Delete customers",
    "permissions.marketing.newsletter.subscriber.view": "View subscribers",
    "permissions.marketing.newsletter.subscriber.export": "Export subscribers",
    "permissions.marketing.page.view": "View pages",
    "permissions.marketing.page.create": "Create pages",
    "permissions.marketing.page.update": "Update pages",
    "permissions.marketing.page.delete": "Delete pages",
    "permissions.marketing.review.view": "View reviews",
    "permissions.marketing.review.publish": "Publish reviews",
    "permissions.marketing.review.settings.update": "Update review settings",
    "permissions.blog.view": "View blog posts",
    "permissions.blog.create": "Create blog posts",
    "permissions.blog.update": "Update blog posts",
    "permissions.blog.delete": "Delete blog posts",
    "permissions.form.view": "View forms",
    "permissions.form.create": "Create forms",
    "permissions.form.update": "Edit forms",
    "permissions.form.delete": "Delete forms and their submissions",
    "permissions.form.submission.view": "Read submissions",
    "permissions.form.submission.manage": "Take, finish and reopen submissions",
    "permissions.form.submission.delete": "Delete submissions",
    "permissions.design.update": "Update design",
    "permissions.design.menu.update": "Update menus",
    "permissions.report.sales.view": "View sales reports",
    "permissions.report.sales.export": "Export sales reports",
    "permissions.redirect.view": "View redirects",
    "permissions.redirect.create": "Create redirects",
    "permissions.redirect.update": "Update redirects",
    "permissions.redirect.delete": "Delete redirects",
    "permissions.webhook.view": "View webhooks",
    "permissions.webhook.create": "Create webhooks",
    "permissions.webhook.update": "Update webhooks",
    "permissions.webhook.delete": "Delete webhooks",
    "permissions.api-client.view": "View API clients",
    "permissions.api-client.create": "Create API clients",
    "permissions.api-client.update": "Update API clients",
    "permissions.api-client.delete": "Delete API clients",
    "permissions.app-store.view": "View app store",
    "permissions.app-store.install": "Install apps",
    "permissions.app-store.update": "Update apps",
    "permissions.settings.contact_info.edit": "Edit contact info",
    "permissions.settings.shipping.edit": "Edit shipping",
    "permissions.settings.logistics.edit": "Edit logistics",
    "permissions.settings.payment.edit": "Edit payment",
    "permissions.settings.store.status.change": "Change store status",
    "permissions.settings.invoice.edit": "Edit invoices",
    "permissions.settings.analytics": "View analytics",
    "n_of_total_permissions_selected": "{n} of {total} permissions selected",
    "import_menu_head_title": "Import — menu preview",
    "import_menu_overview": "Overview",
    "import_menu_title": "Menu preview",
    "import_menu_intro": "How your storefront menu will look after import. Fix issues here and watch the tree update.",
    "import_menu_view_as_list": "View as list",
    "import_menu_orphaned_heading": "{count} categories skipped — orphaned in {source}",
    "import_menu_orphaned_explanation": "Their parent category was deleted or disabled in {source}, so they aren't shown there and won't be imported into the menu.",
    "import_menu_more_count": "+{count} more",
    "import_menu_selected_count": "{count} categories selected",
    "import_menu_strategy": "Strategy",
    "import_menu_flatten_into_parent_suggested": "Flatten into parent (suggested)",
    "import_menu_attribute_name": "Attribute name",
    "import_menu_attribute_placeholder": "e.g. Modell",
    "import_menu_apply_count": "Apply to {count}",
    "import_menu_no_menu_to_preview": "This source doesn't provide a menu to preview.",
    "import_menu_only_show_with_issues": "Only show categories with issues",
    "import_menu_hide_disabled_in_source": "Hide categories disabled in {source}",
    "import_menu_fix": "Fix",
    "import_menu_no_categories_with_issues": "No categories with issues.",
    "import_menu_before": "Before",
    "import_menu_after": "After",
    "import_overview_head_title": "Import tool — overview",
    "import_overview_title": "Import overview",
    "import_overview_intro_before": "A preview of what this import will create or update. Nothing is written to your store until you choose ",
    "import_overview_intro_after": ".",
    "import_overview_meta": "Run {id} · source {source} · status {status}",
    "import_overview_run_preflight": "Run preflight",
    "import_overview_run_import": "Run import",
    "import_overview_failed_analysis": "imports couldn't be analyzed ({labels}) and will be skipped by this import. Fix the source data and re-run preflight to include them.",
    "import_overview_not_analyzed": "This import hasn't been analyzed yet. Run preflight to preview the changes and surface any issues before importing.",
    "import_overview_scanning": "Analyzing the source data — this can take a while for large stores. This page updates automatically when the preview is ready.",
    "import_overview_scanning_short": "Analyzing…",
    "import_overview_restart_scan": "Restart analysis",
    "import_overview_scan_failed": "The analysis failed before it could finish. Check the source connection and run preflight again.",
    "import_overview_unresolved": "records still need a decision before this import can run. Open each entity below to resolve them.",
    "import_overview_ready_to_run": "No decisions needed — you're ready to run the import.",
    "import_overview_status_running": "This import is running. Open it to follow the progress.",
    "import_overview_status_completed": "This import has completed. Re-import to run a fresh pass — your decisions carry over.",
    "import_overview_status_finished": "This import has already been run. Open it to review the results.",
    "import_overview_view_progress": "View progress",
    "import_overview_view_results": "View results",
    "import_overview_tag_analysis_failed": "Analysis failed",
    "import_overview_tag_not_analyzed": "Not analyzed",
    "import_overview_tag_analyzing": "Analyzing…",
    "import_overview_tag_needs_review": "Needs review",
    "import_overview_tag_ready": "Ready",
    "import_overview_preview_menu_link": "Preview the imported menu & resolve issues →",
    "import_overview_resolve_link": "Review & resolve {count} records →",
    "import_options_action_convert": "Convert to attribute",
    "import_options_action_drop": "Don't import",
    "import_options_action_import": "Import as-is",
    "import_options_axis_counts": "{products} products · {values} values",
    "import_options_back": "Back to overview",
    "import_options_bulk_capitalize": "Capitalize",
    "import_options_bulk_lowercase": "lowercase",
    "import_options_bulk_trim": "Trim",
    "import_options_coexist_warning": "{count} products use several of the merged options at once. Those products keep the original option names.",
    "import_options_empty": "No product options were found in the scanned data.",
    "import_options_head_title": "Product options — import",
    "import_options_intro": "These option names become storefront filter facets. Merge duplicate axes, tidy value names, or drop axes you no longer need before running the import.",
    "import_options_saved": "Saved",
    "import_options_suggest_merge_axes": "Merge into “{target}”:",
    "import_options_suggest_merge_values": "In “{axis}”, merge into “{target}”:",
    "import_options_suggestion_accept": "Apply",
    "import_options_suggestion_dismiss": "Dismiss",
    "import_options_suggestions_title": "Suggested cleanups",
    "import_options_tag_attribute": "Becomes attribute",
    "import_options_tag_collapsed_only": "Imports as attribute",
    "import_options_tag_dropped": "Not imported",
    "import_options_tag_existing_attribute": "Matches existing attribute",
    "import_options_tag_existing_option": "Matches existing option",
    "import_options_tag_merged": "Merges with {names}",
    "import_options_title": "Product options",
    "import_options_unsafe_tooltip": "Some products have several values on this option, so it cannot be dropped or converted:",
    "import_options_value_counts": "{products} products · {variants} variants",
    "import_options_values_heading": "Values",
    "import_overview_options_link": "Review product options →",
    "import_overview_no_entities": "No importable entities were selected for this run.",
    "import_connect_connection_successful": "Connection successful.",
    "import_connect_connection_failed": "Connection failed.",
    "import_connect_connection_test_error": "Could not run the connection test.",
    "import_connect_page_title": "Import tool — connect",
    "import_connect_heading": "Import tool",
    "import_connect_subtitle": "Connect to a source and choose what to import.",
    "import_connect_source_help": "Which system are you importing from.",
    "import_connect_source_type": "Source type",
    "import_connect_connection": "Connection",
    "import_connect_connection_help": "How to reach the source. Each source defines what it needs.",
    "import_connect_checking_connection": "Checking connection…",
    "import_connect_connection_not_checked": "Connection not checked yet.",
    "import_connect_test_connection": "Test connection",
    "import_connect_what_to_import": "What to import",
    "import_connect_what_to_import_help": "Select the entity types to include in this run.",
    "import_connect_no_entity_types": "No importable entity types are registered.",
    "import_connect_start_run": "Start run",
    "import_decision_point_source_of_truth": "Source of truth",
    "import_decision_point_category_flatten": "Category flattening",
    "import_decision_point_menu_depth": "Menu depth",
    "import_decision_point_variant_removal": "Variant removal",
    "import_decision_point_variant_overflow": "Variant overflow",
    "import_decision_point_variant_tree": "Variant data",
    "import_decision_point_empty_category": "Empty category",
    "import_decision_point_media_reconciliation": "Image changes",
    "import_decision_point_new_product": "New product",
    "import_decision_point_variant_addition": "New variants",
    "import_strategy_label_mirror_source": "Mirror source",
    "import_strategy_desc_mirror_source": "Attach new images, replace changed ones and remove images no longer in the source.",
    "import_strategy_desc_keep_target": "Leave this product's images exactly as they are.",
    "import_strategy_label_custom": "Choose per image",
    "import_reason_message_media_reconciliation": "The product's images differ from the source — choose which to retain.",
    "import_media_badge_new": "new",
    "import_media_badge_missing": "missing from source",
    "import_media_badge_changed": "content changed",
    "import_media_badge_unchanged": "unchanged",
    "import_media_action_attach": "attach",
    "import_media_action_detach": "remove",
    "import_media_action_replace": "replace",
    "import_media_action_keep": "keep",
    "import_media_custom_active": "Per-image choices active",
    "import_media_target": "This store",
    "import_media_not_in_source": "not in source",
    "import_media_not_on_target": "not imported yet",
    "import_reason_id_overlap": "ID overlap",
    "import_reason_source_of_truth": "Field conflict",
    "import_reason_variant_overflow": "Too many variants",
    "import_reason_menu_depth": "Menu too deep",
    "import_reason_variant_tree": "Variant data error",
    "import_reason_message_id_overlap": "Source #{sourceId} matches an existing record with a different ID — choose which record wins.",
    "import_reason_message_source_of_truth": "{count} fields differ from the existing record — choose the source of truth.",
    "import_issue_too_many_variants": "Product has {count} variants, exceeding the limit of {limit}.",
    "import_issue_broken_variant_tree": "Product '{title}' has variant data that could not be read: {error}",
    "import_run_counter_created": "Created",
    "import_run_counter_updated": "Updated",
    "import_run_counter_unchanged": "Unchanged",
    "import_run_counter_skipped": "Skipped",
    "import_run_counter_remapped": "Remapped",
    "import_run_counter_failed": "Failed",
    "import_field_slug": "Slug",
    "import_field_meta_title": "Meta title",
    "import_field_meta_description": "Meta description",
    "import_field_show_title": "Show title",
    "import_field_article_number": "Article number",
    "import_field_ean": "EAN",
    "import_field_price_excl_vat": "Price (excl. VAT)",
    "import_field_vat_rate": "VAT rate",
    "import_field_stock": "Stock",
    "import_field_google_product_category_id": "Google product category ID",
    "import_field_google_product_category_name": "Google product category name",
    "import_field_google_product_condition": "Google product condition",
    "import_field_google_product_adult": "Google product adult",
    "import_field_customer_type": "Customer type",
    "import_field_billing_first_name": "Billing first name",
    "import_field_billing_last_name": "Billing last name",
    "import_field_billing_phone": "Billing phone",
    "import_field_billing_street": "Billing street",
    "import_field_billing_street2": "Billing street 2",
    "import_field_billing_postal_code": "Billing postal code",
    "import_field_billing_city": "Billing city",
    "import_field_billing_country": "Billing country",
    "import_field_billing_organization_number": "Billing organization number",
    "import_field_billing_company_name": "Billing company name",
    "import_field_billing_company_project": "Billing company project",
    "import_field_billing_company_department": "Billing company department",
    "import_field_uses_shipping_address": "Uses shipping address",
    "import_field_shipping_first_name": "Shipping first name",
    "import_field_shipping_last_name": "Shipping last name",
    "import_field_shipping_phone": "Shipping phone",
    "import_field_shipping_street": "Shipping street",
    "import_field_shipping_street2": "Shipping street 2",
    "import_field_shipping_postal_code": "Shipping postal code",
    "import_field_shipping_city": "Shipping city",
    "import_field_shipping_country": "Shipping country",
    "import_field_store_companyNumber": "Company number",
    "import_field_store_storeDescription": "Store description",
    "import_field_contact_phone": "Contact phone",
    "import_field_contact_email": "Contact email",
    "import_field_billing_postalCode": "Billing postal code",
    "import_field_billing_email": "Billing email",
    "import_run_page_title": "Import tool — run",
    "import_run_overview": "Overview",
    "import_run_heading": "Run import",
    "import_chunks_never_ran": ":count batch(es) of this entity never ran, so its records were not imported. Retry the import.",
    "import_run_start_failed": "The import could not be started. Resolve any outstanding decisions first.",
    "import_run_already_running": "This import is already running.",
    "import_run_already_completed": "This import has already completed. Start a new import to re-sync.",
    "import_run_complete_message": "This import is complete. To run it again, start a fresh import — your decisions carry over.",
    "import_run_reimport": "Re-import",
    "import_run_start": "Start import",
    "import_run_failed_message": "The import did not complete. Review the results below, then retry.",
    "import_run_retry": "Retry",
    "import_run_partial_message": "The import finished, but some batches failed. Review the results below, then retry to re-run any that did not complete.",
    "import_run_results": "Results",
    "import_run_failures": "Failures",
    "import_run_retry_failures": "Retry failed records",
    "import_run_failure_chunk": "chunk",
    "import_run_failure_entity": "Entity",
    "import_run_failure_source": "Source ID",
    "import_run_failure_message": "Error",
    "import_run_failure_all_entities": "All entities",
    "import_run_messages": "Notes",
    "import_run_messages_hint": "Items that were skipped or adjusted during the import",
    "import_run_message_message": "Note",
    "import_run_col_entity": "Entity",
    "import_run_total": "Total",
    "import_run_total_operations": "{count} operations",
    "import_run_auto_refresh": "Auto-refresh",
    "import_run_eta": "Estimated time left",
    "import_run_eta_rough": "(rough estimate)",
    "import_run_duration_lt_min": "under 1 min",
    "import_run_unit_min": "min",
    "import_run_unit_hour": "h",
    "import_entity_page_title": "Import tool — {entity}",
    "import_entity_overview": "Overview",
    "import_entity_record_count": "{count} records",
    "import_entity_source_id": "Source ID",
    "import_entity_title_or_name": "Title / name",
    "import_entity_match": "Match",
    "import_entity_decision": "Decision",
    "import_entity_all_records": "All records",
    "import_entity_all_matches": "All match states",
    "import_entity_needs_review_any_reason": "Needs review — any reason",
    "import_entity_empty_no_reason_match": "No records match this reason.",
    "import_entity_empty_nothing_needs_review": "Nothing needs review on this entity.",
    "import_entity_empty_no_records_on_page": "No records on this page.",
    "import_bulk_apply_strategy": "Apply choices…",
    "import_bulk_apply_field_policy": "Apply field policy…",
    "import_bulk_apply_to_all_fields": "Apply to all fields",
    "import_bulk_keep_source": "Keep {source} (source)",
    "import_bulk_keep_target": "Keep 24Next (current)",
    "import_bulk_skip_field": "Skip field",
    "import_field_backorder": "Allow backorder",
    "import_field_stock_tracking": "Track stock",
    "import_field_redirect": "Redirect from the V1 address",
    "import_bulk_page_selected": "All {count} on this page are selected.",
    "import_bulk_select_all_matching": "Select all {total} matching",
    "import_bulk_all_selected": "All {count} matching records are selected.",
    "import_bulk_fix_button": "Resolve in bulk…",
    "import_bulk_fix_title": "Resolve conflicts in bulk",
    "import_bulk_fix_field_rules": "Field rules",
    "import_bulk_fix_affected": "{count} records",
    "import_bulk_fix_leave_undecided": "Leave undecided",
    "import_bulk_fix_forced_heading": "True conflicts",
    "import_bulk_fix_forced_hint": "Both sides changed since the last import. {source} is pre-selected — set a whole field at once, or adjust per row.",
    "import_bulk_fix_no_rules": "No field deviations in the selection.",
    "import_bulk_fix_apply": "Apply to {count} records",
    "import_bulk_scope_matching": "No rows are ticked, so bulk actions apply to all {count} records in the current filter.",
    "import_bulk_scope_selected": "Bulk actions apply to the {count} selected records.",
    "import_bulk_fix_set_all": "Set all",
    "import_bulk_fix_group_rows": "{count} rows",
    "import_bulk_fix_group_sample": "Showing the first {shown} of {count} rows here. \"Set all\" applies to all {count}.",
    "import_bulk_strategy_title": "Apply choices in bulk",
    "import_bulk_strategy_hint": "The choice applies to every record and variant row in the selection where it is available, including required decisions. A choice made here counts as a manual decision. Choices that need input per record are made in each row.",
    "import_bulk_strategy_none": "No decisions to make in bulk for this selection.",
    "import_bulk_strategy_child_rows": "{count} variant rows",
    "import_strategy_forced": "Forced",
    "import_strategy_suggested": "suggested",
    "import_strategy_split_target": "Split target / option",
    "import_strategy_split_placeholder": "e.g. attribute to split on",
    "import_fix_resolve_item": "Resolve this item",
    "import_fix_pick_placement": "Pick how to place “{label}”. The preview updates as you choose.",
    "import_fix_suggested": "Suggested",
    "import_compare_match": "Match",
    "import_compare_mismatch": "Mismatch",
    "import_compare_update": "Update",
    "import_compare_needs_decision": "Needs decision",
    "import_compare_resolved": "Resolved",
    "import_compare_mismatch_help": "This record already exists in 24Next. The highlighted columns differ — choose which value to keep for each.",
    "import_compare_decisions": "Decisions",
    "import_fielddiff_unchanged": "Unchanged",
    "import_fielddiff_source_advanced": "Source advanced",
    "import_fielddiff_target_edited": "Edited in 24Next",
    "import_fielddiff_conflict": "Conflict",
    "import_fielddiff_field": "Field",
    "import_fielddiff_base_col": "Base (last import)",
    "import_fielddiff_source_col": "Source ({source})",
    "import_fielddiff_current_col": "Current (24Next)",
    "import_fielddiff_verdict": "Verdict",
    "import_fielddiff_keep": "Keep",
    "import_fielddiff_forced": "Forced",
    "import_fielddiff_no_differences": "No field-level differences.",
    "import_variant_ui_update": "Update",
    "import_variant_ui_review": "Review",
    "import_variant_ui_count": "Variants ({count})",
    "import_variant_ui_needs_decision": "needs decision",
    "import_preview_images": "🖼️ Images",
    "import_preview_ready": "{count} ready",
    "import_preview_no_decisions": "No decisions needed.",
    "import_preview_review_images": "Review images",
    "import_preview_google_taxonomy": "🏷️ Google taxonomy",
    "import_preview_issues": "⚠ {count} issues",
    "import_preview_ready_status": "Ready",
    "import_preview_map_resolve_taxonomy": "Map & resolve taxonomy",
    "import_cluster_catalog": "Catalog",
    "import_cluster_customers": "Customers & groups",
    "import_cluster_pages": "Pages",
    "import_cluster_settings": "Store settings",
    "import_cluster_faqs": "FAQs",
    "import_cluster_blog": "Blog",
    "import_cluster_content": "Content",
    "import_cluster_design": "Design",
    "import_cluster_other": "Other",
    "import_field_answers": "Questions & answers",
    "product_variants": "Product variants",
    "customer_group_memberships": "Customer group memberships",
    "customer_group_applications": "Applications",
    "customer_group_rules": "Customer group rules",
    "company_settings": "Company settings",
    "product_google_taxonomy": "Product Google taxonomy",
    "content_images": "Content images",
    "content_urls": "Content image links",
    "scanning": "scanning",
    "reviewing": "reviewing",
    "running": "running",
    "failed": "failed",
    "partial": "partial",
    "import_strategy_label_faithful": "Faithful",
    "import_strategy_label_flatten_promote": "Lift up to allowed level",
    "import_strategy_label_truncate": "Truncate",
    "import_strategy_label_flatten_into_parent": "Flatten into parent",
    "import_strategy_label_skip": "Skip",
    "import_strategy_label_create": "Create",
    "import_strategy_label_add": "Add",
    "import_strategy_label_split_into_products": "Split into products",
    "import_strategy_label_source_of_truth": "Source of truth",
    "import_strategy_label_keep_source": "Keep source",
    "import_strategy_label_keep_target": "Keep current",
    "import_strategy_label_merge": "Merge",
    "import_strategy_label_convert_to_page": "Convert to page",
    "import_strategy_label_skip_empty": "Skip (don't import)",
    "import_strategy_label_import_as_category": "Import as category",
    "import_strategy_label_merge_into_category": "Merge into another category",
    "import_strategy_label_overwrite": "Overwrite",
    "import_strategy_label_remap": "Import with new id",
    "import_strategy_label_deactivate": "Deactivate",
    "import_strategy_label_delete_if_unreferenced": "Delete if unused",
    "import_strategy_label_keep": "Keep",
    "import_strategy_label_cap_first_n": "Keep the first {limit}",
    "import_strategy_label_collapse_to_master": "Collapse to master",
    "import_strategy_label_import_without_variants": "Import without variants",
    "import_strategy_label_skip_product": "Skip product",
    "import_strategy_desc_convert_to_page": "Creates a content page from the category instead of a store category.",
    "import_strategy_desc_import_as_category": "Imports as a normal category even though it has no products.",
    "import_strategy_desc_skip_empty": "Does not import this category at all.",
    "import_strategy_desc_merge": "Keeps the existing v3 record and only fills in fields that are empty.",
    "import_strategy_desc_overwrite": "Overwrites the existing v3 record with the values from V1.",
    "import_strategy_desc_remap": "Imports as a new record with a new id, leaving the existing one untouched.",
    "import_strategy_desc_skip": "Skips — keeps the existing v3 record and does not import this one.",
    "import_strategy_desc_faithful": "Imports everything exactly as it is in V1, with no changes.",
    "import_strategy_desc_flatten_into_parent": "Moves the products up to the parent category and tags them with an attribute for filtering.",
    "import_strategy_desc_flatten_promote": "Lifts menu items that are too deep up to the maximum allowed depth.",
    "import_strategy_desc_merge_into_category": "Merges into another category and tags the products with an attribute.",
    "import_strategy_desc_truncate": "Removes menu items deeper than the limit.",
    "import_strategy_desc_deactivate": "Deactivates the variant but keeps it for order history.",
    "import_strategy_desc_delete_if_unreferenced": "Deletes the variant only if no orders reference it.",
    "import_strategy_desc_keep": "Keeps the variant unchanged.",
    "import_strategy_desc_cap_first_n": "Keeps the first {limit} variants and drops the rest.",
    "import_strategy_desc_collapse_to_master": "Collapses to a single master variant; the variant options become attributes.",
    "import_strategy_desc_split_into_products": "Splits into several standalone products based on one variant option.",
    "import_strategy_desc_import_without_variants": "Imports as a simple product and drops the variants that can't be read.",
    "import_strategy_desc_skip_product": "Skips the whole product — it won't be imported.",
    "import_menu_converted_to_page": "\u2192 page",
    "import_menu_empty_category_action": "Empty categories",
    "import_issue_too_deep": "Menu item '{name}' sits at depth {depth}, exceeding the limit of {limit}.",
    "import_overview_rerun_preflight": "Rerun preflight",
    "import_overview_changes_new": "{count} new",
    "import_overview_changes_updated": "{count} to update",
    "import_overview_changes_unchanged": "{count} unchanged",
    "import_fix_applies_to_count": "This solution will be applied to {count} categories.",
    "import_menu_indirect_product": "Linked via a subcategory",
    "import_merge_proposal_heading": "{count} categories contain “{label}”",
    "import_merge_proposals_heading": "Consolidation proposals",
    "import_merge_proposal_explanation": "Merge them into one category and tag the products with an attribute so customers can filter the storefront.",
    "import_merge_proposal_review": "Review proposal",
    "import_merge_proposal_dismiss": "Dismiss",
    "import_merge_target_heading": "Target category",
    "import_merge_target_new": "Create new category",
    "import_merge_target_existing": "Use existing category",
    "import_merge_target_name": "Name",
    "import_merge_target_placement": "Placement",
    "import_merge_target_top_level": "Top level",
    "import_merge_attribute_value": "Attribute value",
    "import_merge_members_heading": "Categories being merged",
    "import_merge_new_category_badge": "New",
    "import_merge_source_count": "{count} merged",
    "import_merge_apply": "Merge {count}",
    "gift_certificate_liability": "Gift certificate liability",
    "outstanding_gift_certificate_liability": "Outstanding gift certificate liability",
    "outstanding_certificates_list": "Outstanding certificates",
    "no_outstanding_certificates": "No outstanding certificates on the selected date.",
    "gift_card_liability_outstanding": "Outstanding",
    "gift_card_liability_breakage": "Breakage",
    "across_active_certificates": "across {count} active certificates",
    "issued": "Issued",
    "redeemed": "Redeemed",
    "breakage_expired_unredeemed": "Breakage (expired, unredeemed)",
    "n_certificates": "{count} certificates",
    "total_certificates": "Total certificates",
    "as_of": "As of",
    "no_gift_certificates_issued": "No gift certificates have been issued yet.",
    "gift_certificate_line_not_refundable": "A gift certificate cannot be refunded once it has been used.",
    "gift_certificate_cannot_void_redeemed": "A gift certificate cannot be voided once it has been used.",
    "gift_certificate_not_supported_in_express": "Gift cards can't be used with Vipps Express. Complete checkout in the regular flow to redeem your gift card.",
    "gift_card": "Gift card",
    "gift_card_app_description": "Sell gift cards your customers can redeem at checkout.",
    "gift_card_issued_success": "Gift certificate :code created.",
    "gift_card_create": "Create gift certificate",
    "gift_card_field_amount": "Amount (kr)",
    "gift_card_field_recipient_email": "Recipient email (optional)",
    "gift_card_field_message": "Greeting (optional)",
    "gift_card_field_note": "Internal note (optional)",
    "gift_card_field_expires_at": "Expiry date (optional)",
    "gift_card_field_send": "Send to recipient",
    "gift_card_enabled": "Enable gift cards",
    "gift_card_enabled_description": "When enabled, customers can buy gift cards in your store.",
    "gift_card_add_to_menu": "Add to menu",
    "gift_card_add_to_menu_description": "Add the gift card page to a menu in your store.",
    "gift_card_add_to_menu_hint": "Enable gift cards first",
    "gift_card_min_amount": "Minimum amount (kr)",
    "gift_card_min_amount_description": "The smallest gift-card amount a customer can buy.",
    "gift_card_max_amount": "Maximum amount (kr)",
    "gift_card_max_amount_description": "The largest gift-card amount a customer can buy.",
    "gift_card_max_amount_gte_min": "The maximum amount must be greater than or equal to the minimum amount.",
    "gift_card_validity_months": "Validity (months)",
    "gift_card_validity_months_description": "How many months an issued gift card stays valid.",
    "gift_card_purchase_description": "Purchase page text",
    "gift_card_purchase_description_description": "Shown to customers on the gift-card purchase page.",
    "gift_card_email_body": "Delivery email text",
    "gift_card_email_body_description": "Intro text included in the gift-card delivery email.",
    "gift_card_image": "Card image",
    "gift_card_image_description": "Image shown on the purchase page and in the delivery email.",
    "gift_card_heading": "Gift cards",
    "gift_card_sub_heading": "Let customers buy gift cards for your store.",
    "advantages_with_gift_card": "Advantages of gift cards",
    "advantages_with_gift_card_1": "Customers buy now and redeem later.",
    "advantages_with_gift_card_2": "Drive sales and attract new customers.",
    "advantages_with_gift_card_3": "The balance is reusable across multiple orders.",
    "gavekort": "Gift cards",
    "gift_card_issued": "Issued gift cards",
    "gift_card_search_placeholder": "Search by code or email…",
    "gift_card_status_all": "All statuses",
    "gift_card_status_active": "Active",
    "gift_card_status_depleted": "Depleted",
    "gift_card_status_voided": "Voided",
    "gift_card_status_expired": "Expired",
    "gift_card_export_csv": "Export CSV",
    "gift_card_export_hint": "The CSV export includes all gift certificates with their current status, regardless of the filters above.",
    "gift_card_face_value": "Face value",
    "gift_card_balance": "Balance",
    "gift_card_expires": "Expires",
    "gift_card_issued_at": "Issued",
    "gift_card_empty_title": "No gift cards found",
    "gift_card_empty_hint": "Try a different search, or wait until gift cards have been issued.",
    "gift_card_resend_email": "Resend email",
    "gift_card_movement_history": "History",
    "gift_card_movement_issued": "Issued",
    "gift_card_movement_redeemed": "Redeemed",
    "gift_card_movement_restored": "Restored",
    "gift_card_movement_voided": "Voided",
    "gift_card_movement_reactivated": "Reactivated",
    "gift_card_movement_balance_after": "Balance after",
    "gift_card_movement_empty": "No movements",
    "gift_card_movement_date": "Date",
    "gift_card_movement_type": "Event",
    "gift_card_movement_amount": "Amount",
    "gift_card_movement_order": "Order",
    "gift_card_movement_reason": "Reason",
    "gift_card_movement_loading": "Loading…",
    "gift_card_movement_error": "Could not load history",
    "gift_card_bulk_title": "Bulk create gift certificates",
    "gift_card_bulk_intro": "Upload a CSV to create multiple gift certificates at once. Download the template to see the columns.",
    "gift_card_bulk_download_template": "Download template",
    "gift_card_bulk_choose_file": "Choose CSV file",
    "gift_card_bulk_no_file": "No file selected",
    "gift_card_bulk_preview": "Preview",
    "gift_card_bulk_confirm": "Create certificates",
    "gift_card_bulk_back": "Back to gift certificates",
    "gift_card_bulk_open": "Upload CSV",
    "gift_card_bulk_col_line": "Row",
    "gift_card_bulk_col_amount": "Amount",
    "gift_card_bulk_col_recipient": "Recipient",
    "gift_card_bulk_col_send": "Send",
    "gift_card_bulk_col_errors": "Errors",
    "gift_card_bulk_col_code": "Code",
    "gift_card_bulk_all_valid": "All rows are valid. Ready to create.",
    "gift_card_bulk_has_errors": "Some rows have errors. Fix the CSV and upload again.",
    "gift_card_bulk_results_title": "Created gift certificates",
    "gift_card_bulk_download_results": "Download results",
    "gift_card_bulk_yes": "Yes",
    "gift_card_bulk_no": "No",
    "gift_card_bulk_search_code": "Search by code",
    "gift_card_as_of_now": "Now",
    "gift_card_viewing_as_of": "Viewing status as of {date}",
    "choose_image": "Choose image",
    "change_image": "Change image",
    "order_already_locked_to_batch": "The order is already locked to an active batch.",
    "picking_line_not_in_batch": "This line doesn't belong to this batch.",
    "picking_nothing_to_fulfill": "No units are registered as picked for this order.",
    "picking_order_not_in_batch": "The order is not part of this batch.",
    "bulk_picking_batch_completed": "Batch completed — {count} orders packed and shipped.",
    "bulk_picking_batch_done_title": "Batch #{number} completed",
    "bulk_picking_batch_done_subtitle": "All orders in the session have been processed.",
    "bulk_picking_fully_fulfilled": "Fully fulfilled",
    "bulk_picking_partially_fulfilled": "Partially fulfilled",
    "bulk_picking_orders_count": "{count} orders",
    "bulk_picking_back_to_orders": "Back to orders",
    "bulk_picking_batch_started": "Bulk picking started — :count orders locked to the batch.",
    "bulk_picking_batch_started_skipped": "Bulk picking started for :count orders. :skipped orders were skipped because they're already fulfilled or cancelled.",
    "bulk_picking_no_eligible_orders": "None of the selected orders could be picked — they're already fulfilled or cancelled.",
    "bulk_picking_batch_released": "Batch released — the orders are unlocked.",
    "bulk_picking_order_released": "The order was released from the batch.",
    "bulk_picking_release_this_order": "Handle later",
    "bulk_picking_release_batch": "Release batch",
    "bulk_picking_release_batch_title": "Release the batch?",
    "bulk_picking_release_batch_body": "This unlocks all {orders} orders and discards all recorded picking and packing progress in the batch. This can't be undone.",
    "bulk_picking_release_batch_confirm": "Release and discard",
    "bulk_picking_release_orders": "Release from picking",
    "bulk_picking_release_orders_description": "Release the selected orders from their picking batches.",
    "bulk_picking_release_orders_title": "Release the selected orders?",
    "bulk_picking_release_orders_body": "This unlocks {orders} orders and discards their recorded picking and packing progress. This can't be undone.",
    "bulk_picking_release_orders_confirm": "Release and discard",
    "bulk_picking_orders_released": ":count orders were released from picking.",
    "bulk_picking_orders_released_skipped": ":count orders were released from picking. :skipped orders were skipped because they're not locked to a batch.",
    "bulk_picking_no_locked_orders": "None of the selected orders are locked to a picking batch.",
    "bulk_picking_units_left": "{count} left",
    "bulk_picking_order_completed": "Order completed and shipped.",
    "bulk_picking_pickup_point_unavailable": "No pickup point could be found for this order. Release it and handle it individually.",
    "bulk_picking_shipping_needs_attention": "This shipping method isn't mapped to a carrier. Fix it on Shipping mapping, or set the method to manual.",
    "start_bulk_picking": "Start bulk picking",
    "start_bulk_picking_description": "Lock the selected orders to a picking batch.",
    "lock_status": "Picking session",
    "locked": "Locked",
    "bulk_picking_locked_by": "Being picked by {admin}",
    "release": "Release",
    "my_locks": "Mine",
    "available": "Available",
    "moments_ago": "moments ago",
    "bulk_picking_session_title": "Packing session",
    "pack_all": "All",
    "units_packed_of": "{picked} of {total} units packed",
    "complete_order": "Complete order",
    "partial_pick_warning": "{picked} of {total} units picked — the rest stays unfulfilled.",
    "bulk_picking_orders_packed_of": "{packed} of {total} orders packed",
    "bulk_picking_mode_manual": "Manual",
    "bulk_picking_mode_scan": "Scan",
    "bulk_picking_scan_later": "Scanning comes later",
    "bulk_picking_register_hint": "Register quantities as items go into the box.",
    "bulk_picking_units_of": "{picked} of {total} units",
    "bulk_picking_lines_hint": "Use − / +, type a quantity directly, or \"All\" to fill the whole line. Partial lines are marked amber.",
    "bulk_picking_not_picked": "Not picked",
    "bulk_picking_partly_picked": "Only {picked} of {remaining} picked",
    "bulk_picking_partial_badge": "Partial",
    "bulk_picking_complete_badge": "Complete",
    "bulk_picking_shipping": "Shipping",
    "bulk_picking_calculated": "(calculated)",
    "bulk_picking_manual_shipping": "Manual shipping — no label booked",
    "bulk_picking_label_autoprint": "If a Smartprint printer is set up, the label prints automatically when the order is completed.",
    "bulk_picking_incomplete_title": "Incomplete packing",
    "bulk_picking_incomplete_body": "Only {picked} of {total} units are registered. If you complete now, the order is fulfilled partially — the remaining units stay unfulfilled and can be picked later.",
    "bulk_picking_back_to_packing": "Back to packing",
    "bulk_picking_complete_as_partial": "Complete as partial",
    "bulk_picking_picklist_title": "Picklist — all orders combined",
    "bulk_picking_picklist_hint": "Collect the items from the shelves (sorted by location) and register quantities.",
    "bulk_picking_print_picklist": "Print picklist",
    "bulk_picking_no_location_group": "No location — manual retrieval",
    "bulk_picking_no_location": "no location",
    "bulk_picking_picklist_sort_hint": "Sorted naturally by location (A-2 before A-10); items without a location are shown last. Quantities are the sum across all orders in the batch.",
    "bulk_picking_to_packing": "To packing",
    "bulk_picking_picking": "picking",
    "bulk_picking_scan_start": "Start scanning",
    "bulk_picking_scan_pre_prompt": "Turn on the camera to scan barcodes. Manual entry still works.",
    "bulk_picking_scan_starting": "Starting camera …",
    "bulk_picking_scan_denied": "Couldn't access the camera — use manual entry.",
    "bulk_picking_scan_now": "Scan now",
    "bulk_picking_scan_not_on_order": "This product isn't part of this order.",
    "bulk_picking_scan_already_done": "All {total} of {product} are already packed.",
    "bulk_picking_scan_unknown": "This product isn't part of this batch.",
    "bulk_picking_scan_missing_codes": "{count} items have no barcode and must be registered manually.",
    "bulk_picking_scan_qty_title": "Correct item ✓",
    "bulk_picking_scan_all_n": "All {count}",
    "bulk_picking_scan_qty_hint": "How many did you pick?",
    "bulk_picking_scan_qty_hint_pack": "How many did you put in the box?",
    "bulk_picking_no_barcode": "no barcode",
    "bulk_picking_remaining": "remaining",
    "bulk_picking_pick_complete_title": "All picked",
    "bulk_picking_pick_complete_hint": "Bring the items to the packing table.",
    "bulk_picking_review_list": "See the picklist",
    "bulk_picking_pack_complete_title": "All packed",
    "bulk_picking_pack_complete_hint": "Order #{order} is ready to ship.",
    "bulk_picking_edit_details": "Edit details",
    "bulk_picking_initiated_at": "started {time}",
    "bulk_picking_shipping_unmapped_title": "Shipping method not mapped",
    "bulk_picking_shipping_unmapped_body": "This order has no carrier service mapped to its shipping method. Map it, or complete manually without a label.",
    "bulk_picking_shipping_unmapped_cta": "Map shipping methods",
    "bulk_picking_shipping_unmapped_count": "{count} orders need a shipping mapping",
    "bulk_picking_pickup_missing_title": "No pickup point selected",
    "bulk_picking_pickup_missing_body": "The nearest pickup point is selected automatically when you complete the order. If none is available, handle the order individually.",
    "pickup_point_label": "Pickup point",
    "pickup_point_none_available": "No pickup point found for this address. The order can't be booked with this service.",
    "quick_install": "quick install",
    "quick_install_intro": "Pick a provider and paste your ID, and we will set up tracking, scripts and cookie information for you.",
    "quick_install_pick_provider": "pick provider",
    "quick_install_paste_code": "paste code",
    "quick_install_paste_help": "Paste the tracking code you received or copied from the provider, and we will find the IDs automatically.",
    "quick_install_detect": "detect tracking codes",
    "quick_install_no_matches": "We did not recognize any tracking code. Make sure you pasted the whole script tag.",
    "quick_install_found": "found",
    "quick_install_install_selected": "install selected",
    "quick_install_already_installed": "already installed",
    "quick_install_include_events": "include e-commerce events (purchases, product views)",
    "quick_install_note_label": "note (optional)",
    "quick_install_note_placeholder": "e.g. Agency X's ad account",
    "quick_install_confirm_title": "confirm installation",
    "quick_install_confirm_text": "This will create the tracking partner, scripts and cookie declarations for",
    "quick_install_success": "Tracking was installed.",
    "quick_install_invalid_value": "The value has the wrong format. Double-check that you pasted the correct ID.",
    "quick_install_duplicate_text": "This provider is already installed. Do you want to update it with the new values?",
    "quick_install_update_existing": "update existing",
    "quick_install_ga4_extra_account": "add extra GA4 account",
    "quick_install_ga4_primary_hint": "The store's primary GA4 is set up through the Analytics settings. Here you only add extra accounts.",
    "quick_install_ga4_becomes_primary_hint": "Becomes the store's primary GA4 account. You manage it on the Analytics page afterwards, including sales tracking.",
    "quick_install_ga4_primary_installed": "GA4 was added as the store's primary account. You manage it here from now on, including sales tracking.",
    "quick_install_gtag_targets_title": "Google accounts in the same script",
    "quick_install_gtag_targets_help": "These IDs live in the same Google script. Remove a line to stop tracking to that account.",
    "quick_install_double_tracking_warning": "If GA4 is loaded inside GTM you only need GTM, otherwise you get double tracking.",
    "quick_install_conversion_id_help": "Found in Google Ads under Goals, Conversions, Tag setup.",
    "quick_install_remove_target": "remove",
    "quick_install_install": "install",
    "quick_install_primary_ga4_conflict": "This ID is already the store's primary GA4 and is set up through the Analytics settings.",
    "quick_install_managed_partner_locked": "This partner is managed by quick install. Change it there.",
    "quick_install_conflict_title": "tracking already exists",
    "quick_install_conflict_unmanaged_text": "We found this provider in a partner that was not set up through quick install. Installing anyway leaves the store with two tags counting the same thing.",
    "quick_install_install_anyway": "install anyway",
    "quick_install_detect_failed": "We could not check the code. Please try again.",
    "quick_install_install_failed": "Installation failed",
    "quick_install_managed_badge": "managed by quick install",
    "failed": "Failed",
    "line": "Line",
    "auto_matched": "Auto matched",
    "adjustment": "Adjustment",
    "reference": "Reference",
    "tripletex_app_name": "Tripletex Accounting",
    "tripletex_app_description": "Send fulfilled orders to Tripletex as invoices and refunds as credit notes.",
    "tripletex_landing_headline": "Tripletex accounting integration",
    "tripletex_landing_description": "Connect your store to Tripletex to send fulfilled orders over as invoices automatically, and keep credit notes in sync when you refund.",
    "tripletex_landing_features_title": "What you get",
    "tripletex_landing_feature_1": "Each fulfillment becomes an unpaid invoice in Tripletex — partial shipments create one invoice per shipment.",
    "tripletex_landing_feature_2": "Refunds are pushed over as credit notes against the original invoice.",
    "tripletex_landing_feature_3": "Transfer automatically when an order is fulfilled, or manually per fulfillment from the order page.",
    "tripletex_landing_how_it_works_title": "How it works",
    "tripletex_landing_how_it_works_description": "Add your Tripletex API tokens under Settings and enable the app. Once enabled, fulfilled orders are transferred as invoices and refunds as credit notes.",
    "tripletex_landing_requirements_title": "Requirements",
    "tripletex_landing_requirements_description": "A Tripletex account with API access (a consumer token and an employee token), and a registered bank account number on the company so invoices can be created.",
    "tripletex_consumer_token": "Consumer token",
    "tripletex_consumer_token_description": "Your Tripletex API consumer token.",
    "tripletex_employee_token": "Employee token",
    "tripletex_employee_token_description": "Your Tripletex API employee token.",
    "tripletex_auto_transfer": "Transfer orders automatically",
    "tripletex_auto_transfer_description": "Create an unpaid invoice in Tripletex automatically when an order is fully fulfilled.",
    "tripletex_send_invoice_to_customer": "Send invoices to customers",
    "tripletex_send_invoice_to_customer_description": "Let Tripletex send the invoice to the customer when it is created. Leave this off if your customers pay by card or through a payment provider at checkout.",
    "tripletex_invoice_date_override": "Invoice date override",
    "tripletex_invoice_date_override_description": "Force this date on all invoices (YYYY-MM-DD). Leave blank to use today.",
    "tripletex_invalid_credentials": "Could not authenticate with Tripletex. Check the tokens.",
    "tripletex_transfer_success": "Fulfillment transferred to Tripletex.",
    "tripletex_transfer_failed": "Could not transfer the fulfillment to Tripletex.",
    "tripletex_transfer_confirm": "Transfer this fulfillment to Tripletex?",
    "tripletex_credit_note_success": "Credit note created in Tripletex.",
    "tripletex_credit_note_failed": "Could not create the credit note in Tripletex.",
    "tripletex_credit_note_confirm": "Create a credit note for this refund in Tripletex?",
    "tripletex_credit_note_reference": "Credit note for invoice :invoice",
    "transfer_to_tripletex": "Transfer to Tripletex",
    "transfer_to_tripletex_description": "Queue the selected orders' invoices and credit notes for transfer to Tripletex.",
    "accounting_transfer_failed_:system": "Transfer to :system failed",
    "tripletex_fulfillment_not_transferred": "The fulfillment's invoice has not been transferred to Tripletex yet — transfer the invoice before the credit note.",
    "tripletex_error_invoice_number_exists": "Invoice number :number is already used in Tripletex — the store's and Tripletex's numbering series overlap.",
    "tripletex_error_due_before_invoice_date": "The due date is before the invoice date.",
    "tripletex_error_company_missing_bank_account": "The Tripletex company has no bank account number — register one in Tripletex before transferring.",
    "tripletex_error_company_missing_org_number": "The Tripletex company has no organization number — register it in Tripletex before transferring.",
    "tripletex_error_consumer_token": "The Tripletex consumer token is invalid or expired — update it in the app settings.",
    "tripletex_error_employee_token": "The Tripletex employee token is invalid or expired — update it in the app settings.",
    "tripletex_error_customer_missing": "The customer does not exist in Tripletex.",
    "tripletex_error_invalid_vat_code": "Tripletex rejected the VAT code on one of the invoice lines.",
    "tripletex_error_invalid_org_number": "Tripletex rejected the customer's organization number (must be 9 digits without separators).",
    "tripletex_error_invalid_email": "Tripletex rejected the customer's email address.",
    "tripletex_error_invalid_invoice_number": "Tripletex rejected the invoice number (must be 0 or higher).",
    "tripletex_error_invalid_date_field": "Tripletex rejected the date in the :field field.",
    "tripletex_error_customer_name_required": "The customer has no name — Tripletex requires a customer name.",
    "tripletex_error_unauthorized": "Tripletex rejected the API credentials — check the tokens in the app settings.",
    "tripletex_error_forbidden": "The Tripletex API user lacks permission for this operation.",
    "tripletex_error_not_found": "The referenced record was not found in Tripletex.",
    "tripletex_error_conflict": "Tripletex reports that the record already exists.",
    "tripletex_error_rate_limited": "Tripletex is rate limiting requests — try again in a few minutes.",
    "tripletex_error_server": "Tripletex had an internal error — try again later.",
    "tripletex_error_no_vat_code_for_rate": "Tripletex has no outgoing VAT code for :rate% — the product's VAT rate is not a valid Norwegian rate.",
    "tripletex_error_connection": "Could not reach Tripletex — check the connection and try again.",
    "tripletex_error_session": "Could not sign in to Tripletex with the stored API keys.",
    "tripletex_error_unmapped": "Tripletex reported: :message",
    "tripletex_error_generic": "The transfer was rejected by Tripletex without a specific reason.",
    "tripletex_bulk_transfer_queued": "Tripletex transfer queued for :count orders.",
    "transferred_to_tripletex": "Transferred to Tripletex",
    "create_tripletex_credit_note": "Create credit note in Tripletex",
    "tripletex_credit_note_created": "Credit note in Tripletex",
    "trial_tour_step_counter": "Step {current}/{total}",
    "trial_tour_checkout_title": "This is a test order",
    "trial_tour_checkout_body": "We have filled in your name, email and address. Add your phone number yourself, then continue through shipping and payment.",
    "trial_tour_checkout_switched": "We set your checkout to Spennd for this test order.",
    "trial_tour_checkout_no_payment": "No payment will be processed – this is only a test.",
    "document_logo": "Document logo",
    "document_logo_dimensions_invalid": "The logo must be between 100×30 and 4000×4000 pixels, and no more than 8 times as wide as it is tall (or 2 times as tall as it is wide).",
    "upload_a_document_logo_for_your_store": "Upload a dedicated logo for emails and documents (invoices, packing slips, etc.). The logo must be in PNG or JPG format, at most 2 MB, between 100×30 and 4000×4000 pixels, and have a regular logo shape — no more than 8 times as wide as it is tall. PNG with a transparent background is recommended. If no document logo is uploaded, the store name is used instead.",
    "document_logo_updated": "Document logo updated",
    "document_logo_deleted": "Document logo deleted",
    "crop_source_image_too_small": "The image is too small to crop — it must be at least {width}×{height} pixels. Upload a larger image instead.",
    "pickup_point_loading": "Fetching pickup points…",
    "Logistra": "Logistra",
    "aktiver": "activate",
    "logistra_sender_id": "Sender ID",
    "logistra_sender_id_description": "Your sender ID retrieved from cargonizer.no. Normally consists of 4-5 digits.",
    "logistra_api_key": "API key",
    "logistra_api_key_description": "Your API key retrieved from cargonizer.no.",
    "logistra_auto_transfer_to_transporter": "Automatically transfer EDI to carrier",
    "logistra_auto_transfer_to_transporter_description": "Select \"Transfer to Cargonizer and then to carrier\" if you want your shipment information to be automatically forwarded to the carrier. If you choose to forward to the carrier, you do not need to log in to Cargonizer to manually transfer the shipments.",
    "logistra_auto_print": "Use autoprint with Logistra",
    "logistra_auto_print_description": "Prints the shipping label only, on a printer registered in your Cargonizer account. Order confirmations, cancellation forms and delivery confirmations are printed by SmartPrint, and only for 24Shipping shipments — they are not printed for shipments booked through Logistra.",
    "logistra_automatically_choose_sole_printer": "Automatically select printer if only one is available",
    "logistra_automatically_choose_sole_printer_description": "Occurs during bulk and single order processing",
    "logistra_selected_printer": "Available printers",
    "logistra_selected_printer_description": "Printers come from your Cargonizer account and are refreshed automatically. These are separate from the printers set up under SmartPrint.",
    "transfer_to_cargonizer": "Transfer only to Cargonizer",
    "transfer_to_cargonizer_and_transporter": "Transfer to Cargonizer and then to carrier",
    "logistra_wrong_api_key": "API-key is incorrect. Please check your API-key and try again.",
    "logistra_unknown_error": "An unknown error occurred. Please try again later or contact customer support.",
    "logistra_service_attributes_unsupported": "This carrier service has extra options that cannot be sent to Logistra yet. Remove the option values, or book the shipment in Cargonizer.",
    "logistra_service_identifier_invalid": "A selected carrier service was not recognised. Reload the page and select the service again.",
    "logistra_transport_agreement_missing": "No Logistra transport agreement was found for the selected shipping product. Check that the product is still available on your Cargonizer account.",
    "carrier_label_unavailable": "The shipping label could not be fetched from the carrier. Please try again shortly.",
    "carrier_label_url_rejected": "This shipping label link was refused for security reasons. Contact support if the label is missing.",
    "logistra_no_printers_found": "No printers found. Check your API key and save again.",
    "logistra_api_key_rejected": "Logistra rejected the API key. Check the key in your Cargonizer account and try again.",
    "logistra_printer_service_unreachable": "Could not reach Logistra to verify the API key. Try again shortly.",
    "logistra_autoprint_label": "Print the label automatically",
    "logistra_autoprint_no_printer": "Print the label automatically (no printer configured)",
    "fulfillment_autoprint_must_be_boolean": "Autoprint must be true or false",
    "fulfillment_dimensions_length_min_zero": "Length cannot be negative",
    "fulfillment_dimensions_width_min_zero": "Width cannot be negative",
    "fulfillment_dimensions_height_min_zero": "Height cannot be negative",
    "fulfillment_dimensions_weight_min_zero": "Weight cannot be negative",
    "fulfillment_services_must_be_array": "Services must be a list",
    "fulfillment_services_not_supported_for_provider": "Services cannot be used with a manual fulfillment",
    "fulfillment_service_must_be_array": "Each service must be an object",
    "fulfillment_service_identifier_required": "Service identifier is required",
    "fulfillment_service_identifier_must_be_string": "Service identifier must be text",
    "fulfillment_service_identifier_duplicate": "The same service was submitted more than once",
    "fulfillment_service_attributes_must_be_array": "Service attributes must be a list",
    "fulfillment_service_attribute_must_be_array": "Each service attribute must be an object",
    "fulfillment_service_attribute_identifier_required": "Service attribute identifier is required",
    "fulfillment_service_attribute_identifier_must_be_string": "Service attribute identifier must be text",
    "fulfillment_service_attribute_value_missing": "Service attribute value is missing",
    "fulfillment_service_attribute_value_must_be_string": "Service attribute value must be text",
    "mapped_shipping_methods": "Map shipping methods to {name}",
    "mapped_shipping_methods_description": "Select which shipping methods in {name} should be used for each of the store's shipping methods when processing orders.",
    "logistra_description_label": "Logistra settings",
    "logistra_description_text": "Fill in sender ID and API key to activate Logistra in your webshop. You can find the information in your Cargonizer account.",
    "logistra_link_label": "Mapping",
    "logistra_link_text": "After configuring Logistra on here, go to this page to map the stores's shipping methods to Logistra's shipping methods.",
    "logistra_description": "Book shipping labels through Logistra Cargonizer with your own carrier agreements.",
    "logistra_app_headline": "Ship with your own carrier agreements through Logistra",
    "logistra_app_sub_heading": "Logistra Cargonizer connects your store to the carriers you already have agreements with, so you can book shipments and print labels directly from order processing.",
    "logistra_app_advantages": "Advantages of Logistra:",
    "logistra_app_advantage_1": "Use <strong>your own carrier agreements</strong> — Bring, PostNord, DHL Express, helthjem and more.",
    "logistra_app_advantage_2": "Book shipments and print labels <strong>directly from order processing</strong>, one order at a time or in bulk.",
    "logistra_app_advantage_3": "Add carrier services such as <strong>insurance, notifications and cash on delivery</strong> per shipment.",
    "logistra_app_closer": "Enter your sender ID and API key from Cargonizer to get started.",
    "logistra_unknown_return_product": "The chosen return product is not in your Cargonizer agreements.",
    "logistics_sandbox_mode_active": "Sandbox mode — shipments are not real",
    "services": "Services",
    "handover_schedule": "Handover schedule",
    "handover_schedule_updated": "Handover schedule updated",
    "handover_schedule_help": "Choose which days and what time you hand parcels to the carrier. This adjusts the expected delivery date shown at checkout.",
    "handover_closed_dates": "Closed days",
    "handover_prep_days": "Preparation time (days)",
    "handover_own_schedule": "Own handover schedule",
    "handover_no_handover": "No handover",
    "handover_add_closed_date": "Add date",
    "handover_add_closed_range": "Add period",
    "handover_closed_range_to": "to",
    "handover_closed_range_end_before_start": "The end date must be the same day as or after the start date.",
    "handover_note_placeholder": "Note",
    "handover_nothing_selected": "No days selected – the expected delivery date is calculated as before.",
    "invalid_handover_weekday": "Invalid weekday in the handover schedule",
    "monday": "monday",
    "tuesday": "tuesday",
    "wednesday": "wednesday",
    "thursday": "thursday",
    "friday": "friday",
    "saturday": "saturday",
    "sunday": "sunday",
    "free_shipping_over_amount": "Free shipping over {amount}",
    "shipping_price_over_amount": "{price} over {amount}",
    "discard_changes_question": "Discard changes?",
    "discard_changes_description": "You have unsaved changes. Closing now will lose them.",
    "keep_editing": "Keep editing",
    "reorder_shipping_method": "Reorder {name}. Use arrow up and arrow down.",
    "edit_shipping_method": "Edit {name}",
    "toggle_shipping_method": "Enable {name}",
    "pricing_discount_from_list_price": "Prices (discount from list price)",
    "high_volume_contact_us": "High volume? Contact us for custom pricing.",
    "see_full_price_matrix": "See the full price matrix",
    "handover_closed_date_expired": "Expired – the date has passed",
    "weekday_short_1": "Mon",
    "weekday_short_2": "Tue",
    "weekday_short_3": "Wed",
    "weekday_short_4": "Thu",
    "weekday_short_5": "Fri",
    "weekday_short_6": "Sat",
    "weekday_short_7": "Sun",
    "handover_cutoff": "cutoff",
    "handover_summary_days": "No days | {n} day | {n} days",
    "handover_summary_at": "at {time}",
    "handover_not_configured": "Not set up",
    "handover_no_closed_dates": "No closed days added.",
    "shipping_vat_state_on": "VAT is charged on shipping",
    "shipping_vat_state_off": "Shipping without VAT",
    "mailchimp_app_name": "Mailchimp",
    "mailchimp_app_description": "Sync newsletter subscribers to Mailchimp in real time.",
    "mailchimp_description_label": "How to connect",
    "mailchimp_description_text": "Create an API key in Mailchimp under Account & billing → Extras → API keys, paste it here and pick the audience subscribers should be added to.",
    "mailchimp_api_key": "API key",
    "mailchimp_api_key_description": "The key ends with your data center, for example -us21. Use Test connection to check the key and load your audiences.",
    "mailchimp_audience_id": "Audience",
    "mailchimp_audience_id_description": "The Mailchimp audience new subscribers are added to. Test the connection to load the list from your account.",
    "mailchimp_api_key_invalid": "Mailchimp did not accept the API key. Check that it was copied correctly and has not been deleted.",
    "mailchimp_api_key_unreachable": "Could not reach Mailchimp. Please try again shortly.",
    "mailchimp_api_key_missing": "Enter an API key first.",
    "mailchimp_api_key_verified": "Connected to Mailchimp. Audiences found: {count}.",
    "mailchimp_verify_key_button": "Test connection",
    "mailchimp_audience_not_found": "That audience does not exist in the Mailchimp account. Test the connection to refresh the list.",
    "mailchimp_landing_headline": "Mailchimp integration for your store",
    "mailchimp_landing_description": "Connect your store to a Mailchimp audience. New newsletter subscribers appear in Mailchimp within seconds, unsubscribes are mirrored, and you can push your existing subscribers with one click.",
    "mailchimp_landing_features_title": "What you get",
    "mailchimp_landing_feature_1": "Real-time sync of signups from forms and checkout.",
    "mailchimp_landing_feature_2": "Unsubscribes in the store are mirrored to Mailchimp.",
    "mailchimp_landing_feature_3": "Push your existing subscribers with one click.",
    "mailchimp_landing_feature_4": "Subscribers are tagged by source so you can segment in Mailchimp.",
    "mailchimp_landing_how_it_works_title": "How it works",
    "mailchimp_landing_how_it_works_description": "Create an API key in Mailchimp, paste it into the settings, pick an audience and switch the app on. Every new subscriber is then synced automatically.",
    "mailchimp_landing_requirements_title": "Requirements",
    "mailchimp_landing_requirements_description": "You need a Mailchimp account. Mailchimp is priced by contact count, and the free plan covers up to 250 contacts. No contacts are sent to Mailchimp until the app is switched on.",
    "mailchimp_sync_title": "Sync",
    "mailchimp_sync_synced": "Synced",
    "mailchimp_sync_pending": "Queued",
    "mailchimp_sync_failed": "Failed",
    "mailchimp_sync_skipped": "Refused by Mailchimp",
    "mailchimp_sync_not_synced": "Not synced",
    "mailchimp_backfill_button": "Sync existing subscribers",
    "mailchimp_backfill_helper": "{count} subscribers will be queued.",
    "mailchimp_backfill_started": "Sync started. The status updates as subscribers are sent over.",
    "mailchimp_backfill_not_enabled": "The app must be configured and switched on before you can sync.",
    "mailchimp_backfill_already_running": "A sync is already running. Wait for it to finish.",
    "mailchimp_skipped_explanation": "Addresses Mailchimp refuses have unsubscribed or been deleted in Mailchimp. They must re-subscribe through a Mailchimp form.",
    "mailchimp_sync_column_email": "Email",
    "mailchimp_sync_column_status": "Status",
    "mailchimp_sync_column_reason": "Reason",
    "mailchimp_sync_column_time": "Time",
    "ai_wallet": "AI wallet",
    "ai_wallet_balance": "Balance",
    "ai_wallet_balance_hint": "Pays for AI-powered HS code suggestions. You only pay for what you use.",
    "ai_wallet_topup_title": "Top up",
    "ai_wallet_topup_hint": "The minimum top-up is {min}.",
    "ai_wallet_custom_amount": "Other amount",
    "ai_wallet_topup_button": "Top up {amount}",
    "ai_wallet_charged_card": "Charged to {card} immediately.",
    "ai_wallet_change_card": "Change card",
    "ai_wallet_confirm_title": "Top up {amount}?",
    "ai_wallet_confirm_body": "The amount is added to your AI wallet immediately and cannot be refunded to the card.",
    "ai_wallet_confirm_button": "Confirm and pay",
    "ai_wallet_topup_success": "{amount} has been added. New balance: {balance}.",
    "ai_wallet_auto_title": "Auto-recharge",
    "ai_wallet_auto_hint": "When the balance drops below the threshold we top it up automatically so AI features never stop mid-task.",
    "ai_wallet_auto_threshold": "When the balance is below",
    "ai_wallet_auto_amount": "Top up with",
    "ai_wallet_auto_cap": "Monthly cap (optional)",
    "ai_wallet_auto_saved": "Settings saved.",
    "ai_wallet_auto_failed": "Auto-recharge failed {time} ({code}). Save the settings to retry.",
    "ai_wallet_trial_title": "The AI wallet requires a paid subscription",
    "ai_wallet_trial_body": "You cannot top up during the trial. Upgrade your subscription to start using AI features.",
    "ai_wallet_trial_button": "See subscriptions",
    "ai_wallet_no_card_body": "Top-ups are charged to the card registered on the store. No card is registered yet.",
    "ai_wallet_unavailable": "Your balance is safe. Try again shortly, or contact support if the problem persists.",
    "ai_wallet_conflict": "The store is already registered with the AI service, but the key is missing here. Contact support.",
    "ai_wallet_error_code": "Error code: {code}",
    "ai_wallet_error_payment_failed": "The payment was declined ({code}). Check the card under Cards.",
    "ai_wallet_error_validation": "The AI service rejected the values. Check the amounts and try again.",
    "ai_wallet_error_generic": "This could not be completed right now. Try again shortly.",
    "ai_wallet_attr_amount": "the amount",
    "ai_wallet_attr_threshold": "the threshold",
    "ai_wallet_attr_recharge_amount": "the recharge amount",
    "ai_wallet_attr_monthly_cap": "the monthly cap",
    "ai_wallet_validation_min": "The minimum amount is :min.",
    "ai_wallet_validation_max": "The maximum amount is :max.",
    "ai_wallet_validation_recharge_gte_threshold": "The recharge amount must be at least the threshold.",
    "ai_wallet_validation_cap_gte_recharge": "The monthly cap must be at least the recharge amount.",
    "ai_wallet_unavailable_title": "The AI service is not responding",
    "ai_wallet_conflict_title": "The balance cannot be loaded",
    "ai_wallet_custom_range": "Choose an amount between {min} and {max}.",
    "ai_wallet_check_card": "Check the card",
    "ai_wallet_auto_off_hint": "Off. When the balance runs out, AI features stop until you top up manually.",
    "ai_wallet_auto_summary": "Tops up {amount} whenever the balance is below {threshold}.",
    "ai_wallet_auto_summary_cap": "At most {cap} per month.",
    "ai_wallet_ledger_title": "Transactions",
    "ai_wallet_ledger_more": "Show more",
    "ai_wallet_ledger_empty": "No transactions yet. Your first top-up will show up here.",
    "ai_wallet_ledger_unavailable": "Could not load transactions.",
    "ai_wallet_ledger_topup": "Top-up",
    "ai_wallet_ledger_auto_recharge": "Automatic top-up",
    "ai_wallet_ledger_hold": "Reserved: {task}",
    "ai_wallet_ledger_hold_items": "Reserved: {task}, {items} products",
    "ai_wallet_ledger_settlement": "Settlement: {task}",
    "ai_task_hs_code_suggestion": "HS code suggestion",
    "ai_task_product_optimization": "Product text",
    "ai_task_store_profile": "Store profile",
    "ai_task_product_review": "Product review",
    "ai_task_product_image": "Product image",
    "ai_wallet_inline_intro": "AI features are paid from the store's AI balance. Get started in two steps:",
    "ai_wallet_inline_step_card": "Add a payment card",
    "ai_wallet_inline_card_added": "Card added",
    "ai_wallet_inline_step_topup": "Top up the AI balance",
    "ai_wallet_inline_topped_up": "Balance topped up: {amount}",
    "ai_wallet_inline_auto_hint": "Want to skip this next time?",
    "ai_wallet_inline_auto_link": "Turn on automatic top-up",
    "ai_wallet_inline_ask_admin": "Ask an administrator to top up the AI balance.",
    "ai_wallet_more_options": "More options",
    "add_card_error_generic": "The card could not be added right now. Try again shortly.",
    "please_provide_a_valid_email": "The store has no contact email address. Add one under Company details before adding a card.",
    "add_card_gate_title": "Add a payment card",
    "add_card_button": "Add payment card",
    "add_card_description": "Add a card for your store’s payments.",
    "add_card_stripe_notice": "Card details are handled by Stripe.",
    "add_card_cardholder": "Name on card",
    "add_card_submit": "Add card",
    "app_store_requires_payment_card": "Payment card required",
    "bulk_picking_booked_not_captured": "Payment failed: :cause The shipment is booked with tracking number :tracking_number, and its label may have printed. The order is not sent.",
    "bulk_picking_too_many_orders": "Select at most {max} orders for one picking batch. Narrow the filter and try again.",
    "datatable_filter_mode_include": "Contains",
    "datatable_filter_mode_exclude": "Does not contain",
    "datatable_filter_without": "without",
    "datatable_filter_no_products_chosen": "No products chosen yet",
    "datatable_sort": "Sorting",
    "datatable_sort_help": "Sort by several columns in priority order. Clicking a column header replaces this with that column alone.",
    "datatable_sort_column": "Column",
    "datatable_sort_add_level": "Add level",
    "datatable_sort_apply": "Apply",
    "datatable_sort_reset": "Reset",
    "datatable_sort_ascending": "Ascending",
    "datatable_sort_descending": "Descending",
    "datatable_sort_move_up": "Move up",
    "datatable_sort_move_down": "Move down",
    "datatable_sort_remove_level": "Remove level",
    "datatable_all_items_selected": "All {count} selected",
    "select_x_items_across_all_pages": "Select all {count} across all pages",
    "order_index_partially_fulfilled": "Partially fulfilled",
    "order_filter_product_search": "Product",
    "order_filter_product_search_placeholder": "Name, SKU or GTIN",
    "order_filter_products": "Products",
    "order_filter_line_count": "Order lines",
    "order_filter_item_quantity": "Items",
    "order_sort_product_name": "Product name",
    "order_sort_product_location": "Product location",
    "order_filter_stock_location": "Stock location",
    "order_filter_without_stock_location": "Without a stock location",
    "order_filter_help_stock_location": "Orders holding goods on the chosen shelf or in the chosen bin.",
    "order_filter_warehouse": "Warehouse",
    "order_filter_help_warehouse": "Orders holding goods in the chosen warehouse.",
    "order_filter_max_line_quantity": "Largest line quantity",
    "order_filter_total": "Order total",
    "order_filter_without_shipping_method": "Without shipping method",
    "order_filter_gift_certificate": "Gift certificate (partly or fully)",
    "order_filter_customer_type": "Customer type",
    "order_filter_without_customer_group": "Without customer group",
    "order_filter_cancellation": "Cancellation and refund",
    "order_filter_cancellation_requested": "Cancellation request from customer",
    "order_filter_has_cancellations": "Has cancellations",
    "order_filter_has_refunds": "Has refunds",
    "order_filter_accounting_status": "Accounting status",
    "order_filter_accounting_transferred": "Transferred",
    "order_filter_accounting_failed": "Failed",
    "order_filter_accounting_none": "Not transferred",
    "list_customise_title": "Customise",
    "list_customise_intro": "Choose which filters and columns you want to see, and drag them into the order that suits you.",
    "list_customise_filters": "Filters",
    "list_customise_preview": "How it will look",
    "list_customise_preview_empty": "No filters chosen",
    "list_customise_add_filter": "Add filter",
    "list_customise_no_filters_found": "No filter matches the search",
    "list_favourite_menu": "Favourites",
    "list_favourite_empty": "No saved views yet",
    "list_favourite_save_current": "Save this view",
    "list_favourite_name_placeholder": "Give the view a name",
    "list_favourite_applied_partially": "The view was applied, but {count} of its filters no longer exist",
    "datatable_selection_across_pages": "{count} selected, {onPage} on this page",
    "order_filter_group_content": "Items and content",
    "order_filter_group_customer": "Customer",
    "order_filter_group_commerce": "Payment and shipping",
    "order_filter_group_status": "Status and date",
    "order_filter_help_date_range": "Orders placed within a period",
    "order_filter_help_product_search": "Orders with a line matching a name, SKU or GTIN",
    "order_filter_help_products": "Orders containing products you pick",
    "order_filter_help_line_count": "How many order lines the order has",
    "order_filter_help_item_quantity": "How many items in total the order holds",
    "order_filter_help_max_line_quantity": "The largest quantity on a single line",
    "order_filter_help_shipping_method": "The shipping method the order was placed with",
    "order_filter_help_payment_method": "The payment method, including gift certificates",
    "order_filter_help_total": "The order total including VAT",
    "order_filter_help_customer_type": "Private customers or companies",
    "order_filter_help_customer_group": "The customer group the order belongs to",
    "order_filter_help_cancellation": "Cancellation requests, cancellations and refunds",
    "order_filter_help_accounting_status": "Whether the order reached the accounting system",
    "order_filter_help_lock_status": "Orders locked for picking",
    "list_rule_menu": "Rules",
    "list_rule_empty": "No saved rules yet",
    "list_rule_save": "Save as rule",
    "list_rule_name_placeholder": "Give the rule a name",
    "list_customise_no_filters_chosen": "No filters in this rule yet",
    "list_customise_n_chosen": "{count} chosen",
    "order_filter_products_excluded": "Without products",
    "order_filter_help_products_excluded": "Orders that do not contain the products you pick",
    "list_rule_group_store": "The store's rules",
    "list_rule_group_mine": "My rules",
    "list_rule_share_with_store": "Share with the store",
    "list_rule_saved_in_customise": "Rules are saved from Customise",
    "list_rule_limit_reached": "You can keep at most {max} rules here. Delete one first.",
    "add_tag_criterion": "Add tag criterion",
    "add_tag_criterion_action_description": "Add a tag criterion to the selected smart categories",
    "remove_tag_criterion": "Remove tag criterion",
    "remove_tag_criterion_action_description": "Remove a tag criterion from the selected smart categories",
    "add_tag_criterion_to_x_amount_of_categories": "Add tag criterion to {count} smart category | Add tag criterion to {count} smart categories",
    "remove_tag_criterion_from_x_amount_of_categories": "Remove tag criterion from {count} smart category | Remove tag criterion from {count} smart categories",
    "add_x_tag_criteria": "Add {count} criterion | Add {count} criteria",
    "remove_x_tag_criteria": "Remove {count} criterion | Remove {count} criteria",
    "add_tag_criterion_modal_description": "A smart category pulls in its products automatically from the criteria it has. This adds one criterion: the product must carry the tag you pick.",
    "remove_tag_criterion_modal_description": "This deletes the criterion that looks for the tag you pick. A smart category left with no criteria at all shows no products.",
    "x_categories_updated": ":count smart category updated|:count smart categories updated",
    "x_categories_skipped_not_smart": ":count selected category was skipped, it is not a smart category.|:count selected categories were skipped, they are not smart categories.",
    "which_tag_should_the_criterion_look_for": "Which tag should the criterion look for?",
    "no_tags_found": "No tags found",
    "how_should_the_criteria_be_combined": "How should the criteria be combined?",
    "category_match_keep": "Leave this as it is",
    "category_match_keep_hint": "Every category keeps the setting it has today.",
    "category_match_all": "All criteria must be met",
    "category_match_all_hint": "This narrows the category. Products in it now drop out unless they also carry the tag you pick.",
    "category_match_any": "One of the criteria must be met",
    "category_match_any_hint": "This widens the category. Products in it now stay, and everything carrying the tag you pick is added.",
    "x_products_with_this_tag": "{count} product | {count} products",
    "x_categories_selected": "{count} smart category selected | {count} smart categories selected",
    "no_categories_needed_changing": "No smart categories needed changing, they already matched what you picked.",
    "experiments": "A/B testing",
    "experiments_new": "New test",
    "experiments_empty": "You have no A/B tests yet. Create a test to compare two templates against each other.",
    "experiments_index_description": "Compare two templates of the home page or the product pages, and see which sells best.",
    "experiments_needs_two_templates_heading": "You need one more template",
    "experiments_template_guide_label": "How to make a new template",
    "experiments_open_design_editor": "Open the design builder",
    "experiments_template_step_open": "Open the design builder and pick the page type you want to test.",
    "experiments_template_step_duplicate": "Open the \"Page and template\" picker at the top, hover the template and choose \"Duplicate template\".",
    "experiments_template_step_edit": "Name the copy, and change the design the way you want to test it.",
    "experiments_template_step_save": "Save. The copy is not shown in the shop until you start a test with it, or use it yourself.",
    "experiments_template_step_return": "Come back here — the new template can now be chosen as the challenger.",
    "experiments_needs_two_templates": "You need one more template to run a test. Make a copy of today's template in the design builder first.",
    "experiments_manage_from_list": "Your tests are managed from the A/B testing overview.",
    "experiments_settings_description": "Turn A/B testing on or off for the shop.",
    "experiments_enabled_description": "When this is off, no visitor is assigned to a variant and nothing is measured.",
    "experiments_status_on_title": "A/B testing is on",
    "experiments_status_on_body": "Visitors are split between the templates in running tests, and sales are measured.",
    "experiments_status_off_title": "A/B testing is off",
    "experiments_status_off_body": "No visitors are split between the templates and nothing is measured. A test marked as running collects no numbers until you turn A/B testing back on.",
    "experiments_turn_on": "Turn on",
    "experiments_turn_off": "Turn off",
    "experiments_turn_off_confirm_title": "Turn off A/B testing?",
    "experiments_when_on_heading": "When A/B testing is on",
    "experiments_cookie_title": "One necessary cookie",
    "experiments_cookie_body": "It remembers which template the visitor was given. It is added to the cookie overview automatically, and removed again when you turn A/B testing off.",
    "experiments_cookie_link": "See Conversion tracking",
    "experiments_disabled_title": "A/B testing is turned off",
    "experiments_disabled_body": "No visitors are split between the templates and nothing is measured, even if a test is marked as running.",
    "experiments_disabled_link": "Go to settings",
    "experiment_control": "Control",
    "experiment_challenger": "Challenger",
    "experiment_primary_metric": "Primary goal",
    "experiment_primary_metric_help": "Only the primary goal can name a winner. The other numbers are shown as supporting information.",
    "conversion_rate": "Conversion rate",
    "revenue_per_visitor": "Revenue per visitor",
    "experiment_status_draft": "draft",
    "experiment_status_running": "running",
    "experiment_status_stopped": "finished",
    "experiment_start": "Start test",
    "experiment_stop": "End test",
    "experiment_started": "Test started",
    "experiment_stopped": "Test ended",
    "experiment_created": "Test created",
    "experiment_promoted": "Template set as default",
    "experiment_decision_margin": "{winner} against {loser}",
    "experiment_decision_lift": "— {lift} better",
    "experiment_choose_heading": "Choose the template to keep",
    "experiment_choice_recommended": "Recommended",
    "experiment_choice_in_use": "In use now",
    "experiment_choice_keep": "keep as today",
    "experiment_choice_apply": "Use the selected template",
    "experiment_choice_no_recommendation": "The numbers do not point clearly to either one. Choose neither and the shop carries on as before.",
    "experiment_choice_confirm_title": "Use this template?",
    "experiment_choice_confirm_product": "Every product without its own template gets “{template}”. This takes effect straight away.",
    "experiment_choice_confirm_category": "Every category without its own template gets “{template}”. This takes effect straight away.",
    "experiment_choice_confirm_home": "“{template}” becomes the front page visitors see. This takes effect straight away.",
    "experiment_verdict": "Result",
    "experiment_verdict_not_enough_data": "Not enough data yet",
    "experiment_verdict_sample_ratio_mismatch": "Uneven visitor split",
    "experiment_verdict_sample_ratio_mismatch_help": "The templates received noticeably different numbers of visitors compared with the split you chose. The numbers cannot be compared then — the visitors missing are not a random selection. Open the template in the shop and check that it works. If it all looks right it may have been a coincidence; start the test over.",
    "experiment_verdict_challenger_harming": "Challenger B is selling worse",
    "experiment_verdict_challenger_harming_help": "The challenger has sold clearly worse than the control so far. The test is not finished, so this is not a final result — but the gap is large enough that something may be wrong with the template. Check it in the shop, on mobile in particular. Letting the test run on costs sales; ending it leaves you with the template you already had.",
    "experiment_verdict_not_started": "Not started",
    "experiment_verdict_not_started_help": "Start the test to begin gathering numbers.",
    "experiment_verdict_ended_without_enough_data": "Ended without enough data",
    "experiment_verdict_ended_short_help": "The test ended before enough visitors had seen both templates, so it cannot name a winner.",
    "experiment_requirements_heading": "The test cannot pick a winner until the requirements below are met.",
    "experiment_requirement_days": "{have} of {need} days",
    "experiment_requirement_visitors": "{have} of {need} visitors in the smaller variant",
    "experiment_requirement_orders": "{have} of {need} orders in the smaller variant",
    "experiment_requirement_carts": "{have} of {need} added to cart in the smaller variant",
    "experiment_verdict_no_clear_winner": "No clear winner",
    "experiment_verdict_control_wins": "Control A wins",
    "experiment_verdict_challenger_wins": "Challenger B wins",
    "experiment_judged_on_conversion_rate": "Judged on conversion rate.",
    "experiment_judged_on_revenue_per_visitor": "Judged on revenue per visitor.",
    "experiment_exposures": "Visitors",
    "experiment_orders": "Orders",
    "experiment_winner": "Winner",
    "experiment_device_breakdown": "By device",
    "experiment_device": "Device",
    "experiment_device_help": "No winner is named per device. These numbers are here to expose faults: if one template does much worse on one kind of screen, it usually does not look right there. Open the page on that device and check.",
    "experiment_device_mobile": "Mobile",
    "experiment_device_tablet": "Tablet",
    "experiment_device_desktop": "Desktop",
    "experiment_device_unknown": "Unknown",
    "experiment_device_too_little": "Too few visitors on {devices} for the numbers to be usable.",
    "experiment_mde": "Smallest improvement the test should be able to detect",
    "experiment_mde_help": "This is not how much you think the template improves things — it is the smallest improvement the test has enough traffic to see. If the real difference is smaller, the test ends with “no clear winner”, and that is an honest answer. Halving this number quadruples how long the test must run.",
    "experiment_mde_10": "10% — catches smaller improvements, but needs four times the traffic",
    "experiment_mde_20": "20% — the smallest that is practical for most shops",
    "experiment_mde_30": "30% — faster answers, catches only clear improvements",
    "experiment_mde_50": "50% — only major redesigns, such as an entirely new page",
    "experiment_verdict_days_remaining": "About {count} days left at current traffic, assuming everything else is in place.",
    "theme_published_experiment_stopped": "The theme is published. The A/B test “:experiment” was ended, because the templates it was testing belong to a different theme.",
    "theme_editor_publish_stops_experiment": "Publishing this theme ends the A/B test “{experiment}”. The templates it is testing belong to the theme that is active now, so the test cannot continue.",
    "theme_editor_experiment_running": "This template is part of the A/B test “{experiment}”.",
    "theme_editor_experiment_control": "It is shown to {percent}% of visitors — the rest see the challenger template.",
    "theme_editor_experiment_challenger": "It is shown to {percent}% of visitors — the rest see the template the shop used before the test.",
    "theme_editor_experiment_warning": "If you change the template now, you change what the test is measuring while it measures it, and the result becomes unusable.",
    "experiment_progress_column": "Progress",
    "experiment_progress": "{percent}% of the data the test needs",
    "experiment_guardrail_conflict": "The winning template got more people to add to the cart but sold less than the other. Check the order numbers below before choosing.",
    "experiment_numbers_provisional": "Provisional numbers. The test is not finished, and the difference you see now can still turn around. If you end the test because one template looks like winning, you will be wrong roughly one time in four — which is why no winner is named before the test has enough data.",
    "experiment_stop_early_title": "End the test before it is finished?",
    "experiment_stop_early_warning": "The test does not have enough data yet. If you end it now you get no winner, and the numbers below cannot be used to choose a template. The test will be marked as ended early.",
    "experiment_stop_early_confirm": "End anyway",
    "experiment_stopped_before_horizon": "This test was ended before it had enough data. The numbers tell you what happened, but they cannot decide which template is better.",
    "add_to_cart": "La i handlekurv",
    "experiment_judged_on_add_to_cart": "Judged on how many added to the cart.",
    "experiment_results_heading": "The numbers",
    "experiment_diagnostics": "Supporting numbers",
    "experiment_add_to_cart": "Added to cart",
    "experiment_checkout_started": "Started checkout",
    "experiment_revenue_gross": "Revenue (goods, incl. VAT)",
    "experiment_promote_heading": "Choose which template to keep",
    "experiment_promote_recommended": "The numbers point to \u201c{label}\u201d.",
    "experiment_promote_no_recommendation": "The numbers do not point clearly at either template. You can still choose yourself.",
    "experiment_promote_template": "Use “{template}”",
    "experiment_promote_variant": "Use variant {label}",
    "experiment_already_promoted": "A template from this test is already set as the default.",
    "experiment_needs_two_variants": "The test is missing a control and a challenger.",
    "experiment_surface_already_running": "A test is already running on product pages. End it before starting a new one.",
    "experiment_stop_before_promoting": "End the test before choosing a winning template.",
    "experiment_variant_mismatch": "The variant does not belong to this test.",
    "experiments_app_description": "Compare two versions of the home page or the product page, and see which sells best.",
    "experiments_disable_confirm": "This stops all measurement, and every visitor sees the default template again.",
    "experiments_landing_header_text": "Test your shop against itself",
    "experiments_subheading": "Show two different templates to one half of your visitors each, and let the numbers decide which one you keep.",
    "experiments_licence_title": "Included in Premium and Premium Pluss",
    "experiments_licence_body": "A/B testing comes with these licenses at no extra cost. The app cannot be bought separately.",
    "experiments_features_heading": "What you get",
    "experiments_feature_templates_title": "Build the variants in the design builder",
    "experiments_feature_templates_body": "A variant is an ordinary template, so you build and edit it exactly as you always have.",
    "experiments_feature_split_title": "A split that holds",
    "experiments_feature_split_body": "Each visitor lands in the same variant every time, even if they come back later.",
    "experiments_feature_funnel_title": "All the way to the order",
    "experiments_feature_funnel_body": "We follow the visit onward to cart, checkout and completed order.",
    "experiments_feature_honest_title": "Honest numbers",
    "experiments_feature_honest_body": "You get no winner until there is enough data to trust it.",
    "experiments_get_started_heading": "How to get started",
    "experiments_get_started_step_1": "Create a new home page, product page or category page template in the design builder.",
    "experiments_get_started_step_2": "Create a test comparing the new template with the one you use today.",
    "experiments_get_started_step_3": "Start the test and let it run until you have enough visitors.",
    "choose": "Choose",
    "experiment_updated": "Test updated",
    "experiment_deleted": "Test deleted",
    "experiment_archived": "Test archived",
    "experiment_unarchived": "Test restored",
    "experiment_cannot_delete_launched": "“:name” has been running and cannot be deleted. Archive it instead and you keep the numbers.",
    "experiment_cannot_edit_launched": "The test has started and cannot be changed. End it and create a new one if you want to test something else.",
    "experiment_archive_stopped_only": "Only finished tests can be archived. End the test first.",
    "experiment_edit": "Edit test",
    "experiment_delete": "Delete test",
    "experiment_delete_warning": "The draft is deleted for good. No visitor has seen it, so no numbers are lost.",
    "experiment_archive": "Archive",
    "experiment_unarchive": "Restore",
    "experiment_archive_help": "Archived tests are out of the list, but their numbers are kept.",
    "experiments_show_archived": "Show archived ({count})",
    "experiments_show_active": "Back to active tests",
    "experiments_archived_empty": "You have no archived tests.",
    "experiments_index_description_all": "Compare two templates of the home page, product pages or category pages, and see which one sells best.",
    "experiments_running_heading": "Running now",
    "experiments_one_per_surface": "You can have one test running per page type.",
    "experiments_no_test_running": "No test running",
    "experiments_free_surface_help": "Start a test to see which template sells best.",
    "experiments_draft_ready": "Draft ready to start | Drafts ready to start",
    "experiments_draft_ready_help": "Open the draft to review the setup and start the test. | Open a draft to review the setup and start the test.",
    "experiments_open_draft": "Open draft",
    "experiments_drafts_label": "Draft: | Drafts:",
    "experiments_finished_heading": "Finished tests",
    "experiments_all_finished_archived": "All finished tests are archived.",
    "experiment_test": "Test",
    "experiment_period": "Period",
    "experiment_duration_days": "{count} day | {count} days",
    "experiment_running_for": "running for {count} day | running for {count} days",
    "experiment_days_remaining_short": "About {count} day left at current traffic | About {count} days left at current traffic",
    "experiment_verdict_challenger_harming_short": "Check the template in your store, especially on mobile. While the test runs, the wait is costing sales.",
    "experiment_verdict_sample_ratio_mismatch_short": "The templates have received uneven numbers of visitors. Check that the template works in your store.",
    "experiment_traffic_split": "Traffic split",
    "experiment_traffic_split_help": "A 50/50 split gives answers fastest.",
    "experiment_traffic_split_cost": "An uneven split makes the test slower: it needs roughly {percent}% more traffic for the same confidence.",
    "experiment_comparison": "What is being compared",
    "experiment_control_is_live": "Live in the shop now",
    "experiment_help_label": "How the test works",
    "experiment_control_fixed_help": "A test always compares against the template the shop shows today. To start from a different template, make it the default in the design builder first.",
    "experiment_challenger_is_control": "Choose a template other than the one the shop shows today.",
    "experiment_surface_has_no_live_template": "The shop has no default template for this page type yet.",
    "experiment_split_share": "{percent}% of visitors",
    "experiment_traffic_split_locked": "The split locks when the test starts, so no visitor switches template midway.",
    "experiment_progress_of_planned": "of the planned size",
    "experiment_progress_per_arm": "{have} of {need} visitors per template",
    "experiment_requirement_label_days": "Days",
    "experiment_requirement_label_visitors": "Visitors in the smaller template",
    "experiment_requirement_label_orders": "Orders in the smaller template",
    "experiment_requirement_label_carts": "Add to carts in the smaller template",
    "experiment_requirement_value": "{have} of {need}",
    "experiment_scoreboard_running": "Where they stand",
    "experiment_scoreboard_finished": "How it ended",
    "experiment_scoreboard_not_started": "The numbers appear once the test is running.",
    "experiment_provisional": "Provisional",
    "experiment_lift_so_far": "{lift} so far",
    "experiment_all_numbers": "All numbers",
    "experiment_per_visitor": "Per visitor",
    "experiment_choice_adopt": "use it",
    "experiment_diagnostics_help": "Checkout, revenue and devices. They explain the result, but cannot pick a winner.",
    "experiment_create_intro": "Pick a page, and let a new template compete with the one your shop uses today.",
    "experiment_comparison_help": "A is the template your shop shows today. B is a copy you have changed in the design builder.",
    "experiment_versus": "vs",
    "experiment_new_template_link": "Make a new template in the design builder",
    "experiment_surface_reach_single": "Uses the template “{template}”",
    "experiment_surface_reach_product": "{count} product uses “{template}” | {count} products use “{template}”",
    "experiment_surface_reach_category": "{count} category uses “{template}” | {count} categories use “{template}”",
    "experiment_surface_no_template": "No default template yet",
    "experiment_surface_ready": "Ready, {count} challenger | Ready, {count} challengers",
    "experiment_surface_needs_template": "Needs one more template",
    "experiment_split_preset_even": "Fastest answer",
    "experiment_split_preset_cautious": "Fewer see the new template",
    "experiment_split_preset_safest": "Safest, but slowest",
    "experiment_split_custom": "Adjust the split",
    "experiment_option_recommended": "Recommended",
    "experiment_metric_help_conversion_rate": "The share of visitors who place an order. The safest choice for most tests.",
    "experiment_metric_help_revenue_per_visitor": "Also counts how much customers spend. Suits a template meant to grow baskets.",
    "experiment_metric_help_add_to_cart": "Answers sooner, but an add to cart is not a sale.",
    "experiment_name_heading": "Name the test",
    "experiment_name_hint": "Suggested from your choices. You can change it while the test is a draft.",
    "experiment_name_suggestion": "{surface}: {control} vs {challenger}",
    "experiment_summary_heading": "Summary",
    "experiment_summary_surface": "Page",
    "experiment_summary_split": "Split",
    "experiment_summary_mde": "Smallest improvement",
    "experiment_summary_not_chosen": "Not chosen",
    "experiment_create": "Create test",
    "experiment_save_changes": "Save changes",
    "experiment_create_draft_note": "The test is saved as a draft. You start it yourself when you are ready.",
    "experiment_scope_summary": "The test covers {count} product using the template “{template}”. | The test covers {count} products using the template “{template}”.",
    "experiment_scope_help": "Products set up with a different template are untouched — they keep the template you chose for them, and are not counted in the result.",
    "template_is_now_default": "“:template” is now the default",
    "home_template_is_now_live": "“:template” is now your front page",
    "template_default_locked_by_experiment": "You cannot change the default template while the test “:experiment” is running. End the test first.",
    "template_not_the_default": "Not the default template",
    "home_template_not_live": "Not shown in the shop",
    "use_this_template": "Use this template",
    "publish_home_template": "Publish as front page",
    "publish_home_template_title": "Publish this front page?",
    "publish_home_template_warning": "This template becomes the front page visitors see, straight away. The one you use now stays as a draft.",
    "publish_home_template_confirm": "Publish front page",
    "experiment_scope_running": "Covers {count} product. | Covers {count} products.",
    "experiment_started_at": "Started {date}",
    "experiment_stopped_at": "Ended {date}",
    "experiment_ran_for": "ran for {count} day | ran for {count} days",
    "experiment_traffic_share_of": "{percent}% of traffic",
    "experiment_traffic_share_locked": "The split cannot be changed once the test has started. End the test and create a new one if you want a different split.",
    "template_in_use_by_script": "The template is used by the script “:script”. Remove the restriction on the script before deleting the template.",
    "theme_in_use_by_script": "The theme has a template used by the script “:script”. Remove the restriction on the script before deleting the theme.",
    "template_in_use_by_experiment": "The template is used in the A/B test “:experiment”. End or delete the test before deleting the template.",
    "theme_in_use_by_experiment": "The theme has a template used in the A/B test “:experiment”. End or delete the test before deleting the theme.",
    "home_template": "Home template",
    "theme_editor_theme_label": "Theme",
    "theme_editor_themes_heading": "Themes",
    "theme_editor_themes_help": "A theme is the whole look of your shop: colours, fonts, header and footer. One theme is active in the shop at a time.",
    "theme_editor_theme_active": "Active",
    "theme_editor_add_theme": "Add theme",
    "theme_editor_duplicate_theme": "Duplicate theme",
    "theme_editor_delete_theme": "Delete theme",
    "theme_editor_theme_limit_reached": "The limit for number of themes is reached",
    "theme_editor_startup_one_theme": "The Startup plan only allows working with one theme at a time",
    "theme_editor_duplicate_theme_x": "Duplicate the theme {name}",
    "theme_editor_delete_theme_x": "Are you sure you want to delete the theme {name}?",
    "theme_editor_theme_deleted": "The theme is deleted",
    "theme_editor_page_and_template": "Page and template",
    "theme_editor_page_type_heading": "Page type",
    "theme_editor_template_count": "{count} template | {count} templates",
    "theme_editor_page_count": "{count} page | {count} pages",
    "theme_editor_home_templates_in_theme": "Home page templates in the theme {theme}",
    "theme_editor_product_templates_in_theme": "Product page templates in the theme {theme}",
    "theme_editor_category_templates_in_theme": "Category page templates in the theme {theme}",
    "theme_editor_create_home_template": "Create home page template",
    "theme_editor_create_product_template": "Create product page template",
    "theme_editor_create_category_template": "Create category page template",
    "theme_editor_template_is_default": "Used by default",
    "theme_editor_home_template_is_live": "Shown in the shop",
    "theme_editor_confirm_delete_home_template": "Are you sure you want to delete this home page template?",
    "theme_editor_ab_badge": "A/B test",
    "theme_editor_ab_prompt": "Want to know which template sells best?",
    "theme_editor_ab_start": "Start an A/B test",
    "theme_editor_open_ab_testing": "Open A/B testing",
    "theme_editor_preview_with": "Preview with",
    "theme_editor_open_content_pages": "Open content pages",
    "help_product_templates_feature_create_picker": "Create a new template with “Create product page template” in the picker at the top — it starts from the default layout.",
    "help_category_templates_feature_create_picker": "Create a new template with “Create category page template” in the picker at the top – it starts as a copy of what you are editing now.",
    "home_template_copy_open": "Copy \"{name}\" instead of the live front page",
    "home_template_not_live_until_published": "A new design is not shown in the shop until you publish it as the front page.",
    "cannot_delete_live_home_page_template": "This is the home page the shop is showing now and cannot be deleted. Set another template as the home page first.",
    "duplicate_default_home_page_template": "The theme already has a home page template in use.",
    "script_template_scope": "Restrict to specific templates",
    "script_template_scope_description": "Choose the templates this script belongs to. It runs only on pages using one of them — and so follows along automatically in an A/B test showing that template.",
    "script_template_scope_empty_means_global": "Choosing none means the script runs everywhere.",
    "script_template_scope_receipt_warning": "The receipt page uses none of these templates. A script meant to register purchases must therefore be left unrestricted.",
    "conversion_scope_group_product": "Product page templates",
    "conversion_scope_group_home": "Home page templates",
    "conversion_scope_unknown": "Unknown template.",
    "experiment_surface": "What do you want to test?",
    "experiment_surface_product": "Product pages",
    "experiment_surface_category": "Category pages",
    "conversion_scope_group_category": "Category page templates",
    "experiment_scope_summary_category": "The test covers {count} category using the template “{template}”. | The test covers {count} categories using the template “{template}”.",
    "experiment_scope_running_category": "Covers {count} category. | Covers {count} categories.",
    "experiment_surface_home": "Home page",
    "experiment_surface_help": "You can have one test running per page type, so a home page test and a product page test can run at the same time.",
    "experiment_scope_single_page": "The test covers the home page, which is shown using the template “{template}”.",
    "experiment_scope_running_home": "Covers the home page.",
    "product_does_not_track_stock": "The product does not track stock",
    "master_variant_holds_no_stock": "The main variant holds no stock when the product has variants",
    "bulk_stock_updated": "Stock updated for :count products",
    "bulk_stock_updated_skipped_untracked": "Stock updated for :count products, skipped :skipped that do not track stock",
    "stock_units": "in stock",
    "without_stock": "out of stock",
    "stock_negative": "Negative",
    "not_tracking_stock": "not tracking stock",
    "no_stock_location": "no location",
    "n_variants": "{count} variant | {count} variants",
    "variants_empty": "{count} variant empty | {count} variants empty",
    "search_products_sku_gtin": "Search product, SKU or GTIN",
    "select_rows": "select",
    "change_location": "Change location",
    "stock_available": "available",
    "stock_reserved": "reserved",
    "stock_adjustment": "stock change",
    "reserved_units_in_orders": "{units} pcs in {orders} order | {units} pcs in {orders} orders",
    "opening_stock": "opening stock",
    "adjust_stock_on_x_variants": "Adjust stock for {count} variant | Adjust stock for {count} variants",
    "stock_how_it_works": "How stock works",
    "stock_help_numbers_title": "How stock quantities work",
    "stock_help_numbers": "Inventory shows three different quantities that together give you an overview of your stock status:\n\n• Total: The number of items you should physically have in stock.\n• Available: The number of items available for customers to buy right now.\n• Reserved: The number of items linked to orders that have not yet been fully processed.\nTotal = Available + Reserved\nWant to see which orders the reserved items belong to? Click the number under Reserved to see an overview.",
    "stock_help_orders_title": "Stock changes when items are sold",
    "stock_help_orders": "When a new order is created (a sale in the store), the items are deducted from Available immediately and counted as Reserved. Total does not change until the order is processed and the items are shipped. Cancellations and refunds only put items back if you choose to restock them at the time.",
    "stock_help_adjust_title": "How to adjust your inventory",
    "stock_help_adjust": "You always enter the change, never the new count: +5 adds five, −2 removes two. The change saves immediately, with no Save button, and appears in the Stock log. Undo a mistake by entering the opposite number. If you type a number and then press + or −, the number in the field is adjusted before it saves; saving happens when you click the plus or minus sign, or when you leave the field.",
    "stock_help_negative_title": "Negative stock",
    "stock_help_negative": "Stock can become negative when more items are sold than are available in stock. This can happen with backorders, for example, or if several customers buy the last items at the same time.\nA negative stock quantity means that you have sold items that have not yet been registered as available in stock. The sale goes through as normal, and the missing quantity is recorded on the relevant orders.\n\nExample: If you have 2 items in stock and sell 3, available stock will show −1.\nWhen you receive new items, register them with a positive stock adjustment. If you have −1 in stock and add 10 new items, available stock will become 9.",
    "stock_help_variants_title": "Variants and stock tracking",
    "stock_help_variants": "On products with variants, stock is held on each individual variant. The product line shows the total and cannot be adjusted directly; open the variants instead. Products without stock tracking show no field. Tracking is enabled under “Inventory” on the product page.",
    "new_variants_get_stock_on_save": "New variants get their opening stock when you save the product.",
    "stock_saved_with_product": "The stock quantity is saved when you save the product.",
    "stock_adjustment_hint": "Type how many you add or take out, for example +5 or -3.",
    "stock_adjustment_column_hint": "Stock change: type how many you add or take out per variant, for example +5 or -3.",
    "stock_available_now": "available now",
    "stock_your_change": "your change",
    "stock_available_after_save": "available after saving",
    "stock_after_save": "after saving",
    "stock_moved_since_load_title": "Stock has changed since you opened the page",
    "stock_moved_since_load_text": "Your change is applied to the number that applies now. Check that it still makes sense before you save.",
    "stock_when_you_opened": "when you opened the page",
    "stock_now": "now",
    "save_anyway": "Save anyway",
    "role_permission_groups": {
        "users": "Users and roles",
        "order": "Orders",
        "product": "Products",
        "category": "Categories",
        "coupon": "Coupons",
        "marketing": "Marketing",
        "design": "Design",
        "report": "Reports",
        "redirect": "Redirects",
        "webhook": "Webhooks",
        "settings": "Settings",
        "app-store": "Apps",
        "customer": "Customers",
        "blog": "Blog",
        "customer_group": "Customer groups",
        "api-client": "API clients",
        "listings": "Listings",
        "booking": "Booking",
        "customer_club": "Customer club",
        "gift_certificate": "Gift cards",
        "v1import": "Import",
        "accounting": "Accounting",
        "ai": "AI",
        "experiment": "A/B testing",
        "form": "Forms"
    },
    "roles_new_title": "New role",
    "roles_permissions_heading": "Permissions",
    "roles_search_placeholder": "Search permissions",
    "roles_no_search_results": "No permissions match “{query}”",
    "roles_clear_search": "Clear search",
    "roles_group_count": "{selected} of {total}",
    "roles_select_group": "Select all permissions in {group}",
    "roles_selected_heading": "Selected permissions",
    "roles_of_total": "of {total}",
    "roles_locked_title": "The administrator role cannot be changed",
    "roles_locked_text": "It comes with the store. To give someone fewer permissions, add a new role for them.",
    "roles_granted": "Granted",
    "roles_not_granted": "Not granted",
    "trustpilot_app_name": "Trustpilot",
    "trustpilot_app_description": "Automatically invite customers to review your store on Trustpilot when an order is fully fulfilled.",
    "trustpilot_description_label": "How to connect Trustpilot",
    "trustpilot_description_text": "See Trustpilot's guide",
    "trustpilot_enabled_description": "When the whole order has shipped, we ask Trustpilot to invite the customer to review your store.",
    "trustpilot_afs_email": "Trustpilot AFS email address",
    "trustpilot_afs_email_description": "The unique address from Trustpilot Business. It usually ends in {'@'}invite.trustpilot.com.",
    "trustpilot_landing_headline": "More genuine reviews, fully automatic",
    "trustpilot_landing_description": "When an order is fully fulfilled, we ask Trustpilot to send the customer a verified invitation to review your store.",
    "trustpilot_landing_how_it_works_title": "How it works",
    "trustpilot_landing_how_it_works_1": "Copy your AFS address from Trustpilot Business and paste it into the settings.",
    "trustpilot_landing_how_it_works_2": "When every item in an order has shipped, or the rest is cancelled after a partial shipment, we send one email to Trustpilot with the order number, name and email address.",
    "trustpilot_landing_how_it_works_3": "Trustpilot sends the invitation to the customer after the delay and with the template you chose there.",
    "trustpilot_landing_requirements": "Requires a Trustpilot Business account. Automatic Feedback Service is included in every Trustpilot plan, including the free one.",
    "add_variant_type": "Add a variant type",
    "product_variant": "Product variant",
    "product_variants_tooltip_text": "Product variants let you sell different versions of a product, for example in several colours or sizes.<br><br>Add a variant type, for example Colour, with the options the customer can choose from, such as Red, Blue and Yellow. Each combination of options becomes its own product variant, with a price, stock and gallery image in the table below.<br><br>Under Display rules you decide how the options appear in the store: as text, colour swatches or small images. Variant types are also used for the filters on category pages.<br><br>Note: a variant type cannot have the same name as an attribute on the product.",
    "variant_image_scope_legend": "Use the photo for",
    "variant_image_scope_value": "All with {value} ({count})",
    "variant_image_scope_single": "Only this product variant",
    "variant_photo_button": "Gallery image – click to change",
    "variant_photo_button_empty": "Choose a gallery image for this product variant",
    "variant_photo_picker_title": "Gallery image for {variant}",
    "variant_photo_picker_description": "The product page gallery switches to this photo when the customer chooses the product variant. It also shows in the cart.",
    "variant_type": "Variant type",
    "variant_type_name_placeholder": "Type to find a variant type or create a new one, for example Colour",
    "variant_type_values": "Options",
    "variant_type_values_help": "Enter the options the customer can choose between, for example S, M and L. Pick from the list or create new ones.",
    "variant_type_drag": "Drag to reorder",
    "variant_type_delete": "Delete the variant type {option}",
    "variant_type_remove_value": "Remove {value}",
    "variant_type_add_value_placeholder": "Add an option",
    "variant_type_shown_as_text": "Shown as text buttons",
    "variant_type_shown_as_colors": "Shown as colour swatches",
    "variant_type_shown_as_images": "Shown as image buttons",
    "variant_type_used_on_cards": "Used on the product cards",
    "variant_type_values_missing_color": "{count} option has no colour | {count} options have no colour",
    "variant_type_values_missing_image": "{count} option has no image | {count} options have no image",
    "variant_display_rules": "Display rules",
    "variant_display_rules_intro": "Decide how customers see and choose the product variants in your store.",
    "variant_display_heading": "Display in the store",
    "variant_display_heading_description": "Choose how the product variants appear on the product page and in product listings.",
    "variant_display_text_description": "The options appear as buttons with text, for example S, M and L or Red, Blue and Yellow.",
    "variant_display_color_description": "The options appear as colour swatches. You pick one colour for each option.",
    "variant_display_image_description": "The options appear as small images, for example of fabric, pattern or material. You upload one image for each option.",
    "variant_display_design_editor_note": "In the design editor you choose whether the options appear in product listings, and how they look.",
    "variant_display_open_design_editor": "Open the design editor",
    "variant_display_value_missing_color": "No colour yet – shown by name only, and left off the product cards",
    "variant_display_value_missing_image": "No image yet – shown by name only, and left off the product cards",
    "variant_display_color_values_heading": "Colour for each option",
    "variant_display_color_values_description": "The colour fills the button the customer taps.",
    "variant_display_pick_color_for": "Pick a colour for {value}",
    "variant_display_hex_for": "Colour code for {value}",
    "variant_display_image_values_heading": "Image for each option",
    "variant_display_image_values_description": "Use a close-up of the fabric or pattern. The image fills the button the customer taps – it is not the product photo.",
    "variant_display_choose_image_for": "Choose an image for {value}",
    "variant_display_upload_image": "Upload",
    "variant_display_pick_uploaded_image": "Or pick an image you uploaded before:",
    "variant_display_cards_heading": "Product listings",
    "variant_display_cards_description": "Product cards in categories and search show the options of one variant type. Choose which one.",
    "variant_display_card_text": "Text buttons",
    "variant_display_card_color": "Colour swatches",
    "variant_display_card_image": "Image buttons",
    "variant_display_illustration_help": "This is what the customer sees. Tap an option to see which gallery image appears.",
    "variant_display_illustration_caption": "Illustration of the product page and a product card showing where the display rules apply",
    "variant_display_product_page": "Product page",
    "variant_display_product_listing": "Product listing",
    "variant_display_legend_photo": "Gallery image.",
    "variant_display_legend_buttons": "Choice buttons.",
    "variant_display_legend_buttons_text": "What you decide in this window.",
    "variant_display_legend_card": "Product card.",
    "variant_display_gallery_hint_empty": "The image the gallery shows. It is chosen for each product variant in the Gallery image column.",
    "variant_display_gallery_hint_photo": "When the customer chooses {value}, the gallery switches to the gallery image you chose for that product variant.",
    "variant_display_gallery_hint_main": "{value} has no gallery image of its own, so the gallery stays on the main image. You choose it in the Gallery image column of the Product variants table.",
    "variant_display_saved_with_product": "Changes are saved when you save the product.",
    "gallery_badge_option_button": "Button: {value}",
    "variant_display_card_hint": "Shows {option} when options are switched on in the design editor.",
    "variant_gallery_column": "Gallery",
    "variant_gallery_explainer_label": "What is the gallery image?",
    "variant_gallery_explainer_title": "The gallery image",
    "variant_gallery_explainer_text": "When the customer chooses a product variant on the product page, the gallery switches to the image you pick here.",
    "variant_photo_preview_hint": "Hover an image to see it in the gallery.",
    "variant_display_cards_examples_heading": "See how it can look on product cards",
    "variant_display_cards_description_single": "Product cards in categories and search show the options for {option}.",
    "lead_paragraph_placeholder": "A short description of the product",
    "add_product_description": "Add description",
    "add_product_description_hint": "Becomes its own tab on the product page, e.g. Size guide",
    "wysiwyg_tabs_select_label": "Select a tab",
    "hide_price": "Hide price",
    "hide_buy_button": "Hide buy button",
    "hide_buy_button_hint": "Customers can't add the product to the cart.",
    "hide_buy_button_contact_form_link": "Pairs well with a contact form.",
    "x_of_y_variants": "{count} of {total} variants",
    "always_hidden_when_price_hidden": "Always hidden when the price is hidden"
}
